window.theme     = window.theme || {};
window.themeInfo = { name: "Vantage" };

( function vendorLazySizes() {
    /*! lazysizes - v4.0.1 */
    !function ( a, b ) {
	var c = b( a, a.document );
	a.lazySizes = c, "object" == typeof module && module.exports && ( module.exports = c )
    }( window, function ( a, b ) {
	"use strict";
	if ( b.getElementsByClassName ) {
	    var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener",
		i = "getAttribute", j = a[ h ], k = a.setTimeout, l = a.requestAnimationFrame || k,
		m = a.requestIdleCallback, n = /^picture$/i,
		o = [ "load", "error", "lazyincluded", "_lazyloaded" ], p = {}, q = Array.prototype.forEach,
		r = function ( a, b ) {
		    return p[ b ] || ( p[ b ] = new RegExp( "(\\s|^)" + b + "(\\s|$)" ) ), p[ b ].test( a[ i ]( "class" ) || "" ) && p[ b ]
		}, s = function ( a, b ) {
		    r( a, b ) || a.setAttribute( "class", ( a[ i ]( "class" ) || "" ).trim() + " " + b )
		}, t = function ( a, b ) {
		    var c;
		    ( c = r( a, b ) ) && a.setAttribute( "class", ( a[ i ]( "class" ) || "" ).replace( c, " " ) )
		}, u = function ( a, b, c ) {
		    var d = c ? h : "removeEventListener";
		    c && u( a, b ), o.forEach( function ( c ) {
			a[ d ]( c, b )
		    } )
		}, v = function ( a, d, e, f, g ) {
		    var h = b.createEvent( "CustomEvent" );
		    return e || ( e = {} ), e.instance = c, h.initCustomEvent( d, !f, !g, e ), a.dispatchEvent( h ), h
		}, w = function ( b, c ) {
		    var e;
		    !g && ( e = a.picturefill || d.pf ) ? e( {
			reevaluate: !0, elements: [ b ]
		    } ) : c && c.src && ( b.src = c.src )
		}, x = function ( a, b ) {
		    return ( getComputedStyle( a, null ) || {} )[ b ]
		}, y = function ( a, b, c ) {
		    for ( c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; ) c = b.offsetWidth, b = b.parentNode;
		    return c
		}, z = function () {
		    var a, c, d = [], e = [], f = d, g = function () {
			var b = f;
			for ( f = d.length ? e : d, a = !0, c = !1; b.length; ) b.shift()();
			a = !1
		    }, h = function ( d, e ) {
			a && !e ? d.apply( this, arguments ) : ( f.push( d ), c || ( c = !0, ( b.hidden ? k : l )( g ) ) )
		    };
		    return h._lsFlush = g, h
		}(), A = function ( a, b ) {
		    return b ? function () {
			z( a )
		    } : function () {
			var b = this, c = arguments;
			z( function () {
			    a.apply( b, c )
			} )
		    }
		}, B = function ( a ) {
		    var b, c = 0, e = 125, g = d.ricTimeout, h = function () {
			b = !1, c = f.now(), a()
		    }, i = m && d.ricTimeout ? function () {
			m( h, { timeout: g } ), g !== d.ricTimeout && ( g = d.ricTimeout )
		    } : A( function () {
			k( h )
		    }, !0 );
		    return function ( a ) {
			var d;
			( a = a === !0 ) && ( g = 33 ), b || ( b = !0, d = e - ( f.now() - c ), 0 > d && ( d = 0 ), a || 9 > d && m ? i() : k( i, d ) )
		    }
		}, C = function ( a ) {
		    var b, c, d = 99, e = function () {
			b = null, a()
		    }, g = function () {
			var a = f.now() - c;
			d > a ? k( g, d - a ) : ( m || e )( e )
		    };
		    return function () {
			c = f.now(), b || ( b = k( g, d ) )
		    }
		};
	    !function () {
		var b, c = {
		    lazyClass   : "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading",
		    preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes",
		    srcAttr     : "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40,
		    customMedia : {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 300
		};
		d        = a.lazySizesConfig || a.lazysizesConfig || {};
		for ( b in c ) b in d || ( d[ b ] = c[ b ] );
		a.lazySizesConfig = d, k( function () {
		    d.init && F()
		} )
	    }();
	    var D  = function () {
		var g, l, m, o, p, y, D, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i,
		    O = "onscroll" in a && !/glebot/.test( navigator.userAgent ),
		    P = 0, Q = 0, R = 0, S = -1, T = function ( a ) {
			R--, a && a.target && u( a.target, T ), ( !a || 0 > R || !a.target ) && ( R = 0 )
		    }, U = function ( a, c ) {
			var d, f = a, g = "hidden" == x( b.body, "visibility" ) || "hidden" != x( a, "visibility" );
			for ( F -= c, I += c, G -= c, H += c; g && ( f = f.offsetParent ) && f != b.body && f != e; ) g = ( x( f, "opacity" ) || 1 ) > 0, g && "visible" != x( f, "overflow" ) && ( d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1 );
			return g
		    }, V = function () {
			var a, f, h, j, k, m, n, p, q, r = c.elements;
			if ( ( o = d.loadMode ) && 8 > R && ( a = r.length ) ) {
			    f = 0, S++, null == K && ( "expand" in d || ( d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 ), J = d.expand, K = J * d.expFactor ), K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? ( Q = K, S = 0 ) : Q = o > 1 && S > 1 && 6 > R ? J : P;
			    for ( ; a > f; f++ ) if ( r[ f ] && !r[ f ]._lazyRace ) if ( O ) if ( ( p = r[ f ][ i ]( "data-expand" ) ) && ( m = 1 * p ) || ( m = Q ), q !== m && ( y = innerWidth + m * L, D = innerHeight + m, n = -1 * m, q = m ), h = r[ f ].getBoundingClientRect(), ( I = h.bottom ) >= n && ( F = h.top ) <= D && ( H = h.right ) >= n * L && ( G = h.left ) <= y && ( I || H || G || F ) && ( d.loadHidden || "hidden" != x( r[ f ], "visibility" ) ) && ( l && 3 > R && !p && ( 3 > o || 4 > S ) || U( r[ f ], m ) ) ) {
				if ( ba( r[ f ] ), k = !0, R > 9 ) break
			    } else !k && l && !j && 4 > R && 4 > S && o > 2 && ( g[ 0 ] || d.preloadAfterLoad ) && ( g[ 0 ] || !p && ( I || H || G || F || "auto" != r[ f ][ i ]( d.sizesAttr ) ) ) && ( j = g[ 0 ] || r[ f ] ); else ba( r[ f ] );
			    j && !k && ba( j )
			}
		    }, W = B( V ), X = function ( a ) {
			s( a.target, d.loadedClass ), t( a.target, d.loadingClass ), u( a.target, Z ), v( a.target, "lazyloaded" )
		    }, Y = A( X ), Z = function ( a ) {
			Y( { target: a.target } )
		    }, $ = function ( a, b ) {
			try {
			    a.contentWindow.location.replace( b )
			} catch ( c ) {
			    a.src = b
			}
		    }, _ = function ( a ) {
			var b, c = a[ i ]( d.srcsetAttr );
			( b = d.customMedia[ a[ i ]( "data-media" ) || a[ i ]( "media" ) ] ) && a.setAttribute( "media", b ), c && a.setAttribute( "srcset", c )
		    }, aa = A( function ( a, b, c, e, f ) {
			var g, h, j, l, o, p;
			( o = v( a, "lazybeforeunveil", b ) ).defaultPrevented || ( e && ( c ? s( a, d.autosizesClass ) : a.setAttribute( "sizes", e ) ), h = a[ i ]( d.srcsetAttr ), g = a[ i ]( d.srcAttr ), f && ( j = a.parentNode, l = j && n.test( j.nodeName || "" ) ), p = b.firesLoad || "src" in a && ( h || g || l ), o = { target: a }, p && ( u( a, T, !0 ), clearTimeout( m ), m = k( T, 2500 ), s( a, d.loadingClass ), u( a, Z, !0 ) ), l && q.call( j.getElementsByTagName( "source" ), _ ), h ? a.setAttribute( "srcset", h ) : g && !l && ( N.test( a.nodeName ) ? $( a, g ) : a.src = g ), f && ( h || l ) && w( a, { src: g } ) ), a._lazyRace && delete a._lazyRace, t( a, d.lazyClass ), z( function () {
			    ( !p || a.complete && a.naturalWidth > 1 ) && ( p ? T( o ) : R--, X( o ) )
			}, !0 )
		    } ), ba = function ( a ) {
			var b, c = M.test( a.nodeName ), e = c && ( a[ i ]( d.sizesAttr ) || a[ i ]( "sizes" ) ),
			    f = "auto" == e;
			( !f && l || !c || !a[ i ]( "src" ) && !a.srcset || a.complete || r( a, d.errorClass ) || !r( a, d.lazyClass ) ) && ( b = v( a, "lazyunveilread" ).detail, f && E.updateElem( a, !0, a.offsetWidth ), a._lazyRace = !0, R++, aa( a, b, f, e, c ) )
		    }, ca = function () {
			if ( !l ) {
			    if ( f.now() - p < 999 ) return void k( ca, 999 );
			    var a = C( function () {
				d.loadMode = 3, W()
			    } );
			    l = !0, d.loadMode = 3, W(), j( "scroll", function () {
				3 == d.loadMode && ( d.loadMode = 2 ), a()
			    }, !0 )
			}
		    };
		return {
		    _            : function () {
			p = f.now(), c.elements = b.getElementsByClassName( d.lazyClass ), g = b.getElementsByClassName( d.lazyClass + " " + d.preloadClass ), L = d.hFac, j( "scroll", W, !0 ), j( "resize", W, !0 ), a.MutationObserver ? new MutationObserver( W ).observe( e, {
			    childList: !0, subtree: !0, attributes: !0
			} ) : ( e[ h ]( "DOMNodeInserted", W, !0 ), e[ h ]( "DOMAttrModified", W, !0 ), setInterval( W, 999 ) ), j( "hashchange", W, !0 ), [ "focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd" ].forEach( function ( a ) {
			    b[ h ]( a, W, !0 )
			} ), /d$|^c/.test( b.readyState ) ? ca() : ( j( "load", ca ), b[ h ]( "DOMContentLoaded", W ), k( ca, 2e4 ) ), c.elements.length ? ( V(), z._lsFlush() ) : W()
		    }, checkElems: W, unveil: ba
		}
	    }(), E = function () {
		var a, c = A( function ( a, b, c, d ) {
		    var e, f, g;
		    if ( a._lazysizesWidth = d, d += "px", a.setAttribute( "sizes", d ), n.test( b.nodeName || "" ) ) for ( e = b.getElementsByTagName( "source" ), f = 0, g = e.length; g > f; f++ ) e[ f ].setAttribute( "sizes", d );
		    c.detail.dataAttr || w( a, c.detail )
		} ), e   = function ( a, b, d ) {
		    var e, f = a.parentNode;
		    f && ( d = y( a, f, d ), e = v( a, "lazybeforesizes", {
			width: d, dataAttr: !!b
		    } ), e.defaultPrevented || ( d = e.detail.width, d && d !== a._lazysizesWidth && c( a, f, e, d ) ) )
		}, f     = function () {
		    var b, c = a.length;
		    if ( c ) for ( b = 0; c > b; b++ ) e( a[ b ] )
		}, g     = C( f );
		return {
		    _            : function () {
			a = b.getElementsByClassName( d.autosizesClass ), j( "resize", g )
		    }, checkElems: g, updateElem: e
		}
	    }(), F = function () {
		F.i || ( F.i = !0, E._(), D._() )
	    };
	    return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z }
	}
    } );
    
    /*! lazysizes Bgset - v4.0.1 */
    !function ( a, b ) {
	var c = function () {
	    b( a.lazySizes ), a.removeEventListener( "lazyunveilread", c, !0 )
	};
	b = b.bind( null, a, a.document ), "object" == typeof module && module.exports ? b( require( "lazysizes" ) ) : a.lazySizes ? c() : a.addEventListener( "lazyunveilread", c, !0 )
    }( window, function ( a, b, c ) {
	"use strict";
	if ( a.addEventListener ) {
	    var d = /\s+/g, e = /\s*\|\s+|\s+\|\s*/g, f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/, g = /\(|\)|'/,
		h = { contain: 1, cover: 1 }, i = function ( a ) {
		    var b = c.gW( a, a.parentNode );
		    return ( !a._lazysizesWidth || b > a._lazysizesWidth ) && ( a._lazysizesWidth = b ), a._lazysizesWidth
		}, j = function ( a ) {
		    var b;
		    return b = ( getComputedStyle( a ) || {
			getPropertyValue: function () {
			}
		    } ).getPropertyValue( "background-size" ), !h[ b ] && h[ a.style.backgroundSize ] && ( b = a.style.backgroundSize ), b
		}, k = function ( a, c, g ) {
		    var h = b.createElement( "picture" ), i = c.getAttribute( lazySizesConfig.sizesAttr ),
			j = c.getAttribute( "data-ratio" ), k = c.getAttribute( "data-optimumx" );
		    c._lazybgset && c._lazybgset.parentNode == c && c.removeChild( c._lazybgset ), Object.defineProperty( g, "_lazybgset", {
			value: c, writable: !0
		    } ), Object.defineProperty( c, "_lazybgset", {
			value: h, writable: !0
		    } ), a = a.replace( d, " " ).split( e ), h.style.display = "none", g.className = lazySizesConfig.lazyClass, 1 != a.length || i || ( i = "auto" ), a.forEach( function ( a ) {
			var c = b.createElement( "source" );
			i && "auto" != i && c.setAttribute( "sizes", i ), a.match( f ) && ( c.setAttribute( lazySizesConfig.srcsetAttr, RegExp.$1 ), RegExp.$2 && c.setAttribute( "media", lazySizesConfig.customMedia[ RegExp.$2 ] || RegExp.$2 ) ), h.appendChild( c )
		    } ), i && ( g.setAttribute( lazySizesConfig.sizesAttr, i ), c.removeAttribute( lazySizesConfig.sizesAttr ), c.removeAttribute( "sizes" ) ), k && g.setAttribute( "data-optimumx", k ), j && g.setAttribute( "data-ratio", j ), h.appendChild( g ), c.appendChild( h )
		}, l = function ( a ) {
		    if ( a.target._lazybgset ) {
			var b = a.target, d = b._lazybgset, e = b.currentSrc || b.src;
			e && ( d.style.backgroundImage = "url(" + ( g.test( e ) ? JSON.stringify( e ) : e ) + ")" ), b._lazybgsetLoading && ( c.fire( d, "_lazyloaded", {}, !1, !0 ), delete b._lazybgsetLoading )
		    }
		};
	    addEventListener( "lazybeforeunveil", function ( a ) {
		var d, e, f;
		!a.defaultPrevented && ( d = a.target.getAttribute( "data-bgset" ) ) && ( f = a.target, e = b.createElement( "img" ), e.alt = "", e._lazybgsetLoading = !0, a.detail.firesLoad = !0, k( d, f, e ), setTimeout( function () {
		    c.loader.unveil( e ), c.rAF( function () {
			c.fire( e, "_lazyloaded", {}, !0, !0 ), e.complete && l( { target: e } )
		    } )
		} ) )
	    } ), b.addEventListener( "load", l, !0 ), a.addEventListener( "lazybeforesizes", function ( a ) {
		if ( a.detail.instance == c && a.target._lazybgset && a.detail.dataAttr ) {
		    var b = a.target._lazybgset, d = j( b );
		    h[ d ] && ( a.target._lazysizesParentFit = d, c.rAF( function () {
			a.target.setAttribute( "data-parent-fit", d ), a.target._lazysizesParentFit && delete a.target._lazysizesParentFit
		    } ) )
		}
	    }, !0 ), b.documentElement.addEventListener( "lazybeforesizes", function ( a ) {
		!a.defaultPrevented && a.target._lazybgset && a.detail.instance == c && ( a.detail.width = i( a.target._lazybgset ) )
	    } )
	}
    } );
    
    /*! lazysizes rias - v4.0.1 */
    !function ( a, b ) {
	var c = function () {
	    b( a.lazySizes ), a.removeEventListener( "lazyunveilread", c, !0 )
	};
	b = b.bind( null, a, a.document ), "object" == typeof module && module.exports ? b( require( "lazysizes" ) ) : a.lazySizes ? c() : a.addEventListener( "lazyunveilread", c, !0 )
    }( window, function ( a, b, c ) {
	"use strict";
	
	function d( b, c ) {
	    var d, e, f, g, h = a.getComputedStyle( b );
	    e = b.parentNode, g = { isPicture: !( !e || !m.test( e.nodeName || "" ) ) }, f = function ( a, c ) {
		var d = b.getAttribute( "data-" + a );
		if ( !d ) {
		    var e = h.getPropertyValue( "--ls-" + a );
		    e && ( d = e.trim() )
		}
		if ( d ) {
		    if ( "true" == d ) d = !0; else if ( "false" == d ) d = !1; else if ( l.test( d ) ) d = parseFloat( d ); else if ( "function" == typeof j[ a ] ) d = j[ a ]( b, d ); else if ( q.test( d ) ) try {
			d = JSON.parse( d )
		    } catch ( f ) {
		    }
		    g[ a ] = d
		} else a in j && "function" != typeof j[ a ] ? g[ a ] = j[ a ] : c && "function" == typeof j[ a ] && ( g[ a ] = j[ a ]( b, d ) )
	    };
	    for ( d in j ) f( d );
	    return c.replace( p, function ( a, b ) {
		b in g || f( b, !0 )
	    } ), g
	}
	
	function e( a, b ) {
	    var c = [], d = function ( a, c ) {
		return k[ typeof b[ c ] ] ? b[ c ] : a
	    };
	    return c.srcset = [], b.absUrl && ( s.setAttribute( "href", a ), a = s.href ), a = ( ( b.prefix || "" ) + a + ( b.postfix || "" ) ).replace( p, d ), b.widths.forEach( function ( d ) {
		var e = b.widthmap[ d ] || d,
		    f = { u: a.replace( n, e ).replace( o, b.ratio ? Math.round( d * b.ratio ) : "" ), w: d };
		c.push( f ), c.srcset.push( f.c = f.u + " " + d + "w" )
	    } ), c
	}
	
	function f( a, c, d ) {
	    var f = 0, g = 0, h = d;
	    if ( a ) {
		if ( "container" === c.ratio ) {
		    for ( f = h.scrollWidth, g = h.scrollHeight; !( f && g || h === b ); ) h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight;
		    f && g && ( c.ratio = g / f )
		}
		a = e( a, c ), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute( i.srcsetAttr ) : d.setAttribute( i.srcsetAttr, a.srcset.join( ", " ) ), Object.defineProperty( d, "_lazyrias", {
		    value: a, writable: !0
		} )
	    }
	}
	
	function g( a, b ) {
	    var e = d( a, b );
	    return j.modifyOptions.call( a, {
		target: a, details: e, detail: e
	    } ), c.fire( a, "lazyriasmodifyoptions", e ), e
	}
	
	function h( a ) {
	    return a.getAttribute( a.getAttribute( "data-srcattr" ) || j.srcAttr ) || a.getAttribute( i.srcsetAttr ) || a.getAttribute( i.srcAttr ) || a.getAttribute( "data-pfsrcset" ) || ""
	}
	
	var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i,
	    o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/,
	    r = /^(?:auto|\d+(px)?)$/, s = b.createElement( "a" ), t = b.createElement( "img" ),
	    u = "srcset" in t && !( "sizes" in t ), v = !!a.HTMLPictureElement && !u;
	!function () {
	    var b, d = function () {
	    }, e     = {
		prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1
	    };
	    i = c && c.cfg || a.lazySizesConfig, i || ( i = {}, a.lazySizesConfig = i ), i.supportsType || ( i.supportsType = function ( a ) {
		return !a
	    } ), i.rias || ( i.rias = {} ), j = i.rias, "widths" in j || ( j.widths = [], function ( a ) {
		for ( var b, c = 0; !b || 3e3 > b; ) c += 5, c > 30 && ( c += 1 ), b = 36 * c, a.push( b )
	    }( j.widths ) );
	    for ( b in e ) b in j || ( j[ b ] = e[ b ] )
	}(), addEventListener( "lazybeforesizes", function ( a ) {
	    if ( a.detail.instance == c ) {
		var b, d, e, k, l, m, o, p, q, s, t, u, x;
		if ( b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && ( q = b.getAttribute( i.sizesAttr ) || b.getAttribute( "sizes" ) ) && r.test( q ) ) {
		    if ( d = h( b ), e = g( b, d ), t = n.test( e.prefix ) || n.test( e.postfix ), e.isPicture && ( k = b.parentNode ) ) for ( l = k.getElementsByTagName( "source" ), m = 0, o = l.length; o > m; m++ ) ( t || n.test( p = h( l[ m ] ) ) ) && ( f( p, e, l[ m ] ), u = !0 );
		    t || n.test( d ) ? ( f( d, e, b ), u = !0 ) : u && ( x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty( b, "_lazyrias", {
			value: x, writable: !0
		    } ) ), u && ( v ? b.removeAttribute( i.srcAttr ) : "auto" != q && ( s = { width: parseInt( q, 10 ) }, w( {
			target: b, detail: s
		    } ) ) )
		}
	    }
	}, !0 );
	var w = function () {
	    var d = function ( a, b ) {
		return a.w - b.w
	    }, e  = function ( a ) {
		var b, c, d = a.length, e = a[ d - 1 ], f = 0;
		for ( f; d > f; f++ ) if ( e = a[ f ], e.d = e.w / a.w, e.d >= a.d ) {
		    !e.cached && ( b = a[ f - 1 ] ) && b.d > a.d - .13 * Math.pow( a.d, 2.2 ) && ( c = Math.pow( b.d - .6, 1.6 ), b.cached && ( b.d += .15 * c ), b.d + ( e.d - a.d ) * c > a.d && ( e = b ) );
		    break
		}
		return e
	    }, f  = function ( a, b ) {
		var d;
		return !a._lazyrias && c.pWS && ( d = c.pWS( a.getAttribute( i.srcsetAttr || "" ) ) ).length && ( Object.defineProperty( a, "_lazyrias", {
		    value: d, writable: !0
		} ), b && a.parentNode && ( d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase() ) ), a._lazyrias
	    }, g  = function ( b ) {
		var d = a.devicePixelRatio || 1, e = c.getX && c.getX( b );
		return Math.min( e || d, 2.4, d )
	    }, h  = function ( b, c ) {
		var h, i, j, k, l, m;
		if ( l = b._lazyrias, l.isPicture && a.matchMedia ) for ( i = 0, h = b.parentNode.getElementsByTagName( "source" ), j = h.length; j > i; i++ ) if ( f( h[ i ] ) && !h[ i ].getAttribute( "type" ) && ( !( k = h[ i ].getAttribute( "media" ) ) || ( matchMedia( k ) || {} ).matches ) ) {
		    l = h[ i ]._lazyrias;
		    break
		}
		return ( !l.w || l.w < c ) && ( l.w = c, l.d = g( b ), m = e( l.sort( d ) ) ), m
	    }, j  = function ( d ) {
		if ( d.detail.instance == c ) {
		    var e, g = d.target;
		    return !u && ( a.respimage || a.picturefill || lazySizesConfig.pf ) ? void b.removeEventListener( "lazybeforesizes", j ) : void ( ( "_lazyrias" in g || d.detail.dataAttr && f( g, !0 ) ) && ( e = h( g, d.detail.width ), e && e.u && g._lazyrias.cur != e.u && ( g._lazyrias.cur = e.u, e.cached = !0, c.rAF( function () {
			g.setAttribute( i.srcAttr, e.u ), g.setAttribute( "src", e.u )
		    } ) ) ) )
		}
	    };
	    return v ? j = function () {
	    } : addEventListener( "lazybeforesizes", j ), j
	}()
    } );
    
} )();

( function polyfillNodeList() {
    /* For IE 11+ Nodelist forEach Function */
    if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = function ( callback, thisArg ) {
	    thisArg = thisArg || window;
	    for ( var i = 0; i < this.length; i++ ) {
		callback.call( thisArg, this[ i ], i, this );
	    }
	};
    }
    
    
    /* IE 11 Includes Polyfill */
    if ( !String.prototype.includes ) {
	String.prototype.includes = function ( search, start ) {
	    'use strict';
	    if ( typeof start !== 'number' ) {
		start = 0;
	    }
	    
	    if ( start + search.length > this.length ) {
		return false;
	    } else {
		return this.indexOf( search, start ) !== -1;
	    }
	};
    }
    /* IE11 Polyfill for remove */
    ( function ( arr ) {
	arr.forEach( function ( item ) {
	    if ( item.hasOwnProperty( 'remove' ) ) {
		return;
	    }
	    Object.defineProperty( item, 'remove', {
		configurable: true,
		enumerable  : true,
		writable    : true,
		value       : function remove() {
		    this.parentNode.removeChild( this );
		}
	    } );
	} );
    } )( [ Element.prototype, CharacterData.prototype, DocumentType.prototype ] );
} )();

( function vendorModernizr() {
    /* Modernizr 2.8.2 (Custom Build) | MIT & BSD
   * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-cssclassprefix:supports!
   */
    ;window.Modernizr = function ( a, b, c ) {
	function z( a ) {
	    j.cssText = a
	}
	
	function A( a, b ) {
	    return z( m.join( a + ";" ) + ( b || "" ) )
	}
	
	function B( a, b ) {
	    return typeof a === b
	}
	
	function C( a, b ) {
	    return !!~( "" + a ).indexOf( b )
	}
	
	function D( a, b ) {
	    for ( var d in a ) {
		var e = a[ d ];
		if ( !C( e, "-" ) && j[ e ] !== c ) return b == "pfx" ? e : !0
	    }
	    return !1
	}
	
	function E( a, b, d ) {
	    for ( var e in a ) {
		var f = b[ a[ e ] ];
		if ( f !== c ) return d === !1 ? a[ e ] : B( f, "function" ) ? f.bind( d || b ) : f
	    }
	    return !1
	}
	
	function F( a, b, c ) {
	    var d = a.charAt( 0 ).toUpperCase() + a.slice( 1 ), e = ( a + " " + o.join( d + " " ) + d ).split( " " );
	    return B( b, "string" ) || B( b, "undefined" ) ? D( e, b ) : ( e = ( a + " " + p.join( d + " " ) + d ).split( " " ), E( e, b, c ) )
	}
	
	var d = "2.8.2", e = {}, f = !0, g = b.documentElement, h = "modernizr", i = b.createElement( h ),
	    j = i.style, k, l = {}.toString, m = " -webkit- -moz- -o- -ms- ".split( " " ), n = "Webkit Moz O ms",
	    o = n.split( " " ), p = n.toLowerCase().split( " " ), q = {}, r = {}, s = {}, t = [], u = t.slice, v,
	    w = function ( a, c, d, e ) {
		var f, i, j, k, l = b.createElement( "div" ), m = b.body, n = m || b.createElement( "body" );
		if ( parseInt( d, 10 ) ) while ( d-- ) j = b.createElement( "div" ), j.id = e ? e[ d ] : h + ( d + 1 ), l.appendChild( j );
		return f = [ "&#173;", '<style id="s', h, '">', a, "</style>" ].join( "" ), l.id = h, ( m ? l : n ).innerHTML += f, n.appendChild( l ), m || ( n.style.background = "", n.style.overflow = "hidden", k = g.style.overflow, g.style.overflow = "hidden", g.appendChild( n ) ), i = c( l, a ), m ? l.parentNode.removeChild( l ) : ( n.parentNode.removeChild( n ), g.style.overflow = k ), !!i
	    }, x = {}.hasOwnProperty, y;
	!B( x, "undefined" ) && !B( x.call, "undefined" ) ? y = function ( a, b ) {
	    return x.call( a, b )
	} : y = function ( a, b ) {
	    return b in a && B( a.constructor.prototype[ b ], "undefined" )
	}, Function.prototype.bind || ( Function.prototype.bind = function ( b ) {
	    var c = this;
	    if ( typeof c != "function" ) throw new TypeError;
	    var d = u.call( arguments, 1 ), e = function () {
		if ( this instanceof e ) {
		    var a       = function () {
		    };
		    a.prototype = c.prototype;
		    var f       = new a, g = c.apply( f, d.concat( u.call( arguments ) ) );
		    return Object( g ) === g ? g : f
		}
		return c.apply( b, d.concat( u.call( arguments ) ) )
	    };
	    return e
	} ), q.touch = function () {
	    var c;
	    return "ontouchstart" in a || a.DocumentTouch && b instanceof DocumentTouch ? c = !0 : w( [ "@media (", m.join( "touch-enabled),(" ), h, ")", "{#modernizr{top:9px;position:absolute}}" ].join( "" ), function ( a ) {
		c = a.offsetTop === 9
	    } ), c
	}, q.csstransforms = function () {
	    return !!F( "transform" )
	}, q.csstransforms3d = function () {
	    var a = !!F( "perspective" );
	    return a && "webkitPerspective" in g.style && w( "@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function ( b, c ) {
		a = b.offsetLeft === 9 && b.offsetHeight === 3
	    } ), a
	}, q.fontface = function () {
	    var a;
	    return w( '@font-face {font-family:"font";src:url("https://")}', function ( c, d ) {
		var e = b.getElementById( "smodernizr" ), f = e.sheet || e.styleSheet,
		    g = f ? f.cssRules && f.cssRules[ 0 ] ? f.cssRules[ 0 ].cssText : f.cssText || "" : "";
		a = /src/i.test( g ) && g.indexOf( d.split( " " )[ 0 ] ) === 0
	    } ), a
	};
	for ( var G in q ) y( q, G ) && ( v = G.toLowerCase(), e[ v ] = q[ G ](), t.push( ( e[ v ] ? "" : "no-" ) + v ) );
	return e.addTest = function ( a, b ) {
	    if ( typeof a == "object" ) for ( var d in a ) y( a, d ) && e.addTest( d, a[ d ] ); else {
		a = a.toLowerCase();
		if ( e[ a ] !== c ) return e;
		b = typeof b == "function" ? b() : b, typeof f != "undefined" && f && ( g.className += " supports-" + ( b ? "" : "no-" ) + a ), e[ a ] = b
	    }
	    return e
	}, z( "" ), i = k = null, e._version = d, e._prefixes = m, e._domPrefixes = p, e._cssomPrefixes = o, e.testProp = function ( a ) {
	    return D( [ a ] )
	}, e.testAllProps = F, e.testStyles = w, g.className = g.className.replace( /(^|\s)no-js(\s|$)/, "$1$2" ) + ( f ? " supports-js supports-" + t.join( " supports-" ) : "" ), e
    }( this, this.document );
} )();

( function helperCookie() {
    !function ( e ) {
	var n;
	if ( "function" == typeof define && define.amd && ( define( e ), n = !0 ), "object" == typeof exports && ( module.exports = e(), n = !0 ), !n ) {
	    var t        = window.Cookies, o = window.Cookies = e();
	    o.noConflict = function () {
		return window.Cookies = t, o
	    }
	}
    }( function () {
	function e() {
	    for ( var e = 0, n = {}; e < arguments.length; e++ ) {
		var t = arguments[ e ];
		for ( var o in t ) n[ o ] = t[ o ]
	    }
	    return n
	}
	
	function n( e ) {
	    return e.replace( /(%[0-9A-Z]{2})+/g, decodeURIComponent )
	}
	
	return function t( o ) {
	    function r() {
	    }
	    
	    function i( n, t, i ) {
		if ( "undefined" != typeof document ) {
		    "number" == typeof ( i = e( { path: "/" }, r.defaults, i ) ).expires && ( i.expires = new Date( 1 * new Date + 864e5 * i.expires ) ), i.expires = i.expires ? i.expires.toUTCString() : "";
		    try {
			var c = JSON.stringify( t );
			/^[\{\[]/.test( c ) && ( t = c )
		    } catch ( e ) {
		    }
		    t = o.write ? o.write( t, n ) : encodeURIComponent( String( t ) ).replace( /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent ), n = encodeURIComponent( String( n ) ).replace( /%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent ).replace( /[\(\)]/g, escape );
		    var f = "";
		    for ( var u in i ) i[ u ] && ( f += "; " + u, !0 !== i[ u ] && ( f += "=" + i[ u ].split( ";" )[ 0 ] ) );
		    return document.cookie = n + "=" + t + f
		}
	    }
	    
	    function c( e, t ) {
		if ( "undefined" != typeof document ) {
		    for ( var r = {}, i = document.cookie ? document.cookie.split( "; " ) : [], c = 0; c < i.length; c++ ) {
			var f = i[ c ].split( "=" ), u = f.slice( 1 ).join( "=" );
			t || '"' !== u.charAt( 0 ) || ( u = u.slice( 1, -1 ) );
			try {
			    var a = n( f[ 0 ] );
			    if ( u = ( o.read || o )( u, a ) || n( u ), t ) try {
				u = JSON.parse( u )
			    } catch ( e ) {
			    }
			    if ( r[ a ] = u, e === a ) break
			} catch ( e ) {
			}
		    }
		    return e ? r[ e ] : r
		}
	    }
	    
	    return r.set = i, r.get = function ( e ) {
		return c( e, !1 )
	    }, r.getJSON = function ( e ) {
		return c( e, !0 )
	    }, r.remove = function ( n, t ) {
		i( n, "", e( t, { expires: -1 } ) )
	    }, r.defaults = {}, r.withConverter = t, r
	}( function () {
	} )
    } );
} )();

( function vendorLodash() {
    // lodash.core.min.js
    
    /**
     * @license
     * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
     * Build: `lodash core -o ./dist/lodash.core.js`
     */
    ;( function () {
	function n( n, t ) {
	    for ( var r = -1, e = t.length, u = n.length; ++r < e; ) n[ u + r ] = t[ r ];
	    return n
	}
	
	function t( n, t, r ) {
	    for ( var e = -1, u = n.length; ++e < u; ) {
		var o = n[ e ], i = t( o );
		if ( null != i && ( c === an ? i === i : r( i, c ) ) ) var c = i, f = o
	    }
	    return f
	}
	
	function r( n, t, r ) {
	    var e;
	    return r( n, function ( n, r, u ) {
		return t( n, r, u ) ? ( e = n, false ) : void 0
	    } ), e
	}
	
	function e( n, t, r, e, u ) {
	    return u( n, function ( n, u, o ) {
		r = e ? ( e = false, n ) : t( r, n, u, o )
	    } ), r
	}
	
	function u( n, t ) {
	    return O( t, function ( t ) {
		return n[ t ]
	    } )
	}
	
	function o( n ) {
	    return n && n.Object === Object ? n : null
	}
	
	function i( n ) {
	    return vn[ n ];
	}
	
	function c( n ) {
	    var t = false;
	    if ( null != n && typeof n.toString != "function" ) try {
		t = !!( n + "" )
	    } catch ( r ) {
	    }
	    return t
	}
	
	function f( n, t ) {
	    return n = typeof n == "number" || hn.test( n ) ? +n : -1, n > -1 && 0 == n % 1 && ( null == t ? 9007199254740991 : t ) > n
	}
	
	function a( n ) {
	    if ( Y( n ) && !Pn( n ) ) {
		if ( n instanceof l ) return n;
		if ( En.call( n, "__wrapped__" ) ) {
		    var t = new l( n.__wrapped__, n.__chain__ );
		    return t.__actions__ = N( n.__actions__ ), t
		}
	    }
	    return new l( n )
	}
	
	function l( n, t ) {
	    this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t
	}
	
	function p( n, t, r, e ) {
	    var u;
	    return ( u = n === an ) || ( u = xn[ r ],
		u = ( n === u || n !== n && u !== u ) && !En.call( e, r ) ), u ? t : n
	}
	
	function s( n ) {
	    return X( n ) ? Fn( n ) : {}
	}
	
	function h( n, t, r ) {
	    if ( typeof n != "function" ) throw new TypeError( "Expected a function" );
	    return setTimeout( function () {
		n.apply( an, r )
	    }, t )
	}
	
	function v( n, t ) {
	    var r = true;
	    return $n( n, function ( n, e, u ) {
		return r = !!t( n, e, u )
	    } ), r
	}
	
	function y( n, t ) {
	    var r = [];
	    return $n( n, function ( n, e, u ) {
		t( n, e, u ) && r.push( n )
	    } ), r
	}
	
	function _( t, r, e, u ) {
	    u || ( u = [] );
	    for ( var o = -1, i = t.length; ++o < i; ) {
		var c = t[ o ];
		r > 0 && Y( c ) && L( c ) && ( e || Pn( c ) || K( c ) ) ? r > 1 ? _( c, r - 1, e, u ) : n( u, c ) : e || ( u[ u.length ] = c );
	    }
	    return u
	}
	
	function g( n, t ) {
	    return n && qn( n, t, en )
	}
	
	function b( n, t ) {
	    return y( t, function ( t ) {
		return Q( n[ t ] )
	    } )
	}
	
	function j( n, t, r, e, u ) {
	    return n === t ? true : null == n || null == t || !X( n ) && !Y( t ) ? n !== n && t !== t : m( n, t, j, r, e, u )
	}
	
	function m( n, t, r, e, u, o ) {
	    var i = Pn( n ), f = Pn( t ), a = "[object Array]", l = "[object Array]";
	    i || ( a = kn.call( n ), "[object Arguments]" == a && ( a = "[object Object]" ) ), f || ( l = kn.call( t ), "[object Arguments]" == l && ( l = "[object Object]" ) );
	    var p = "[object Object]" == a && !c( n ), f = "[object Object]" == l && !c( t );
	    return !( l = a == l ) || i || p ? 2 & u || ( a = p && En.call( n, "__wrapped__" ),
		f = f && En.call( t, "__wrapped__" ), !a && !f ) ? l ? ( o || ( o = [] ), ( a = J( o, function ( t ) {
		return t[ 0 ] === n
	    } ) ) && a[ 1 ] ? a[ 1 ] == t : ( o.push( [ n, t ] ), t = ( i ? I : q )( n, t, r, e, u, o ), o.pop(), t ) ) : false : r( a ? n.value() : n, f ? t.value() : t, e, u, o ) : $( n, t, a )
	}
	
	function d( n ) {
	    var t = typeof n;
	    return "function" == t ? n : null == n ? cn : ( "object" == t ? x : A )( n )
	}
	
	function w( n ) {
	    n        = null == n ? n : Object( n );
	    var t, r = [];
	    for ( t in n ) r.push( t );
	    return r
	}
	
	function O( n, t ) {
	    var r = -1, e = L( n ) ? Array( n.length ) : [];
	    return $n( n, function ( n, u, o ) {
		e[ ++r ] = t( n, u, o )
	    } ), e
	}
	
	function x( n ) {
	    var t = en( n );
	    return function ( r ) {
		var e = t.length;
		if ( null == r ) return !e;
		for ( r = Object( r ); e--; ) {
		    var u = t[ e ];
		    if ( !( u in r && j( n[ u ], r[ u ], an, 3 ) ) ) return false
		}
		return true
	    }
	}
	
	function E( n, t ) {
	    return n = Object( n ), P( t, function ( t, r ) {
		return r in n && ( t[ r ] = n[ r ] ), t
	    }, {} )
	}
	
	function A( n ) {
	    return function ( t ) {
		return null == t ? an : t[ n ]
	    }
	}
	
	function k( n, t, r ) {
	    var e = -1, u = n.length;
	    for ( 0 > t && ( t = -t > u ? 0 : u + t ), r = r > u ? u : r, 0 > r && ( r += u ), u = t > r ? 0 : r - t >>> 0, t >>>= 0, r = Array( u ); ++e < u; ) r[ e ] = n[ e + t ];
	    return r
	}
	
	function N( n ) {
	    return k( n, 0, n.length )
	}
	
	function S( n, t ) {
	    var r;
	    return $n( n, function ( n, e, u ) {
		return r = t( n, e, u ),
		    !r
	    } ), !!r
	}
	
	function T( t, r ) {
	    return P( r, function ( t, r ) {
		return r.func.apply( r.thisArg, n( [ t ], r.args ) )
	    }, t )
	}
	
	function F( n, t, r, e ) {
	    r || ( r = {} );
	    for ( var u = -1, o = t.length; ++u < o; ) {
		var i = t[ u ], c = e ? e( r[ i ], n[ i ], i, r, n ) : n[ i ], f = r, a = f[ i ];
		En.call( f, i ) && ( a === c || a !== a && c !== c ) && ( c !== an || i in f ) || ( f[ i ] = c )
	    }
	    return r
	}
	
	function R( n ) {
	    return V( function ( t, r ) {
		var e = -1, u = r.length, o = u > 1 ? r[ u - 1 ] : an, o = typeof o == "function" ? ( u--, o ) : an;
		for ( t = Object( t ); ++e < u; ) {
		    var i = r[ e ];
		    i && n( t, i, e, o )
		}
		return t
	    } )
	}
	
	function B( n ) {
	    return function () {
		var t = arguments, r = s( n.prototype ), t = n.apply( r, t );
		return X( t ) ? t : r
	    }
	}
	
	function D( n, t, r ) {
	    function e() {
		for ( var o = -1, i = arguments.length, c = -1, f = r.length, a = Array( f + i ), l = this && this !== wn && this instanceof e ? u : n; ++c < f; ) a[ c ] = r[ c ];
		for ( ; i--; ) a[ c++ ] = arguments[ ++o ];
		return l.apply( t, a )
	    }
	    
	    if ( typeof n != "function" ) throw new TypeError( "Expected a function" );
	    var u = B( n );
	    return e
	}
	
	function I( n, t, r, e, u, o ) {
	    var i = -1, c = 1 & u, f = n.length, a = t.length;
	    if ( f != a && !( 2 & u && a > f ) ) return false;
	    for ( a = true; ++i < f; ) {
		var l = n[ i ], p = t[ i ];
		if ( void 0 !== an ) {
		    a = false;
		    break
		}
		if ( c ) {
		    if ( !S( t, function ( n ) {
			return l === n || r( l, n, e, u, o );
		    } ) ) {
			a = false;
			break
		    }
		} else if ( l !== p && !r( l, p, e, u, o ) ) {
		    a = false;
		    break
		}
	    }
	    return a
	}
	
	function $( n, t, r ) {
	    switch ( r ) {
		case"[object Boolean]":
		case"[object Date]":
		    return +n == +t;
		case"[object Error]":
		    return n.name == t.name && n.message == t.message;
		case"[object Number]":
		    return n != +n ? t != +t : n == +t;
		case"[object RegExp]":
		case"[object String]":
		    return n == t + ""
	    }
	    return false
	}
	
	function q( n, t, r, e, u, o ) {
	    var i = 2 & u, c = en( n ), f = c.length, a = en( t ).length;
	    if ( f != a && !i ) return false;
	    for ( var l = f; l--; ) {
		var p = c[ l ];
		if ( !( i ? p in t : En.call( t, p ) ) ) return false
	    }
	    for ( a = true; ++l < f; ) {
		var p = c[ l ], s = n[ p ], h = t[ p ];
		if ( void 0 !== an || s !== h && !r( s, h, e, u, o ) ) {
		    a = false;
		    break
		}
		i || ( i = "constructor" == p )
	    }
	    return a && !i && ( r = n.constructor, e = t.constructor, r != e && "constructor" in n && "constructor" in t && !( typeof r == "function" && r instanceof r && typeof e == "function" && e instanceof e ) && ( a = false ) ), a
	}
	
	function z( n ) {
	    var t = n ? n.length : an;
	    if ( W( t ) && ( Pn( n ) || nn( n ) || K( n ) ) ) {
		n = String;
		for ( var r = -1, e = Array( t ); ++r < t; ) e[ r ] = n( r );
		t = e
	    } else t = null;
	    return t
	}
	
	function C( n ) {
	    var t = n && n.constructor, t = Q( t ) && t.prototype || xn;
	    return n === t
	}
	
	function G( n ) {
	    return n ? n[ 0 ] : an
	}
	
	function J( n, t ) {
	    return r( n, d( t ), $n )
	}
	
	function M( n, t ) {
	    return $n( n, typeof t == "function" ? t : cn )
	}
	
	function P( n, t, r ) {
	    return e( n, d( t ), r, 3 > arguments.length, $n )
	}
	
	function U( n, t ) {
	    var r;
	    if ( typeof t != "function" ) throw new TypeError( "Expected a function" );
	    return n = Un( n ), function () {
		return 0 < --n && ( r = t.apply( this, arguments ) ), 1 >= n && ( t = an ), r
	    }
	}
	
	function V( n ) {
	    var t;
	    if ( typeof n != "function" ) throw new TypeError( "Expected a function" );
	    return t = In( t === an ? n.length - 1 : Un( t ), 0 ), function () {
		for ( var r = arguments, e = -1, u = In( r.length - t, 0 ), o = Array( u ); ++e < u; ) o[ e ] = r[ t + e ];
		for ( u = Array( t + 1 ), e = -1; ++e < t; ) u[ e ] = r[ e ];
		return u[ t ] = o, n.apply( this, u )
	    }
	}
	
	function H( n, t ) {
	    return n > t
	}
	
	function K( n ) {
	    return Y( n ) && L( n ) && En.call( n, "callee" ) && ( !Rn.call( n, "callee" ) || "[object Arguments]" == kn.call( n ) )
	}
	
	function L( n ) {
	    return null != n && !( typeof n == "function" && Q( n ) ) && W( zn( n ) )
	}
	
	function Q( n ) {
	    return n = X( n ) ? kn.call( n ) : "", "[object Function]" == n || "[object GeneratorFunction]" == n
	}
	
	function W( n ) {
	    return typeof n == "number" && n > -1 && 0 == n % 1 && 9007199254740991 >= n
	}
	
	function X( n ) {
	    var t = typeof n;
	    return !!n && ( "object" == t || "function" == t );
	}
	
	function Y( n ) {
	    return !!n && typeof n == "object"
	}
	
	function Z( n ) {
	    return typeof n == "number" || Y( n ) && "[object Number]" == kn.call( n )
	}
	
	function nn( n ) {
	    return typeof n == "string" || !Pn( n ) && Y( n ) && "[object String]" == kn.call( n )
	}
	
	function tn( n, t ) {
	    return t > n
	}
	
	function rn( n ) {
	    return typeof n == "string" ? n : null == n ? "" : n + ""
	}
	
	function en( n ) {
	    var t = C( n );
	    if ( !t && !L( n ) ) return Dn( Object( n ) );
	    var r, e = z( n ), u = !!e, e = e || [], o = e.length;
	    for ( r in n ) !En.call( n, r ) || u && ( "length" == r || f( r, o ) ) || t && "constructor" == r || e.push( r );
	    return e
	}
	
	function un( n ) {
	    for ( var t = -1, r = C( n ), e = w( n ), u = e.length, o = z( n ), i = !!o, o = o || [], c = o.length; ++t < u; ) {
		var a = e[ t ];
		i && ( "length" == a || f( a, c ) ) || "constructor" == a && ( r || !En.call( n, a ) ) || o.push( a )
	    }
	    return o
	}
	
	function on( n ) {
	    return n ? u( n, en( n ) ) : []
	}
	
	function cn( n ) {
	    return n
	}
	
	function fn( t, r, e ) {
	    var u = en( r ), o = b( r, u );
	    null != e || X( r ) && ( o.length || !u.length ) || ( e = r, r = t, t = this, o = b( r, en( r ) ) );
	    var i = X( e ) && "chain" in e ? e.chain : true, c = Q( t );
	    return $n( o, function ( e ) {
		var u = r[ e ];
		t[ e ] = u, c && ( t.prototype[ e ] = function () {
		    var r = this.__chain__;
		    if ( i || r ) {
			var e = t( this.__wrapped__ );
			return ( e.__actions__ = N( this.__actions__ ) ).push( {
			    func   : u, args: arguments,
			    thisArg: t
			} ), e.__chain__ = r, e
		    }
		    return u.apply( t, n( [ this.value() ], arguments ) )
		} )
	    } ), t
	}
	
	var an, ln = 1 / 0, pn = /[&<>"'`]/g, sn = RegExp( pn.source ), hn = /^(?:0|[1-9]\d*)$/,
	    vn = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" },
	    yn = { "function": true, object: true },
	    _n = yn[ typeof exports ] && exports && !exports.nodeType ? exports : an,
	    gn = yn[ typeof module ] && module && !module.nodeType ? module : an,
	    bn = gn && gn.exports === _n ? _n : an, jn = o( yn[ typeof self ] && self ),
	    mn = o( yn[ typeof window ] && window ), dn = o( yn[ typeof this ] && this ),
	    wn = o( _n && gn && typeof global == "object" && global ) || mn !== ( dn && dn.window ) && mn || jn || dn || Function( "return this" )(),
	    On = Array.prototype, xn = Object.prototype, En = xn.hasOwnProperty, An = 0, kn = xn.toString,
	    Nn = wn._, Sn = wn.Reflect, Tn = Sn ? Sn.f : an, Fn = Object.create, Rn = xn.propertyIsEnumerable,
	    Bn = wn.isFinite, Dn = Object.keys, In = Math.max, $n = function ( n, t ) {
		return function ( r, e ) {
		    if ( null == r ) return r;
		    if ( !L( r ) ) return n( r, e );
		    for ( var u = r.length, o = t ? u : -1, i = Object( r ); ( t ? o-- : ++o < u ) && false !== e( i[ o ], o, i ); ) ;
		    return r
		}
	    }( g ), qn                                                                      = function ( n ) {
		return function ( t, r, e ) {
		    var u = -1, o = Object( t );
		    e = e( t );
		    for ( var i = e.length; i--; ) {
			var c = e[ n ? i : ++u ];
			if ( false === r( o[ c ], c, o ) ) break
		    }
		    return t
		}
	    }();
	Tn && !Rn.call( { valueOf: 1 }, "valueOf" ) && ( w = function ( n ) {
	    n = Tn( n );
	    for ( var t, r = []; !( t = n.next() ).done; ) r.push( t.value );
	    return r
	} );
	var zn  = A( "length" ), Cn = V( function ( t, r ) {
	    return Pn( t ) || ( t = null == t ? [] : [ Object( t ) ] ), _( r, 1 ),
		n( N( t ), on )
	} ), Gn = V( function ( n, t, r ) {
	    return D( n, t, r )
	} ), Jn = V( function ( n, t ) {
	    return h( n, 1, t )
	} ), Mn = V( function ( n, t, r ) {
	    return h( n, Vn( t ) || 0, r )
	} ), Pn = Array.isArray, Un = Number, Vn = Number, Hn = R( function ( n, t ) {
	    F( t, en( t ), n )
	} ), Kn = R( function ( n, t ) {
	    F( t, un( t ), n )
	} ), Ln = R( function ( n, t, r, e ) {
	    F( t, un( t ), n, e )
	} ), Qn = V( function ( n ) {
	    return n.push( an, p ), Ln.apply( an, n )
	} ), Wn = V( function ( n, t ) {
	    return null == n ? {} : E( n, _( t, 1 ) )
	} ), Xn = d;
	l.prototype = s( a.prototype ), l.prototype.constructor = l, a.assignIn = Kn, a.before = U, a.bind = Gn, a.chain = function ( n ) {
	    return n = a( n ),
		n.__chain__ = true, n
	}, a.compact = function ( n ) {
	    return y( n, Boolean )
	}, a.concat = Cn, a.create = function ( n, t ) {
	    var r = s( n );
	    return t ? Hn( r, t ) : r
	}, a.defaults = Qn, a.defer = Jn, a.delay = Mn, a.filter = function ( n, t ) {
	    return y( n, d( t ) )
	}, a.flatten = function ( n ) {
	    return n && n.length ? _( n, 1 ) : []
	}, a.flattenDeep = function ( n ) {
	    return n && n.length ? _( n, ln ) : []
	}, a.iteratee = Xn, a.keys = en, a.map = function ( n, t ) {
	    return O( n, d( t ) )
	}, a.matches = function ( n ) {
	    return x( Hn( {}, n ) )
	}, a.mixin = fn, a.negate = function ( n ) {
	    if ( typeof n != "function" ) throw new TypeError( "Expected a function" );
	    return function () {
		return !n.apply( this, arguments )
	    }
	}, a.once = function ( n ) {
	    return U( 2, n )
	}, a.pick = Wn, a.slice = function ( n, t, r ) {
	    var e = n ? n.length : 0;
	    return r = r === an ? e : +r, e ? k( n, null == t ? 0 : +t, r ) : []
	}, a.sortBy = function ( n, t ) {
	    var r = 0;
	    return t = d( t ), O( O( n, function ( n, e, u ) {
		return { c: n, b: r++, a: t( n, e, u ) }
	    } ).sort( function ( n, t ) {
		var r;
		n:{
		    r     = n.a;
		    var e = t.a;
		    if ( r !== e ) {
			var u = null === r, o = r === an, i = r === r, c = null === e, f = e === an, a = e === e;
			if ( r > e && !c || !i || u && !f && a || o && a ) {
			    r = 1;
			    break n
			}
			if ( e > r && !u || !a || c && !o && i || f && i ) {
			    r = -1;
			    break n
			}
		    }
		    r = 0
		}
		return r || n.b - t.b;
	    } ), A( "c" ) )
	}, a.tap = function ( n, t ) {
	    return t( n ), n
	}, a.thru = function ( n, t ) {
	    return t( n )
	}, a.toArray = function ( n ) {
	    return L( n ) ? n.length ? N( n ) : [] : on( n )
	}, a.values = on, a.extend = Kn, fn( a, a ), a.clone = function ( n ) {
	    return X( n ) ? Pn( n ) ? N( n ) : F( n, en( n ) ) : n
	}, a.escape = function ( n ) {
	    return ( n = rn( n ) ) && sn.test( n ) ? n.replace( pn, i ) : n
	}, a.every = function ( n, t, r ) {
	    return t = r ? an : t, v( n, d( t ) )
	}, a.find = J, a.forEach = M, a.has = function ( n, t ) {
	    return null != n && En.call( n, t )
	}, a.head = G, a.identity = cn, a.indexOf = function ( n, t, r ) {
	    var e = n ? n.length : 0;
	    r = typeof r == "number" ? 0 > r ? In( e + r, 0 ) : r : 0,
		r = ( r || 0 ) - 1;
	    for ( var u = t === t; ++r < e; ) {
		var o = n[ r ];
		if ( u ? o === t : o !== o ) return r
	    }
	    return -1
	}, a.isArguments = K, a.isArray = Pn, a.isBoolean = function ( n ) {
	    return true === n || false === n || Y( n ) && "[object Boolean]" == kn.call( n )
	}, a.isDate = function ( n ) {
	    return Y( n ) && "[object Date]" == kn.call( n )
	}, a.isEmpty = function ( n ) {
	    if ( L( n ) && ( Pn( n ) || nn( n ) || Q( n.splice ) || K( n ) ) ) return !n.length;
	    for ( var t in n ) if ( En.call( n, t ) ) return false;
	    return true
	}, a.isEqual = function ( n, t ) {
	    return j( n, t )
	}, a.isFinite = function ( n ) {
	    return typeof n == "number" && Bn( n )
	}, a.isFunction = Q, a.isNaN = function ( n ) {
	    return Z( n ) && n != +n
	}, a.isNull = function ( n ) {
	    return null === n
	}, a.isNumber = Z, a.isObject = X, a.isRegExp = function ( n ) {
	    return X( n ) && "[object RegExp]" == kn.call( n )
	}, a.isString = nn, a.isUndefined = function ( n ) {
	    return n === an
	}, a.last = function ( n ) {
	    var t = n ? n.length : 0;
	    return t ? n[ t - 1 ] : an
	}, a.max = function ( n ) {
	    return n && n.length ? t( n, cn, H ) : an
	}, a.min = function ( n ) {
	    return n && n.length ? t( n, cn, tn ) : an
	}, a.noConflict = function () {
	    return wn._ === this && ( wn._ = Nn ), this
	}, a.noop = function () {
	}, a.reduce = P, a.result = function ( n, t, r ) {
	    return t = null == n ? an : n[ t ],
	    t === an && ( t = r ), Q( t ) ? t.call( n ) : t
	}, a.size = function ( n ) {
	    return null == n ? 0 : ( n = L( n ) ? n : en( n ), n.length )
	}, a.some = function ( n, t, r ) {
	    return t = r ? an : t, S( n, d( t ) )
	}, a.uniqueId = function ( n ) {
	    var t = ++An;
	    return rn( n ) + t
	}, a.each = M, a.first = G, fn( a, function () {
	    var n = {};
	    return g( a, function ( t, r ) {
		En.call( a.prototype, r ) || ( n[ r ] = t )
	    } ), n
	}(), { chain: false } ), a.VERSION = "4.5.1", $n( "pop join replace reverse split push shift sort splice unshift".split( " " ), function ( n ) {
	    var t            = ( /^(?:replace|split)$/.test( n ) ? String.prototype : On )[ n ],
		r            = /^(?:push|sort|unshift)$/.test( n ) ? "tap" : "thru",
		e            = /^(?:pop|join|replace|shift)$/.test( n );
	    a.prototype[ n ] = function () {
		var n = arguments;
		return e && !this.__chain__ ? t.apply( this.value(), n ) : this[ r ]( function ( r ) {
		    return t.apply( r, n )
		} )
	    }
	} ), a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = function () {
	    return T( this.__wrapped__, this.__actions__ )
	}, ( mn || jn || {} )._ = a, typeof define == "function" && typeof define.amd == "object" && define.amd ? define( function () {
	    return a
	} ) : _n && gn ? ( bn && ( ( gn.exports = a )._ = a ), _n._ = a ) : wn._ = a
    } ).call( this );
} )();

( function vendorFlickity() {
    /*!
   * Flickity PACKAGED v2.2.1
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2019 Metafizzy
   */
    
    !function ( e, i ) {
	"function" == typeof define && define.amd ? define( "jquery-bridget/jquery-bridget", [ "jquery" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "jquery" ) ) : e.jQueryBridget = i( e, e.jQuery )
    }( window, function ( t, e ) {
	"use strict";
	var i = Array.prototype.slice, n = t.console, d = void 0 === n ? function () {
	} : function ( t ) {
	    n.error( t )
	};
	
	function s( h, s, c ) {
	    ( c = c || e || t.jQuery ) && ( s.prototype.option || ( s.prototype.option = function ( t ) {
		c.isPlainObject( t ) && ( this.options = c.extend( !0, this.options, t ) )
	    } ), c.fn[ h ] = function ( t ) {
		return "string" == typeof t ? function ( t, o, r ) {
		    var a, l = "$()." + h + '("' + o + '")';
		    return t.each( function ( t, e ) {
			var i = c.data( e, h );
			if ( i ) {
			    var n = i[ o ];
			    if ( n && "_" != o.charAt( 0 ) ) {
				var s = n.apply( i, r );
				a     = void 0 === a ? s : a
			    } else d( l + " is not a valid method" )
			} else d( h + " not initialized. Cannot call methods, i.e. " + l )
		    } ), void 0 !== a ? a : t
		}( this, t, i.call( arguments, 1 ) ) : ( function ( t, n ) {
		    t.each( function ( t, e ) {
			var i = c.data( e, h );
			i ? ( i.option( n ), i._init() ) : ( i = new s( e, n ), c.data( e, h, i ) )
		    } )
		}( this, t ), this )
	    }, o( c ) )
	}
	
	function o( t ) {
	    !t || t && t.bridget || ( t.bridget = s )
	}
	
	return o( e || t.jQuery ), s
    } ), function ( t, e ) {
	"function" == typeof define && define.amd ? define( "ev-emitter/ev-emitter", e ) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
    }( "undefined" != typeof window ? window : this, function () {
	function t() {
	}
	
	var e = t.prototype;
	return e.on = function ( t, e ) {
	    if ( t && e ) {
		var i = this._events = this._events || {}, n = i[ t ] = i[ t ] || [];
		return -1 == n.indexOf( e ) && n.push( e ), this
	    }
	}, e.once = function ( t, e ) {
	    if ( t && e ) {
		this.on( t, e );
		var i = this._onceEvents = this._onceEvents || {};
		return ( i[ t ] = i[ t ] || {} )[ e ] = !0, this
	    }
	}, e.off = function ( t, e ) {
	    var i = this._events && this._events[ t ];
	    if ( i && i.length ) {
		var n = i.indexOf( e );
		return -1 != n && i.splice( n, 1 ), this
	    }
	}, e.emitEvent = function ( t, e ) {
	    var i = this._events && this._events[ t ];
	    if ( i && i.length ) {
		i = i.slice( 0 ), e = e || [];
		for ( var n = this._onceEvents && this._onceEvents[ t ], s = 0; s < i.length; s++ ) {
		    var o = i[ s ];
		    n && n[ o ] && ( this.off( t, o ), delete n[ o ] ), o.apply( this, e )
		}
		return this
	    }
	}, e.allOff = function () {
	    delete this._events, delete this._onceEvents
	}, t
    } ), function ( t, e ) {
	"function" == typeof define && define.amd ? define( "get-size/get-size", e ) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
    }( window, function () {
	"use strict";
	
	function m( t ) {
	    var e = parseFloat( t );
	    return -1 == t.indexOf( "%" ) && !isNaN( e ) && e
	}
	
	var i = "undefined" == typeof console ? function () {
	    } : function ( t ) {
		console.error( t )
	    },
	    y = [ "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth" ],
	    b = y.length;
	
	function E( t ) {
	    var e = getComputedStyle( t );
	    return e || i( "Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1" ), e
	}
	
	var S, C = !1;
	
	function x( t ) {
	    if ( function () {
		if ( !C ) {
		    C     = !0;
		    var t = document.createElement( "div" );
		    t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style.boxSizing = "border-box";
		    var e = document.body || document.documentElement;
		    e.appendChild( t );
		    var i = E( t );
		    S = 200 == Math.round( m( i.width ) ), x.isBoxSizeOuter = S, e.removeChild( t )
		}
	    }(), "string" == typeof t && ( t = document.querySelector( t ) ), t && "object" == typeof t && t.nodeType ) {
		var e = E( t );
		if ( "none" == e.display ) return function () {
		    for ( var t = {
			width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0
		    }, e        = 0; e < b; e++ ) {
			t[ y[ e ] ] = 0
		    }
		    return t
		}();
		var i = {};
		i.width = t.offsetWidth, i.height = t.offsetHeight;
		for ( var n = i.isBorderBox = "border-box" == e.boxSizing, s = 0; s < b; s++ ) {
		    var o  = y[ s ], r = e[ o ], a = parseFloat( r );
		    i[ o ] = isNaN( a ) ? 0 : a
		}
		var l = i.paddingLeft + i.paddingRight, h = i.paddingTop + i.paddingBottom,
		    c = i.marginLeft + i.marginRight, d = i.marginTop + i.marginBottom,
		    u = i.borderLeftWidth + i.borderRightWidth, f = i.borderTopWidth + i.borderBottomWidth, p = n && S,
		    g = m( e.width );
		!1 !== g && ( i.width = g + ( p ? 0 : l + u ) );
		var v = m( e.height );
		return !1 !== v && ( i.height = v + ( p ? 0 : h + f ) ), i.innerWidth = i.width - ( l + u ), i.innerHeight = i.height - ( h + f ), i.outerWidth = i.width + c, i.outerHeight = i.height + d, i
	    }
	}
	
	return x
    } ), function ( t, e ) {
	"use strict";
	"function" == typeof define && define.amd ? define( "desandro-matches-selector/matches-selector", e ) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
    }( window, function () {
	"use strict";
	var i = function () {
	    var t = window.Element.prototype;
	    if ( t.matches ) return "matches";
	    if ( t.matchesSelector ) return "matchesSelector";
	    for ( var e = [ "webkit", "moz", "ms", "o" ], i = 0; i < e.length; i++ ) {
		var n = e[ i ] + "MatchesSelector";
		if ( t[ n ] ) return n
	    }
	}();
	return function ( t, e ) {
	    return t[ i ]( e )
	}
    } ), function ( e, i ) {
	"function" == typeof define && define.amd ? define( "fizzy-ui-utils/utils", [ "desandro-matches-selector/matches-selector" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "desandro-matches-selector" ) ) : e.fizzyUIUtils = i( e, e.matchesSelector )
    }( window, function ( h, o ) {
	var c = {
	    extend   : function ( t, e ) {
		for ( var i in e ) t[ i ] = e[ i ];
		return t
	    }, modulo: function ( t, e ) {
		return ( t % e + e ) % e
	    }
	}, e  = Array.prototype.slice;
	c.makeArray = function ( t ) {
	    return Array.isArray( t ) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call( t ) : [ t ]
	}, c.removeFrom = function ( t, e ) {
	    var i = t.indexOf( e );
	    -1 != i && t.splice( i, 1 )
	}, c.getParent = function ( t, e ) {
	    for ( ; t.parentNode && t != document.body; ) if ( t = t.parentNode, o( t, e ) ) return t
	}, c.getQueryElement = function ( t ) {
	    return "string" == typeof t ? document.querySelector( t ) : t
	}, c.handleEvent = function ( t ) {
	    var e = "on" + t.type;
	    this[ e ] && this[ e ]( t )
	}, c.filterFindElements = function ( t, n ) {
	    t     = c.makeArray( t );
	    var s = [];
	    return t.forEach( function ( t ) {
		if ( t instanceof HTMLElement ) if ( n ) {
		    o( t, n ) && s.push( t );
		    for ( var e = t.querySelectorAll( n ), i = 0; i < e.length; i++ ) s.push( e[ i ] )
		} else s.push( t )
	    } ), s
	}, c.debounceMethod = function ( t, e, n ) {
	    n                = n || 100;
	    var s            = t.prototype[ e ], o = e + "Timeout";
	    t.prototype[ e ] = function () {
		var t = this[ o ];
		clearTimeout( t );
		var e     = arguments, i = this;
		this[ o ] = setTimeout( function () {
		    s.apply( i, e ), delete i[ o ]
		}, n )
	    }
	}, c.docReady = function ( t ) {
	    var e = document.readyState;
	    "complete" == e || "interactive" == e ? setTimeout( t ) : document.addEventListener( "DOMContentLoaded", t )
	}, c.toDashed = function ( t ) {
	    return t.replace( /(.)([A-Z])/g, function ( t, e, i ) {
		return e + "-" + i
	    } ).toLowerCase()
	};
	var d = h.console;
	return c.htmlInit = function ( a, l ) {
	    c.docReady( function () {
		var t = c.toDashed( l ), s = "data-" + t, e = document.querySelectorAll( "[" + s + "]" ),
		    i = document.querySelectorAll( ".js-" + t ), n = c.makeArray( e ).concat( c.makeArray( i ) ),
		    o = s + "-options", r = h.jQuery;
		n.forEach( function ( e ) {
		    var t, i = e.getAttribute( s ) || e.getAttribute( o );
		    try {
			t = i && JSON.parse( i )
		    } catch ( t ) {
			return void ( d && d.error( "Error parsing " + s + " on " + e.className + ": " + t ) )
		    }
		    var n = new a( e, t );
		    r && r.data( e, l, n )
		} )
	    } )
	}, c
    } ), function ( e, i ) {
	"function" == typeof define && define.amd ? define( "flickity/js/cell", [ "get-size/get-size" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "get-size" ) ) : ( e.Flickity = e.Flickity || {}, e.Flickity.Cell = i( e, e.getSize ) )
    }( window, function ( t, e ) {
	function i( t, e ) {
	    this.element = t, this.parent = e, this.create()
	}
	
	var n = i.prototype;
	return n.create = function () {
	    this.element.style.position = "absolute", this.element.setAttribute( "aria-hidden", "true" ), this.x = 0, this.shift = 0
	}, n.destroy = function () {
	    this.unselect(), this.element.style.position = "";
	    var t                   = this.parent.originSide;
	    this.element.style[ t ] = ""
	}, n.getSize = function () {
	    this.size = e( this.element )
	}, n.setPosition = function ( t ) {
	    this.x = t, this.updateTarget(), this.renderPosition( t )
	}, n.updateTarget = n.setDefaultTarget = function () {
	    var t       = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
	    this.target = this.x + this.size[ t ] + this.size.width * this.parent.cellAlign
	}, n.renderPosition = function ( t ) {
	    var e                   = this.parent.originSide;
	    this.element.style[ e ] = this.parent.getPositionValue( t )
	}, n.select = function () {
	    this.element.classList.add( "is-selected" ), this.element.removeAttribute( "aria-hidden" )
	}, n.unselect = function () {
	    this.element.classList.remove( "is-selected" ), this.element.setAttribute( "aria-hidden", "true" )
	}, n.wrapShift = function ( t ) {
	    this.shift = t, this.renderPosition( this.x + this.parent.slideableWidth * t )
	}, n.remove = function () {
	    this.element.parentNode.removeChild( this.element )
	}, i
    } ), function ( t, e ) {
	"function" == typeof define && define.amd ? define( "flickity/js/slide", e ) : "object" == typeof module && module.exports ? module.exports = e() : ( t.Flickity = t.Flickity || {}, t.Flickity.Slide = e() )
    }( window, function () {
	"use strict";
	
	function t( t ) {
	    this.parent = t, this.isOriginLeft = "left" == t.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
	}
	
	var e = t.prototype;
	return e.addCell = function ( t ) {
	    if ( this.cells.push( t ), this.outerWidth += t.size.outerWidth, this.height = Math.max( t.size.outerHeight, this.height ), 1 == this.cells.length ) {
		this.x           = t.x;
		var e            = this.isOriginLeft ? "marginLeft" : "marginRight";
		this.firstMargin = t.size[ e ]
	    }
	}, e.updateTarget = function () {
	    var t = this.isOriginLeft ? "marginRight" : "marginLeft", e = this.getLastCell(),
		i = e ? e.size[ t ] : 0, n = this.outerWidth - ( this.firstMargin + i );
	    this.target = this.x + this.firstMargin + n * this.parent.cellAlign
	}, e.getLastCell = function () {
	    return this.cells[ this.cells.length - 1 ]
	}, e.select = function () {
	    this.cells.forEach( function ( t ) {
		t.select()
	    } )
	}, e.unselect = function () {
	    this.cells.forEach( function ( t ) {
		t.unselect()
	    } )
	}, e.getCellElements = function () {
	    return this.cells.map( function ( t ) {
		return t.element
	    } )
	}, t
    } ), function ( e, i ) {
	"function" == typeof define && define.amd ? define( "flickity/js/animate", [ "fizzy-ui-utils/utils" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "fizzy-ui-utils" ) ) : ( e.Flickity = e.Flickity || {}, e.Flickity.animatePrototype = i( e, e.fizzyUIUtils ) )
    }( window, function ( t, e ) {
	var i = {
	    startAnimation             : function () {
		this.isAnimating || ( this.isAnimating = !0, this.restingFrames = 0, this.animate() )
	    }, animate                 : function () {
		this.applyDragForce(), this.applySelectedAttraction();
		var t = this.x;
		if ( this.integratePhysics(), this.positionSlider(), this.settle( t ), this.isAnimating ) {
		    var e = this;
		    requestAnimationFrame( function () {
			e.animate()
		    } )
		}
	    }, positionSlider          : function () {
		var t = this.x;
		this.options.wrapAround && 1 < this.cells.length && ( t = e.modulo( t, this.slideableWidth ), t -= this.slideableWidth, this.shiftWrapCells( t ) ), this.setTranslateX( t, this.isAnimating ), this.dispatchScrollEvent()
	    }, setTranslateX           : function ( t, e ) {
		t += this.cursorPosition, t = this.options.rightToLeft ? -t : t;
		var i                       = this.getPositionValue( t );
		this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")"
	    }, dispatchScrollEvent     : function () {
		var t = this.slides[ 0 ];
		if ( t ) {
		    var e = -this.x - t.target, i = e / this.slidesWidth;
		    this.dispatchEvent( "scroll", null, [ i, e ] )
		}
	    }, positionSliderAtSelected: function () {
		this.cells.length && ( this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider() )
	    }, getPositionValue        : function ( t ) {
		return this.options.percentPosition ? .01 * Math.round( t / this.size.innerWidth * 1e4 ) + "%" : Math.round( t ) + "px"
	    }, settle                  : function ( t ) {
		this.isPointerDown || Math.round( 100 * this.x ) != Math.round( 100 * t ) || this.restingFrames++, 2 < this.restingFrames && ( this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent( "settle", null, [ this.selectedIndex ] ) )
	    }, shiftWrapCells          : function ( t ) {
		var e = this.cursorPosition + t;
		this._shiftCells( this.beforeShiftCells, e, -1 );
		var i = this.size.innerWidth - ( t + this.slideableWidth + this.cursorPosition );
		this._shiftCells( this.afterShiftCells, i, 1 )
	    }, _shiftCells             : function ( t, e, i ) {
		for ( var n = 0; n < t.length; n++ ) {
		    var s = t[ n ], o = 0 < e ? i : 0;
		    s.wrapShift( o ), e -= s.size.outerWidth
		}
	    }, _unshiftCells           : function ( t ) {
		if ( t && t.length ) for ( var e = 0; e < t.length; e++ ) t[ e ].wrapShift( 0 )
	    }, integratePhysics        : function () {
		this.x += this.velocity, this.velocity *= this.getFrictionFactor()
	    }, applyForce              : function ( t ) {
		this.velocity += t
	    }, getFrictionFactor       : function () {
		return 1 - this.options[ this.isFreeScrolling ? "freeScrollFriction" : "friction" ]
	    }, getRestingPosition      : function () {
		return this.x + this.velocity / ( 1 - this.getFrictionFactor() )
	    }, applyDragForce          : function () {
		if ( this.isDraggable && this.isPointerDown ) {
		    var t = this.dragX - this.x - this.velocity;
		    this.applyForce( t )
		}
	    }, applySelectedAttraction : function () {
		if ( !( this.isDraggable && this.isPointerDown ) && !this.isFreeScrolling && this.slides.length ) {
		    var t = ( -1 * this.selectedSlide.target - this.x ) * this.options.selectedAttraction;
		    this.applyForce( t )
		}
	    }
	};
	return i
    } ), function ( r, a ) {
	if ( "function" == typeof define && define.amd ) define( "flickity/js/flickity", [ "ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate" ], function ( t, e, i, n, s, o ) {
	    return a( r, t, e, i, n, s, o )
	} ); else if ( "object" == typeof module && module.exports ) module.exports = a( r, require( "ev-emitter" ), require( "get-size" ), require( "fizzy-ui-utils" ), require( "./cell" ), require( "./slide" ), require( "./animate" ) ); else {
	    var t      = r.Flickity;
	    r.Flickity = a( r, r.EvEmitter, r.getSize, r.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype )
	}
    }( window, function ( n, t, e, a, i, r, s ) {
	var l = n.jQuery, o = n.getComputedStyle, h = n.console;
	
	function c( t, e ) {
	    for ( t = a.makeArray( t ); t.length; ) e.appendChild( t.shift() )
	}
	
	var d = 0, u = {};
	
	function f( t, e ) {
	    var i = a.getQueryElement( t );
	    if ( i ) {
		if ( this.element = i, this.element.flickityGUID ) {
		    var n = u[ this.element.flickityGUID ];
		    return n.option( e ), n
		}
		l && ( this.$element = l( this.element ) ), this.options = a.extend( {}, this.constructor.defaults ), this.option( e ), this._create()
	    } else h && h.error( "Bad element for Flickity: " + ( i || t ) )
	}
	
	f.defaults = {
	    accessibility        : !0, cellAlign: "center", freeScrollFriction: .075, friction: .28,
	    namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: .025, setGallerySize: !0
	}, f.createMethods = [];
	var p = f.prototype;
	a.extend( p, t.prototype ), p._create = function () {
	    var t = this.guid = ++d;
	    for ( var e in this.element.flickityGUID = t, ( u[ t ] = this ).selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement( "div" ), this.viewport.className = "flickity-viewport", this._createSlider(), ( this.options.resize || this.options.watchCSS ) && n.addEventListener( "resize", this ), this.options.on ) {
		var i = this.options.on[ e ];
		this.on( e, i )
	    }
	    f.createMethods.forEach( function ( t ) {
		this[ t ]()
	    }, this ), this.options.watchCSS ? this.watchCSS() : this.activate()
	}, p.option = function ( t ) {
	    a.extend( this.options, t )
	}, p.activate = function () {
	    this.isActive || ( this.isActive = !0, this.element.classList.add( "flickity-enabled" ), this.options.rightToLeft && this.element.classList.add( "flickity-rtl" ), this.getSize(), c( this._filterFindCellElements( this.element.children ), this.slider ), this.viewport.appendChild( this.slider ), this.element.appendChild( this.viewport ), this.reloadCells(), this.options.accessibility && ( this.element.tabIndex = 0, this.element.addEventListener( "keydown", this ) ), this.emitEvent( "activate" ), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent( "ready" ) )
	}, p._createSlider = function () {
	    var t = document.createElement( "div" );
	    t.className = "flickity-slider", t.style[ this.originSide ] = 0, this.slider = t
	}, p._filterFindCellElements = function ( t ) {
	    return a.filterFindElements( t, this.options.cellSelector )
	}, p.reloadCells = function () {
	    this.cells = this._makeCells( this.slider.children ), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
	}, p._makeCells = function ( t ) {
	    return this._filterFindCellElements( t ).map( function ( t ) {
		return new i( t, this )
	    }, this )
	}, p.getLastCell = function () {
	    return this.cells[ this.cells.length - 1 ]
	}, p.getLastSlide = function () {
	    return this.slides[ this.slides.length - 1 ]
	}, p.positionCells = function () {
	    this._sizeCells( this.cells ), this._positionCells( 0 )
	}, p._positionCells = function ( t ) {
	    t = t || 0, this.maxCellHeight = t && this.maxCellHeight || 0;
	    var e = 0;
	    if ( 0 < t ) {
		var i = this.cells[ t - 1 ];
		e     = i.x + i.size.outerWidth
	    }
	    for ( var n = this.cells.length, s = t; s < n; s++ ) {
		var o = this.cells[ s ];
		o.setPosition( e ), e += o.size.outerWidth, this.maxCellHeight = Math.max( o.size.outerHeight, this.maxCellHeight )
	    }
	    this.slideableWidth = e, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[ 0 ].target : 0
	}, p._sizeCells = function ( t ) {
	    t.forEach( function ( t ) {
		t.getSize()
	    } )
	}, p.updateSlides = function () {
	    if ( this.slides = [], this.cells.length ) {
		var n = new r( this );
		this.slides.push( n );
		var s = "left" == this.originSide ? "marginRight" : "marginLeft", o = this._getCanCellFit();
		this.cells.forEach( function ( t, e ) {
		    if ( n.cells.length ) {
			var i = n.outerWidth - n.firstMargin + ( t.size.outerWidth - t.size[ s ] );
			o.call( this, e, i ) || ( n.updateTarget(), n = new r( this ), this.slides.push( n ) ), n.addCell( t )
		    } else n.addCell( t )
		}, this ), n.updateTarget(), this.updateSelectedSlide()
	    }
	}, p._getCanCellFit = function () {
	    var t = this.options.groupCells;
	    if ( !t ) return function () {
		return !1
	    };
	    if ( "number" == typeof t ) {
		var e = parseInt( t, 10 );
		return function ( t ) {
		    return t % e != 0
		}
	    }
	    var i = "string" == typeof t && t.match( /^(\d+)%$/ ), n = i ? parseInt( i[ 1 ], 10 ) / 100 : 1;
	    return function ( t, e ) {
		return e <= ( this.size.innerWidth + 1 ) * n
	    }
	}, p._init = p.reposition = function () {
	    this.positionCells(), this.positionSliderAtSelected()
	}, p.getSize = function () {
	    this.size = e( this.element ), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
	};
	var g = { center: { left: .5, right: .5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
	return p.setCellAlign = function () {
	    var t          = g[ this.options.cellAlign ];
	    this.cellAlign = t ? t[ this.originSide ] : this.options.cellAlign
	}, p.setGallerySize = function () {
	    if ( this.options.setGallerySize ) {
		var t                      = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
		this.viewport.style.height = t + "px"
	    }
	}, p._getWrapShiftCells = function () {
	    if ( this.options.wrapAround ) {
		this._unshiftCells( this.beforeShiftCells ), this._unshiftCells( this.afterShiftCells );
		var t = this.cursorPosition, e = this.cells.length - 1;
		this.beforeShiftCells = this._getGapCells( t, e, -1 ), t = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells( t, 0, 1 )
	    }
	}, p._getGapCells = function ( t, e, i ) {
	    for ( var n = []; 0 < t; ) {
		var s = this.cells[ e ];
		if ( !s ) break;
		n.push( s ), e += i, t -= s.size.outerWidth
	    }
	    return n
	}, p._containSlides = function () {
	    if ( this.options.contain && !this.options.wrapAround && this.cells.length ) {
		var t = this.options.rightToLeft, e = t ? "marginRight" : "marginLeft",
		    i = t ? "marginLeft" : "marginRight", n = this.slideableWidth - this.getLastCell().size[ i ],
		    s = n < this.size.innerWidth, o = this.cursorPosition + this.cells[ 0 ].size[ e ],
		    r = n - this.size.innerWidth * ( 1 - this.cellAlign );
		this.slides.forEach( function ( t ) {
		    s ? t.target = n * this.cellAlign : ( t.target = Math.max( t.target, o ), t.target = Math.min( t.target, r ) )
		}, this )
	    }
	}, p.dispatchEvent = function ( t, e, i ) {
	    var n = e ? [ e ].concat( i ) : i;
	    if ( this.emitEvent( t, n ), l && this.$element ) {
		var s = t += this.options.namespaceJQueryEvents ? ".flickity" : "";
		if ( e ) {
		    var o = l.Event( e );
		    o.type = t, s = o
		}
		this.$element.trigger( s, i )
	    }
	}, p.select = function ( t, e, i ) {
	    if ( this.isActive && ( t = parseInt( t, 10 ), this._wrapSelect( t ), ( this.options.wrapAround || e ) && ( t = a.modulo( t, this.slides.length ) ), this.slides[ t ] ) ) {
		var n = this.selectedIndex;
		this.selectedIndex = t, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent( "select", null, [ t ] ), t != n && this.dispatchEvent( "change", null, [ t ] ), this.dispatchEvent( "cellSelect" )
	    }
	}, p._wrapSelect = function ( t ) {
	    var e = this.slides.length;
	    if ( !( this.options.wrapAround && 1 < e ) ) return t;
	    var i = a.modulo( t, e ), n = Math.abs( i - this.selectedIndex ),
		s = Math.abs( i + e - this.selectedIndex ), o = Math.abs( i - e - this.selectedIndex );
	    !this.isDragSelect && s < n ? t += e : !this.isDragSelect && o < n && ( t -= e ), t < 0 ? this.x -= this.slideableWidth : e <= t && ( this.x += this.slideableWidth )
	}, p.previous = function ( t, e ) {
	    this.select( this.selectedIndex - 1, t, e )
	}, p.next = function ( t, e ) {
	    this.select( this.selectedIndex + 1, t, e )
	}, p.updateSelectedSlide = function () {
	    var t = this.slides[ this.selectedIndex ];
	    t && ( this.unselectSelectedSlide(), ( this.selectedSlide = t ).select(), this.selectedCells = t.cells, this.selectedElements = t.getCellElements(), this.selectedCell = t.cells[ 0 ], this.selectedElement = this.selectedElements[ 0 ] )
	}, p.unselectSelectedSlide = function () {
	    this.selectedSlide && this.selectedSlide.unselect()
	}, p.selectInitialIndex = function () {
	    var t = this.options.initialIndex;
	    if ( this.isInitActivated ) this.select( this.selectedIndex, !1, !0 ); else {
		if ( t && "string" == typeof t ) if ( this.queryCell( t ) ) return void this.selectCell( t, !1, !0 );
		var e = 0;
		t && this.slides[ t ] && ( e = t ), this.select( e, !1, !0 )
	    }
	}, p.selectCell = function ( t, e, i ) {
	    var n = this.queryCell( t );
	    if ( n ) {
		var s = this.getCellSlideIndex( n );
		this.select( s, e, i )
	    }
	}, p.getCellSlideIndex = function ( t ) {
	    for ( var e = 0; e < this.slides.length; e++ ) {
		if ( -1 != this.slides[ e ].cells.indexOf( t ) ) return e
	    }
	}, p.getCell = function ( t ) {
	    for ( var e = 0; e < this.cells.length; e++ ) {
		var i = this.cells[ e ];
		if ( i.element == t ) return i
	    }
	}, p.getCells = function ( t ) {
	    t     = a.makeArray( t );
	    var i = [];
	    return t.forEach( function ( t ) {
		var e = this.getCell( t );
		e && i.push( e )
	    }, this ), i
	}, p.getCellElements = function () {
	    return this.cells.map( function ( t ) {
		return t.element
	    } )
	}, p.getParentCell = function ( t ) {
	    var e = this.getCell( t );
	    return e || ( t = a.getParent( t, ".flickity-slider > *" ), this.getCell( t ) )
	}, p.getAdjacentCellElements = function ( t, e ) {
	    if ( !t ) return this.selectedSlide.getCellElements();
	    e     = void 0 === e ? this.selectedIndex : e;
	    var i = this.slides.length;
	    if ( i <= 1 + 2 * t ) return this.getCellElements();
	    for ( var n = [], s = e - t; s <= e + t; s++ ) {
		var o = this.options.wrapAround ? a.modulo( s, i ) : s, r = this.slides[ o ];
		r && ( n = n.concat( r.getCellElements() ) )
	    }
	    return n
	}, p.queryCell = function ( t ) {
	    if ( "number" == typeof t ) return this.cells[ t ];
	    if ( "string" == typeof t ) {
		if ( t.match( /^[#\.]?[\d\/]/ ) ) return;
		t = this.element.querySelector( t )
	    }
	    return this.getCell( t )
	}, p.uiChange = function () {
	    this.emitEvent( "uiChange" )
	}, p.childUIPointerDown = function ( t ) {
	    "touchstart" != t.type && t.preventDefault(), this.focus()
	}, p.onresize = function () {
	    this.watchCSS(), this.resize()
	}, a.debounceMethod( f, "onresize", 150 ), p.resize = function () {
	    if ( this.isActive ) {
		this.getSize(), this.options.wrapAround && ( this.x = a.modulo( this.x, this.slideableWidth ) ), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent( "resize" );
		var t = this.selectedElements && this.selectedElements[ 0 ];
		this.selectCell( t, !1, !0 )
	    }
	}, p.watchCSS = function () {
	    this.options.watchCSS && ( -1 != o( this.element, ":after" ).content.indexOf( "flickity" ) ? this.activate() : this.deactivate() )
	}, p.onkeydown = function ( t ) {
	    var e = document.activeElement && document.activeElement != this.element;
	    if ( this.options.accessibility && !e ) {
		var i = f.keyboardHandlers[ t.keyCode ];
		i && i.call( this )
	    }
	}, f.keyboardHandlers = {
	    37   : function () {
		var t = this.options.rightToLeft ? "next" : "previous";
		this.uiChange(), this[ t ]()
	    }, 39: function () {
		var t = this.options.rightToLeft ? "previous" : "next";
		this.uiChange(), this[ t ]()
	    }
	}, p.focus = function () {
	    var t = n.pageYOffset;
	    this.element.focus( { preventScroll: !0 } ), n.pageYOffset != t && n.scrollTo( n.pageXOffset, t )
	}, p.deactivate = function () {
	    this.isActive && ( this.element.classList.remove( "flickity-enabled" ), this.element.classList.remove( "flickity-rtl" ), this.unselectSelectedSlide(), this.cells.forEach( function ( t ) {
		t.destroy()
	    } ), this.element.removeChild( this.viewport ), c( this.slider.children, this.element ), this.options.accessibility && ( this.element.removeAttribute( "tabIndex" ), this.element.removeEventListener( "keydown", this ) ), this.isActive = !1, this.emitEvent( "deactivate" ) )
	}, p.destroy = function () {
	    this.deactivate(), n.removeEventListener( "resize", this ), this.allOff(), this.emitEvent( "destroy" ), l && this.$element && l.removeData( this.element, "flickity" ), delete this.element.flickityGUID, delete u[ this.guid ]
	}, a.extend( p, s ), f.data = function ( t ) {
	    var e = ( t = a.getQueryElement( t ) ) && t.flickityGUID;
	    return e && u[ e ]
	}, a.htmlInit( f, "flickity" ), l && l.bridget && l.bridget( "flickity", f ), f.setJQuery = function ( t ) {
	    l = t
	}, f.Cell = i, f.Slide = r, f
    } ), function ( e, i ) {
	"function" == typeof define && define.amd ? define( "unipointer/unipointer", [ "ev-emitter/ev-emitter" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "ev-emitter" ) ) : e.Unipointer = i( e, e.EvEmitter )
    }( window, function ( s, t ) {
	function e() {
	}
	
	var i = e.prototype = Object.create( t.prototype );
	i.bindStartEvent = function ( t ) {
	    this._bindStartEvent( t, !0 )
	}, i.unbindStartEvent = function ( t ) {
	    this._bindStartEvent( t, !1 )
	}, i._bindStartEvent = function ( t, e ) {
	    var i = ( e = void 0 === e || e ) ? "addEventListener" : "removeEventListener", n = "mousedown";
	    s.PointerEvent ? n = "pointerdown" : "ontouchstart" in s && ( n = "touchstart" ), t[ i ]( n, this )
	}, i.handleEvent = function ( t ) {
	    var e = "on" + t.type;
	    this[ e ] && this[ e ]( t )
	}, i.getTouch = function ( t ) {
	    for ( var e = 0; e < t.length; e++ ) {
		var i = t[ e ];
		if ( i.identifier == this.pointerIdentifier ) return i
	    }
	}, i.onmousedown = function ( t ) {
	    var e = t.button;
	    e && 0 !== e && 1 !== e || this._pointerDown( t, t )
	}, i.ontouchstart = function ( t ) {
	    this._pointerDown( t, t.changedTouches[ 0 ] )
	}, i.onpointerdown = function ( t ) {
	    this._pointerDown( t, t )
	}, i._pointerDown = function ( t, e ) {
	    t.button || this.isPointerDown || ( this.isPointerDown = !0, this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier, this.pointerDown( t, e ) )
	}, i.pointerDown = function ( t, e ) {
	    this._bindPostStartEvents( t ), this.emitEvent( "pointerDown", [ t, e ] )
	};
	var n = {
	    mousedown  : [ "mousemove", "mouseup" ], touchstart: [ "touchmove", "touchend", "touchcancel" ],
	    pointerdown: [ "pointermove", "pointerup", "pointercancel" ]
	};
	return i._bindPostStartEvents = function ( t ) {
	    if ( t ) {
		var e = n[ t.type ];
		e.forEach( function ( t ) {
		    s.addEventListener( t, this )
		}, this ), this._boundPointerEvents = e
	    }
	}, i._unbindPostStartEvents = function () {
	    this._boundPointerEvents && ( this._boundPointerEvents.forEach( function ( t ) {
		s.removeEventListener( t, this )
	    }, this ), delete this._boundPointerEvents )
	}, i.onmousemove = function ( t ) {
	    this._pointerMove( t, t )
	}, i.onpointermove = function ( t ) {
	    t.pointerId == this.pointerIdentifier && this._pointerMove( t, t )
	}, i.ontouchmove = function ( t ) {
	    var e = this.getTouch( t.changedTouches );
	    e && this._pointerMove( t, e )
	}, i._pointerMove = function ( t, e ) {
	    this.pointerMove( t, e )
	}, i.pointerMove = function ( t, e ) {
	    this.emitEvent( "pointerMove", [ t, e ] )
	}, i.onmouseup = function ( t ) {
	    this._pointerUp( t, t )
	}, i.onpointerup = function ( t ) {
	    t.pointerId == this.pointerIdentifier && this._pointerUp( t, t )
	}, i.ontouchend = function ( t ) {
	    var e = this.getTouch( t.changedTouches );
	    e && this._pointerUp( t, e )
	}, i._pointerUp = function ( t, e ) {
	    this._pointerDone(), this.pointerUp( t, e )
	}, i.pointerUp = function ( t, e ) {
	    this.emitEvent( "pointerUp", [ t, e ] )
	}, i._pointerDone = function () {
	    this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
	}, i._pointerReset = function () {
	    this.isPointerDown = !1, delete this.pointerIdentifier
	}, i.pointerDone = function () {
	}, i.onpointercancel = function ( t ) {
	    t.pointerId == this.pointerIdentifier && this._pointerCancel( t, t )
	}, i.ontouchcancel = function ( t ) {
	    var e = this.getTouch( t.changedTouches );
	    e && this._pointerCancel( t, e )
	}, i._pointerCancel = function ( t, e ) {
	    this._pointerDone(), this.pointerCancel( t, e )
	}, i.pointerCancel = function ( t, e ) {
	    this.emitEvent( "pointerCancel", [ t, e ] )
	}, e.getPointerPoint = function ( t ) {
	    return { x: t.pageX, y: t.pageY }
	}, e
    } ), function ( e, i ) {
	"function" == typeof define && define.amd ? define( "unidragger/unidragger", [ "unipointer/unipointer" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "unipointer" ) ) : e.Unidragger = i( e, e.Unipointer )
    }( window, function ( o, t ) {
	function e() {
	}
	
	var i = e.prototype = Object.create( t.prototype );
	i.bindHandles = function () {
	    this._bindHandles( !0 )
	}, i.unbindHandles = function () {
	    this._bindHandles( !1 )
	}, i._bindHandles = function ( t ) {
	    for ( var e = ( t = void 0 === t || t ) ? "addEventListener" : "removeEventListener", i = t ? this._touchActionValue : "", n = 0; n < this.handles.length; n++ ) {
		var s = this.handles[ n ];
		this._bindStartEvent( s, t ), s[ e ]( "click", this ), o.PointerEvent && ( s.style.touchAction = i )
	    }
	}, i._touchActionValue = "none", i.pointerDown = function ( t, e ) {
	    this.okayPointerDown( t ) && ( this.pointerDownPointer = e, t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents( t ), this.emitEvent( "pointerDown", [ t, e ] ) )
	};
	var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
	    r = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
	return i.okayPointerDown = function ( t ) {
	    var e = s[ t.target.nodeName ], i = r[ t.target.type ], n = !e || i;
	    return n || this._pointerReset(), n
	}, i.pointerDownBlur = function () {
	    var t = document.activeElement;
	    t && t.blur && t != document.body && t.blur()
	}, i.pointerMove = function ( t, e ) {
	    var i = this._dragPointerMove( t, e );
	    this.emitEvent( "pointerMove", [ t, e, i ] ), this._dragMove( t, e, i )
	}, i._dragPointerMove = function ( t, e ) {
	    var i = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
	    return !this.isDragging && this.hasDragStarted( i ) && this._dragStart( t, e ), i
	}, i.hasDragStarted = function ( t ) {
	    return 3 < Math.abs( t.x ) || 3 < Math.abs( t.y )
	}, i.pointerUp = function ( t, e ) {
	    this.emitEvent( "pointerUp", [ t, e ] ), this._dragPointerUp( t, e )
	}, i._dragPointerUp = function ( t, e ) {
	    this.isDragging ? this._dragEnd( t, e ) : this._staticClick( t, e )
	}, i._dragStart = function ( t, e ) {
	    this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart( t, e )
	}, i.dragStart = function ( t, e ) {
	    this.emitEvent( "dragStart", [ t, e ] )
	}, i._dragMove = function ( t, e, i ) {
	    this.isDragging && this.dragMove( t, e, i )
	}, i.dragMove = function ( t, e, i ) {
	    t.preventDefault(), this.emitEvent( "dragMove", [ t, e, i ] )
	}, i._dragEnd = function ( t, e ) {
	    this.isDragging = !1, setTimeout( function () {
		delete this.isPreventingClicks
	    }.bind( this ) ), this.dragEnd( t, e )
	}, i.dragEnd = function ( t, e ) {
	    this.emitEvent( "dragEnd", [ t, e ] )
	}, i.onclick = function ( t ) {
	    this.isPreventingClicks && t.preventDefault()
	}, i._staticClick = function ( t, e ) {
	    this.isIgnoringMouseUp && "mouseup" == t.type || ( this.staticClick( t, e ), "mouseup" != t.type && ( this.isIgnoringMouseUp = !0, setTimeout( function () {
		delete this.isIgnoringMouseUp
	    }.bind( this ), 400 ) ) )
	}, i.staticClick = function ( t, e ) {
	    this.emitEvent( "staticClick", [ t, e ] )
	}, e.getPointerPoint = t.getPointerPoint, e
    } ), function ( n, s ) {
	"function" == typeof define && define.amd ? define( "flickity/js/drag", [ "./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils" ], function ( t, e, i ) {
	    return s( n, t, e, i )
	} ) : "object" == typeof module && module.exports ? module.exports = s( n, require( "./flickity" ), require( "unidragger" ), require( "fizzy-ui-utils" ) ) : n.Flickity = s( n, n.Flickity, n.Unidragger, n.fizzyUIUtils )
    }( window, function ( i, t, e, a ) {
	a.extend( t.defaults, { draggable: ">1", dragThreshold: 3 } ), t.createMethods.push( "_createDrag" );
	var n = t.prototype;
	a.extend( n, e.prototype ), n._touchActionValue = "pan-y";
	var s = "createTouch" in document, o = !1;
	n._createDrag = function () {
	    this.on( "activate", this.onActivateDrag ), this.on( "uiChange", this._uiChangeDrag ), this.on( "deactivate", this.onDeactivateDrag ), this.on( "cellChange", this.updateDraggable ), s && !o && ( i.addEventListener( "touchmove", function () {
	    } ), o = !0 )
	}, n.onActivateDrag = function () {
	    this.handles = [ this.viewport ], this.bindHandles(), this.updateDraggable()
	}, n.onDeactivateDrag = function () {
	    this.unbindHandles(), this.element.classList.remove( "is-draggable" )
	}, n.updateDraggable = function () {
	    ">1" == this.options.draggable ? this.isDraggable = 1 < this.slides.length : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add( "is-draggable" ) : this.element.classList.remove( "is-draggable" )
	}, n.bindDrag = function () {
	    this.options.draggable = !0, this.updateDraggable()
	}, n.unbindDrag = function () {
	    this.options.draggable = !1, this.updateDraggable()
	}, n._uiChangeDrag = function () {
	    delete this.isFreeScrolling
	}, n.pointerDown = function ( t, e ) {
	    this.isDraggable ? this.okayPointerDown( t ) && ( this._pointerDownPreventDefault( t ), this.pointerDownFocus( t ), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add( "is-pointer-down" ), this.pointerDownScroll = l(), i.addEventListener( "scroll", this ), this._pointerDownDefault( t, e ) ) : this._pointerDownDefault( t, e )
	}, n._pointerDownDefault = function ( t, e ) {
	    this.pointerDownPointer = {
		pageX: e.pageX, pageY: e.pageY
	    }, this._bindPostStartEvents( t ), this.dispatchEvent( "pointerDown", t, [ e ] )
	};
	var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
	
	function l() {
	    return { x: i.pageXOffset, y: i.pageYOffset }
	}
	
	return n.pointerDownFocus = function ( t ) {
	    r[ t.target.nodeName ] || this.focus()
	}, n._pointerDownPreventDefault = function ( t ) {
	    var e = "touchstart" == t.type, i = "touch" == t.pointerType, n = r[ t.target.nodeName ];
	    e || i || n || t.preventDefault()
	}, n.hasDragStarted = function ( t ) {
	    return Math.abs( t.x ) > this.options.dragThreshold
	}, n.pointerUp = function ( t, e ) {
	    delete this.isTouchScrolling, this.viewport.classList.remove( "is-pointer-down" ), this.dispatchEvent( "pointerUp", t, [ e ] ), this._dragPointerUp( t, e )
	}, n.pointerDone = function () {
	    i.removeEventListener( "scroll", this ), delete this.pointerDownScroll
	}, n.dragStart = function ( t, e ) {
	    this.isDraggable && ( this.dragStartPosition = this.x, this.startAnimation(), i.removeEventListener( "scroll", this ), this.dispatchEvent( "dragStart", t, [ e ] ) )
	}, n.pointerMove = function ( t, e ) {
	    var i = this._dragPointerMove( t, e );
	    this.dispatchEvent( "pointerMove", t, [ e, i ] ), this._dragMove( t, e, i )
	}, n.dragMove = function ( t, e, i ) {
	    if ( this.isDraggable ) {
		t.preventDefault(), this.previousDragX = this.dragX;
		var n = this.options.rightToLeft ? -1 : 1;
		this.options.wrapAround && ( i.x = i.x % this.slideableWidth );
		var s = this.dragStartPosition + i.x * n;
		if ( !this.options.wrapAround && this.slides.length ) {
		    var o = Math.max( -this.slides[ 0 ].target, this.dragStartPosition );
		    s     = o < s ? .5 * ( s + o ) : s;
		    var r = Math.min( -this.getLastSlide().target, this.dragStartPosition );
		    s     = s < r ? .5 * ( s + r ) : s
		}
		this.dragX = s, this.dragMoveTime = new Date, this.dispatchEvent( "dragMove", t, [ e, i ] )
	    }
	}, n.dragEnd = function ( t, e ) {
	    if ( this.isDraggable ) {
		this.options.freeScroll && ( this.isFreeScrolling = !0 );
		var i = this.dragEndRestingSelect();
		if ( this.options.freeScroll && !this.options.wrapAround ) {
		    var n                = this.getRestingPosition();
		    this.isFreeScrolling = -n > this.slides[ 0 ].target && -n < this.getLastSlide().target
		} else this.options.freeScroll || i != this.selectedIndex || ( i += this.dragEndBoostSelect() );
		delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select( i ), delete this.isDragSelect, this.dispatchEvent( "dragEnd", t, [ e ] )
	    }
	}, n.dragEndRestingSelect = function () {
	    var t = this.getRestingPosition(), e = Math.abs( this.getSlideDistance( -t, this.selectedIndex ) ),
		i = this._getClosestResting( t, e, 1 ), n = this._getClosestResting( t, e, -1 );
	    return i.distance < n.distance ? i.index : n.index
	}, n._getClosestResting = function ( t, e, i ) {
	    for ( var n = this.selectedIndex, s = 1 / 0, o = this.options.contain && !this.options.wrapAround ? function ( t, e ) {
		return t <= e
	    } : function ( t, e ) {
		return t < e
	    }; o( e, s ) && ( n += i, s = e, null !== ( e = this.getSlideDistance( -t, n ) ) ); ) e = Math.abs( e );
	    return { distance: s, index: n - i }
	}, n.getSlideDistance = function ( t, e ) {
	    var i = this.slides.length, n = this.options.wrapAround && 1 < i, s = n ? a.modulo( e, i ) : e,
		o = this.slides[ s ];
	    if ( !o ) return null;
	    var r = n ? this.slideableWidth * Math.floor( e / i ) : 0;
	    return t - ( o.target + r )
	}, n.dragEndBoostSelect = function () {
	    if ( void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date - this.dragMoveTime ) return 0;
	    var t = this.getSlideDistance( -this.dragX, this.selectedIndex ), e = this.previousDragX - this.dragX;
	    return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0
	}, n.staticClick = function ( t, e ) {
	    var i = this.getParentCell( t.target ), n = i && i.element, s = i && this.cells.indexOf( i );
	    this.dispatchEvent( "staticClick", t, [ e, n, s ] )
	}, n.onscroll = function () {
	    var t = l(), e = this.pointerDownScroll.x - t.x, i = this.pointerDownScroll.y - t.y;
	    ( 3 < Math.abs( e ) || 3 < Math.abs( i ) ) && this._pointerDone()
	}, t
    } ), function ( n, s ) {
	"function" == typeof define && define.amd ? define( "flickity/js/prev-next-button", [ "./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils" ], function ( t, e, i ) {
	    return s( n, t, e, i )
	} ) : "object" == typeof module && module.exports ? module.exports = s( n, require( "./flickity" ), require( "unipointer" ), require( "fizzy-ui-utils" ) ) : s( n, n.Flickity, n.Unipointer, n.fizzyUIUtils )
    }( window, function ( t, e, i, n ) {
	"use strict";
	var s = "http://www.w3.org/2000/svg";
	
	function o( t, e ) {
	    this.direction = t, this.parent = e, this._create()
	}
	
	( o.prototype = Object.create( i.prototype ) )._create = function () {
	    this.isEnabled = !0, this.isPrevious = -1 == this.direction;
	    var t       = this.parent.options.rightToLeft ? 1 : -1;
	    this.isLeft = this.direction == t;
	    var e       = this.element = document.createElement( "button" );
	    e.className = "flickity-button flickity-prev-next-button", e.className += this.isPrevious ? " previous" : " next", e.setAttribute( "type", "button" ), this.disable(), e.setAttribute( "aria-label", this.isPrevious ? "Previous" : "Next" );
	    var i = this.createSVG();
	    e.appendChild( i ), this.parent.on( "select", this.update.bind( this ) ), this.on( "pointerDown", this.parent.childUIPointerDown.bind( this.parent ) )
	}, o.prototype.activate = function () {
	    this.bindStartEvent( this.element ), this.element.addEventListener( "click", this ), this.parent.element.appendChild( this.element )
	}, o.prototype.deactivate = function () {
	    this.parent.element.removeChild( this.element ), this.unbindStartEvent( this.element ), this.element.removeEventListener( "click", this )
	}, o.prototype.createSVG = function () {
	    var t = document.createElementNS( s, "svg" );
	    t.setAttribute( "class", "flickity-button-icon" ), t.setAttribute( "viewBox", "0 0 100 100" );
	    var e = document.createElementNS( s, "path" ), i = function ( t ) {
		return "string" != typeof t ? "M " + t.x0 + ",50 L " + t.x1 + "," + ( t.y1 + 50 ) + " L " + t.x2 + "," + ( t.y2 + 50 ) + " L " + t.x3 + ",50  L " + t.x2 + "," + ( 50 - t.y2 ) + " L " + t.x1 + "," + ( 50 - t.y1 ) + " Z" : t
	    }( this.parent.options.arrowShape );
	    return e.setAttribute( "d", i ), e.setAttribute( "class", "arrow" ), this.isLeft || e.setAttribute( "transform", "translate(100, 100) rotate(180) " ), t.appendChild( e ), t
	}, o.prototype.handleEvent = n.handleEvent, o.prototype.onclick = function () {
	    if ( this.isEnabled ) {
		this.parent.uiChange();
		var t = this.isPrevious ? "previous" : "next";
		this.parent[ t ]()
	    }
	}, o.prototype.enable = function () {
	    this.isEnabled || ( this.element.disabled = !1, this.isEnabled = !0 )
	}, o.prototype.disable = function () {
	    this.isEnabled && ( this.element.disabled = !0, this.isEnabled = !1 )
	}, o.prototype.update = function () {
	    var t = this.parent.slides;
	    if ( this.parent.options.wrapAround && 1 < t.length ) this.enable(); else {
		var e = t.length ? t.length - 1 : 0, i = this.isPrevious ? 0 : e;
		this[ this.parent.selectedIndex == i ? "disable" : "enable" ]()
	    }
	}, o.prototype.destroy = function () {
	    this.deactivate(), this.allOff()
	}, n.extend( e.defaults, {
	    prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 }
	} ), e.createMethods.push( "_createPrevNextButtons" );
	var r = e.prototype;
	return r._createPrevNextButtons = function () {
	    this.options.prevNextButtons && ( this.prevButton = new o( -1, this ), this.nextButton = new o( 1, this ), this.on( "activate", this.activatePrevNextButtons ) )
	}, r.activatePrevNextButtons = function () {
	    this.prevButton.activate(), this.nextButton.activate(), this.on( "deactivate", this.deactivatePrevNextButtons )
	}, r.deactivatePrevNextButtons = function () {
	    this.prevButton.deactivate(), this.nextButton.deactivate(), this.off( "deactivate", this.deactivatePrevNextButtons )
	}, e.PrevNextButton = o, e
    } ), function ( n, s ) {
	"function" == typeof define && define.amd ? define( "flickity/js/page-dots", [ "./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils" ], function ( t, e, i ) {
	    return s( n, t, e, i )
	} ) : "object" == typeof module && module.exports ? module.exports = s( n, require( "./flickity" ), require( "unipointer" ), require( "fizzy-ui-utils" ) ) : s( n, n.Flickity, n.Unipointer, n.fizzyUIUtils )
    }( window, function ( t, e, i, n ) {
	function s( t ) {
	    this.parent = t, this._create()
	}
	
	( s.prototype = Object.create( i.prototype ) )._create = function () {
	    this.holder = document.createElement( "ol" ), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind( this ), this.on( "pointerDown", this.parent.childUIPointerDown.bind( this.parent ) )
	}, s.prototype.activate = function () {
	    this.setDots(), this.holder.addEventListener( "click", this.handleClick ), this.bindStartEvent( this.holder ), this.parent.element.appendChild( this.holder )
	}, s.prototype.deactivate = function () {
	    this.holder.removeEventListener( "click", this.handleClick ), this.unbindStartEvent( this.holder ), this.parent.element.removeChild( this.holder )
	}, s.prototype.setDots = function () {
	    var t = this.parent.slides.length - this.dots.length;
	    0 < t ? this.addDots( t ) : t < 0 && this.removeDots( -t )
	}, s.prototype.addDots = function ( t ) {
	    for ( var e = document.createDocumentFragment(), i = [], n = this.dots.length, s = n + t, o = n; o < s; o++ ) {
		var r = document.createElement( "li" );
		r.className = "dot", r.setAttribute( "aria-label", "Page dot " + ( o + 1 ) ), e.appendChild( r ), i.push( r )
	    }
	    this.holder.appendChild( e ), this.dots = this.dots.concat( i )
	}, s.prototype.removeDots = function ( t ) {
	    this.dots.splice( this.dots.length - t, t ).forEach( function ( t ) {
		this.holder.removeChild( t )
	    }, this )
	}, s.prototype.updateSelected = function () {
	    this.selectedDot && ( this.selectedDot.className = "dot", this.selectedDot.removeAttribute( "aria-current" ) ), this.dots.length && ( this.selectedDot = this.dots[ this.parent.selectedIndex ], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute( "aria-current", "step" ) )
	}, s.prototype.onTap = s.prototype.onClick = function ( t ) {
	    var e = t.target;
	    if ( "LI" == e.nodeName ) {
		this.parent.uiChange();
		var i = this.dots.indexOf( e );
		this.parent.select( i )
	    }
	}, s.prototype.destroy = function () {
	    this.deactivate(), this.allOff()
	}, e.PageDots = s, n.extend( e.defaults, { pageDots: !0 } ), e.createMethods.push( "_createPageDots" );
	var o = e.prototype;
	return o._createPageDots = function () {
	    this.options.pageDots && ( this.pageDots = new s( this ), this.on( "activate", this.activatePageDots ), this.on( "select", this.updateSelectedPageDots ), this.on( "cellChange", this.updatePageDots ), this.on( "resize", this.updatePageDots ), this.on( "deactivate", this.deactivatePageDots ) )
	}, o.activatePageDots = function () {
	    this.pageDots.activate()
	}, o.updateSelectedPageDots = function () {
	    this.pageDots.updateSelected()
	}, o.updatePageDots = function () {
	    this.pageDots.setDots()
	}, o.deactivatePageDots = function () {
	    this.pageDots.deactivate()
	}, e.PageDots = s, e
    } ), function ( t, n ) {
	"function" == typeof define && define.amd ? define( "flickity/js/player", [ "ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity" ], function ( t, e, i ) {
	    return n( t, e, i )
	} ) : "object" == typeof module && module.exports ? module.exports = n( require( "ev-emitter" ), require( "fizzy-ui-utils" ), require( "./flickity" ) ) : n( t.EvEmitter, t.fizzyUIUtils, t.Flickity )
    }( window, function ( t, e, i ) {
	function n( t ) {
	    this.parent = t, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind( this ), this.onVisibilityPlay = this.visibilityPlay.bind( this )
	}
	
	( n.prototype = Object.create( t.prototype ) ).play = function () {
	    "playing" != this.state && ( document.hidden ? document.addEventListener( "visibilitychange", this.onVisibilityPlay ) : ( this.state = "playing", document.addEventListener( "visibilitychange", this.onVisibilityChange ), this.tick() ) )
	}, n.prototype.tick = function () {
	    if ( "playing" == this.state ) {
		var t = this.parent.options.autoPlay;
		t     = "number" == typeof t ? t : 3e3;
		var e = this;
		this.clear(), this.timeout = setTimeout( function () {
		    e.parent.next( !0 ), e.tick()
		}, t )
	    }
	}, n.prototype.stop = function () {
	    this.state = "stopped", this.clear(), document.removeEventListener( "visibilitychange", this.onVisibilityChange )
	}, n.prototype.clear = function () {
	    clearTimeout( this.timeout )
	}, n.prototype.pause = function () {
	    "playing" == this.state && ( this.state = "paused", this.clear() )
	}, n.prototype.unpause = function () {
	    "paused" == this.state && this.play()
	}, n.prototype.visibilityChange = function () {
	    this[ document.hidden ? "pause" : "unpause" ]()
	}, n.prototype.visibilityPlay = function () {
	    this.play(), document.removeEventListener( "visibilitychange", this.onVisibilityPlay )
	}, e.extend( i.defaults, { pauseAutoPlayOnHover: !0 } ), i.createMethods.push( "_createPlayer" );
	var s = i.prototype;
	return s._createPlayer = function () {
	    this.player = new n( this ), this.on( "activate", this.activatePlayer ), this.on( "uiChange", this.stopPlayer ), this.on( "pointerDown", this.stopPlayer ), this.on( "deactivate", this.deactivatePlayer )
	}, s.activatePlayer = function () {
	    this.options.autoPlay && ( this.player.play(), this.element.addEventListener( "mouseenter", this ) )
	}, s.playPlayer = function () {
	    this.player.play()
	}, s.stopPlayer = function () {
	    this.player.stop()
	}, s.pausePlayer = function () {
	    this.player.pause()
	}, s.unpausePlayer = function () {
	    this.player.unpause()
	}, s.deactivatePlayer = function () {
	    this.player.stop(), this.element.removeEventListener( "mouseenter", this )
	}, s.onmouseenter = function () {
	    this.options.pauseAutoPlayOnHover && ( this.player.pause(), this.element.addEventListener( "mouseleave", this ) )
	}, s.onmouseleave = function () {
	    this.player.unpause(), this.element.removeEventListener( "mouseleave", this )
	}, i.Player = n, i
    } ), function ( i, n ) {
	"function" == typeof define && define.amd ? define( "flickity/js/add-remove-cell", [ "./flickity", "fizzy-ui-utils/utils" ], function ( t, e ) {
	    return n( i, t, e )
	} ) : "object" == typeof module && module.exports ? module.exports = n( i, require( "./flickity" ), require( "fizzy-ui-utils" ) ) : n( i, i.Flickity, i.fizzyUIUtils )
    }( window, function ( t, e, n ) {
	var i = e.prototype;
	return i.insert = function ( t, e ) {
	    var i = this._makeCells( t );
	    if ( i && i.length ) {
		var n     = this.cells.length;
		e         = void 0 === e ? n : e;
		var s     = function ( t ) {
		    var e = document.createDocumentFragment();
		    return t.forEach( function ( t ) {
			e.appendChild( t.element )
		    } ), e
		}( i ), o = e == n;
		if ( o ) this.slider.appendChild( s ); else {
		    var r = this.cells[ e ].element;
		    this.slider.insertBefore( s, r )
		}
		if ( 0 === e ) this.cells = i.concat( this.cells ); else if ( o ) this.cells = this.cells.concat( i ); else {
		    var a      = this.cells.splice( e, n - e );
		    this.cells = this.cells.concat( i ).concat( a )
		}
		this._sizeCells( i ), this.cellChange( e, !0 )
	    }
	}, i.append = function ( t ) {
	    this.insert( t, this.cells.length )
	}, i.prepend = function ( t ) {
	    this.insert( t, 0 )
	}, i.remove = function ( t ) {
	    var e = this.getCells( t );
	    if ( e && e.length ) {
		var i = this.cells.length - 1;
		e.forEach( function ( t ) {
		    t.remove();
		    var e = this.cells.indexOf( t );
		    i = Math.min( e, i ), n.removeFrom( this.cells, t )
		}, this ), this.cellChange( i, !0 )
	    }
	}, i.cellSizeChange = function ( t ) {
	    var e = this.getCell( t );
	    if ( e ) {
		e.getSize();
		var i = this.cells.indexOf( e );
		this.cellChange( i )
	    }
	}, i.cellChange = function ( t, e ) {
	    var i = this.selectedElement;
	    this._positionCells( t ), this._getWrapShiftCells(), this.setGallerySize();
	    var n = this.getCell( i );
	    n && ( this.selectedIndex = this.getCellSlideIndex( n ) ), this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex ), this.emitEvent( "cellChange", [ t ] ), this.select( this.selectedIndex ), e && this.positionSliderAtSelected()
	}, e
    } ), function ( i, n ) {
	"function" == typeof define && define.amd ? define( "flickity/js/lazyload", [ "./flickity", "fizzy-ui-utils/utils" ], function ( t, e ) {
	    return n( i, t, e )
	} ) : "object" == typeof module && module.exports ? module.exports = n( i, require( "./flickity" ), require( "fizzy-ui-utils" ) ) : n( i, i.Flickity, i.fizzyUIUtils )
    }( window, function ( t, e, o ) {
	"use strict";
	e.createMethods.push( "_createLazyload" );
	var i = e.prototype;
	
	function s( t, e ) {
	    this.img = t, this.flickity = e, this.load()
	}
	
	return i._createLazyload = function () {
	    this.on( "select", this.lazyLoad )
	}, i.lazyLoad = function () {
	    var t = this.options.lazyLoad;
	    if ( t ) {
		var e = "number" == typeof t ? t : 0, i = this.getAdjacentCellElements( e ), n = [];
		i.forEach( function ( t ) {
		    var e = function ( t ) {
			if ( "IMG" == t.nodeName ) {
			    var e = t.getAttribute( "data-flickity-lazyload" ),
				i = t.getAttribute( "data-flickity-lazyload-src" ),
				n = t.getAttribute( "data-flickity-lazyload-srcset" );
			    if ( e || i || n ) return [ t ]
			}
			var s = t.querySelectorAll( "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]" );
			return o.makeArray( s )
		    }( t );
		    n     = n.concat( e )
		} ), n.forEach( function ( t ) {
		    new s( t, this )
		}, this )
	    }
	}, s.prototype.handleEvent = o.handleEvent, s.prototype.load = function () {
	    this.img.addEventListener( "load", this ), this.img.addEventListener( "error", this );
	    var t = this.img.getAttribute( "data-flickity-lazyload" ) || this.img.getAttribute( "data-flickity-lazyload-src" ),
		e = this.img.getAttribute( "data-flickity-lazyload-srcset" );
	    this.img.src = t, e && this.img.setAttribute( "srcset", e ), this.img.removeAttribute( "data-flickity-lazyload" ), this.img.removeAttribute( "data-flickity-lazyload-src" ), this.img.removeAttribute( "data-flickity-lazyload-srcset" )
	}, s.prototype.onload = function ( t ) {
	    this.complete( t, "flickity-lazyloaded" )
	}, s.prototype.onerror = function ( t ) {
	    this.complete( t, "flickity-lazyerror" )
	}, s.prototype.complete = function ( t, e ) {
	    this.img.removeEventListener( "load", this ), this.img.removeEventListener( "error", this );
	    var i = this.flickity.getParentCell( this.img ), n = i && i.element;
	    this.flickity.cellSizeChange( n ), this.img.classList.add( e ), this.flickity.dispatchEvent( "lazyLoad", t, n )
	}, e.LazyLoader = s, e
    } ), function ( t, e ) {
	"function" == typeof define && define.amd ? define( "flickity/js/index", [ "./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload" ], e ) : "object" == typeof module && module.exports && ( module.exports = e( require( "./flickity" ), require( "./drag" ), require( "./prev-next-button" ), require( "./page-dots" ), require( "./player" ), require( "./add-remove-cell" ), require( "./lazyload" ) ) )
    }( window, function ( t ) {
	return t
    } ), function ( t, e ) {
	"function" == typeof define && define.amd ? define( "flickity-as-nav-for/as-nav-for", [ "flickity/js/index", "fizzy-ui-utils/utils" ], e ) : "object" == typeof module && module.exports ? module.exports = e( require( "flickity" ), require( "fizzy-ui-utils" ) ) : t.Flickity = e( t.Flickity, t.fizzyUIUtils )
    }( window, function ( n, s ) {
	n.createMethods.push( "_createAsNavFor" );
	var t = n.prototype;
	return t._createAsNavFor = function () {
	    this.on( "activate", this.activateAsNavFor ), this.on( "deactivate", this.deactivateAsNavFor ), this.on( "destroy", this.destroyAsNavFor );
	    var t = this.options.asNavFor;
	    if ( t ) {
		var e = this;
		setTimeout( function () {
		    e.setNavCompanion( t )
		} )
	    }
	}, t.setNavCompanion = function ( t ) {
	    t     = s.getQueryElement( t );
	    var e = n.data( t );
	    if ( e && e != this ) {
		this.navCompanion = e;
		var i             = this;
		this.onNavCompanionSelect = function () {
		    i.navCompanionSelect()
		}, e.on( "select", this.onNavCompanionSelect ), this.on( "staticClick", this.onNavStaticClick ), this.navCompanionSelect( !0 )
	    }
	}, t.navCompanionSelect = function ( t ) {
	    var e = this.navCompanion && this.navCompanion.selectedCells;
	    if ( e ) {
		var i = e[ 0 ], n = this.navCompanion.cells.indexOf( i ), s = n + e.length - 1,
		    o = Math.floor( function ( t, e, i ) {
			return ( e - t ) * i + t
		    }( n, s, this.navCompanion.cellAlign ) );
		if ( this.selectCell( o, !1, t ), this.removeNavSelectedElements(), !( o >= this.cells.length ) ) {
		    var r = this.cells.slice( n, 1 + s );
		    this.navSelectedElements = r.map( function ( t ) {
			return t.element
		    } ), this.changeNavSelectedClass( "add" )
		}
	    }
	}, t.changeNavSelectedClass = function ( e ) {
	    this.navSelectedElements.forEach( function ( t ) {
		t.classList[ e ]( "is-nav-selected" )
	    } )
	}, t.activateAsNavFor = function () {
	    this.navCompanionSelect( !0 )
	}, t.removeNavSelectedElements = function () {
	    this.navSelectedElements && ( this.changeNavSelectedClass( "remove" ), delete this.navSelectedElements )
	}, t.onNavStaticClick = function ( t, e, i, n ) {
	    "number" == typeof n && this.navCompanion.selectCell( n )
	}, t.deactivateAsNavFor = function () {
	    this.removeNavSelectedElements()
	}, t.destroyAsNavFor = function () {
	    this.navCompanion && ( this.navCompanion.off( "select", this.onNavCompanionSelect ), this.off( "staticClick", this.onNavStaticClick ), delete this.navCompanion )
	}, n
    } ), function ( e, i ) {
	"use strict";
	"function" == typeof define && define.amd ? define( "imagesloaded/imagesloaded", [ "ev-emitter/ev-emitter" ], function ( t ) {
	    return i( e, t )
	} ) : "object" == typeof module && module.exports ? module.exports = i( e, require( "ev-emitter" ) ) : e.imagesLoaded = i( e, e.EvEmitter )
    }( "undefined" != typeof window ? window : this, function ( e, t ) {
	var s = e.jQuery, o = e.console;
	
	function r( t, e ) {
	    for ( var i in e ) t[ i ] = e[ i ];
	    return t
	}
	
	var a = Array.prototype.slice;
	
	function l( t, e, i ) {
	    if ( !( this instanceof l ) ) return new l( t, e, i );
	    var n = t;
	    "string" == typeof t && ( n = document.querySelectorAll( t ) ), n ? ( this.elements = function ( t ) {
		return Array.isArray( t ) ? t : "object" == typeof t && "number" == typeof t.length ? a.call( t ) : [ t ]
	    }( n ), this.options = r( {}, this.options ), "function" == typeof e ? i = e : r( this.options, e ), i && this.on( "always", i ), this.getImages(), s && ( this.jqDeferred = new s.Deferred ), setTimeout( this.check.bind( this ) ) ) : o.error( "Bad element for imagesLoaded " + ( n || t ) )
	}
	
	( l.prototype = Object.create( t.prototype ) ).options = {}, l.prototype.getImages = function () {
	    this.images = [], this.elements.forEach( this.addElementImages, this )
	}, l.prototype.addElementImages = function ( t ) {
	    "IMG" == t.nodeName && this.addImage( t ), !0 === this.options.background && this.addElementBackgroundImages( t );
	    var e = t.nodeType;
	    if ( e && h[ e ] ) {
		for ( var i = t.querySelectorAll( "img" ), n = 0; n < i.length; n++ ) {
		    var s = i[ n ];
		    this.addImage( s )
		}
		if ( "string" == typeof this.options.background ) {
		    var o = t.querySelectorAll( this.options.background );
		    for ( n = 0; n < o.length; n++ ) {
			var r = o[ n ];
			this.addElementBackgroundImages( r )
		    }
		}
	    }
	};
	var h = { 1: !0, 9: !0, 11: !0 };
	
	function i( t ) {
	    this.img = t
	}
	
	function n( t, e ) {
	    this.url = t, this.element = e, this.img = new Image
	}
	
	return l.prototype.addElementBackgroundImages = function ( t ) {
	    var e = getComputedStyle( t );
	    if ( e ) for ( var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec( e.backgroundImage ); null !== n; ) {
		var s = n && n[ 2 ];
		s && this.addBackground( s, t ), n = i.exec( e.backgroundImage )
	    }
	}, l.prototype.addImage = function ( t ) {
	    var e = new i( t );
	    this.images.push( e )
	}, l.prototype.addBackground = function ( t, e ) {
	    var i = new n( t, e );
	    this.images.push( i )
	}, l.prototype.check = function () {
	    var n = this;
	    
	    function e( t, e, i ) {
		setTimeout( function () {
		    n.progress( t, e, i )
		} )
	    }
	    
	    this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach( function ( t ) {
		t.once( "progress", e ), t.check()
	    } ) : this.complete()
	}, l.prototype.progress = function ( t, e, i ) {
	    this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent( "progress", [ this, t, e ] ), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify( this, t ), this.progressedCount == this.images.length && this.complete(), this.options.debug && o && o.log( "progress: " + i, t, e )
	}, l.prototype.complete = function () {
	    var t = this.hasAnyBroken ? "fail" : "done";
	    if ( this.isComplete = !0, this.emitEvent( t, [ this ] ), this.emitEvent( "always", [ this ] ), this.jqDeferred ) {
		var e = this.hasAnyBroken ? "reject" : "resolve";
		this.jqDeferred[ e ]( this )
	    }
	}, ( i.prototype = Object.create( t.prototype ) ).check = function () {
	    this.getIsImageComplete() ? this.confirm( 0 !== this.img.naturalWidth, "naturalWidth" ) : ( this.proxyImage = new Image, this.proxyImage.addEventListener( "load", this ), this.proxyImage.addEventListener( "error", this ), this.img.addEventListener( "load", this ), this.img.addEventListener( "error", this ), this.proxyImage.src = this.img.src )
	}, i.prototype.getIsImageComplete = function () {
	    return this.img.complete && this.img.naturalWidth
	}, i.prototype.confirm = function ( t, e ) {
	    this.isLoaded = t, this.emitEvent( "progress", [ this, this.img, e ] )
	}, i.prototype.handleEvent = function ( t ) {
	    var e = "on" + t.type;
	    this[ e ] && this[ e ]( t )
	}, i.prototype.onload = function () {
	    this.confirm( !0, "onload" ), this.unbindEvents()
	}, i.prototype.onerror = function () {
	    this.confirm( !1, "onerror" ), this.unbindEvents()
	}, i.prototype.unbindEvents = function () {
	    this.proxyImage.removeEventListener( "load", this ), this.proxyImage.removeEventListener( "error", this ), this.img.removeEventListener( "load", this ), this.img.removeEventListener( "error", this )
	}, ( n.prototype = Object.create( i.prototype ) ).check = function () {
	    this.img.addEventListener( "load", this ), this.img.addEventListener( "error", this ), this.img.src = this.url, this.getIsImageComplete() && ( this.confirm( 0 !== this.img.naturalWidth, "naturalWidth" ), this.unbindEvents() )
	}, n.prototype.unbindEvents = function () {
	    this.img.removeEventListener( "load", this ), this.img.removeEventListener( "error", this )
	}, n.prototype.confirm = function ( t, e ) {
	    this.isLoaded = t, this.emitEvent( "progress", [ this, this.element, e ] )
	}, l.makeJQueryPlugin = function ( t ) {
	    ( t = t || e.jQuery ) && ( ( s = t ).fn.imagesLoaded = function ( t, e ) {
		return new l( this, t, e ).jqDeferred.promise( s( this ) )
	    } )
	}, l.makeJQueryPlugin(), l
    } ), function ( i, n ) {
	"function" == typeof define && define.amd ? define( [ "flickity/js/index", "imagesloaded/imagesloaded" ], function ( t, e ) {
	    return n( i, t, e )
	} ) : "object" == typeof module && module.exports ? module.exports = n( i, require( "flickity" ), require( "imagesloaded" ) ) : i.Flickity = n( i, i.Flickity, i.imagesLoaded )
    }( window, function ( t, e, i ) {
	"use strict";
	e.createMethods.push( "_createImagesLoaded" );
	var n = e.prototype;
	return n._createImagesLoaded = function () {
	    this.on( "activate", this.imagesLoaded )
	}, n.imagesLoaded = function () {
	    if ( this.options.imagesLoaded ) {
		var n = this;
		i( this.slider ).on( "progress", function ( t, e ) {
		    var i = n.getParentCell( e.img );
		    n.cellSizeChange( i && i.element ), n.options.freeScroll || n.positionSliderAtSelected()
		} )
	    }
	}, e
    } );
    
    /**
     * Flickity fade v1.0.0
     * Fade between Flickity slides
     */
    
    /* jshint browser: true, undef: true, unused: true */
    
    !function ( e, t ) {
	"function" == typeof define && define.amd ? define( [ "flickity/js/index", "fizzy-ui-utils/utils" ], t ) : "object" == typeof module && module.exports ? module.exports = t( require( "flickity" ), require( "fizzy-ui-utils" ) ) : t( e.Flickity, e.fizzyUIUtils )
    }( this, function ( e, t ) {
	var i = e.Slide, s = i.prototype.updateTarget;
	i.prototype.updateTarget = function () {
	    if ( s.apply( this, arguments ), this.parent.options.fade ) {
		var e = this.target - this.x, t = this.cells[ 0 ].x;
		this.cells.forEach( function ( i ) {
		    var s = i.x - t - e;
		    i.renderPosition( s )
		} )
	    }
	}, i.prototype.setOpacity = function ( e ) {
	    this.cells.forEach( function ( t ) {
		t.element.style.opacity = e
	    } )
	};
	var a = e.prototype;
	e.createMethods.push( "_createFade" ), a._createFade = function () {
	    this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, this.on( "select", this.onSelectFade ), this.on( "dragEnd", this.onDragEndFade ), this.on( "settle", this.onSettleFade ), this.on( "activate", this.onActivateFade ), this.on( "deactivate", this.onDeactivateFade )
	};
	var n = a.updateSlides;
	a.updateSlides = function () {
	    n.apply( this, arguments ), this.options.fade && this.slides.forEach( function ( e, t ) {
		var i = t == this.selectedIndex ? 1 : 0;
		e.setOpacity( i )
	    }, this )
	}, a.onSelectFade = function () {
	    this.fadeIndex = Math.min( this.prevSelectedIndex, this.slides.length - 1 ), this.prevSelectedIndex = this.selectedIndex
	}, a.onSettleFade = function () {
	    ( delete this.didDragEnd, this.options.fade ) && ( this.selectedSlide.setOpacity( 1 ), this.slides[ this.fadeIndex ] && this.fadeIndex != this.selectedIndex && this.slides[ this.fadeIndex ].setOpacity( 0 ) )
	}, a.onDragEndFade = function () {
	    this.didDragEnd = !0
	}, a.onActivateFade = function () {
	    this.options.fade && this.element.classList.add( "is-fade" )
	}, a.onDeactivateFade = function () {
	    this.options.fade && ( this.element.classList.remove( "is-fade" ), this.slides.forEach( function ( e ) {
		e.setOpacity( "" )
	    } ) )
	};
	var d            = a.positionSlider;
	a.positionSlider = function () {
	    this.options.fade ? ( this.fadeSlides(), this.dispatchScrollEvent() ) : d.apply( this, arguments )
	};
	var h            = a.positionSliderAtSelected;
	a.positionSliderAtSelected = function () {
	    this.options.fade && this.setTranslateX( 0 ), h.apply( this, arguments )
	}, a.fadeSlides = function () {
	    if ( !( this.slides.length < 2 ) ) {
		var e = this.getFadeIndexes(), t = this.slides[ e.a ], i = this.slides[ e.b ],
		    s = this.wrapDifference( t.target, i.target ), a = this.wrapDifference( t.target, -this.x );
		a /= s, t.setOpacity( 1 - a ), i.setOpacity( a );
		var n = e.a;
		this.isDragging && ( n = a > .5 ? e.a : e.b ), null != this.fadeHideIndex && this.fadeHideIndex != n && this.fadeHideIndex != e.a && this.fadeHideIndex != e.b && this.slides[ this.fadeHideIndex ].setOpacity( 0 ), this.fadeHideIndex = n
	    }
	}, a.getFadeIndexes = function () {
	    return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
		a: this.fadeIndex, b: this.selectedIndex
	    }
	}, a.getFadeDragWrapIndexes = function () {
	    var e = this.slides.map( function ( e, t ) {
		    return this.getSlideDistance( -this.x, t )
		}, this ), i = e.map( function ( e ) {
		    return Math.abs( e )
		} ), s = Math.min.apply( Math, i ), a = i.indexOf( s ), n = e[ a ], d = this.slides.length,
		h = n >= 0 ? 1 : -1;
	    return { a: a, b: t.modulo( a + h, d ) }
	}, a.getFadeDragLimitIndexes = function () {
	    for ( var e = 0, t = 0; t < this.slides.length - 1; t++ ) {
		var i = this.slides[ t ];
		if ( -this.x < i.target ) break;
		e = t
	    }
	    return { a: e, b: e + 1 }
	}, a.wrapDifference = function ( e, t ) {
	    var i = t - e;
	    if ( !this.options.wrapAround ) return i;
	    var s = i + this.slideableWidth, a = i - this.slideableWidth;
	    return Math.abs( s ) < Math.abs( i ) && ( i = s ), Math.abs( a ) < Math.abs( i ) && ( i = a ), i
	};
	var o                = a._getWrapShiftCells;
	a._getWrapShiftCells = function () {
	    this.options.fade || o.apply( this, arguments )
	};
	var r                = a.shiftWrapCells;
	return a.shiftWrapCells = function () {
	    this.options.fade || r.apply( this, arguments )
	}, e
    } );
    
    /*!
 * Flickity sync v2.0.0
 * enable sync for Flickity
 */
    
    /*jshint browser: true, undef: true, unused: true, strict: true*/
    
    !function ( t, n ) {
	"function" == typeof define && define.amd ? define( [ "flickity/js/index", "fizzy-ui-utils/utils" ], n ) : "object" == typeof module && module.exports ? module.exports = n( require( "flickity" ), require( "fizzy-ui-utils" ) ) : t.Flickity = n( t.Flickity, t.fizzyUIUtils )
    }( window, function ( t, n ) {
	"use strict";
	return t.createMethods.push( "_createSync" ), t.prototype._createSync = function () {
	    this.syncers = {};
	    var t        = this.options.sync;
	    if ( this.on( "destroy", this.unsyncAll ), t ) {
		var n = this;
		setTimeout( function () {
		    n.sync( t )
		} )
	    }
	}, t.prototype.sync = function ( i ) {
	    i     = n.getQueryElement( i );
	    var e = t.data( i );
	    e && ( this._syncCompanion( e ), e._syncCompanion( this ) )
	}, t.prototype._syncCompanion = function ( t ) {
	    var n = this;
	    
	    function i() {
		var i = n.selectedIndex;
		t.selectedIndex != i && t.select( i )
	    }
	    
	    this.on( "select", i ), this.syncers[ t.guid ] = { flickity: t, listener: i }
	}, t.prototype.unsync = function ( i ) {
	    i     = n.getQueryElement( i );
	    var e = t.data( i );
	    this._unsync( e )
	}, t.prototype._unsync = function ( t ) {
	    t && ( this._unsyncCompanion( t ), t._unsyncCompanion( this ) )
	}, t.prototype._unsyncCompanion = function ( t ) {
	    var n = t.guid, i = this.syncers[ n ];
	    this.off( "select", i.listener ), delete this.syncers[ n ]
	}, t.prototype.unsyncAll = function () {
	    for ( var t in this.syncers ) {
		var n = this.syncers[ t ];
		this._unsync( n.flickity )
	    }
	}, t
    } );
    
} )();

( function vendorPhotoSwipe() {
    /*! PhotoSwipe - v4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov; */
    !function ( a, b ) {
	"function" == typeof define && define.amd ? define( b ) : "object" == typeof exports ? module.exports = b() : a.PhotoSwipe = b()
    }( this, function () {
	"use strict";
	var a = function ( a, b, c, d ) {
	    var e = {
		features          : null, bind: function ( a, b, c, d ) {
		    var e = ( d ? "remove" : "add" ) + "EventListener";
		    b     = b.split( " " );
		    for ( var f = 0; f < b.length; f++ ) b[ f ] && a[ e ]( b[ f ], c, !1 )
		}, isArray        : function ( a ) {
		    return a instanceof Array
		}, createEl       : function ( a, b ) {
		    var c = document.createElement( b || "div" );
		    return a && ( c.className = a ), c
		}, getScrollY     : function () {
		    var a = window.pageYOffset;
		    return void 0 !== a ? a : document.documentElement.scrollTop
		}, unbind         : function ( a, b, c ) {
		    e.bind( a, b, c, !0 )
		}, removeClass    : function ( a, b ) {
		    var c       = new RegExp( "(\\s|^)" + b + "(\\s|$)" );
		    a.className = a.className.replace( c, " " ).replace( /^\s\s*/, "" ).replace( /\s\s*$/, "" )
		}, addClass       : function ( a, b ) {
		    e.hasClass( a, b ) || ( a.className += ( a.className ? " " : "" ) + b )
		}, hasClass       : function ( a, b ) {
		    return a.className && new RegExp( "(^|\\s)" + b + "(\\s|$)" ).test( a.className )
		}, getChildByClass: function ( a, b ) {
		    for ( var c = a.firstChild; c; ) {
			if ( e.hasClass( c, b ) ) return c;
			c = c.nextSibling
		    }
		}, arraySearch    : function ( a, b, c ) {
		    for ( var d = a.length; d--; ) if ( a[ d ][ c ] === b ) return d;
		    return -1
		}, extend         : function ( a, b, c ) {
		    for ( var d in b ) if ( b.hasOwnProperty( d ) ) {
			if ( c && a.hasOwnProperty( d ) ) continue;
			a[ d ] = b[ d ]
		    }
		}, easing         : {
		    sine    : {
			out     : function ( a ) {
			    return Math.sin( a * ( Math.PI / 2 ) )
			}, inOut: function ( a ) {
			    return -( Math.cos( Math.PI * a ) - 1 ) / 2
			}
		    }, cubic: {
			out: function ( a ) {
			    return --a * a * a + 1
			}
		    }
		}, detectFeatures : function () {
		    if ( e.features ) return e.features;
		    var a = e.createEl(), b = a.style, c = "", d = {};
		    if ( d.oldIE = document.all && !document.addEventListener, d.touch = "ontouchstart" in window, window.requestAnimationFrame && ( d.raf = window.requestAnimationFrame, d.caf = window.cancelAnimationFrame ), d.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !d.pointerEvent ) {
			var f = navigator.userAgent;
			if ( /iP(hone|od)/.test( navigator.platform ) ) {
			    var g = navigator.appVersion.match( /OS (\d+)_(\d+)_?(\d+)?/ );
			    g && g.length > 0 && ( g = parseInt( g[ 1 ], 10 ), g >= 1 && g < 8 && ( d.isOldIOSPhone = !0 ) )
			}
			var h = f.match( /Android\s([0-9\.]*)/ ), i = h ? h[ 1 ] : 0;
			i = parseFloat( i ), i >= 1 && ( i < 4.4 && ( d.isOldAndroid = !0 ), d.androidVersion = i ), d.isMobileOpera = /opera mini|opera mobi/i.test( f )
		    }
		    for ( var j, k, l = [ "transform", "perspective", "animationName" ], m = [ "", "webkit", "Moz", "ms", "O" ], n = 0; n < 4; n++ ) {
			c = m[ n ];
			for ( var o = 0; o < 3; o++ ) j = l[ o ], k = c + ( c ? j.charAt( 0 ).toUpperCase() + j.slice( 1 ) : j ), !d[ j ] && k in b && ( d[ j ] = k );
			c && !d.raf && ( c = c.toLowerCase(), d.raf = window[ c + "RequestAnimationFrame" ], d.raf && ( d.caf = window[ c + "CancelAnimationFrame" ] || window[ c + "CancelRequestAnimationFrame" ] ) )
		    }
		    if ( !d.raf ) {
			var p = 0;
			d.raf = function ( a ) {
			    var b = ( new Date ).getTime(), c = Math.max( 0, 16 - ( b - p ) ),
				d = window.setTimeout( function () {
				    a( b + c )
				}, c );
			    return p = b + c, d
			}, d.caf = function ( a ) {
			    clearTimeout( a )
			}
		    }
		    return d.svg = !!document.createElementNS && !!document.createElementNS( "http://www.w3.org/2000/svg", "svg" ).createSVGRect, e.features = d, d
		}
	    };
	    e.detectFeatures(), e.features.oldIE && ( e.bind = function ( a, b, c, d ) {
		b = b.split( " " );
		for ( var e, f = ( d ? "detach" : "attach" ) + "Event", g = function () {
		    c.handleEvent.call( c )
		}, h           = 0; h < b.length; h++ ) if ( e = b[ h ] ) if ( "object" == typeof c && c.handleEvent ) {
		    if ( d ) {
			if ( !c[ "oldIE" + e ] ) return !1
		    } else c[ "oldIE" + e ] = g;
		    a[ f ]( "on" + e, c[ "oldIE" + e ] )
		} else a[ f ]( "on" + e, c )
	    } );
	    var f = this, g = 25, h = 3, i = {
		allowPanToNext       : !0, spacing: .12, bgOpacity: 1, mouseUsed: !1, loop: !0, pinchToClose: !0,
		closeOnScroll        : !0, closeOnVerticalDrag: !0, verticalDragRange: .75, hideAnimationDuration: 333,
		showAnimationDuration: 333, showHideOpacity: !1, focus: !0, escKey: !0, arrowKeys: !0,
		mainScrollEndFriction: .35, panEndFriction: .35, isClickableElement: function ( a ) {
		    return "A" === a.tagName
		}, getDoubleTapZoom  : function ( a, b ) {
		    return a ? 1 : b.initialZoomLevel < .7 ? 1 : 1.33
		}, maxSpreadZoom     : 1.33, modal: !0, scaleMode: "fit"
	    };
	    e.extend( i, d );
	    var j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R,
		S, T, U, V, W, X, Y, Z, $, _, aa, ba, ca, da, ea, fa, ga, ha, ia, ja, ka, la, ma = function () {
		    return { x: 0, y: 0 }
		}, na = ma(), oa = ma(),
		pa = ma(), qa = {},
		ra = 0, sa = {},
		ta = ma(), ua = 0,
		va = !0, wa = [], xa = {},
		ya = !1,
		za = function ( a, b ) {
		    e.extend( f, b.publicMethods ), wa.push( a )
		}, Aa = function ( a ) {
		    var b = ac();
		    return a > b - 1 ? a - b : a < 0 ? b + a : a
		}, Ba = {},
		Ca = function ( a, b ) {
		    return Ba[ a ] || ( Ba[ a ] = [] ), Ba[ a ].push( b )
		}, Da = function ( a ) {
		    var b = Ba[ a ];
		    if ( b ) {
			var c = Array.prototype.slice.call( arguments );
			c.shift();
			for ( var d = 0; d < b.length; d++ ) b[ d ].apply( f, c )
		    }
		}, Ea = function () {
		    return ( new Date ).getTime()
		}, Fa = function ( a ) {
		    ja = a, f.bg.style.opacity = a * i.bgOpacity
		},
		Ga = function ( a, b, c, d, e ) {
		    ( !ya || e && e !== f.currItem ) && ( d /= e ? e.fitRatio : f.currItem.fitRatio ), a[ E ] = u + b + "px, " + c + "px" + v + " scale(" + d + ")"
		}, Ha = function ( a ) {
		    ea && ( a && ( s > f.currItem.fitRatio ? ya || ( mc( f.currItem, !1, !0 ), ya = !0 ) : ya && ( mc( f.currItem ), ya = !1 ) ), Ga( ea, pa.x, pa.y, s ) )
		}, Ia = function ( a ) {
		    a.container && Ga( a.container.style, a.initialPosition.x, a.initialPosition.y, a.initialZoomLevel, a )
		}, Ja = function ( a, b ) {
		    b[ E ] = u + a + "px, 0px" + v
		}, Ka = function ( a, b ) {
		    if ( !i.loop && b ) {
			var c = m + ( ta.x * ra - a ) / ta.x, d = Math.round( a - tb.x );
			( c < 0 && d > 0 || c >= ac() - 1 && d < 0 ) && ( a = tb.x + d * i.mainScrollEndFriction )
		    }
		    tb.x = a, Ja( a, n )
		}, La = function ( a, b ) {
		    var c = ub[ a ] - sa[ a ];
		    return oa[ a ] + na[ a ] + c - c * ( b / t )
		}, Ma = function ( a, b ) {
		    a.x = b.x, a.y = b.y, b.id && ( a.id = b.id )
		}, Na = function ( a ) {
		    a.x = Math.round( a.x ), a.y = Math.round( a.y )
		}, Oa = null,
		Pa = function () {
		    Oa && ( e.unbind( document, "mousemove", Pa ), e.addClass( a, "pswp--has_mouse" ), i.mouseUsed = !0, Da( "mouseUsed" ) ), Oa = setTimeout( function () {
			Oa = null
		    }, 100 )
		}, Qa = function () {
		    e.bind( document, "keydown", f ), N.transform && e.bind( f.scrollWrap, "click", f ), i.mouseUsed || e.bind( document, "mousemove", Pa ), e.bind( window, "resize scroll orientationchange", f ), Da( "bindEvents" )
		}, Ra = function () {
		    e.unbind( window, "resize scroll orientationchange", f ), e.unbind( window, "scroll", r.scroll ), e.unbind( document, "keydown", f ), e.unbind( document, "mousemove", Pa ), N.transform && e.unbind( f.scrollWrap, "click", f ), V && e.unbind( window, p, f ), clearTimeout( O ), Da( "unbindEvents" )
		}, Sa = function ( a, b ) {
		    var c = ic( f.currItem, qa, a );
		    return b && ( da = c ), c
		}, Ta = function ( a ) {
		    return a || ( a = f.currItem ), a.initialZoomLevel
		}, Ua = function ( a ) {
		    return a || ( a = f.currItem ), a.w > 0 ? i.maxSpreadZoom : 1
		},
		Va = function ( a, b, c, d ) {
		    return d === f.currItem.initialZoomLevel ? ( c[ a ] = f.currItem.initialPosition[ a ], !0 ) : ( c[ a ] = La( a, d ), c[ a ] > b.min[ a ] ? ( c[ a ] = b.min[ a ], !0 ) : c[ a ] < b.max[ a ] && ( c[ a ] = b.max[ a ], !0 ) )
		}, Wa = function () {
		    if ( E ) {
			var b = N.perspective && !G;
			return u = "translate" + ( b ? "3d(" : "(" ), void ( v = N.perspective ? ", 0px)" : ")" )
		    }
		    E = "left", e.addClass( a, "pswp--ie" ), Ja = function ( a, b ) {
			b.left = a + "px"
		    }, Ia = function ( a ) {
			var b = a.fitRatio > 1 ? 1 : a.fitRatio, c = a.container.style, d = b * a.w, e = b * a.h;
			c.width = d + "px", c.height = e + "px", c.left = a.initialPosition.x + "px", c.top = a.initialPosition.y + "px"
		    }, Ha = function () {
			if ( ea ) {
			    var a = ea, b = f.currItem, c = b.fitRatio > 1 ? 1 : b.fitRatio, d = c * b.w, e = c * b.h;
			    a.width = d + "px", a.height = e + "px", a.left = pa.x + "px", a.top = pa.y + "px"
			}
		    }
		}, Xa = function ( a ) {
		    var b = "";
		    i.escKey && 27 === a.keyCode ? b = "close" : i.arrowKeys && ( 37 === a.keyCode ? b = "prev" : 39 === a.keyCode && ( b = "next" ) ), b && ( a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || ( a.preventDefault ? a.preventDefault() : a.returnValue = !1, f[ b ]() ) )
		}, Ya = function ( a ) {
		    a && ( Y || X || fa || T ) && ( a.preventDefault(), a.stopPropagation() )
		}, Za = function () {
		    f.setScrollOffset( 0, e.getScrollY() )
		}, $a = {}, _a = 0,
		ab = function ( a ) {
		    $a[ a ] && ( $a[ a ].raf && I( $a[ a ].raf ), _a--, delete $a[ a ] )
		}, bb = function ( a ) {
		    $a[ a ] && ab( a ), $a[ a ] || ( _a++, $a[ a ] = {} )
		}, cb = function () {
		    for ( var a in $a ) $a.hasOwnProperty( a ) && ab( a )
		},
		db = function ( a, b, c, d, e, f, g ) {
		    var h, i = Ea();
		    bb( a );
		    var j = function () {
			if ( $a[ a ] ) {
			    if ( h = Ea() - i, h >= d ) return ab( a ), f( c ), void ( g && g() );
			    f( ( c - b ) * e( h / d ) + b ), $a[ a ].raf = H( j )
			}
		    };
		    j()
		}, eb = {
		    shout: Da, listen: Ca, viewportSize: qa, options: i,
		    isMainScrollAnimating: function () {
			return fa
		    }, getZoomLevel: function () {
			return s
		    }, getCurrentIndex: function () {
			return m
		    }, isDragging: function () {
			return V
		    }, isZooming: function () {
			return aa
		    }, setScrollOffset: function ( a, b ) {
			sa.x = a, M = sa.y = b, Da( "updateScrollOffset", sa )
		    }, applyZoomPan: function ( a, b, c, d ) {
			pa.x = b, pa.y = c, s = a, Ha( d )
		    }, init: function () {
			if ( !j && !k ) {
			    var c;
			    f.framework = e, f.template = a, f.bg = e.getChildByClass( a, "pswp__bg" ), J = a.className, j = !0, N = e.detectFeatures(), H = N.raf, I = N.caf, E = N.transform, L = N.oldIE, f.scrollWrap = e.getChildByClass( a, "pswp__scroll-wrap" ), f.container = e.getChildByClass( f.scrollWrap, "pswp__container" ), n = f.container.style, f.itemHolders = y = [ {
				el: f.container.children[ 0 ], wrap: 0, index: -1
			    }, { el: f.container.children[ 1 ], wrap: 0, index: -1 }, {
				el: f.container.children[ 2 ], wrap: 0, index: -1
			    } ], y[ 0 ].el.style.display = y[ 2 ].el.style.display = "none", Wa(), r = {
				resize: f.updateSize, orientationchange: function () {
				    clearTimeout( O ), O = setTimeout( function () {
					qa.x !== f.scrollWrap.clientWidth && f.updateSize()
				    }, 500 )
				}, scroll: Za, keydown: Xa, click: Ya
			    };
			    var d = N.isOldIOSPhone || N.isOldAndroid || N.isMobileOpera;
			    for ( N.animationName && N.transform && !d || ( i.showAnimationDuration = i.hideAnimationDuration = 0 ), c = 0; c < wa.length; c++ ) f[ "init" + wa[ c ] ]();
			    if ( b ) {
				var g = f.ui = new b( f, e );
				g.init()
			    }
			    Da( "firstUpdate" ), m = m || i.index || 0, ( isNaN( m ) || m < 0 || m >= ac() ) && ( m = 0 ), f.currItem = _b( m ), ( N.isOldIOSPhone || N.isOldAndroid ) && ( va = !1 ), a.setAttribute( "aria-hidden", "false" ), i.modal && ( va ? a.style.position = "fixed" : ( a.style.position = "absolute", a.style.top = e.getScrollY() + "px" ) ), void 0 === M && ( Da( "initialLayout" ), M = K = e.getScrollY() );
			    var l = "pswp--open ";
			    for ( i.mainClass && ( l += i.mainClass + " " ), i.showHideOpacity && ( l += "pswp--animate_opacity " ), l += G ? "pswp--touch" : "pswp--notouch", l += N.animationName ? " pswp--css_animation" : "", l += N.svg ? " pswp--svg" : "", e.addClass( a, l ), f.updateSize(), o = -1, ua = null, c = 0; c < h; c++ ) Ja( ( c + o ) * ta.x, y[ c ].el.style );
			    L || e.bind( f.scrollWrap, q, f ), Ca( "initialZoomInEnd", function () {
				f.setContent( y[ 0 ], m - 1 ), f.setContent( y[ 2 ], m + 1 ), y[ 0 ].el.style.display = y[ 2 ].el.style.display = "block", i.focus && a.focus(), Qa()
			    } ), f.setContent( y[ 1 ], m ), f.updateCurrItem(), Da( "afterInit" ), va || ( w = setInterval( function () {
				_a || V || aa || s !== f.currItem.initialZoomLevel || f.updateSize()
			    }, 1e3 ) ), e.addClass( a, "pswp--visible" )
			}
		    }, close: function () {
			j && ( j = !1, k = !0, Da( "close" ), Ra(), cc( f.currItem, null, !0, f.destroy ) )
		    }, destroy: function () {
			Da( "destroy" ), Xb && clearTimeout( Xb ), a.setAttribute( "aria-hidden", "true" ), a.className = J, w && clearInterval( w ), e.unbind( f.scrollWrap, q, f ), e.unbind( window, "scroll", f ), zb(), cb(), Ba = null
		    }, panTo: function ( a, b, c ) {
			c || ( a > da.min.x ? a = da.min.x : a < da.max.x && ( a = da.max.x ), b > da.min.y ? b = da.min.y : b < da.max.y && ( b = da.max.y ) ), pa.x = a, pa.y = b, Ha()
		    }, handleEvent: function ( a ) {
			a = a || window.event, r[ a.type ] && r[ a.type ]( a )
		    }, goTo: function ( a ) {
			a = Aa( a );
			var b = a - m;
			ua = b, m = a, f.currItem = _b( m ), ra -= b, Ka( ta.x * ra ), cb(), fa = !1, f.updateCurrItem()
		    }, next: function () {
			f.goTo( m + 1 )
		    }, prev: function () {
			f.goTo( m - 1 )
		    }, updateCurrZoomItem: function ( a ) {
			if ( a && Da( "beforeChange", 0 ), y[ 1 ].el.children.length ) {
			    var b = y[ 1 ].el.children[ 0 ];
			    ea = e.hasClass( b, "pswp__zoom-wrap" ) ? b.style : null
			} else ea = null;
			da = f.currItem.bounds, t = s = f.currItem.initialZoomLevel, pa.x = da.center.x, pa.y = da.center.y, a && Da( "afterChange" )
		    }, invalidateCurrItems: function () {
			x = !0;
			for ( var a = 0; a < h; a++ ) y[ a ].item && ( y[ a ].item.needsUpdate = !0 )
		    }, updateCurrItem: function ( a ) {
			if ( 0 !== ua ) {
			    var b, c = Math.abs( ua );
			    if ( !( a && c < 2 ) ) {
				f.currItem = _b( m ), ya = !1, Da( "beforeChange", ua ), c >= h && ( o += ua + ( ua > 0 ? -h : h ), c = h );
				for ( var d = 0; d < c; d++ ) ua > 0 ? ( b = y.shift(), y[ h - 1 ] = b, o++, Ja( ( o + 2 ) * ta.x, b.el.style ), f.setContent( b, m - c + d + 1 + 1 ) ) : ( b = y.pop(), y.unshift( b ), o--, Ja( o * ta.x, b.el.style ), f.setContent( b, m + c - d - 1 - 1 ) );
				if ( ea && 1 === Math.abs( ua ) ) {
				    var e = _b( z );
				    e.initialZoomLevel !== s && ( ic( e, qa ), mc( e ), Ia( e ) )
				}
				ua = 0, f.updateCurrZoomItem(), z = m, Da( "afterChange" )
			    }
			}
		    }, updateSize: function ( b ) {
			if ( !va && i.modal ) {
			    var c = e.getScrollY();
			    if ( M !== c && ( a.style.top = c + "px", M = c ), !b && xa.x === window.innerWidth && xa.y === window.innerHeight ) return;
			    xa.x = window.innerWidth, xa.y = window.innerHeight, a.style.height = xa.y + "px"
			}
			if ( qa.x = f.scrollWrap.clientWidth, qa.y = f.scrollWrap.clientHeight, Za(), ta.x = qa.x + Math.round( qa.x * i.spacing ), ta.y = qa.y, Ka( ta.x * ra ), Da( "beforeResize" ), void 0 !== o ) {
			    for ( var d, g, j, k = 0; k < h; k++ ) d = y[ k ], Ja( ( k + o ) * ta.x, d.el.style ), j = m + k - 1, i.loop && ac() > 2 && ( j = Aa( j ) ), g = _b( j ), g && ( x || g.needsUpdate || !g.bounds ) ? ( f.cleanSlide( g ), f.setContent( d, j ), 1 === k && ( f.currItem = g, f.updateCurrZoomItem( !0 ) ), g.needsUpdate = !1 ) : d.index === -1 && j >= 0 && f.setContent( d, j ), g && g.container && ( ic( g, qa ), mc( g ), Ia( g ) );
			    x = !1
			}
			t = s = f.currItem.initialZoomLevel, da = f.currItem.bounds, da && ( pa.x = da.center.x, pa.y = da.center.y, Ha( !0 ) ), Da( "resize" )
		    }, zoomTo: function ( a, b, c, d, f ) {
			b && ( t = s, ub.x = Math.abs( b.x ) - pa.x, ub.y = Math.abs( b.y ) - pa.y, Ma( oa, pa ) );
			var g = Sa( a, !1 ), h = {};
			Va( "x", g, h, a ), Va( "y", g, h, a );
			var i = s, j = { x: pa.x, y: pa.y };
			Na( h );
			var k = function ( b ) {
			    1 === b ? ( s = a, pa.x = h.x, pa.y = h.y ) : ( s = ( a - i ) * b + i, pa.x = ( h.x - j.x ) * b + j.x, pa.y = ( h.y - j.y ) * b + j.y ), f && f( b ), Ha( 1 === b )
			};
			c ? db( "customZoomTo", 0, 1, c, d || e.easing.sine.inOut, k ) : k( 1 )
		    }
		}, fb = 30, gb = 10, hb = {},
		ib = {}, jb = {}, kb = {},
		lb = {}, mb = [], nb = {},
		ob = [], pb = {}, qb = 0,
		rb = ma(), sb = 0,
		tb = ma(), ub = ma(),
		vb = ma(),
		wb = function ( a, b ) {
		    return a.x === b.x && a.y === b.y
		}, xb = function ( a, b ) {
		    return Math.abs( a.x - b.x ) < g && Math.abs( a.y - b.y ) < g
		}, yb = function ( a, b ) {
		    return pb.x = Math.abs( a.x - b.x ), pb.y = Math.abs( a.y - b.y ), Math.sqrt( pb.x * pb.x + pb.y * pb.y )
		}, zb = function () {
		    Z && ( I( Z ), Z = null )
		}, Ab = function () {
		    V && ( Z = H( Ab ), Qb() )
		}, Bb = function () {
		    return !( "fit" === i.scaleMode && s === f.currItem.initialZoomLevel )
		}, Cb = function ( a, b ) {
		    return !( !a || a === document ) && ( !( a.getAttribute( "class" ) && a.getAttribute( "class" ).indexOf( "pswp__scroll-wrap" ) > -1 ) && ( b( a ) ? a : Cb( a.parentNode, b ) ) )
		}, Db = {},
		Eb = function ( a, b ) {
		    return Db.prevent = !Cb( a.target, i.isClickableElement ), Da( "preventDragEvent", a, b, Db ), Db.prevent
		}, Fb = function ( a, b ) {
		    return b.x = a.pageX, b.y = a.pageY, b.id = a.identifier, b
		},
		Gb = function ( a, b, c ) {
		    c.x = .5 * ( a.x + b.x ), c.y = .5 * ( a.y + b.y )
		},
		Hb = function ( a, b, c ) {
		    if ( a - Q > 50 ) {
			var d = ob.length > 2 ? ob.shift() : {};
			d.x = b, d.y = c, ob.push( d ), Q = a
		    }
		}, Ib = function () {
		    var a = pa.y - f.currItem.initialPosition.y;
		    return 1 - Math.abs( a / ( qa.y / 2 ) )
		}, Jb = {}, Kb = {}, Lb = [],
		Mb = function ( a ) {
		    for ( ; Lb.length > 0; ) Lb.pop();
		    return F ? ( la = 0, mb.forEach( function ( a ) {
			0 === la ? Lb[ 0 ] = a : 1 === la && ( Lb[ 1 ] = a ), la++
		    } ) ) : a.type.indexOf( "touch" ) > -1 ? a.touches && a.touches.length > 0 && ( Lb[ 0 ] = Fb( a.touches[ 0 ], Jb ), a.touches.length > 1 && ( Lb[ 1 ] = Fb( a.touches[ 1 ], Kb ) ) ) : ( Jb.x = a.pageX, Jb.y = a.pageY, Jb.id = "", Lb[ 0 ] = Jb ), Lb
		}, Nb = function ( a, b ) {
		    var c, d, e, g, h = 0, j = pa[ a ] + b[ a ], k = b[ a ] > 0, l = tb.x + b.x, m = tb.x - nb.x;
		    return c = j > da.min[ a ] || j < da.max[ a ] ? i.panEndFriction : 1, j = pa[ a ] + b[ a ] * c, !i.allowPanToNext && s !== f.currItem.initialZoomLevel || ( ea ? "h" !== ga || "x" !== a || X || ( k ? ( j > da.min[ a ] && ( c = i.panEndFriction, h = da.min[ a ] - j, d = da.min[ a ] - oa[ a ] ), ( d <= 0 || m < 0 ) && ac() > 1 ? ( g = l, m < 0 && l > nb.x && ( g = nb.x ) ) : da.min.x !== da.max.x && ( e = j ) ) : ( j < da.max[ a ] && ( c = i.panEndFriction, h = j - da.max[ a ], d = oa[ a ] - da.max[ a ] ), ( d <= 0 || m > 0 ) && ac() > 1 ? ( g = l, m > 0 && l < nb.x && ( g = nb.x ) ) : da.min.x !== da.max.x && ( e = j ) ) ) : g = l, "x" !== a ) ? void ( fa || $ || s > f.currItem.fitRatio && ( pa[ a ] += b[ a ] * c ) ) : ( void 0 !== g && ( Ka( g, !0 ), $ = g !== nb.x ), da.min.x !== da.max.x && ( void 0 !== e ? pa.x = e : $ || ( pa.x += b.x * c ) ), void 0 !== g )
		}, Ob = function ( a ) {
		    if ( !( "mousedown" === a.type && a.button > 0 ) ) {
			if ( $b ) return void a.preventDefault();
			if ( !U || "mousedown" !== a.type ) {
			    if ( Eb( a, !0 ) && a.preventDefault(), Da( "pointerDown" ), F ) {
				var b = e.arraySearch( mb, a.pointerId, "id" );
				b < 0 && ( b = mb.length ), mb[ b ] = { x: a.pageX, y: a.pageY, id: a.pointerId }
			    }
			    var c = Mb( a ), d = c.length;
			    _ = null, cb(), V && 1 !== d || ( V = ha = !0, e.bind( window, p, f ), S = ka = ia = T = $ = Y = W = X = !1, ga = null, Da( "firstTouchStart", c ), Ma( oa, pa ), na.x = na.y = 0, Ma( kb, c[ 0 ] ), Ma( lb, kb ), nb.x = ta.x * ra, ob = [ {
				x: kb.x, y: kb.y
			    } ], Q = P = Ea(), Sa( s, !0 ), zb(), Ab() ), !aa && d > 1 && !fa && !$ && ( t = s, X = !1, aa = W = !0, na.y = na.x = 0, Ma( oa, pa ), Ma( hb, c[ 0 ] ), Ma( ib, c[ 1 ] ), Gb( hb, ib, vb ), ub.x = Math.abs( vb.x ) - pa.x, ub.y = Math.abs( vb.y ) - pa.y, ba = ca = yb( hb, ib ) )
			}
		    }
		}, Pb = function ( a ) {
		    if ( a.preventDefault(), F ) {
			var b = e.arraySearch( mb, a.pointerId, "id" );
			if ( b > -1 ) {
			    var c = mb[ b ];
			    c.x = a.pageX, c.y = a.pageY
			}
		    }
		    if ( V ) {
			var d = Mb( a );
			if ( ga || Y || aa ) _ = d; else if ( tb.x !== ta.x * ra ) ga = "h"; else {
			    var f = Math.abs( d[ 0 ].x - kb.x ) - Math.abs( d[ 0 ].y - kb.y );
			    Math.abs( f ) >= gb && ( ga = f > 0 ? "h" : "v", _ = d )
			}
		    }
		}, Qb = function () {
		    if ( _ ) {
			var a = _.length;
			if ( 0 !== a ) if ( Ma( hb, _[ 0 ] ), jb.x = hb.x - kb.x, jb.y = hb.y - kb.y, aa && a > 1 ) {
			    if ( kb.x = hb.x, kb.y = hb.y, !jb.x && !jb.y && wb( _[ 1 ], ib ) ) return;
			    Ma( ib, _[ 1 ] ), X || ( X = !0, Da( "zoomGestureStarted" ) );
			    var b = yb( hb, ib ), c = Vb( b );
			    c > f.currItem.initialZoomLevel + f.currItem.initialZoomLevel / 15 && ( ka = !0 );
			    var d = 1, e = Ta(), g = Ua();
			    if ( c < e ) if ( i.pinchToClose && !ka && t <= f.currItem.initialZoomLevel ) {
				var h = e - c, j = 1 - h / ( e / 1.2 );
				Fa( j ), Da( "onPinchClose", j ), ia = !0
			    } else d = ( e - c ) / e, d > 1 && ( d = 1 ), c = e - d * ( e / 3 ); else c > g && ( d = ( c - g ) / ( 6 * e ), d > 1 && ( d = 1 ), c = g + d * e );
			    d < 0 && ( d = 0 ), ba = b, Gb( hb, ib, rb ), na.x += rb.x - vb.x, na.y += rb.y - vb.y, Ma( vb, rb ), pa.x = La( "x", c ), pa.y = La( "y", c ), S = c > s, s = c, Ha()
			} else {
			    if ( !ga ) return;
			    if ( ha && ( ha = !1, Math.abs( jb.x ) >= gb && ( jb.x -= _[ 0 ].x - lb.x ), Math.abs( jb.y ) >= gb && ( jb.y -= _[ 0 ].y - lb.y ) ), kb.x = hb.x, kb.y = hb.y, 0 === jb.x && 0 === jb.y ) return;
			    if ( "v" === ga && i.closeOnVerticalDrag && !Bb() ) {
				na.y += jb.y, pa.y += jb.y;
				var k = Ib();
				return T = !0, Da( "onVerticalDrag", k ), Fa( k ), void Ha()
			    }
			    Hb( Ea(), hb.x, hb.y ), Y = !0, da = f.currItem.bounds;
			    var l = Nb( "x", jb );
			    l || ( Nb( "y", jb ), Na( pa ), Ha() )
			}
		    }
		}, Rb = function ( a ) {
		    if ( N.isOldAndroid ) {
			if ( U && "mouseup" === a.type ) return;
			a.type.indexOf( "touch" ) > -1 && ( clearTimeout( U ), U = setTimeout( function () {
			    U = 0
			}, 600 ) )
		    }
		    Da( "pointerUp" ), Eb( a, !1 ) && a.preventDefault();
		    var b;
		    if ( F ) {
			var c = e.arraySearch( mb, a.pointerId, "id" );
			if ( c > -1 ) if ( b = mb.splice( c, 1 )[ 0 ], navigator.msPointerEnabled ) {
			    var d = { 4: "mouse", 2: "touch", 3: "pen" };
			    b.type = d[ a.pointerType ], b.type || ( b.type = a.pointerType || "mouse" )
			} else b.type = a.pointerType || "mouse"
		    }
		    var g, h = Mb( a ), j = h.length;
		    if ( "mouseup" === a.type && ( j = 0 ), 2 === j ) return _ = null, !0;
		    1 === j && Ma( lb, h[ 0 ] ), 0 !== j || ga || fa || ( b || ( "mouseup" === a.type ? b = {
			x: a.pageX, y: a.pageY, type: "mouse"
		    } : a.changedTouches && a.changedTouches[ 0 ] && ( b = {
			x: a.changedTouches[ 0 ].pageX, y: a.changedTouches[ 0 ].pageY, type: "touch"
		    } ) ), Da( "touchRelease", a, b ) );
		    var k = -1;
		    if ( 0 === j && ( V = !1, e.unbind( window, p, f ), zb(), aa ? k = 0 : sb !== -1 && ( k = Ea() - sb ) ), sb = 1 === j ? Ea() : -1, g = k !== -1 && k < 150 ? "zoom" : "swipe", aa && j < 2 && ( aa = !1, 1 === j && ( g = "zoomPointerUp" ), Da( "zoomGestureEnded" ) ), _ = null, Y || X || fa || T ) if ( cb(), R || ( R = Sb() ), R.calculateSwipeSpeed( "x" ), T ) {
			var l = Ib();
			if ( l < i.verticalDragRange ) f.close(); else {
			    var m = pa.y, n = ja;
			    db( "verticalDrag", 0, 1, 300, e.easing.cubic.out, function ( a ) {
				pa.y = ( f.currItem.initialPosition.y - m ) * a + m, Fa( ( 1 - n ) * a + n ), Ha()
			    } ), Da( "onVerticalDrag", 1 )
			}
		    } else {
			if ( ( $ || fa ) && 0 === j ) {
			    var o = Ub( g, R );
			    if ( o ) return;
			    g = "zoomPointerUp"
			}
			if ( !fa ) return "swipe" !== g ? void Wb() : void ( !$ && s > f.currItem.fitRatio && Tb( R ) )
		    }
		}, Sb = function () {
		    var a, b, c = {
			lastFlickOffset: {}, lastFlickDist: {}, lastFlickSpeed: {}, slowDownRatio: {},
			slowDownRatioReverse: {}, speedDecelerationRatio: {}, speedDecelerationRatioAbs: {},
			distanceOffset: {}, backAnimDestination: {}, backAnimStarted: {},
			calculateSwipeSpeed: function ( d ) {
			    ob.length > 1 ? ( a = Ea() - Q + 50, b = ob[ ob.length - 2 ][ d ] ) : ( a = Ea() - P, b = lb[ d ] ), c.lastFlickOffset[ d ] = kb[ d ] - b, c.lastFlickDist[ d ] = Math.abs( c.lastFlickOffset[ d ] ), c.lastFlickDist[ d ] > 20 ? c.lastFlickSpeed[ d ] = c.lastFlickOffset[ d ] / a : c.lastFlickSpeed[ d ] = 0, Math.abs( c.lastFlickSpeed[ d ] ) < .1 && ( c.lastFlickSpeed[ d ] = 0 ), c.slowDownRatio[ d ] = .95, c.slowDownRatioReverse[ d ] = 1 - c.slowDownRatio[ d ], c.speedDecelerationRatio[ d ] = 1
			}, calculateOverBoundsAnimOffset: function ( a, b ) {
			    c.backAnimStarted[ a ] || ( pa[ a ] > da.min[ a ] ? c.backAnimDestination[ a ] = da.min[ a ] : pa[ a ] < da.max[ a ] && ( c.backAnimDestination[ a ] = da.max[ a ] ), void 0 !== c.backAnimDestination[ a ] && ( c.slowDownRatio[ a ] = .7, c.slowDownRatioReverse[ a ] = 1 - c.slowDownRatio[ a ], c.speedDecelerationRatioAbs[ a ] < .05 && ( c.lastFlickSpeed[ a ] = 0, c.backAnimStarted[ a ] = !0, db( "bounceZoomPan" + a, pa[ a ], c.backAnimDestination[ a ], b || 300, e.easing.sine.out, function ( b ) {
				pa[ a ] = b, Ha()
			    } ) ) ) )
			}, calculateAnimOffset: function ( a ) {
			    c.backAnimStarted[ a ] || ( c.speedDecelerationRatio[ a ] = c.speedDecelerationRatio[ a ] * ( c.slowDownRatio[ a ] + c.slowDownRatioReverse[ a ] - c.slowDownRatioReverse[ a ] * c.timeDiff / 10 ), c.speedDecelerationRatioAbs[ a ] = Math.abs( c.lastFlickSpeed[ a ] * c.speedDecelerationRatio[ a ] ), c.distanceOffset[ a ] = c.lastFlickSpeed[ a ] * c.speedDecelerationRatio[ a ] * c.timeDiff, pa[ a ] += c.distanceOffset[ a ] )
			}, panAnimLoop: function () {
			    if ( $a.zoomPan && ( $a.zoomPan.raf = H( c.panAnimLoop ), c.now = Ea(), c.timeDiff = c.now - c.lastNow, c.lastNow = c.now, c.calculateAnimOffset( "x" ), c.calculateAnimOffset( "y" ), Ha(), c.calculateOverBoundsAnimOffset( "x" ), c.calculateOverBoundsAnimOffset( "y" ), c.speedDecelerationRatioAbs.x < .05 && c.speedDecelerationRatioAbs.y < .05 ) ) return pa.x = Math.round( pa.x ), pa.y = Math.round( pa.y ), Ha(), void ab( "zoomPan" )
			}
		    };
		    return c
		}, Tb = function ( a ) {
		    return a.calculateSwipeSpeed( "y" ), da = f.currItem.bounds, a.backAnimDestination = {}, a.backAnimStarted = {}, Math.abs( a.lastFlickSpeed.x ) <= .05 && Math.abs( a.lastFlickSpeed.y ) <= .05 ? ( a.speedDecelerationRatioAbs.x = a.speedDecelerationRatioAbs.y = 0, a.calculateOverBoundsAnimOffset( "x" ), a.calculateOverBoundsAnimOffset( "y" ), !0 ) : ( bb( "zoomPan" ), a.lastNow = Ea(), void a.panAnimLoop() )
		}, Ub = function ( a, b ) {
		    var c;
		    fa || ( qb = m );
		    var d;
		    if ( "swipe" === a ) {
			var g = kb.x - lb.x, h = b.lastFlickDist.x < 10;
			g > fb && ( h || b.lastFlickOffset.x > 20 ) ? d = -1 : g < -fb && ( h || b.lastFlickOffset.x < -20 ) && ( d = 1 )
		    }
		    var j;
		    d && ( m += d, m < 0 ? ( m = i.loop ? ac() - 1 : 0, j = !0 ) : m >= ac() && ( m = i.loop ? 0 : ac() - 1, j = !0 ), j && !i.loop || ( ua += d, ra -= d, c = !0 ) );
		    var k, l = ta.x * ra, n = Math.abs( l - tb.x );
		    return c || l > tb.x == b.lastFlickSpeed.x > 0 ? ( k = Math.abs( b.lastFlickSpeed.x ) > 0 ? n / Math.abs( b.lastFlickSpeed.x ) : 333, k = Math.min( k, 400 ), k = Math.max( k, 250 ) ) : k = 333, qb === m && ( c = !1 ), fa = !0, Da( "mainScrollAnimStart" ), db( "mainScroll", tb.x, l, k, e.easing.cubic.out, Ka, function () {
			cb(), fa = !1, qb = -1, ( c || qb !== m ) && f.updateCurrItem(), Da( "mainScrollAnimComplete" )
		    } ), c && f.updateCurrItem( !0 ), c
		}, Vb = function ( a ) {
		    return 1 / ca * a * t
		}, Wb = function () {
		    var a = s, b = Ta(), c = Ua();
		    s < b ? a = b : s > c && ( a = c );
		    var d, g = 1, h = ja;
		    return ia && !S && !ka && s < b ? ( f.close(), !0 ) : ( ia && ( d = function ( a ) {
			Fa( ( g - h ) * a + h )
		    } ), f.zoomTo( a, 0, 200, e.easing.cubic.out, d ), !0 )
		};
	    za( "Gestures", {
		publicMethods: {
		    initGestures: function () {
			var a = function ( a, b, c, d, e ) {
			    A = a + b, B = a + c, C = a + d, D = e ? a + e : ""
			};
			F = N.pointerEvent, F && N.touch && ( N.touch = !1 ), F ? navigator.msPointerEnabled ? a( "MSPointer", "Down", "Move", "Up", "Cancel" ) : a( "pointer", "down", "move", "up", "cancel" ) : N.touch ? ( a( "touch", "start", "move", "end", "cancel" ), G = !0 ) : a( "mouse", "down", "move", "up" ), p = B + " " + C + " " + D, q = A, F && !G && ( G = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1 ), f.likelyTouchDevice = G, r[ A ] = Ob, r[ B ] = Pb, r[ C ] = Rb, D && ( r[ D ] = r[ C ] ), N.touch && ( q += " mousedown", p += " mousemove mouseup", r.mousedown = r[ A ], r.mousemove = r[ B ], r.mouseup = r[ C ] ), G || ( i.allowPanToNext = !1 )
		    }
		}
	    } );
	    var Xb, Yb, Zb, $b, _b, ac, bc, cc = function ( b, c, d, g ) {
		Xb && clearTimeout( Xb ), $b = !0, Zb = !0;
		var h;
		b.initialLayout ? ( h = b.initialLayout, b.initialLayout = null ) : h = i.getThumbBoundsFn && i.getThumbBoundsFn( m );
		var j = d ? i.hideAnimationDuration : i.showAnimationDuration, k = function () {
		    ab( "initialZoom" ), d ? ( f.template.removeAttribute( "style" ), f.bg.removeAttribute( "style" ) ) : ( Fa( 1 ), c && ( c.style.display = "block" ), e.addClass( a, "pswp--animated-in" ), Da( "initialZoom" + ( d ? "OutEnd" : "InEnd" ) ) ), g && g(), $b = !1
		};
		if ( !j || !h || void 0 === h.x ) return Da( "initialZoom" + ( d ? "Out" : "In" ) ), s = b.initialZoomLevel, Ma( pa, b.initialPosition ), Ha(), a.style.opacity = d ? 0 : 1, Fa( 1 ), void ( j ? setTimeout( function () {
		    k()
		}, j ) : k() );
		var n = function () {
		    var c = l, g = !f.currItem.src || f.currItem.loadError || i.showHideOpacity;
		    b.miniImg && ( b.miniImg.style.webkitBackfaceVisibility = "hidden" ), d || ( s = h.w / b.w, pa.x = h.x, pa.y = h.y - K, f[ g ? "template" : "bg" ].style.opacity = .001, Ha() ), bb( "initialZoom" ), d && !c && e.removeClass( a, "pswp--animated-in" ), g && ( d ? e[ ( c ? "remove" : "add" ) + "Class" ]( a, "pswp--animate_opacity" ) : setTimeout( function () {
			e.addClass( a, "pswp--animate_opacity" )
		    }, 30 ) ), Xb = setTimeout( function () {
			if ( Da( "initialZoom" + ( d ? "Out" : "In" ) ), d ) {
			    var f = h.w / b.w, i = { x: pa.x, y: pa.y }, l = s, m = ja, n = function ( b ) {
				1 === b ? ( s = f, pa.x = h.x, pa.y = h.y - M ) : ( s = ( f - l ) * b + l, pa.x = ( h.x - i.x ) * b + i.x, pa.y = ( h.y - M - i.y ) * b + i.y ), Ha(), g ? a.style.opacity = 1 - b : Fa( m - b * m )
			    };
			    c ? db( "initialZoom", 0, 1, j, e.easing.cubic.out, n, k ) : ( n( 1 ), Xb = setTimeout( k, j + 20 ) )
			} else s = b.initialZoomLevel, Ma( pa, b.initialPosition ), Ha(), Fa( 1 ), g ? a.style.opacity = 1 : Fa( 1 ), Xb = setTimeout( k, j + 20 )
		    }, d ? 25 : 90 )
		};
		n()
	    }, dc                              = {}, ec = [], fc = {
		index                  : 0,
		errorMsg               : '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
		forceProgressiveLoading: !1, preload: [ 1, 1 ], getNumItemsFn: function () {
		    return Yb.length
		}
	    }, gc                              = function () {
		return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } }
	    }, hc                              = function ( a, b, c ) {
		var d = a.bounds;
		d.center.x = Math.round( ( dc.x - b ) / 2 ), d.center.y = Math.round( ( dc.y - c ) / 2 ) + a.vGap.top, d.max.x = b > dc.x ? Math.round( dc.x - b ) : d.center.x, d.max.y = c > dc.y ? Math.round( dc.y - c ) + a.vGap.top : d.center.y, d.min.x = b > dc.x ? 0 : d.center.x, d.min.y = c > dc.y ? a.vGap.top : d.center.y
	    }, ic                              = function ( a, b, c ) {
		if ( a.src && !a.loadError ) {
		    var d = !c;
		    if ( d && ( a.vGap || ( a.vGap = {
			top: 0, bottom: 0
		    } ), Da( "parseVerticalMargin", a ) ), dc.x = b.x, dc.y = b.y - a.vGap.top - a.vGap.bottom, d ) {
			var e      = dc.x / a.w, f = dc.y / a.h;
			a.fitRatio = e < f ? e : f;
			var g      = i.scaleMode;
			"orig" === g ? c = 1 : "fit" === g && ( c = a.fitRatio ), c > 1 && ( c = 1 ), a.initialZoomLevel = c, a.bounds || ( a.bounds = gc() )
		    }
		    if ( !c ) return;
		    return hc( a, a.w * c, a.h * c ), d && c === a.initialZoomLevel && ( a.initialPosition = a.bounds.center ), a.bounds
		}
		return a.w = a.h = 0, a.initialZoomLevel = a.fitRatio = 1, a.bounds = gc(), a.initialPosition = a.bounds.center, a.bounds
	    }, jc                              = function ( a, b, c, d, e, g ) {
		b.loadError || d && ( b.imageAppended = !0, mc( b, d, b === f.currItem && ya ), c.appendChild( d ), g && setTimeout( function () {
		    b && b.loaded && b.placeholder && ( b.placeholder.style.display = "none", b.placeholder = null )
		}, 500 ) )
	    }, kc                              = function ( a ) {
		a.loading = !0, a.loaded = !1;
		var b = a.img = e.createEl( "pswp__img", "img" ), c = function () {
		    a.loading = !1, a.loaded = !0, a.loadComplete ? a.loadComplete( a ) : a.img = null, b.onload = b.onerror = null, b = null
		};
		return b.onload = c, b.onerror = function () {
		    a.loadError = !0, c()
		}, b.src = a.src, b
	    }, lc                              = function ( a, b ) {
		if ( a.src && a.loadError && a.container ) return b && ( a.container.innerHTML = "" ), a.container.innerHTML = i.errorMsg.replace( "%url%", a.src ), !0
	    }, mc                              = function ( a, b, c ) {
		if ( a.src ) {
		    b || ( b = a.container.lastChild );
		    var d = c ? a.w : Math.round( a.w * a.fitRatio ), e = c ? a.h : Math.round( a.h * a.fitRatio );
		    a.placeholder && !a.loaded && ( a.placeholder.style.width = d + "px", a.placeholder.style.height = e + "px" ), b.style.width = d + "px", b.style.height = e + "px"
		}
	    }, nc                              = function () {
		if ( ec.length ) {
		    for ( var a, b = 0; b < ec.length; b++ ) a = ec[ b ], a.holder.index === a.index && jc( a.index, a.item, a.baseDiv, a.img, !1, a.clearPlaceholder );
		    ec = []
		}
	    };
	    za( "Controller", {
		publicMethods: {
		    lazyLoadItem          : function ( a ) {
			a     = Aa( a );
			var b = _b( a );
			b && ( !b.loaded && !b.loading || x ) && ( Da( "gettingData", a, b ), b.src && kc( b ) )
		    }, initController     : function () {
			e.extend( i, fc, !0 ), f.items = Yb = c, _b = f.getItemAt, ac = i.getNumItemsFn, bc = i.loop, ac() < 3 && ( i.loop = !1 ), Ca( "beforeChange", function ( a ) {
			    var b, c = i.preload, d = null === a || a >= 0, e = Math.min( c[ 0 ], ac() ),
				g = Math.min( c[ 1 ], ac() );
			    for ( b = 1; b <= ( d ? g : e ); b++ ) f.lazyLoadItem( m + b );
			    for ( b = 1; b <= ( d ? e : g ); b++ ) f.lazyLoadItem( m - b )
			} ), Ca( "initialLayout", function () {
			    f.currItem.initialLayout = i.getThumbBoundsFn && i.getThumbBoundsFn( m )
			} ), Ca( "mainScrollAnimComplete", nc ), Ca( "initialZoomInEnd", nc ), Ca( "destroy", function () {
			    for ( var a, b = 0; b < Yb.length; b++ ) a = Yb[ b ], a.container && ( a.container = null ), a.placeholder && ( a.placeholder = null ), a.img && ( a.img = null ), a.preloader && ( a.preloader = null ), a.loadError && ( a.loaded = a.loadError = !1 );
			    ec = null
			} )
		    }, getItemAt          : function ( a ) {
			return a >= 0 && ( void 0 !== Yb[ a ] && Yb[ a ] )
		    }, allowProgressiveImg: function () {
			return i.forceProgressiveLoading || !G || i.mouseUsed || screen.width > 1200
		    }, setContent         : function ( a, b ) {
			i.loop && ( b = Aa( b ) );
			var c = f.getItemAt( a.index );
			c && ( c.container = null );
			var d, g = f.getItemAt( b );
			if ( !g ) return void ( a.el.innerHTML = "" );
			Da( "gettingData", b, g ), a.index = b, a.item = g;
			var h = g.container = e.createEl( "pswp__zoom-wrap" );
			if ( !g.src && g.html && ( g.html.tagName ? h.appendChild( g.html ) : h.innerHTML = g.html ), lc( g ), ic( g, qa ), !g.src || g.loadError || g.loaded ) g.src && !g.loadError && ( d = e.createEl( "pswp__img", "img" ), d.style.opacity = 1, d.src = g.src, mc( g, d ), jc( b, g, h, d, !0 ) ); else {
			    if ( g.loadComplete = function ( c ) {
				if ( j ) {
				    if ( a && a.index === b ) {
					if ( lc( c, !0 ) ) return c.loadComplete = c.img = null, ic( c, qa ), Ia( c ), void ( a.index === m && f.updateCurrZoomItem() );
					c.imageAppended ? !$b && c.placeholder && ( c.placeholder.style.display = "none", c.placeholder = null ) : N.transform && ( fa || $b ) ? ec.push( {
					    item: c, baseDiv: h, img: c.img, index: b, holder: a, clearPlaceholder: !0
					} ) : jc( b, c, h, c.img, fa || $b, !0 )
				    }
				    c.loadComplete = null, c.img = null, Da( "imageLoadComplete", b, c )
				}
			    }, e.features.transform ) {
				var k = "pswp__img pswp__img--placeholder";
				k += g.msrc ? "" : " pswp__img--placeholder--blank";
				var l = e.createEl( k, g.msrc ? "img" : "" );
				g.msrc && ( l.src = g.msrc ), mc( g, l ), h.appendChild( l ), g.placeholder = l
			    }
			    g.loading || kc( g ), f.allowProgressiveImg() && ( !Zb && N.transform ? ec.push( {
				item: g, baseDiv: h, img: g.img, index: b, holder: a
			    } ) : jc( b, g, h, g.img, !0, !0 ) )
			}
			Zb || b !== m ? Ia( g ) : ( ea = h.style, cc( g, d || g.img ) ), a.el.innerHTML = "", a.el.appendChild( h )
		    }, cleanSlide         : function ( a ) {
			a.img && ( a.img.onload = a.img.onerror = null ), a.loaded = a.loading = a.img = a.imageAppended = !1
		    }
		}
	    } );
	    var oc, pc = {}, qc = function ( a, b, c ) {
		var d = document.createEvent( "CustomEvent" ),
		    e = { origEvent: a, target: a.target, releasePoint: b, pointerType: c || "touch" };
		d.initCustomEvent( "pswpTap", !0, !0, e ), a.target.dispatchEvent( d )
	    };
	    za( "Tap", {
		publicMethods: {
		    initTap        : function () {
			Ca( "firstTouchStart", f.onTapStart ), Ca( "touchRelease", f.onTapRelease ), Ca( "destroy", function () {
			    pc = {}, oc = null
			} )
		    }, onTapStart  : function ( a ) {
			a.length > 1 && ( clearTimeout( oc ), oc = null )
		    }, onTapRelease: function ( a, b ) {
			if ( b && !Y && !W && !_a ) {
			    var c = b;
			    if ( oc && ( clearTimeout( oc ), oc = null, xb( c, pc ) ) ) return void Da( "doubleTap", c );
			    if ( "mouse" === b.type ) return void qc( a, b, "mouse" );
			    var d = a.target.tagName.toUpperCase();
			    if ( "BUTTON" === d || e.hasClass( a.target, "pswp__single-tap" ) ) return void qc( a, b );
			    Ma( pc, c ), oc = setTimeout( function () {
				qc( a, b ), oc = null
			    }, 300 )
			}
		    }
		}
	    } );
	    var rc;
	    za( "DesktopZoom", {
		publicMethods: {
		    initDesktopZoom     : function () {
			L || ( G ? Ca( "mouseUsed", function () {
			    f.setupDesktopZoom()
			} ) : f.setupDesktopZoom( !0 ) )
		    }, setupDesktopZoom : function ( b ) {
			rc    = {};
			var c = "wheel mousewheel DOMMouseScroll";
			Ca( "bindEvents", function () {
			    e.bind( a, c, f.handleMouseWheel )
			} ), Ca( "unbindEvents", function () {
			    rc && e.unbind( a, c, f.handleMouseWheel )
			} ), f.mouseZoomedIn = !1;
			var d, g = function () {
			    f.mouseZoomedIn && ( e.removeClass( a, "pswp--zoomed-in" ), f.mouseZoomedIn = !1 ), s < 1 ? e.addClass( a, "pswp--zoom-allowed" ) : e.removeClass( a, "pswp--zoom-allowed" ), h()
			}, h     = function () {
			    d && ( e.removeClass( a, "pswp--dragging" ), d = !1 )
			};
			Ca( "resize", g ), Ca( "afterChange", g ), Ca( "pointerDown", function () {
			    f.mouseZoomedIn && ( d = !0, e.addClass( a, "pswp--dragging" ) )
			} ), Ca( "pointerUp", h ), b || g()
		    }, handleMouseWheel : function ( a ) {
			if ( s <= f.currItem.fitRatio ) return i.modal && ( !i.closeOnScroll || _a || V ? a.preventDefault() : E && Math.abs( a.deltaY ) > 2 && ( l = !0, f.close() ) ), !0;
			if ( a.stopPropagation(), rc.x = 0, "deltaX" in a ) 1 === a.deltaMode ? ( rc.x = 18 * a.deltaX, rc.y = 18 * a.deltaY ) : ( rc.x = a.deltaX, rc.y = a.deltaY ); else if ( "wheelDelta" in a ) a.wheelDeltaX && ( rc.x = -.16 * a.wheelDeltaX ), a.wheelDeltaY ? rc.y = -.16 * a.wheelDeltaY : rc.y = -.16 * a.wheelDelta; else {
			    if ( !( "detail" in a ) ) return;
			    rc.y = a.detail
			}
			Sa( s, !0 );
			var b = pa.x - rc.x, c = pa.y - rc.y;
			( i.modal || b <= da.min.x && b >= da.max.x && c <= da.min.y && c >= da.max.y ) && a.preventDefault(), f.panTo( b, c )
		    }, toggleDesktopZoom: function ( b ) {
			b     = b || { x: qa.x / 2 + sa.x, y: qa.y / 2 + sa.y };
			var c = i.getDoubleTapZoom( !0, f.currItem ), d = s === c;
			f.mouseZoomedIn = !d, f.zoomTo( d ? f.currItem.initialZoomLevel : c, b, 333 ), e[ ( d ? "remove" : "add" ) + "Class" ]( a, "pswp--zoomed-in" )
		    }
		}
	    } );
	    var sc, tc, uc, vc, wc, xc, yc, zc, Ac, Bc, Cc, Dc, Ec = { history: !0, galleryUID: 1 }, Fc = function () {
		return Cc.hash.substring( 1 )
	    }, Gc                                                  = function () {
		sc && clearTimeout( sc ), uc && clearTimeout( uc )
	    }, Hc                                                  = function () {
		var a = Fc(), b = {};
		if ( a.length < 5 ) return b;
		var c, d = a.split( "&" );
		for ( c = 0; c < d.length; c++ ) if ( d[ c ] ) {
		    var e = d[ c ].split( "=" );
		    e.length < 2 || ( b[ e[ 0 ] ] = e[ 1 ] )
		}
		if ( i.galleryPIDs ) {
		    var f = b.pid;
		    for ( b.pid = 0, c = 0; c < Yb.length; c++ ) if ( Yb[ c ].pid === f ) {
			b.pid = c;
			break
		    }
		} else b.pid = parseInt( b.pid, 10 ) - 1;
		return b.pid < 0 && ( b.pid = 0 ), b
	    }, Ic                                                  = function () {
		if ( uc && clearTimeout( uc ), _a || V ) return void ( uc = setTimeout( Ic, 500 ) );
		vc ? clearTimeout( tc ) : vc = !0;
		var a = m + 1, b = _b( m );
		b.hasOwnProperty( "pid" ) && ( a = b.pid );
		var c = yc + "&gid=" + i.galleryUID + "&pid=" + a;
		zc || Cc.hash.indexOf( c ) === -1 && ( Bc = !0 );
		var d = Cc.href.split( "#" )[ 0 ] + "#" + c;
		Dc ? "#" + c !== window.location.hash && history[ zc ? "replaceState" : "pushState" ]( "", document.title, d ) : zc ? Cc.replace( d ) : Cc.hash = c, zc = !0, tc = setTimeout( function () {
		    vc = !1
		}, 60 )
	    };
	    za( "History", {
		publicMethods: {
		    initHistory    : function () {
			if ( e.extend( i, Ec, !0 ), i.history ) {
			    Cc = window.location, Bc = !1, Ac = !1, zc = !1, yc = Fc(), Dc = "pushState" in history, yc.indexOf( "gid=" ) > -1 && ( yc = yc.split( "&gid=" )[ 0 ], yc = yc.split( "?gid=" )[ 0 ] ), Ca( "afterChange", f.updateURL ), Ca( "unbindEvents", function () {
				e.unbind( window, "hashchange", f.onHashChange )
			    } );
			    var a = function () {
				xc = !0, Ac || ( Bc ? history.back() : yc ? Cc.hash = yc : Dc ? history.pushState( "", document.title, Cc.pathname + Cc.search ) : Cc.hash = "" ), Gc()
			    };
			    Ca( "unbindEvents", function () {
				l && a()
			    } ), Ca( "destroy", function () {
				xc || a()
			    } ), Ca( "firstUpdate", function () {
				m = Hc().pid
			    } );
			    var b = yc.indexOf( "pid=" );
			    b > -1 && ( yc = yc.substring( 0, b ), "&" === yc.slice( -1 ) && ( yc = yc.slice( 0, -1 ) ) ), setTimeout( function () {
				j && e.bind( window, "hashchange", f.onHashChange )
			    }, 40 )
			}
		    }, onHashChange: function () {
			return Fc() === yc ? ( Ac = !0, void f.close() ) : void ( vc || ( wc = !0, f.goTo( Hc().pid ), wc = !1 ) )
		    }, updateURL   : function () {
			Gc(), wc || ( zc ? sc = setTimeout( Ic, 800 ) : Ic() )
		    }
		}
	    } ), e.extend( f, eb )
	};
	return a
    } );
    
    /*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
  * http://photoswipe.com
  * Copyright (c) 2019 Dmitry Semenov; */
    !function ( a, b ) {
	"function" == typeof define && define.amd ? define( b ) : "object" == typeof exports ? module.exports = b() : a.PhotoSwipeUI_Default = b()
    }( this, function () {
	"use strict";
	var a = function ( a, b ) {
	    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v = this, w = !1, x = !0, y = !0, z = {
		barsSize               : { top: 44, bottom: "auto" },
		closeElClasses         : [ "item", "caption", "zoom-wrap", "ui", "top-bar" ], timeToIdle: 4e3,
		timeToIdleOutside      : 1e3, loadingIndicatorDelay: 1e3, addCaptionHTMLFn: function ( a, b ) {
		    return a.title ? ( b.children[ 0 ].innerHTML = a.title, !0 ) : ( b.children[ 0 ].innerHTML = "", !1 )
		}, closeEl             : !0, captionEl: !0, fullscreenEl: !0, zoomEl: !0, shareEl: !0, counterEl: !0,
		arrowEl                : !0, preloaderEl: !0, tapToClose: !1, tapToToggleControls: !0,
		clickToCloseNonZoomable: !0, shareButtons: [ {
		    id : "facebook", label: "Share on Facebook",
		    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
		}, {
		    id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
		}, {
		    id : "pinterest", label: "Pin it",
		    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
		}, { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 } ],
		getImageURLForShare    : function () {
		    return a.currItem.src || ""
		}, getPageURLForShare  : function () {
		    return window.location.href
		}, getTextForShare     : function () {
		    return a.currItem.title || ""
		}, indexIndicatorSep   : " / ", fitControlsWidth: 1200
	    }, A                                                           = function ( a ) {
		if ( r ) return !0;
		a = a || window.event, q.timeToIdle && q.mouseUsed && !k && K();
		for ( var c, d, e = a.target || a.srcElement, f = e.getAttribute( "class" ) || "", g = 0; g < S.length; g++ ) c = S[ g ], c.onTap && f.indexOf( "pswp__" + c.name ) > -1 && ( c.onTap(), d = !0 );
		if ( d ) {
		    a.stopPropagation && a.stopPropagation(), r = !0;
		    var h = b.features.isOldAndroid ? 600 : 30;
		    s     = setTimeout( function () {
			r = !1
		    }, h )
		}
	    }, B                                                           = function () {
		return !a.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth
	    }, C                                                           = function ( a, c, d ) {
		b[ ( d ? "add" : "remove" ) + "Class" ]( a, "pswp__" + c )
	    }, D                                                           = function () {
		var a = 1 === q.getNumItemsFn();
		a !== p && ( C( d, "ui--one-slide", a ), p = a )
	    }, E                                                           = function () {
		C( i, "share-modal--hidden", y )
	    }, F                                                           = function () {
		return y = !y, y ? ( b.removeClass( i, "pswp__share-modal--fade-in" ), setTimeout( function () {
		    y && E()
		}, 300 ) ) : ( E(), setTimeout( function () {
		    y || b.addClass( i, "pswp__share-modal--fade-in" )
		}, 30 ) ), y || H(), !1
	    }, G                                                           = function ( b ) {
		b     = b || window.event;
		var c = b.target || b.srcElement;
		return a.shout( "shareLinkClick", b, c ), !!c.href && ( !!c.hasAttribute( "download" ) || ( window.open( c.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + ( window.screen ? Math.round( screen.width / 2 - 275 ) : 100 ) ), y || F(), !1 ) )
	    }, H                                                           = function () {
		for ( var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++ ) a = q.shareButtons[ g ], c = q.getImageURLForShare( a ), d = q.getPageURLForShare( a ), e = q.getTextForShare( a ), b = a.url.replace( "{{url}}", encodeURIComponent( d ) ).replace( "{{image_url}}", encodeURIComponent( c ) ).replace( "{{raw_image_url}}", c ).replace( "{{text}}", encodeURIComponent( e ) ), f += '<a href="' + b + '" target="_blank" class="pswp__share--' + a.id + '"' + ( a.download ? "download" : "" ) + ">" + a.label + "</a>", q.parseShareButtonOut && ( f = q.parseShareButtonOut( a, f ) );
		i.children[ 0 ].innerHTML = f, i.children[ 0 ].onclick = G
	    }, I                                                           = function ( a ) {
		for ( var c = 0; c < q.closeElClasses.length; c++ ) if ( b.hasClass( a, "pswp__" + q.closeElClasses[ c ] ) ) return !0
	    }, J                                                           = 0, K = function () {
		clearTimeout( u ), J = 0, k && v.setIdle( !1 )
	    }, L                                                           = function ( a ) {
		a     = a ? a : window.event;
		var b = a.relatedTarget || a.toElement;
		b && "HTML" !== b.nodeName || ( clearTimeout( u ), u = setTimeout( function () {
		    v.setIdle( !0 )
		}, q.timeToIdleOutside ) )
	    }, M                                                           = function () {
		q.fullscreenEl && !b.features.isOldAndroid && ( c || ( c = v.getFullscreenAPI() ), c ? ( b.bind( document, c.eventK, v.updateFullscreen ), v.updateFullscreen(), b.addClass( a.template, "pswp--supports-fs" ) ) : b.removeClass( a.template, "pswp--supports-fs" ) )
	    }, N                                                           = function () {
		q.preloaderEl && ( O( !0 ), l( "beforeChange", function () {
		    clearTimeout( o ), o = setTimeout( function () {
			a.currItem && a.currItem.loading ? ( !a.allowProgressiveImg() || a.currItem.img && !a.currItem.img.naturalWidth ) && O( !1 ) : O( !0 )
		    }, q.loadingIndicatorDelay )
		} ), l( "imageLoadComplete", function ( b, c ) {
		    a.currItem === c && O( !0 )
		} ) )
	    }, O                                                           = function ( a ) {
		n !== a && ( C( m, "preloader--active", !a ), n = a )
	    }, P                                                           = function ( a ) {
		var c = a.vGap;
		if ( B() ) {
		    var g = q.barsSize;
		    if ( q.captionEl && "auto" === g.bottom ) if ( f || ( f = b.createEl( "pswp__caption pswp__caption--fake" ), f.appendChild( b.createEl( "pswp__caption__center" ) ), d.insertBefore( f, e ), b.addClass( d, "pswp__ui--fit" ) ), q.addCaptionHTMLFn( a, f, !0 ) ) {
			var h    = f.clientHeight;
			c.bottom = parseInt( h, 10 ) || 44
		    } else c.bottom = g.top; else c.bottom = "auto" === g.bottom ? 0 : g.bottom;
		    c.top = g.top
		} else c.top = c.bottom = 0
	    }, Q                                                           = function () {
		q.timeToIdle && l( "mouseUsed", function () {
		    b.bind( document, "mousemove", K ), b.bind( document, "mouseout", L ), t = setInterval( function () {
			J++, 2 === J && v.setIdle( !0 )
		    }, q.timeToIdle / 2 )
		} )
	    }, R                                                           = function () {
		l( "onVerticalDrag", function ( a ) {
		    x && a < .95 ? v.hideControls() : !x && a >= .95 && v.showControls()
		} );
		var a;
		l( "onPinchClose", function ( b ) {
		    x && b < .9 ? ( v.hideControls(), a = !0 ) : a && !x && b > .9 && v.showControls()
		} ), l( "zoomGestureEnded", function () {
		    a = !1, a && !x && v.showControls()
		} )
	    }, S                                                           = [ {
		name: "caption", option: "captionEl", onInit: function ( a ) {
		    e = a
		}
	    }, {
		name    : "share-modal", option: "shareEl", onInit: function ( a ) {
		    i = a
		}, onTap: function () {
		    F()
		}
	    }, {
		name    : "button--share", option: "shareEl", onInit: function ( a ) {
		    h = a
		}, onTap: function () {
		    F()
		}
	    }, { name: "button--zoom", option: "zoomEl", onTap: a.toggleDesktopZoom }, {
		name: "counter", option: "counterEl", onInit: function ( a ) {
		    g = a
		}
	    }, { name: "button--close", option: "closeEl", onTap: a.close }, {
		name: "button--arrow--left", option: "arrowEl", onTap: a.prev
	    }, { name: "button--arrow--right", option: "arrowEl", onTap: a.next }, {
		name: "button--fs", option: "fullscreenEl", onTap: function () {
		    c.isFullscreen() ? c.exit() : c.enter()
		}
	    }, {
		name: "preloader", option: "preloaderEl", onInit: function ( a ) {
		    m = a
		}
	    } ], T                                                         = function () {
		var a, c, e, f = function ( d ) {
		    if ( d ) for ( var f = d.length, g = 0; g < f; g++ ) {
			a = d[ g ], c = a.className;
			for ( var h = 0; h < S.length; h++ ) e = S[ h ], c.indexOf( "pswp__" + e.name ) > -1 && ( q[ e.option ] ? ( b.removeClass( a, "pswp__element--disabled" ), e.onInit && e.onInit( a ) ) : b.addClass( a, "pswp__element--disabled" ) )
		    }
		};
		f( d.children );
		var g = b.getChildByClass( d, "pswp__top-bar" );
		g && f( g.children )
	    };
	    v.init = function () {
		b.extend( a.options, z, !0 ), q = a.options, d = b.getChildByClass( a.scrollWrap, "pswp__ui" ), l = a.listen, R(), l( "beforeChange", v.update ), l( "doubleTap", function ( b ) {
		    var c = a.currItem.initialZoomLevel;
		    a.getZoomLevel() !== c ? a.zoomTo( c, b, 333 ) : a.zoomTo( q.getDoubleTapZoom( !1, a.currItem ), b, 333 )
		} ), l( "preventDragEvent", function ( a, b, c ) {
		    var d = a.target || a.srcElement;
		    d && d.getAttribute( "class" ) && a.type.indexOf( "mouse" ) > -1 && ( d.getAttribute( "class" ).indexOf( "__caption" ) > 0 || /(SMALL|STRONG|EM)/i.test( d.tagName ) ) && ( c.prevent = !1 )
		} ), l( "bindEvents", function () {
		    b.bind( d, "pswpTap click", A ), b.bind( a.scrollWrap, "pswpTap", v.onGlobalTap ), a.likelyTouchDevice || b.bind( a.scrollWrap, "mouseover", v.onMouseOver )
		} ), l( "unbindEvents", function () {
		    y || F(), t && clearInterval( t ), b.unbind( document, "mouseout", L ), b.unbind( document, "mousemove", K ), b.unbind( d, "pswpTap click", A ), b.unbind( a.scrollWrap, "pswpTap", v.onGlobalTap ), b.unbind( a.scrollWrap, "mouseover", v.onMouseOver ), c && ( b.unbind( document, c.eventK, v.updateFullscreen ), c.isFullscreen() && ( q.hideAnimationDuration = 0, c.exit() ), c = null )
		} ), l( "destroy", function () {
		    q.captionEl && ( f && d.removeChild( f ), b.removeClass( e, "pswp__caption--empty" ) ), i && ( i.children[ 0 ].onclick = null ), b.removeClass( d, "pswp__ui--over-close" ), b.addClass( d, "pswp__ui--hidden" ), v.setIdle( !1 )
		} ), q.showAnimationDuration || b.removeClass( d, "pswp__ui--hidden" ), l( "initialZoomIn", function () {
		    q.showAnimationDuration && b.removeClass( d, "pswp__ui--hidden" )
		} ), l( "initialZoomOut", function () {
		    b.addClass( d, "pswp__ui--hidden" )
		} ), l( "parseVerticalMargin", P ), T(), q.shareEl && h && i && ( y = !0 ), D(), Q(), M(), N()
	    }, v.setIdle = function ( a ) {
		k = a, C( d, "ui--idle", a )
	    }, v.update = function () {
		x && a.currItem ? ( v.updateIndexIndicator(), q.captionEl && ( q.addCaptionHTMLFn( a.currItem, e ), C( e, "caption--empty", !a.currItem.title ) ), w = !0 ) : w = !1, y || F(), D()
	    }, v.updateFullscreen = function ( d ) {
		d && setTimeout( function () {
		    a.setScrollOffset( 0, b.getScrollY() )
		}, 50 ), b[ ( c.isFullscreen() ? "add" : "remove" ) + "Class" ]( a.template, "pswp--fs" )
	    }, v.updateIndexIndicator = function () {
		q.counterEl && ( g.innerHTML = a.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn() )
	    }, v.onGlobalTap = function ( c ) {
		c     = c || window.event;
		var d = c.target || c.srcElement;
		if ( !r ) if ( c.detail && "mouse" === c.detail.pointerType ) {
		    if ( I( d ) ) return void a.close();
		    b.hasClass( d, "pswp__img" ) && ( 1 === a.getZoomLevel() && a.getZoomLevel() <= a.currItem.fitRatio ? q.clickToCloseNonZoomable && a.close() : a.toggleDesktopZoom( c.detail.releasePoint ) )
		} else if ( q.tapToToggleControls && ( x ? v.hideControls() : v.showControls() ), q.tapToClose && ( b.hasClass( d, "pswp__img" ) || I( d ) ) ) return void a.close()
	    }, v.onMouseOver = function ( a ) {
		a     = a || window.event;
		var b = a.target || a.srcElement;
		C( d, "ui--over-close", I( b ) )
	    }, v.hideControls = function () {
		b.addClass( d, "pswp__ui--hidden" ), x = !1
	    }, v.showControls = function () {
		x = !0, w || v.update(), b.removeClass( d, "pswp__ui--hidden" )
	    }, v.supportsFullscreen = function () {
		var a = document;
		return !!( a.exitFullscreen || a.mozCancelFullScreen || a.webkitExitFullscreen || a.msExitFullscreen )
	    }, v.getFullscreenAPI = function () {
		var b, c = document.documentElement, d = "fullscreenchange";
		return c.requestFullscreen ? b = {
		    enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: d
		} : c.mozRequestFullScreen ? b = {
		    enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement",
		    eventK: "moz" + d
		} : c.webkitRequestFullscreen ? b = {
		    enterK  : "webkitRequestFullscreen", exitK: "webkitExitFullscreen",
		    elementK: "webkitFullscreenElement", eventK: "webkit" + d
		} : c.msRequestFullscreen && ( b = {
		    enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement",
		    eventK: "MSFullscreenChange"
		} ), b && ( b.enter = function () {
		    return j = q.closeOnScroll, q.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? a.template[ this.enterK ]() : void a.template[ this.enterK ]( Element.ALLOW_KEYBOARD_INPUT )
		}, b.exit = function () {
		    return q.closeOnScroll = j, document[ this.exitK ]()
		}, b.isFullscreen = function () {
		    return document[ this.elementK ]
		} ), b
	    }
	};
	return a
    } );
} )();

/*============================================================================
 Underground Functions
==============================================================================*/
var Events     = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

window.WAU = window.WAU || {};

WAU.Slideout = ( function () {
    /*
	 * Elements
	 */
    var wrapper = undefined;
    /*
	 * @description - Makes sure that the ESC Key works to close the menus.
	 */
    document.addEventListener( 'keyup', function ( event ) {
	if ( event.key === 'Escape' ) {
	    event.preventDefault();
	    closeActiveSlideout();
	}
    } );
    document.addEventListener( 'click', function ( event ) {
	if ( event.target === document.querySelector( ".js-slideout-overlay" ) ) {
	    closeActiveSlideout();
	}
    } );
    
    /*
	 * @description - Closes the currently active slide.
	 */
    function closeActiveSlideout() {
	// Find the open slideout.
	const activeSlideout     = document.querySelector( '.slideout--active' );
	const activeSlideoutName = activeSlideout.getAttribute( 'data-wau-slideout' );
	const opener             = document.querySelector( '.js-slideout-open[data-wau-slideout-target="' + activeSlideoutName + '"]' );
	const direction          = opener.getAttribute( 'data-slideout-direction' );
	close( direction, opener );
    }
    
    /*
	 * @description - Checks if the slideout is currently open or not.
	 * @return Boolean
	 */
    function isOpen() {
	wrapper = document.querySelector( ".js-slideout-toggle-wrapper" );
	return wrapper.classList.contains( "slideout-left--open" ) || wrapper.classList.contains( "slideout-right--open" );
    }
    
    /*
	 * @description - Open a specific slideout in a specific direction.
	 * @param direction:String - the drction to open the slideout in.
	 * @param targetSlideoutEl:Node - The slideout element that will be opened.
	 */
    function open( direction, targetSlideoutEl, opener ) {
	wrapper.classList.add( "slideout-" + direction + "--open" );
	wrapper.classList.remove( "slideout-" + direction + "--closed" );
	targetSlideoutEl.classList.add( 'slideout--active' );
	opener.setAttribute( "aria-expanded", "true" );
	if ( document.activeElement === opener ) {
	    theme.a11yHelpers.focusOnElement( targetSlideoutEl );
	}
	// Fix body wrapper so no scrolling on mobile
	if ( !document.querySelector( '.site-wrap' ) ) return false;
	let scrollPosition = Math.abs( 0 - document.querySelector( '.site-wrap' ).getBoundingClientRect().top );
	// Set tabindex so it will tab slideout
	targetSlideoutEl.querySelectorAll( '*' ).forEach( ( item, i ) => {
	    item.setAttribute( 'tabIndex', '0' );
	} );
	wrapper.style.overflow = 'hidden';
	wrapper.style.position = 'fixed';
	wrapper.style.top      = `-${ scrollPosition }px`;
	wrapper.style.width    = '100%';
    }
    
    /*
	 * @description - Closes all slideouts. Puts a11y focus back on the original opener.
	 * @param opener:Node - the opener element.
	 */
    function close( direction, openerEl ) {
	const activeOpenSlideouts = document.querySelectorAll( '.slideout--active' );
	const openers             = document.querySelectorAll( ".js-slideout-open" );
	const closers             = document.querySelectorAll( ".js-slideout-close" );
	// Close the slideout.
	wrapper.classList.remove( "slideout-" + direction + "--open" );
	wrapper.classList.add( "slideout-" + direction + "--closed" );
	// Close all active drawers. This is incase there is more than 1 slide on a direction.
	activeOpenSlideouts.forEach( function ( activeSlideoutDrawer ) {
	    activeSlideoutDrawer.classList.remove( 'slideout--active' );
	    // Set tabindex so it skips hidden slideout
	    activeSlideoutDrawer.querySelectorAll( '*' ).forEach( ( item, i ) => {
		item.setAttribute( 'tabIndex', '-1' );
	    } );
	} );
	// Makes sure aria-expanded false is added to all the open and close buttons.
	openers.forEach( function ( opener ) {
	    opener.setAttribute( 'aria-expanded', 'false' );
	} );
	closers.forEach( function ( closer ) {
	    closer.setAttribute( 'aria-expanded', 'false' );
	} );
	openerEl.focus();
	// Fix body wrapper so no scrolling on mobile
	if ( !document.querySelector( '.site-wrap' ) ) return false;
	let scrollPosition = Math.abs( 0 - document.querySelector( '.site-wrap' ).getBoundingClientRect().top );
	wrapper.style.removeProperty( 'overflow' );
	wrapper.style.removeProperty( 'position' );
	wrapper.style.removeProperty( 'top' );
	wrapper.style.removeProperty( 'width' );
	window.scrollTo( 0, scrollPosition );
    }
    
    /*
	 * @description - Closes a specific slideout given the name in data-wau-slideout attribute
	 * @return void
	 */
    function closeByName( name ) {
	const closer    = document.querySelector( '[data-wau-slideout-target="' + name + '"]' );
	const direction = closer.getAttribute( 'data-slideout-direction' );
	const opener    = document.querySelector( '.js-slideout-open[data-wau-slideout-target="' + name + '"]' );
	close( direction, opener );
    }
    
    /*
	 * @description - Opens a specific slideout given the name in data-wau-slideout attribute
	 * @return void
	 */
    function openByName( name ) {
	const opener           = document.querySelector( '[data-wau-slideout-target="' + name + '"]' )
	const direction        = opener.getAttribute( 'data-slideout-direction' );
	const targetSlideoutEl = document.querySelector( '[data-wau-slideout="' + name + '"]' );
	open( direction, targetSlideoutEl, opener );
    }
    
    /*
	 * @description - Creates a new aside element to be used as a slideout.
	 * @param direction:String - the direction that the slideout will open in. "left" or "right"
	 * @param name:String - An explicit name to refer to the slideout by on a trigger.
	 * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
	 */
    function createSlideoutEl( direction, name, wrapperEl ) {
	const aside       = document.createElement( 'aside' );
	const opener      = document.querySelector( '[data-wau-slideout-target="' + name + '"]' );
	const generatedId = "slideout-" + name;
	wrapperEl         = wrapperEl || wrapper;
	aside.classList.add( 'slideout' );
	aside.classList.add( 'slideout__drawer-' + direction );
	aside.setAttribute( 'data-wau-slideout', name );
	aside.setAttribute( 'id', generatedId ); // setting an id here so that we can set the aria-controls attribute on the opener.
	opener.setAttribute( 'aria-controls', generatedId );
	wrapperEl.appendChild( aside );
	return aside;
    }
    
    /*
	 * @description - Initializes the plugin by adding all of the appropriate event listeners.
	 */
    function init( name ) {
	if ( typeof name === "undefined" ) {
	    console.log( "The Slideout must have an associated name." );
	    return;
	}
	wrapper               = document.querySelector( '.js-slideout-toggle-wrapper' );
	const slideoutClosers = document.querySelectorAll( '.js-slideout-close' ),
	      slideoutOpeners = document.querySelectorAll( '.js-slideout-open[data-wau-slideout-target="' + name + '"]' );
	let slideoutTargetEl  = undefined;
	if ( slideoutOpeners ) {
	    slideoutTargetEl = document.querySelector( `aside[data-wau-slideout=${ name }]` );
	}
	if ( !slideoutTargetEl ) {
	    slideoutTargetEl = createSlideoutEl( direction );
	}
	// Set slideout tabindex no tabbing when closed
	slideoutTargetEl.querySelectorAll( '*' ).forEach( ( item, i ) => {
	    item.setAttribute( 'tabIndex', '-1' );
	} );
	slideoutOpeners.forEach( ( slideoutOpener, i ) => {
	    const slideoutDirection = slideoutOpener.getAttribute( 'data-slideout-direction' );
	    slideoutOpener.addEventListener( 'click', function () {
		open( slideoutDirection, slideoutTargetEl, slideoutOpener );
	    } );
	} );
	slideoutClosers.forEach( ( slideoutCloser, i ) => {
	    const slideoutCloseDirection = slideoutCloser.getAttribute( 'data-slideout-direction' );
	    slideoutCloser.addEventListener( 'click', function () {
		close( slideoutCloseDirection, slideoutCloser );
	    } );
	} );
    }
    
    const privateFunctions = {
	openByName,
	closeByName,
	createSlideoutEl
    };
    let returnObj          = {};
    returnObj.init         = init;
    /*
	 * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
	 */
    Object.keys( privateFunctions ).forEach( function ( pf ) {
	returnObj[ '_' + pf ] = privateFunctions[ pf ];
    } );
    return returnObj;
}() );

WAU.Modal = ( function () {
    /*
   * Elements
   */
    var wrapper = undefined;
    /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
    document.addEventListener( 'keyup', function ( event ) {
	if ( event.key === 'Escape' ) {
	    event.preventDefault();
	    closeActiveModal();
	}
    } );
    document.addEventListener( 'click', function ( event ) {
	if ( event.target === document.querySelector( ".js-modal-overlay" ) ) {
	    closeActiveModal();
	}
    } );
    
    /*
   * @description - Closes the currently active modal.
   */
    function closeActiveModal() {
	// Find the open modal.
	const activeModal     = document.querySelector( '.modal--active' );
	const activeModalName = activeModal.getAttribute( 'data-wau-modal' );
	const opener          = document.querySelector( '.js-modal-open[data-wau-modal-target="' + activeModalName + '"]' );
	close( opener );
    }
    
    /*
   * @description - Checks if the modal is currently open or not.
   * @return Boolean
   */
    function isOpen() {
	wrapper = document.querySelector( ".js-modal-toggle-wrapper" );
	return wrapper.classList.contains( "modal--open" );
    }
    
    /*
   * @description - Open a specific modal.
   * @param targetSlideoutEl:Node - The modal element that will be opened.
   */
    function open( targetModalEl, opener ) {
	
	// Fix body wrapper so no scrolling on mobile
	let scrollPosition  = Math.abs( 0 - document.querySelector( '.site-wrap' ).getBoundingClientRect().top );
	wrapper.style.top   = `-${ scrollPosition }px`;
	wrapper.style.width = '100%';
	
	// Stop from scrolling to top on quickview and modal cart
	if ( opener.getAttribute( "data-wau-modal-target" ) == 'quickview' ) {
	    targetModalEl.style.top = `calc(${ scrollPosition }px + 15vh)`;
	} else if ( targetModalEl.id == 'modal-ajax-cart' && targetModalEl.getAttribute( "data-wau-modal" ) == 'ajax-cart' ) {
	    targetModalEl.style.top = `calc(${ scrollPosition }px + 15vh)`;
	}
	
	wrapper.classList.add( "modal--open" );
	wrapper.classList.remove( "modal--closed" );
	targetModalEl.classList.add( 'modal--active' );
	
	// Add specific modal type class
	if ( targetModalEl.getAttribute( "data-wau-modal" ) ) {
	    var elClass = targetModalEl.getAttribute( "data-wau-modal" ),
		elClass = "modal-" + elClass + "--open";
	    wrapper.classList.add( elClass );
	}
	
	opener.setAttribute( "aria-expanded", "true" );
	
	if ( document.activeElement === opener ) {
	    theme.a11yHelpers.focusOnElement( targetModalEl );
	}
    }
    
    /*
   * @description - Closes all modals. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
    function close( openerEl ) {
	const activeOpenModals = document.querySelectorAll( '.modal--active' );
	const openers          = document.querySelectorAll( ".js-modal-open" );
	const closers          = document.querySelectorAll( ".js-modal-close" );
	
	// Remove content if quickview
	if ( openerEl.getAttribute( "aria-controls" ) == 'modal-quickview' ) {
	    document.querySelector( '.js-quickview-content' ).innerHTML = '';
	}
	
	// Close the Modal.
	wrapper.classList.remove( "modal--open" );
	wrapper.classList.add( "modal--closed" );
	
	// Close all active modals. This is incase there is more than 1..
	activeOpenModals.forEach( function ( activeModalDrawer ) {
	    // Remove specific modal type class
	    if ( activeModalDrawer.getAttribute( "data-wau-modal" ) ) {
		var elClass = activeModalDrawer.getAttribute( "data-wau-modal" ),
		    elClass = "modal-" + elClass + "--open";
		wrapper.classList.remove( elClass );
	    }
	    
	    activeModalDrawer.classList.remove( 'modal--active' );
	    
	    
	    // if (activeModalDrawer.getAttribute("data-wau-modal") == 'quickview') {
	    //   activeModalDrawer.style.top = 0;
	    // }
	} );
	
	// Makes sure aria-expanded false is added to all the open and close buttons.
	openers.forEach( function ( opener ) {
	    opener.setAttribute( 'aria-expanded', 'false' );
	} );
	closers.forEach( function ( closer ) {
	    closer.setAttribute( 'aria-expanded', 'false' );
	} );
	
	// Fix body wrapper so no scrolling on mobile
	wrapper.style.removeProperty( 'overflow' );
	wrapper.style.removeProperty( 'position' );
	wrapper.style.removeProperty( 'padding-right' );
	wrapper.style.removeProperty( 'top' );
	wrapper.style.removeProperty( 'width' );
    }
    
    /*
   * @description - Closes a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
    function closeByName( name ) {
	const closer = document.querySelector( '[data-wau-modal-target="' + name + '"]' );
	const opener = document.querySelector( '.js-modal-open[data-wau-modal-target="' + name + '"]' );
	close( opener );
    }
    
    /*
   * @description - Opens a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
    function openByName( name ) {
	const opener        = document.querySelector( '[data-wau-modal-target="' + name + '"]' );
	const targetModalEl = document.querySelector( '[data-wau-modal="' + name + '"]' );
	open( targetModalEl, opener );
    }
    
    /*
   * @description - Creates a new close button inside created modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   */
    function createCloser( name ) {
	const closeDiv = document.createElement( 'div' );
	const button   = document.createElement( 'button' );
	const icon     = document.createElement( 'div' );
	closeDiv.classList.add( 'slideout__trigger--close' );
	closeDiv.classList.add( 'slideout__trigger-' + name + '__wrapper' );
	closeDiv.classList.add( 'slideout__trigger-general-modal__wrapper' );
	button.classList.add( 'slideout__trigger-' + name );
	button.classList.add( 'slideout__trigger-general-modal' );
	button.classList.add( 'js-modal-close' );
	button.setAttribute( 'aria-controls', 'modal-' + name );
	button.setAttribute( 'aria-label', 'Close modal' );
	icon.classList.add( 'icn-close' );
	button.appendChild( icon );
	closeDiv.appendChild( button );
	return closeDiv;
    }
    
    /*
   * @description - Creates a new div element to be used as a modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
    function createModalEl( name, wrapperEl ) {
	const div             = document.createElement( 'div' );
	const innerDiv        = document.createElement( 'div' );
	const innerContentDiv = document.createElement( 'div' );
	const opener          = document.querySelector( '[data-wau-modal-target="' + name + '"]' );
	const content         = document.querySelector( '[data-wau-modal-content="' + name + '"]' );
	const generatedId     = "modal-" + name;
	wrapperEl             = wrapperEl || wrapper;
	// Create outer wrapper
	div.classList.add( 'modal' );
	div.classList.add( 'modal__container' );
	div.setAttribute( 'data-wau-modal', name );
	div.setAttribute( 'id', generatedId ); // setting an id here so that we can set the aria-controls attribute on the opener.
	// Create inner wrapper and move content to it
	innerDiv.classList.add( 'modal__inner-wrapper' );
	innerDiv.classList.add( 'modal__general-modal__wrapper' );
	innerContentDiv.innerHTML = content.innerHTML;
	innerContentDiv.classList.add( 'modal__inner-content-container' );
	// Add close button to Inner
	let closeDiv = createCloser( name );
	innerDiv.prepend( closeDiv );
	// Add inner wrapper to outer wrapper
	div.appendChild( innerDiv );
	innerDiv.appendChild( innerContentDiv );
	opener.setAttribute( 'aria-controls', generatedId );
	wrapperEl.appendChild( div );
	return div;
    }
    
    /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
    function init( name ) {
	if ( typeof name === "undefined" ) {
	    console.log( "The Modal must have an associated name." );
	    return;
	}
	wrapper            = document.querySelector( '.js-modal-toggle-wrapper' );
	const modalOpeners = document.querySelectorAll( '.js-modal-open[data-wau-modal-target="' + name + '"]' );
	
	let modalTargetEl = undefined;
	if ( modalOpeners ) {
	    modalTargetEl = document.querySelector( `div[data-wau-modal=${ name }]` );
	}
	
	if ( !modalTargetEl ) {
	    modalTargetEl = createModalEl( name, wrapper );
	}
	
	modalOpeners.forEach( ( modalOpener, i ) => {
	    modalOpener.addEventListener( 'click', function () {
		open( modalTargetEl, modalOpener );
	    } );
	} );
	
	const modalClosers = document.querySelectorAll( '.js-modal-close' );
	modalClosers.forEach( function ( modalCloser ) {
	    modalCloser.addEventListener( 'click', function () {
		close( modalCloser );
	    } );
	} );
    }
    
    const privateFunctions = {
	openByName,
	closeByName,
	createModalEl
    };
    let returnObj          = {};
    returnObj.init         = init;
    /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
    Object.keys( privateFunctions ).forEach( function ( pf ) {
	returnObj[ '_' + pf ] = privateFunctions[ pf ];
    } );
    return returnObj;
}() );

WAU.Accordion = ( function () {
    
    const classes = {
	show              : "is-active",
	open              : "js-accordion-is-open",
	mobileNavAccordion: "js-accordion-mobile-nav"
    };
    
    const selectors = {
	accordion      : ".js-accordion",
	accordionItem  : '.c-accordion__item',
	accordionLink  : ".js-accordion-link",
	accordionHeader: ".js-accordion-header",
	accordionPanel : ".c-accordion__panel"
    };
    
    const publicAPIs = {};
    
    /*
   * @description strips class period
   */
    const stripClassPeriod = function ( className ) {
	if ( !className ) return;
	return className.split( '.' )[ 1 ];
    }
    
    /*
   * @description returns class naem
   */
    publicAPIs.getConfigClass = function ( className ) {
	if ( !className ) return;
	if ( classes[ className ] && classes[ className ] != '' ) {
	    return classes[ className ];
	} else {
	    return false;
	}
    };
    
    /*
   * @description Hides an accordion item
   */
    publicAPIs.hide = function ( target ) {
	
	target.setAttribute( "aria-expanded", "false" );
	
	const panel = document.querySelector(
	    `#${ target.getAttribute( "aria-controls" ) }`
	);
	
	panel.setAttribute( "hidden", "" );
	
	panel.classList.remove( classes.show );
	
	// 350 matches the CSS transition timing
	setTimeout( function () {
	    panel.style.display = "none";
	}, 350 );
    };
    
    
    /*
   * @description Shows an accordion item
   */
    publicAPIs.show = function ( target, allowMultiple ) {
	
	const panel = document.querySelector(
	    `#${ target.getAttribute( "aria-controls" ) }`
	);
	
	const parentElement = target.closest( panel.getAttribute( "data-parent" ) );
	
	const allowMultipleFlag = allowMultiple || parentElement
	    .hasAttribute( "data-accordion-allow-multiple" ) ? true : false;
	
	const isMobileNav = parentElement.classList.contains( classes.mobileNavAccordion );
	
	if ( !allowMultipleFlag && panel.hasAttribute( "data-parent" ) ) {
	    
	    let childSelector = '';
	    
	    if ( isMobileNav ) {
		childSelector = ':scope > li > [aria-expanded="true"]';
	    } else {
		childSelector = ':scope > [aria-expanded="true"]';
	    }
	    
	    if ( !childSelector ) {
		return;
	    }
	    
	    const activePanels = target
		.closest( panel.getAttribute( "data-parent" ) )
		.querySelectorAll(
		    childSelector
		);
	    
	    if ( !activePanels ) {
		return;
	    }
	    
	    activePanels.forEach( function ( element ) {
		publicAPIs.hide( element );
	    } );
	}
	
	target.setAttribute( "aria-expanded", "true" );
	
	panel.removeAttribute( "hidden" );
	
	panel.style.display = "block";
	
	setTimeout( function () {
	    panel.classList.add( classes.show );
	}, 10 );
	
    };
    
    /*
   * @description Toggle showing and hiding an accordion item
   */
    publicAPIs.toggle = function ( target, allowMultiple ) {
	
	if ( target.getAttribute( "aria-expanded" ) == "true" ) {
	    publicAPIs.hide( target );
	    return;
	} else {
	    publicAPIs.show( target, allowMultiple );
	}
    };
    
    /*
   * @description Initialize function
   */
    publicAPIs.init = function () {
	
	// Hide add accordion panels
	document.querySelectorAll( `[data-toggle="accordion"]:not(.${ classes.open })` ).forEach( function ( element, index ) {
	    publicAPIs.hide( element );
	} );
	
	// Add keyboard accessibility events
	document.addEventListener( 'keydown', function ( event ) {
	    let target              = event.target;
	    const key               = event.code;
	    const disablePageScroll = false;
	    const pageScrollOptions = disablePageScroll ? { preventScroll: true } : { preventScroll: false };
	    const isDropDownArrow   = target.classList.contains( 'dropdown-arrow' );
	    
	    if ( target.classList.contains( stripClassPeriod( selectors.accordionHeader ) ) ||
		target.classList.contains( stripClassPeriod( selectors.accordionLink ) ) ||
		isDropDownArrow ) {
		
		if ( key == 'ArrowUp' || key == 'ArrowDown' ) {
		    
		    
		    const isMobile = target.closest( selectors.accordion ).classList.contains( classes.mobileNavAccordion ) ? true : false;
		    
		    const accordionSelector = isMobile ? `:scope > li > ${ selectors.accordionLink }` : `:scope > ${ selectors.accordionHeader }`;
		    
		    const accordions = target.closest( selectors.accordion ).querySelectorAll( accordionSelector );
		    
		    if ( isMobile && isDropDownArrow ) {
			target.previousElementSibling.focus( pageScrollOptions );
			return;
		    }
		    
		    let indexPlace;
		    accordions.forEach( function ( element, index ) {
			if ( element == target ) {
			    indexPlace = index;
			}
		    } );
		    const direction = key == 'PageDown' || key == 'ArrowDown' ? 1 : -1;
		    const length    = accordions.length;
		    const newIndex  = ( indexPlace + length + direction ) % length;
		    
		    accordions[ newIndex ].focus( pageScrollOptions );
		}
	    }
	} );
	
	document.addEventListener( "click", function ( event ) {
	    
	    const target = event.target.matches( '[data-toggle="accordion"]' ) ? event.target : event.target.closest( '[data-toggle="accordion"]' );
	    
	    if ( !target ) {
		return false;
	    }
	    
	    publicAPIs.toggle( target );
	    
	    event.preventDefault();
	} );
    };
    
    return publicAPIs;
    
} )();

/*============================================================================
 Theme Functions
==============================================================================*/
window.theme = window.theme || {};

theme.a11yHelpers = ( function () {
    
    let alreadySetUpKeyEvents = false;
    
    /*
  * @description - Sets up the aria-expanded property to true and false on hover.
  */
    function setUpAriaExpansion() {
	const ariaExpandEls = document.querySelectorAll( '.js-aria-expand' );
	
	ariaExpandEls.forEach( function ( ariaExpandEl ) {
	    ariaExpandEl.addEventListener( 'mouseover', function ( event ) {
		ariaExpandEl.setAttribute( 'aria-expanded', 'true' );
	    } );
	    
	    ariaExpandEl.addEventListener( 'mouseout', function ( event ) {
		ariaExpandEl.setAttribute( 'aria-expanded', 'false' );
	    } );
	} );
    }
    
    /*
  * @description - Takes a parent element and focuses on the next focusable element inside of there.
  */
    function focusOnElement( parent ) {
	var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
	
	const elementToFocusOn = parent.querySelector( focussableElements );
	
	if ( elementToFocusOn ) {
	    elementToFocusOn.focus();
	}
	
    }
    
    function findFocusableElement( parent, element, direction ) {
	const focusableElementSelectors = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
	const focusableElements         = parent.querySelectorAll( focusableElementSelectors );
	const numOfFocusableElements    = focusableElements.length;
	
	var elementIndex = 0;
	
	for ( let i = 0; i < focusableElements.length; i += 1 ) {
	    let currentElement = focusableElements[ i ];
	    
	    if ( currentElement === element ) {
		elementIndex = i;
	    }
	}
	
	if ( direction === 'next' ) {
	    if ( elementIndex === ( numOfFocusableElements - 1 ) ) {
		return focusableElements[ 0 ];
	    } else {
		return focusableElements[ elementIndex + 1 ];
	    }
	}
	
	if ( direction === 'prev' ) {
	    if ( elementIndex === 0 ) {
		return focusableElements[ numOfFocusableElements - 1 ];
	    } else {
		return focusableElements[ elementIndex - 1 ];
	    }
	}
    }
    
    /*
  * @description - Takes a parent and a dom node and returns the next element that is focusable that is not the current element.
  * @param parent:DOMNode
  * @param element:DOMNode
  * @return DOMNode
  */
    function findNextFocusableElement( parent, element ) {
	return findFocusableElement( parent, element, 'next' );
    }
    
    function findPreviousFocusableElement( parent, element ) {
	return findFocusableElement( parent, element, 'prev' );
    }
    
    /*
  * @description - Enables accessible keyboard navigation throughout the navigation menus.
  */
    function setUpAccessibleNavigationMenus() {
	
	function closeDropdownMenus() {
	    const activeMenuItems = document.querySelectorAll( '.navigation__menuitem--active' );
	    activeMenuItems.forEach( function ( activeMenuItem ) {
		activeMenuItem.classList.remove( 'navigation__menuitem--active' );
		activeMenuItem.setAttribute( 'aria-expanded', 'false' );
	    } );
	}
	
	function closeNestedDropdownMenus() {
	    //remove the class that makes the dropdown show... the active class
	    const nestedDropdowns = document.querySelectorAll( ".js-menuitem-with-nested-dropdown" );
	    
	    nestedDropdowns.forEach( function ( nestedDropdown ) {
		nestedDropdown.classList.remove( "dropdown__menuitem--active" );
		nestedDropdown.setAttribute( 'aria-expanded', 'false' );
	    } );
	    
	}
	
	function closeNestedMegaMenuDropdownMenus() {
	    const nestedDropdowns = document.querySelectorAll( ".js-megamenu-listitem-with-nested-dropdown" );
	    
	    nestedDropdowns.forEach( function ( nestedDropdown ) {
		nestedDropdown.classList.remove( "megamenu__listitem--active" );
		nestedDropdown.setAttribute( 'aria-expanded', 'false' );
	    } );
	}
	
	function addEdgeToDropdown( dropdown ) {
	    setTimeout( function () {
		if ( theme.DOMHelpers.isElementPastEdge( dropdown ) ) {
		    dropdown.classList.add( "dropdown--edge" );
		} else {
		    dropdown.classList.remove( "dropdown--edge" );
		}
	    }, 0 );
	}
	
	if ( !alreadySetUpKeyEvents ) {
	    document.addEventListener( 'keyup', function ( event ) {
		if ( event.key === 'Escape' ) {
		    const openNestedDropdownMenus         = document.querySelectorAll( ".dropdown__menuitem--active" ),
			  openDropdownMenus               = document.querySelectorAll( ".navigation__menuitem--active" ),
			  openMegaMenuNestedDropdownMenus = document.querySelectorAll( ".megamenu__listitem--active" );
		    
		    event.preventDefault();
		    
		    if ( openNestedDropdownMenus.length >= 1 ) {
			closeNestedDropdownMenus();
			return;
		    }
		    
		    if ( openMegaMenuNestedDropdownMenus.length >= 1 ) {
			closeNestedMegaMenuDropdownMenus();
			return;
		    }
		    
		    if ( openDropdownMenus.length >= 1 ) {
			closeDropdownMenus();
			return;
		    }
		    
		}
	    } );
	}
	
	if ( !alreadySetUpKeyEvents ) {
	    document.addEventListener( 'keydown', function ( event ) {
		if ( event.key === 'Enter' ) {
		    
		    if ( document.activeElement.classList.contains( "js-open-dropdown-on-key" ) || document.activeElement.parentNode.classList.contains( "js-menuitem-with-nested-dropdown" ) || document.activeElement.parentNode.classList.contains( "js-megamenu-listitem-with-nested-dropdown" ) ) {
			event.stopPropagation();
			event.preventDefault();
		    }
		    
		    if ( document.activeElement.parentNode.classList.contains( "navigation__menuitem--active" ) ) {
			closeDropdownMenus();
			return;
		    }
		    
		    if ( document.activeElement.parentNode.classList.contains( "dropdown__menuitem--active" ) ) {
			closeNestedDropdownMenus();
			return;
		    }
		    
		    if ( document.activeElement.parentNode.classList.contains( "megamenu__listitem--active" ) ) {
			closeNestedMegaMenuDropdownMenus();
			return;
		    }
		    
		    if ( document.activeElement.classList.contains( "js-open-dropdown-on-key" ) ) {
			document.activeElement.parentNode.classList.add( "navigation__menuitem--active" ); // Show the menu by adding the appropriate class.
			return;
		    }
		    
		    if ( document.activeElement.parentNode.classList.contains( "js-menuitem-with-nested-dropdown" ) ) {
			document.activeElement.parentNode.classList.add( "dropdown__menuitem--active" );
			addEdgeToDropdown( document.activeElement.parentNode );
			return;
		    }
		    
		    if ( document.activeElement.parentNode.classList.contains( "js-megamenu-listitem-with-nested-dropdown" ) ) {
			document.activeElement.parentNode.classList.add( "megamenu__listitem--active" );
			addEdgeToDropdown( document.activeElement.parentNode );
			return;
		    }
		    
		}
	    } );
	}
	
	alreadySetUpKeyEvents = true;
	
    }
    
    return {
	setUpAriaExpansion            : setUpAriaExpansion,
	setUpAccessibleNavigationMenus: setUpAccessibleNavigationMenus,
	focusOnElement                : focusOnElement
    }
    
}() );

theme.DOMHelpers = ( function () {
    
    /*
	 * @description - Determines if an element is off screen or not.
	 * @param element:<Node> - A DOMNode
	 * @return Boolean
	 */
    function isElementPastEdge( element ) {
	const bounding = element.getBoundingClientRect(),
	      l        = bounding.left,
	      w        = bounding.width,
	      docH     = document.documentElement.clientHeight,
	      docW     = document.documentElement.clientWidth;
	
	return ( l + w >= docW );
    }
    
    /**
     * Wrap tables in a container div to make them scrollable when needed
     *
     * @param {object} options - Options to be used
     * @param {NodeList} options.tables - Elements of the table(s) to wrap
     * @param {string} options.tableWrapperClass - table wrapper class name
     */
    
    function wrapTable( options ) {
	options.tables.forEach( function ( table ) {
	    var wrapper = document.createElement( 'div' );
	    wrapper.classList.add( options.tableWrapperClass );
	    table.parentNode.insertBefore( wrapper, table );
	    wrapper.appendChild( table );
	} );
    }
    
    /**
     * Wrap iframes in a container div to make them responsive
     *
     * @param {object} options - Options to be used
     * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
     * @param {string} options.iframeWrapperClass - class name used on the wrapping div
     */
    function wrapIframe( options ) {
	options.iframes.forEach( function ( iframe ) {
	    var wrapper = document.createElement( 'div' );
	    wrapper.classList.add( options.iframeWrapperClass );
	    iframe.parentNode.insertBefore( wrapper, iframe );
	    wrapper.appendChild( iframe );
	    iframe.src = iframe.src;
	} );
    }
    
    return {
	isElementPastEdge: isElementPastEdge,
	wrapIframe       : wrapIframe,
	wrapTable        : wrapTable
    };
    
}() );

theme.Helpers = ( function () {
    var touchDevice = false;
    
    function setTouch() {
	touchDevice = true;
    }
    
    function isTouch() {
	return touchDevice;
    }
    
    function debounce( func, wait, immediate ) {
	var timeout;
	
	return function () {
	    var context = this,
		args    = arguments;
	    
	    var later = function () {
		timeout = null;
		if ( !immediate ) func.apply( context, args );
	    };
	    
	    var callNow = immediate && !timeout;
	    clearTimeout( timeout );
	    timeout = setTimeout( later, wait );
	    if ( callNow ) func.apply( context, args );
	};
    }
    
    function makeSticky( amountToScroll, elementClass, elementHeight ) {
	const clearElement  = document.querySelector( ".js-clear-element" ),
	      stickyElement = document.querySelector( elementClass ),
	      height        = elementHeight + "px";
	
	if ( window.pageYOffset > amountToScroll ) {
	    stickyElement.classList.add( 'sticky--active' );
	    clearElement.style.height = height;
	} else {
	    stickyElement.classList.remove( 'sticky--active' );
	    clearElement.style.height = "0px";
	}
    }
    
    function animateCSS( element, animation, prefix = 'animate__' ) {
	return new Promise( function ( resolve, reject ) {
	    
	    const animationName = `${ prefix }${ animation }`;
	    // const node = document.querySelector(element);
	    const node          = element;
	    
	    node.classList.add( `${ prefix }animated`, animationName );
	    
	    // When the animation ends, we clean the classes and resolve the Promise
	    function handleAnimationEnd() {
		node.classList.remove( `${ prefix }animated`, animationName );
		resolve( 'Animation ended' );
	    }
	    
	    node.addEventListener( 'animationend', handleAnimationEnd, { once: true } );
	} );
    };
    
    function Toggle( id ) {
	var element = document.getElementById( id );
	if ( element.classList.contains( 'animate-hide' ) ) {
	    element.classList.remove( "animate-hide", "fadeOut" );
	    element.classList.add( "animate-show", "fadeIn" );
	    element.style.visibility = "visible";
	} else {
	    element.classList.remove( "animate-show", "fadeIn" );
	    element.classList.add( "animate-hide", "fadeOut" );
	    element.style.visibility = "hidden";
	}
    }
    
    function toggleClass( id, className ) {
	var element = document.getElementById( id );
	if ( !element ) return false;
	if ( element.classList.contains( className ) ) {
	    element.classList.remove( className );
	} else {
	    element.classList.add( className );
	}
    }
    
    function Accordion( container, tlink, submenu ) {
	
	let accorContent = container.querySelector( submenu );
	
	if ( !container.querySelector( tlink ) ) return false;
	
	container.querySelector( tlink ).addEventListener( 'click', function ( event ) {
	    event.preventDefault();
	    
	    // Toggle class on label and update a11y
	    if ( this.classList.contains( 'closed' ) ) {
		this.classList.remove( 'closed' );
		this.parentElement.classList.remove( 'closed' );
		this.setAttribute( 'aria-expanded', 'true' );
	    } else {
		this.classList.add( 'closed' );
		this.parentElement.classList.add( 'closed' );
		this.setAttribute( 'aria-expanded', 'false' );
	    }
	    
	    // Show content
	    if ( accorContent.classList.contains( 'closed' ) ) {
		accorContent.classList.remove( "closed" );
		accorContent.style.display = "block";
	    } else {
		accorContent.classList.add( "closed" );
		accorContent.style.display = "none";
	    }
	    
	} );
    }
    
    function fadeOut( el ) {
	el.style.opacity = 1;
	
	( function fade() {
	    if ( ( el.style.opacity -= .1 ) < 0 ) {
		el.style.display = "none";
	    } else {
		requestAnimationFrame( fade );
	    }
	} )();
    }
    
    function fadeIn( el, display ) {
	el.style.opacity = 0;
	el.style.display = display || "block";
	
	( function fade() {
	    var val = parseFloat( el.style.opacity );
	    if ( !( ( val += .1 ) > 1 ) ) {
		el.style.opacity = val;
		requestAnimationFrame( fade );
	    }
	} )();
    }
    
    function getScrollbarWidth() {
	// Creating invisible container
	const outer                 = document.createElement( 'div' );
	outer.style.visibility      = 'hidden';
	outer.style.overflow        = 'scroll'; // forcing scrollbar to appear
	outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	document.body.appendChild( outer );
	
	// Creating inner element and placing it in the container
	const inner = document.createElement( 'div' );
	outer.appendChild( inner );
	
	// Calculating difference between container's full width and the child width
	const scrollbarWidth = ( outer.offsetWidth - inner.offsetWidth );
	
	// Removing temporary elements from the DOM
	outer.parentNode.removeChild( outer );
	
	return scrollbarWidth;
    }
    
    function smoothScrollTo( endX, endY, duration ) {
	let startX         = window.scrollX || window.pageXOffset,
	    startY         = window.scrollY || window.pageYOffset,
	    distanceX      = endX - startX,
	    distanceY      = endY - startY,
	    startTime      = new Date().getTime();
	// Easing function
	let easeInOutQuart = function ( time, from, distance, duration ) {
	    if ( ( time /= duration / 2 ) < 1 ) return distance / 2 * time * time * time * time + from;
	    return -distance / 2 * ( ( time -= 2 ) * time * time * time - 2 ) + from;
	};
	let timer          = window.setInterval( function () {
	    let time = new Date().getTime() - startTime,
		newX = easeInOutQuart( time, startX, distanceX, duration ),
		newY = easeInOutQuart( time, startY, distanceY, duration );
	    if ( time >= duration ) {
		window.clearInterval( timer );
	    }
	    window.scrollTo( newX, newY );
	}, 1000 / 60 ); // 60 fps
    }
    
    return {
	setTouch         : setTouch,
	isTouch          : isTouch,
	debounce         : debounce,
	makeSticky       : makeSticky,
	animateCSS       : animateCSS,
	Toggle           : Toggle,
	toggleClass      : toggleClass,
	Accordion        : Accordion,
	fadeOut          : fadeOut,
	fadeIn           : fadeIn,
	getScrollbarWidth: getScrollbarWidth,
	smoothScrollTo   : smoothScrollTo
    };
} )();

theme.LibraryLoader = ( function () {
    var types = {
	link  : 'link',
	script: 'script'
    };
    
    var status = {
	requested: 'requested',
	loaded   : 'loaded'
    };
    
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
    
    var libraries = {
	youtubeSdk         : {
	    tagId: 'youtube-sdk',
	    src  : 'https://www.youtube.com/iframe_api',
	    type : types.script
	},
	plyrShopifyStyles  : {
	    tagId: 'plyr-shopify-styles',
	    src  : cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
	    type : types.link
	},
	modelViewerUiStyles: {
	    tagId: 'shopify-model-viewer-ui-styles',
	    src  : cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
	    type : types.link
	}
    };
    
    function load( libraryName, callback ) {
	var library = libraries[ libraryName ];
	
	if ( !library ) return;
	if ( library.status === status.requested ) return;
	
	callback = callback || function () {
	};
	if ( library.status === status.loaded ) {
	    callback();
	    return;
	}
	
	library.status = status.requested;
	
	var tag;
	
	switch ( library.type ) {
	    case types.script:
		tag = createScriptTag( library, callback );
		break;
	    case types.link:
		tag = createLinkTag( library, callback );
		break;
	}
	
	tag.id          = library.tagId;
	library.element = tag;
	
	var firstScriptTag = document.getElementsByTagName( library.type )[ 0 ];
	firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
    }
    
    function createScriptTag( library, callback ) {
	var tag = document.createElement( 'script' );
	tag.src = library.src;
	tag.addEventListener( 'load', function () {
	    library.status = status.loaded;
	    callback();
	} );
	return tag;
    }
    
    function createLinkTag( library, callback ) {
	var tag  = document.createElement( 'link' );
	tag.href = library.src;
	tag.rel  = 'stylesheet';
	tag.type = 'text/css';
	tag.addEventListener( 'load', function () {
	    library.status = status.loaded;
	    callback();
	} );
	return tag;
    }
    
    return {
	load: load
    };
} )();

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances    = [];
    document.addEventListener(
	'shopify:section:load',
	this._onSectionLoad.bind( this )
    );
    document.addEventListener(
	'shopify:section:unload',
	this._onSectionUnload.bind( this )
    );
    document.addEventListener(
	'shopify:section:select',
	this._onSelect.bind( this )
    );
    document.addEventListener(
	'shopify:section:deselect',
	this._onDeselect.bind( this )
    );
    document.addEventListener(
	'shopify:block:select',
	this._onBlockSelect.bind( this )
    );
    document.addEventListener(
	'shopify:block:deselect',
	this._onBlockDeselect.bind( this )
    );
};

theme.Sections.prototype = Object.assign( {}, theme.Sections.prototype, {
    _createInstance : function ( container, constructor ) {
	var id      = container.getAttribute( 'data-section-id' );
	var type    = container.getAttribute( 'data-section-type' );
	constructor = constructor || this.constructors[ type ];
	if ( typeof constructor === 'undefined' ) {
	    return;
	}
	var instance = Object.assign( new constructor( container ), {
	    id       : id,
	    type     : type,
	    container: container
	} );
	this.instances.push( instance );
    },
    _onSectionLoad  : function ( evt ) {
	var container = document.querySelector(
	    '[data-section-id="' + evt.detail.sectionId + '"]'
	);
	if ( container ) {
	    this._createInstance( container );
	}
    },
    _onSectionUnload: function ( evt ) {
	this.instances = this.instances.filter( function ( instance ) {
	    var isEventInstance = instance.id === evt.detail.sectionId;
	    if ( isEventInstance ) {
		if ( typeof instance.onUnload === 'function' ) {
		    instance.onUnload( evt );
		}
	    }
	    return !isEventInstance;
	} );
    },
    _onSelect       : function ( evt ) {
	// eslint-disable-next-line no-shadow
	var instance = this.instances.find( function ( instance ) {
	    return instance.id === evt.detail.sectionId;
	} );
	if (
	    typeof instance !== 'undefined' &&
	    typeof instance.onSelect === 'function'
	) {
	    instance.onSelect( evt );
	}
    },
    _onDeselect     : function ( evt ) {
	// eslint-disable-next-line no-shadow
	var instance = this.instances.find( function ( instance ) {
	    return instance.id === evt.detail.sectionId;
	} );
	if (
	    typeof instance !== 'undefined' &&
	    typeof instance.onDeselect === 'function'
	) {
	    instance.onDeselect( evt );
	}
    },
    _onBlockSelect  : function ( evt ) {
	// eslint-disable-next-line no-shadow
	var instance = this.instances.find( function ( instance ) {
	    return instance.id === evt.detail.sectionId;
	} );
	if (
	    typeof instance !== 'undefined' &&
	    typeof instance.onBlockSelect === 'function'
	) {
	    instance.onBlockSelect( evt );
	}
    },
    _onBlockDeselect: function ( evt ) {
	// eslint-disable-next-line no-shadow
	var instance = this.instances.find( function ( instance ) {
	    return instance.id === evt.detail.sectionId;
	} );
	if (
	    typeof instance !== 'undefined' &&
	    typeof instance.onBlockDeselect === 'function'
	) {
	    instance.onBlockDeselect( evt );
	}
    },
    register        : function ( type, constructor ) {
	this.constructors[ type ] = constructor;
	document.querySelectorAll( '[data-section-type="' + type + '"]' ).forEach(
	    function ( container ) {
		this._createInstance( container, constructor );
	    }.bind( this )
	);
    }
} );

theme.Disclosure = ( function () {
    var selectors = {
	disclosureForm   : '[data-disclosure-form]',
	disclosureList   : '[data-disclosure-list]',
	disclosureToggle : '[data-disclosure-toggle]',
	disclosureInput  : '[data-disclosure-input]',
	disclosureOptions: '[data-disclosure-option]'
    };
    
    var classes = {
	listVisible: 'disclosure-list--visible'
    };
    
    function Disclosure( disclosure ) {
	this.container = disclosure;
	this._cacheSelectors();
	this._setupListeners();
    }
    
    Disclosure.prototype = Object.assign( {}, Disclosure.prototype, {
	_cacheSelectors: function () {
	    this.cache = {
		disclosureForm   : this.container.closest( selectors.disclosureForm ),
		disclosureList   : this.container.querySelector( selectors.disclosureList ),
		disclosureToggle : this.container.querySelector(
		    selectors.disclosureToggle
		),
		disclosureInput  : this.container.querySelector(
		    selectors.disclosureInput
		),
		disclosureOptions: this.container.querySelectorAll(
		    selectors.disclosureOptions
		)
	    };
	},
	
	_setupListeners: function () {
	    this.eventHandlers = this._setupEventHandlers();
	    
	    this.cache.disclosureToggle.addEventListener(
		'click',
		this.eventHandlers.toggleList
	    );
	    
	    this.cache.disclosureOptions.forEach( function ( disclosureOption ) {
		disclosureOption.addEventListener(
		    'click',
		    this.eventHandlers.connectOptions
		);
	    }, this );
	    
	    this.container.addEventListener(
		'keyup',
		this.eventHandlers.onDisclosureKeyUp
	    );
	    
	    this.cache.disclosureList.addEventListener(
		'focusout',
		this.eventHandlers.onDisclosureListFocusOut
	    );
	    
	    this.cache.disclosureToggle.addEventListener(
		'focusout',
		this.eventHandlers.onDisclosureToggleFocusOut
	    );
	    
	    document.body.addEventListener( 'click', this.eventHandlers.onBodyClick );
	},
	
	_setupEventHandlers: function () {
	    return {
		connectOptions            : this._connectOptions.bind( this ),
		toggleList                : this._toggleList.bind( this ),
		onBodyClick               : this._onBodyClick.bind( this ),
		onDisclosureKeyUp         : this._onDisclosureKeyUp.bind( this ),
		onDisclosureListFocusOut  : this._onDisclosureListFocusOut.bind( this ),
		onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind( this )
	    };
	},
	
	_connectOptions: function ( event ) {
	    event.preventDefault();
	    
	    this._submitForm( event.currentTarget.dataset.value );
	},
	
	_onDisclosureToggleFocusOut: function ( event ) {
	    var disclosureLostFocus =
		    this.container.contains( event.relatedTarget ) === false;
	    
	    if ( disclosureLostFocus ) {
		this._hideList();
	    }
	},
	
	_onDisclosureListFocusOut: function ( event ) {
	    var childInFocus = event.currentTarget.contains( event.relatedTarget );
	    
	    var isVisible = this.cache.disclosureList.classList.contains(
		classes.listVisible
	    );
	    
	    if ( isVisible && !childInFocus ) {
		this._hideList();
	    }
	},
	
	_onDisclosureKeyUp: function ( event ) {
	    if ( event.which !== 27 ) return;
	    this._hideList();
	    this.cache.disclosureToggle.focus();
	},
	
	_onBodyClick: function ( event ) {
	    var isOption  = this.container.contains( event.target );
	    var isVisible = this.cache.disclosureList.classList.contains(
		classes.listVisible
	    );
	    
	    if ( isVisible && !isOption ) {
		this._hideList();
	    }
	},
	
	_submitForm: function ( value ) {
	    this.cache.disclosureInput.value = value;
	    this.cache.disclosureForm.submit();
	},
	
	_hideList: function () {
	    this.cache.disclosureList.classList.remove( classes.listVisible );
	    this.cache.disclosureToggle.setAttribute( 'aria-expanded', false );
	},
	
	_toggleList: function () {
	    var ariaExpanded =
		    this.cache.disclosureToggle.getAttribute( 'aria-expanded' ) === 'true';
	    this.cache.disclosureList.classList.toggle( classes.listVisible );
	    this.cache.disclosureToggle.setAttribute( 'aria-expanded', !ariaExpanded );
	},
	
	destroy: function () {
	    this.cache.disclosureToggle.removeEventListener(
		'click',
		this.eventHandlers.toggleList
	    );
	    
	    this.cache.disclosureOptions.forEach( function ( disclosureOption ) {
		disclosureOption.removeEventListener(
		    'click',
		    this.eventHandlers.connectOptions
		);
	    }, this );
	    
	    this.container.removeEventListener(
		'keyup',
		this.eventHandlers.onDisclosureKeyUp
	    );
	    
	    this.cache.disclosureList.removeEventListener(
		'focusout',
		this.eventHandlers.onDisclosureListFocusOut
	    );
	    
	    this.cache.disclosureToggle.removeEventListener(
		'focusout',
		this.eventHandlers.onDisclosureToggleFocusOut
	    );
	    
	    document.body.removeEventListener(
		'click',
		this.eventHandlers.onBodyClick
	    );
	}
    } );
    
    return Disclosure;
} )();

/*============================================================================
 Shopify Functions
==============================================================================*/
Shopify.theme.cart = ( function ( exports ) {
    'use strict';
    
    function getDefaultRequestConfig() {
	return JSON.parse(
	    JSON.stringify( {
		credentials: 'same-origin',
		headers    : {
		    'X-Requested-With': 'XMLHttpRequest',
		    'Content-Type'    : 'application/json;'
		}
	    } )
	);
    }
    
    function fetchJSON( url, config ) {
	return fetch( url, config ).then( function ( response ) {
	    if ( !response.ok ) {
		throw response;
	    }
	    return response.json();
	} );
    }
    
    function cart() {
	return fetchJSON( '/cart.js', getDefaultRequestConfig() );
    }
    
    function cartAdd( id, quantity, properties ) {
	var config = getDefaultRequestConfig();
	
	config.method = 'POST';
	config.body   = JSON.stringify( {
	    id        : id,
	    quantity  : quantity,
	    properties: properties
	} );
	
	return fetchJSON( '/cart/add.js', config );
    }
    
    function cartAddFromForm( formData ) {
	var config = getDefaultRequestConfig();
	delete config.headers[ 'Content-Type' ];
	
	config.method = 'POST';
	config.body   = formData;
	
	return fetchJSON( '/cart/add.js', config );
    }
    
    function cartChange( line, options ) {
	var config = getDefaultRequestConfig();
	
	options = options || {};
	
	config.method = 'POST';
	config.body   = JSON.stringify( {
	    line      : line,
	    quantity  : options.quantity,
	    properties: options.properties
	} );
	
	return fetchJSON( '/cart/change.js', config );
    }
    
    function cartClear() {
	var config    = getDefaultRequestConfig();
	config.method = 'POST';
	
	return fetchJSON( '/cart/clear.js', config );
    }
    
    function cartUpdate( body ) {
	var config = getDefaultRequestConfig();
	
	config.method = 'POST';
	config.body   = JSON.stringify( body );
	
	return fetchJSON( '/cart/update.js', config );
    }
    
    function cartShippingRates() {
	return fetchJSON( '/cart/shipping_rates.json', getDefaultRequestConfig() );
    }
    
    function key( key ) {
	if ( typeof key !== 'string' || key.split( ':' ).length !== 2 ) {
	    throw new TypeError(
		'Theme Cart: Provided key value is not a string with the format xxx:xxx'
	    );
	}
    }
    
    function quantity( quantity ) {
	if ( typeof quantity !== 'number' || isNaN( quantity ) ) {
	    throw new TypeError(
		'Theme Cart: An object which specifies a quantity or properties value is required'
	    );
	}
    }
    
    function id( id ) {
	if ( typeof id !== 'number' || isNaN( id ) ) {
	    throw new TypeError( 'Theme Cart: Variant ID must be a number' );
	}
    }
    
    function properties( properties ) {
	if ( typeof properties !== 'object' ) {
	    throw new TypeError( 'Theme Cart: Properties must be an object' );
	}
    }
    
    function form( form ) {
	if ( !( form instanceof HTMLFormElement ) ) {
	    throw new TypeError( 'Theme Cart: Form must be an instance of HTMLFormElement' );
	}
    }
    
    function options( options ) {
	if ( typeof options !== 'object' ) {
	    throw new TypeError( 'Theme Cart: Options must be an object' );
	}
	
	if (
	    typeof options.quantity === 'undefined' &&
	    typeof options.properties === 'undefined'
	) {
	    throw new Error(
		'Theme Cart: You muse define a value for quantity or properties'
	    );
	}
	
	if ( typeof options.quantity !== 'undefined' ) {
	    quantity( options.quantity );
	}
	
	if ( typeof options.properties !== 'undefined' ) {
	    properties( options.properties );
	}
    }
    
    /**
     * Cart Template Script
     * ------------------------------------------------------------------------------
     * A file that contains scripts highly couple code to the Cart template.
     *
     * @namespace cart
     */
    
    /**
     * Returns the state object of the cart
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function getState() {
	return cart().then( function ( cart ) {
	    Events.trigger( "cart:ready", cart )
	} );
    }
    
    /**
     * Returns the object of the cart
     * @returns {Promise} Resolves with the object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function getCart() {
	return cart().then( function ( cart ) {
	    return cart;
	} );
    }
    
    /**
     * Returns the index of the cart line item
     * @param {string} key The unique key of the line item
     * @returns {Promise} Resolves with the index number of the line item
     */
    function getItemIndex( key$$1 ) {
	key( key$$1 );
	
	return cart().then( function ( state ) {
	    var index = -1;
	    
	    state.items.forEach( function ( item, i ) {
		index = item.key === key$$1 ? i + 1 : index;
	    } );
	    
	    if ( index === -1 ) {
		return Promise.reject(
		    new Error( 'Theme Cart: Unable to match line item with provided key' )
		);
	    }
	    
	    return index;
	} );
    }
    
    /**
     * Fetches the line item object
     * @param {string} key The unique key of the line item
     * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
     */
    function getItem( key$$1 ) {
	key( key$$1 );
	
	return cart().then( function ( state ) {
	    var lineItem = null;
	    
	    state.items.forEach( function ( item ) {
		lineItem = item.key === key$$1 ? item : lineItem;
	    } );
	    
	    if ( lineItem === null ) {
		return Promise.reject(
		    new Error( 'Theme Cart: Unable to match line item with provided key' )
		);
	    }
	    return lineItem;
	} );
    }
    
    /**
     * Add a new line item to the cart
     * @param {number} id The variant's unique ID
     * @param {object} options Optional values to pass to /cart/add.js
     * @param {number} options.quantity The quantity of items to be added to the cart
     * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
     * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
     */
    function addItem( id$$1, options$$1 ) {
	options$$1 = options$$1 || {};
	
	id( id$$1 );
	
	return cartAdd( id$$1, options$$1.quantity, options$$1.properties );
    }
    
    /**
     * Add a new line item to the cart from a product form
     * @param {object} form DOM element which is equal to the <form> node
     * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
     */
    function addItemFromForm( form$$1 ) {
	form( form$$1 );
	
	var formData = new FormData( form$$1 );
	id( parseInt( formData.get( 'id' ), 10 ) );
	
	return cartAddFromForm( formData );
    }
    
    /**
     * Changes the quantity and/or properties of an existing line item.
     * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
     * @param {object} options Optional values to pass to /cart/add.js
     * @param {number} options.quantity The quantity of items to be added to the cart
     * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function updateItem( key$$1, options$$1 ) {
	key( key$$1 );
	options( options$$1 );
	
	return getItemIndex( key$$1 ).then( function ( line ) {
	    return cartChange( line, options$$1 );
	} );
    }
    
    /**
     * Removes a line item from the cart
     * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function removeItem( key$$1 ) {
	key( key$$1 );
	
	return getItemIndex( key$$1 ).then( function ( line ) {
	    return cartChange( line, { quantity: 0 } );
	} );
    }
    
    /**
     * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
     * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
     */
    function clearItems() {
	return cartClear().then( function () {
	    Events.trigger( "cart:clear" );
	} );
    }
    
    /**
     * Gets all cart attributes
     * @returns {Promise} Resolves with the cart attributes object
     */
    function getAttributes() {
	return cart().then( function ( state ) {
	    return state.attributes;
	} );
    }
    
    /**
     * Sets all cart attributes
     * @returns {Promise} Resolves with the cart state object
     */
    function updateAttributes( attributes ) {
	return cartUpdate( { attributes: attributes } );
    }
    
    /**
     * Clears all cart attributes
     * @returns {Promise} Resolves with the cart state object
     */
    function clearAttributes() {
	return getAttributes().then( function ( attributes ) {
	    for ( var key$$1 in attributes ) {
		attributes[ key$$1 ] = '';
	    }
	    return updateAttributes( attributes );
	} );
    }
    
    /**
     * Gets cart note
     * @returns {Promise} Resolves with the cart note string
     */
    function getNote() {
	return cart().then( function ( state ) {
	    return state.note;
	} );
    }
    
    /**
     * Sets cart note
     * @returns {Promise} Resolves with the cart state object
     */
    function updateNote( note ) {
	return cartUpdate( { note: note } );
    }
    
    /**
     * Clears cart note
     * @returns {Promise} Resolves with the cart state object
     */
    function clearNote() {
	return cartUpdate( { note: '' } );
    }
    
    /**
     * Get estimated shipping rates.
     * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
     */
    function getShippingRates() {
	return cartShippingRates();
    }
    
    exports.getState         = getState;
    exports.getCart          = getCart;
    exports.getItemIndex     = getItemIndex;
    exports.getItem          = getItem;
    exports.addItem          = addItem;
    exports.addItemFromForm  = addItemFromForm;
    exports.updateItem       = updateItem;
    exports.removeItem       = removeItem;
    exports.clearItems       = clearItems;
    exports.getAttributes    = getAttributes;
    exports.updateAttributes = updateAttributes;
    exports.clearAttributes  = clearAttributes;
    exports.getNote          = getNote;
    exports.updateNote       = updateNote;
    exports.clearNote        = clearNote;
    exports.getShippingRates = getShippingRates;
    
    return exports;
    
}( {} ) );

Shopify.theme.ajaxCart = {
    init              : function init() {
	let config = document.getElementById( 'cart-config' );
	if ( !config ) return false;
	config = JSON.parse( config.innerHTML || '{}' );
	
	var selectors = {
	    cartTrigger   : '.js-mini-cart-trigger',
	    cartPageLoader: '.ajax-cart__page-wrapper .js-mini-cart-loader',
	    addToCart     : '.js-ajax-submit',
	    stickyCart    : '.js-sticky-cart'
	};
	
	// Init carts
	this.initializeAjaxCart( config );
	
	// Init cart type
	if ( config.cart_action == 'drawer' ) {
	    WAU.Slideout.init( "ajax-cart" );
	} else if ( config.cart_action == 'modal_cart' ) {
	    WAU.Modal.init( "ajax-cart" );
	} else if ( config.cart_action == 'mini_cart' ) {
	    WAU.Modal.init( "mini-ajax-cart" );
	}
	
	// Override add to cart form
	document.querySelectorAll( selectors.addToCart ).forEach( ( element, i ) => {
	    element.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		
		var addToCartForm = this.closest( 'form' );
		Shopify.theme.ajaxCart.addToCart( addToCartForm, element.parentNode, config, false );
		
		return false;
	    } );
	} );
	
	// Update cart page on load
	if ( document.querySelector( 'body' ).classList.contains( 'template-cart' ) ) {
	    Shopify.theme.cart.getCart().then( Cart => {
		Shopify.theme.ajaxCart.updateView( config, Cart );
		
		// Remove page loader
		setTimeout( function () {
		    document.querySelector( 'body' ).classList.add( 'cart-loaded' );
		    // Trigger sticky cart on cart page
		    Shopify.theme.ajaxCart.cartStickyBar();
		}, 800 );
		
	    } );
	}
	
	// On cart trigger click
	let cartTriggers = document.querySelectorAll( selectors.cartTrigger );
	
	cartTriggers.forEach( ( item, i ) => {
	    item.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		
		// Open drawer
		Shopify.theme.cart.getCart().then( Cart => {
		    
		    Shopify.theme.ajaxCart.updateView( config, Cart );
		    
		    if ( config.cart_action == 'drawer' ) {
			Shopify.theme.ajaxCart.showDrawer( config );
		    } else if ( config.cart_action == 'modal_cart' ) {
			Shopify.theme.ajaxCart.showModal( config );
		    } else if ( config.cart_action == 'mini_cart' ) {
			Shopify.theme.ajaxCart.showModal( config );
		    } else {
			window.location.href = config.cart_url;
		    }
		    
		} );
		
		return false;
	    } );
	} );
    },
    cartStickyBar     : function cartStickyBar() {
	let lastKnownScrollPosition = 0;
	let ticking                 = false;
	
	function initSticky( scrollPos ) {
	    var cartForm = document.querySelectorAll( '.js-cart-form' );
	    if ( !cartForm ) return false;
	    
	    cartForm.forEach( ( item, i ) => {
		var topOfHiddenDiv = item.offsetTop;
		var position       = scrollPos >= topOfHiddenDiv,
		    footer         = document.getElementById( 'footer' ),
		    stickyBar      = document.querySelector( '.js-sticky-cart' );
		
		if ( i === 1 ) return false;
		
		if ( position && !stickyBar.classList.contains( 'show' ) ) {
		    stickyBar.classList.add( 'show' );
		    footer.classList.add( 'padding-sticky' );
		} else if ( !position && stickyBar.classList.contains( 'show' ) ) {
		    stickyBar.classList.remove( 'show' );
		    footer.classList.remove( 'padding-sticky' );
		}
	    } );
	}
	
	document.addEventListener( 'scroll', function ( e ) {
	    lastKnownScrollPosition = window.scrollY;
	    
	    if ( !ticking ) {
		window.requestAnimationFrame( function () {
		    initSticky( lastKnownScrollPosition );
		    ticking = false;
		} );
		
		ticking = true;
	    }
	} );
	
    },
    cartEvents        : function cartEvents( config ) {
	var selectors = {
	    cartDrawerRemove     : '.js-cart-remove',
	    cartDrawerQty        : '[data-item-qty]',
	    cartDrawerQtyDecrease: '[data-ajax-qty-decrease]',
	    cartDrawerQtyIncrease: '[data-ajax-qty-increase]',
	    cartNote             : '.js-cart-note'
	};
	
	// Cart Events
	document.querySelectorAll( selectors.cartDrawerQty )?.forEach( ( element, i ) => {
	    element.addEventListener( 'change', function ( e ) {
		e.preventDefault();
		
		var quantity    = parseInt( this.value ),
		    itemKey     = this.dataset.itemKey,
		    itemMax     = this.dataset.limit,
		    lineElement = element.closest( '.ajax-cart__cart-item' );
		
		// Set new quantity
		element.value = quantity;
		
		// Adjust cart object
		setTimeout( function () {
		    
		    if ( quantity === 0 ) {
			Shopify.theme.ajaxCart.removeFromCart( itemKey, config );
		    } else {
			Shopify.theme.ajaxCart.checkLimit( itemMax, quantity, lineElement, config );
			Shopify.theme.cart.updateItem( itemKey, { quantity } ).then( state => {
			    Shopify.theme.ajaxCart.updateView( config, state );
			} );
		    }
		}, 250 );
		return false;
	    } ); // End add event listener
	} ); // End of querySelectorAll
	document.querySelectorAll( selectors.cartDrawerRemove ).forEach( ( element, i ) => {
	    element.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		
		var itemKey = this.dataset.itemKey;
		
		Shopify.theme.ajaxCart.removeFromCart( itemKey, config );
		
		return false;
	    } );
	} );
	document.querySelectorAll( selectors.cartDrawerQtyDecrease ).forEach( ( element, i ) => {
	    element.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		
		if ( this.nextElementSibling.value === '1' ) {
		    var itemKey = this.dataset.itemKey;
		    Shopify.theme.ajaxCart.removeFromCart( itemKey, config );
		} else {
		    var itemId = this.dataset.ajaxQtyDecrease;
		    Shopify.theme.ajaxCart.adjustQty( -1, itemId, config );
		}
		
		return false;
	    } );
	} );
	document.querySelectorAll( selectors.cartDrawerQtyIncrease ).forEach( ( element, i ) => {
	    element.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		
		var itemId = this.dataset.ajaxQtyIncrease;
		Shopify.theme.ajaxCart.adjustQty( +1, itemId, config );
		
		return false;
	    } );
	} );
	document.querySelectorAll( selectors.cartNote ).forEach( ( element, i ) => {
	    
	    element.addEventListener( 'blur', ( event ) => {
		let note = element.value;
		Shopify.theme.cart.updateNote( note ).then( state => {
		    Shopify.theme.ajaxCart.updateView( config, state );
		} );
	    } );
	    
	} );
	
	// Reinit shipping calc
	if ( config.show_calculator ) {
	    setTimeout( function () {
		Shopify.theme.shippingCalculator.init();
	    }, 1000 );
	}
	
	// Restart Payment buttons
	if ( Shopify && Shopify.StorefrontExpressButtons ) {
	    Shopify.StorefrontExpressButtons.initialize();
	}
    },
    showDrawer        : function showDrawer( config ) {
	if ( config.cart_action != 'drawer' ) return false;
	
	WAU.Slideout._openByName( "ajax-cart" );
    },
    hideDrawer        : function hideDrawer( config ) {
	if ( config.cart_action != 'drawer' ) return false;
	
	WAU.Slideout._closeByName( "ajax-cart" );
    },
    showModal         : function showModal( config ) {
	if ( config.cart_action == 'modal_cart' ) {
	    WAU.Modal._openByName( "ajax-cart" );
	} else if ( config.cart_action == 'mini_cart' ) {
	    WAU.Modal._openByName( "mini-ajax-cart" );
	}
    },
    hideModal         : function hideModal( config ) {
	if ( config.cart_action == 'modal_cart' ) {
	    WAU.Modal._closeByName( "ajax-cart" );
	} else if ( config.cart_action == 'mini_cart' ) {
	    WAU.Modal._closeByName( "mini-ajax-cart" );
	}
    },
    removeFromCart    : function removeFromCart( itemKey, config, callback ) {
	Shopify.theme.cart.removeItem( itemKey ).then( state => {
	    Shopify.theme.ajaxCart.updateView( config, state );
	} );
    },
    adjustQty         : function adjustQty( value, itemId, config ) {
	
	var selectors = {
	    lineItem   : '.item_' + itemId,
	    updatesItem: '.updates_' + itemId
	};
	
	// Update Line Item
	document.querySelectorAll( selectors.lineItem ).forEach( ( element, i ) => {
	    elementInput = element.querySelector( selectors.updatesItem ),
		key = elementInput.dataset.itemKey,
		max = elementInput.dataset.limit,
		quantity = parseInt( elementInput.value ) + parseInt( value );
	    
	    // Check limit to prevent over adding
	    Shopify.theme.ajaxCart.checkLimit( max, quantity, element, config );
	    
	    // Check new qty to prevent going lower than 1
	    if ( quantity === 0 ) return false;
	    
	    // Set new quantity
	    elementInput.value = quantity;
	    
	    // Adjust cart object
	    setTimeout( function () {
		Shopify.theme.cart.updateItem( key, { quantity } ).then( state => {
		    Shopify.theme.ajaxCart.updateView( config, state );
		} );
	    }, 250 );
	    
	} );
    },
    checkLimit        : function checkLimit( max, quantity, element, config ) {
	// Check limit to prevent over adding
	if ( max != '' && quantity > max ) {
	    
	    let cartNote = document.createElement( 'div' );
	    
	    cartNote.classList.add( 'mini-cart__cart-note' );
	    cartNote.innerHTML = '<p class="a-center"><b>' + config.cart_error + '</b>&nbsp;&nbsp;' + config.update_qty_error + '</p>';
	    
	    let adjacentElement = element.querySelector( '.js-item-quantity' );
	    let parentElement   = adjacentElement.parentNode;
	    
	    parentElement.appendChild( cartNote, adjacentElement );
	    
	    setTimeout( function () {
		theme.Helpers.fadeOut( cartNote );
		parentElement.removeChild( cartNote );
	    }, 7000 );
	    
	    return false;
	}
    },
    addToCart         : function addToCart( addToCartForm, formContext, config, isQuickview ) {
	var selectors = {
	    addToCart   : '.js-ajax-submit',
	    cartAddedMsg: '.js-added-msg'
	}
	
	let context;
	
	if ( isQuickview ) {
	    context = document.querySelector( '.js-quickview-content' );
	} else {
	    context = formContext;
	}
	
	// Disable add to cart button temporarily]
	context.querySelector( selectors.addToCart ).value = config.adding_to_cart;
	context.querySelector( selectors.addToCart ).classList.add( 'disabled' );
	context.querySelector( selectors.addToCart ).getAttribute( 'disabled', 'disabled' );
	
	Shopify.theme.cart.addItemFromForm( addToCartForm ).then( item => {
	    // Re-enable add to cart button
	    context.querySelector( selectors.addToCart ).value = config.added_to_cart;
	    context.querySelector( selectors.addToCart ).classList.remove( 'disabled' );
	    context.querySelector( selectors.addToCart ).removeAttribute( 'disabled', 'disabled' );
	    
	    setTimeout( function () {
		context.querySelector( selectors.addToCart ).value = config.add_to_cart;
	    }, 3000 );
	    
	    Shopify.theme.cart.getCart().then( Cart => {
		
		if ( isQuickview && config.cart_added_event != 'product_page' ) {
		    Shopify.theme.quickview.hideModal();
		} else if ( isQuickview && config.cart_added_event == 'product_page' ) {
		    theme.Helpers.fadeIn( context.querySelector( selectors.cartAddedMsg ) );
		    
		    setTimeout( function () {
			theme.Helpers.fadeOut( context.querySelector( selectors.cartAddedMsg ) );
		    }, 3000 );
		}
		
		if ( config.cart_action == 'drawer' && config.cart_added_event == 'mini_cart' ) {
		    Shopify.theme.ajaxCart.showDrawer( config );
		} else if ( config.cart_action == 'modal_cart' && config.cart_added_event == 'mini_cart' ) {
		    Shopify.theme.ajaxCart.showModal( config );
		} else if ( config.cart_action == 'mini_cart' && config.cart_added_event == 'mini_cart' ) {
		    Shopify.theme.ajaxCart.showModal( config );
		} else if ( config.cart_action == 'page_only' && config.cart_added_event == 'mini_cart' ) {
		    window.location.href = config.cart_url;
		} else if ( config.cart_added_event == 'product_page' ) {
		    theme.Helpers.fadeIn( context.querySelector( selectors.cartAddedMsg ) );
		    
		    setTimeout( function () {
			theme.Helpers.fadeOut( context.querySelector( selectors.cartAddedMsg ) );
		    }, 3000 );
		} else {
		    window.location.href = config.cart_url;
		}
		
		Shopify.theme.ajaxCart.updateView( config, Cart );
	    } );
	} ).catch( error => {
	    if ( error.status == 422 ) {
		
		// Show error msg
		theme.Helpers.fadeIn( context.querySelector( '.js-error-msg' ) );
		
		// Re-enable add to cart button
		context.querySelector( selectors.addToCart ).value = config.add_to_cart;
		context.querySelector( selectors.addToCart ).classList.remove( 'disabled' );
		context.querySelector( selectors.addToCart ).removeAttribute( 'disabled', 'disabled' );
		
		setTimeout( function () {
		    theme.Helpers.fadeOut( context.querySelector( '.js-error-msg' ) );
		}, 3000 );
	    } else {
		console.log( error )
	    }
	} );
    },
    getAjaxCart       : function getAjaxCart( response ) {
	const el     = document.createElement( 'div' );
	el.innerHTML = response;
	
	const responseOptions = JSON.parse( el.querySelector( '[data-options]' ).innerHTML );
	const htmls           = el.querySelectorAll( '[data-html]' );
	
	let html = {};
	if ( htmls.length === 1 && htmls[ 0 ].getAttribute( 'data-html' ) === '' ) {
	    html = htmls[ 0 ].innerHTML;
	} else {
	    for ( let i = 0; i < htmls.length; i++ ) {
		html[ htmls[ i ].getAttribute( 'data-html' ) ] = htmls[ i ].innerHTML;
	    }
	}
	let options = responseOptions;
	
	return html;
    },
    initializeAjaxCart: function initializeAjaxCart( config ) {
	let data, url;
	url = config.cart_url + '/?view=ajax';
	
	fetch( url, data )
	    .then( res => res.text() )
	    .then( response => {
		let html = Shopify.theme.ajaxCart.getAjaxCart( response );
		
		// Replace cart content
		document.querySelectorAll( '.js-ajax-cart-content' ).forEach( ( item, i ) => {
		    item.innerHTML = html.content;
		} );
		
	    } ).then( response => {
	    // Init shipping calc
	    if ( config.show_calculator ) {
		setTimeout( function () {
		    Shopify.theme.shippingCalculator.init();
		}, 1000 );
	    }
	} ).catch( error => {
	    console.log( error )
	} );
    },
    updateView        : function updateView( config, Cart ) {
	let data, url;
	url = config.cart_url + '/?view=ajax';
	
	fetch( url, data )
	    .then( res => res.text() )
	    .then( response => {
		let html = Shopify.theme.ajaxCart.getAjaxCart( response );
		
		var selectors = {
		    cartContent  : '.js-ajax-cart-content',
		    cartEmpty    : '.js-cart-empty',
		    cartForm     : '.js-cart-form',
		    cartAccordion: '.js-cart-accordion',
		    cartCount    : '.js-cart-count'
		};
		
		/**
		 * Updates the sticky cart
		 * @param  {object} Cart   Cart object
		 * @param  {config} config config object
		 */
		const updateStickyCart = function ( cart, config, disable = false ) {
		    
		    const selectors = {
			stickyCart    : '.js-sticky-cart',
			cartTotal     : '.js-cart-total',
			checkoutButton: '.js-sticky-checkout-btn'
		    };
		    
		    // Check for necessary arguments
		    if ( !cart ) {
			console.log( 'Error. updateStickyCart requires a Cart object' );
			return false;
		    }
		    if ( !config ) {
			console.log( 'Error. updateStickyCart requires a config object' );
			return false;
		    }
		    
		    // Update sticky cart price
		    document.querySelectorAll( selectors.stickyCart )?.forEach( ( stickyCart, i ) => {
			
			// Get the original price element
			let cartOriginalPriceEl = stickyCart.querySelector( selectors.cartTotal );
			
			// Format the price
			let formattedPrice = Shopify.formatMoney( cart.total_price, config.money_format );
			
			// Log error if no original price element was found
			if ( !cartOriginalPriceEl ) {
			    console.log( 'Error. No original price element found in sticky cart' );
			}
			
			// Update the price
			cartOriginalPriceEl.innerHTML = formattedPrice;
			window.sintraElectronicInvoice().init();
			//
			// Disable checkout button
			//
			
			// Get the checkout button
			let checkoutButton = stickyCart.querySelector( selectors.checkoutButton );
			
			// If disable
			if ( disable && checkoutButton && checkoutButton.disabled == false ) {
			    checkoutButton.disabled = true;
			} else {
			    checkoutButton.disabled = false;
			}
		    } );
		};
		
		if ( Cart.item_count === 0 ) {
		    // Hide form
		    document.querySelectorAll( selectors.cartForm ).forEach( ( item, i ) => {
			item.classList.add( 'hide' );
		    } );
		    // Show empty msg
		    document.querySelectorAll( selectors.cartEmpty ).forEach( ( item, i ) => {
			item.classList.remove( 'hide' );
		    } );
		    // Update cart count
		    document.querySelectorAll( selectors.cartCount ).forEach( ( item, i ) => {
			item.innerHTML = '0';
		    } );
		    
		    // Update sticky cart total if on the cart page
		    if ( document.querySelector( 'body' ).classList.contains( 'template-cart' ) ) {
			updateStickyCart( Cart, config, true );
		    }
		} else {
		    // Hide empty msg
		    document.querySelectorAll( selectors.cartEmpty ).forEach( ( item, i ) => {
			item.classList.add( 'hide' );
		    } );
		    // Update cart count
		    document.querySelectorAll( selectors.cartCount ).forEach( ( item, i ) => {
			item.innerHTML = Cart.item_count;
		    } );
		    // Replace cart page and drawer content
		    document.querySelectorAll( selectors.cartContent ).forEach( ( item, i ) => {
			item.innerHTML = html.content;
		    } );
		    // Reload accordions
		    document.querySelectorAll( selectors.cartAccordion ).forEach( ( item, i ) => {
			theme.Helpers.Accordion( item, '.tlink.has_sub_menu a', '.accordion-content.sub' );
			theme.Helpers.Accordion( item, '.tlink2.has_sub_menu a', '.accordion-content2.sub' );
		    } );
		    
		    // Update sticky cart total if on the cart page
		    if ( document.querySelector( 'body' ).classList.contains( 'template-cart' ) ) {
			updateStickyCart( Cart, config );
		    }
		    
		    // Reload events
		    Shopify.theme.ajaxCart.cartEvents( config );
		    
		}
		
		// Set Cart Loaded
		setTimeout( function () {
		    document.querySelector( 'body' ).classList.add( 'cart-loaded' );
		    
		    // Remove dynamic buttons from drawer or model if on cart page
		    if ( config.cart_action == 'mini_cart' ) {
			if ( document.querySelectorAll( '#dynamic-checkout-cart' ).length > 2 ) {
			    document.querySelectorAll( '.js-mini-cart-wrapper #dynamic-checkout-cart' ).forEach( ( item, i ) => {
				item.remove();
			    } );
			}
		    } else {
			if ( document.querySelectorAll( '#dynamic-checkout-cart' ).length >= 2 ) document.querySelectorAll( '#dynamic-checkout-cart' )[ 1 ].remove();
		    }
		    
		    window.sintraElectronicInvoice().init();
		    
		}, 500 );
		
		
	    } )
	    .catch( error => {
		console.log( error )
	    } );
    }
}

Shopify.theme.shippingCalculator = {
    init          : function init() {
	var config = document.getElementById( 'cart-config' );
	if ( !config ) return false;
	var config = JSON.parse( config.innerHTML || '{}' );
	
	var selectors = {
	    container           : '.js-shipping-calc-wrapper',
	    submitButton        : '.js-shipping-calc-submit',
	    addressZip          : '.js-shipping-calc-address-zip',
	    addressCountry      : '.js-shipping-calc-address-country',
	    addressProvince     : '.js-shipping-calc-address-province',
	    addressProvinceLabel: '.js-shipping-calc-address-province-label',
	    response            : '.js-shipping-calc-response'
	}
	
	// let calculators = document.querySelectorAll(selectors.container);
	//
	// calculators.forEach((element, i) => {
	//   element.classList.add("shipping-calculator-" + i);
	// });
	
	var container;
	if ( config.cart_action == 'mini_cart' ) {
	    if ( document.querySelectorAll( selectors.container )[ 0 ] ) {
		document.querySelectorAll( selectors.container )[ 0 ].innerHTML = '';
	    }
	    container = document.querySelectorAll( selectors.container )[ 1 ];
	} else {
	    if ( document.querySelectorAll( selectors.container )[ 1 ] ) {
		document.querySelectorAll( selectors.container )[ 1 ].innerHTML = '';
	    }
	    container = document.querySelectorAll( selectors.container )[ 0 ];
	}
	
	if ( !container ) return false;
	
	// Initialize observer on shipping address.
	new Shopify.CountryProvinceSelector( 'address_country', 'address_province', {
	    hideElement: 'address_province_container'
	} );
	
	// Updating province label.
	var countriesSelect        = container.querySelector( selectors.addressCountry );
	var addressProvinceLabelEl = container.querySelector( selectors.addressProvinceLabel );
	
	if ( typeof Countries !== 'undefined' ) {
	    Countries.updateProvinceLabel( countriesSelect.val(), addressProvinceLabelEl );
	    countriesSelect.change( function () {
		Countries.updateProvinceLabel( countriesSelect.val(), addressProvinceLabelEl );
	    } );
	}
	
	// When any of the calculator buttons is clicked, get rates.
	let button = container.querySelector( selectors.submitButton );
	
	button.addEventListener( 'click', function ( e ) {
	    e.preventDefault();
	    
	    // Disabling all buttons.
	    Shopify.theme.shippingCalculator.disableButtons( config, container );
	    
	    // Hiding response.
	    container.querySelector( selectors.response ).style.display = 'none';
	    
	    // Reading shipping address for submission.
	    let shippingAddress      = {};
	    shippingAddress.zip      = container.querySelector( selectors.addressZip ).value || '';
	    shippingAddress.country  = container.querySelector( selectors.addressCountry ).value || '';
	    shippingAddress.province = container.querySelector( selectors.addressProvince ).value || '';
	    
	    Shopify.theme.shippingCalculator.getRates( config, shippingAddress, container );
	} );
    },
    enableButtons : function enableButtons( config, container ) {
	var selectors = {
	    submitButton: '.js-shipping-calc-submit'
	}
	container.querySelector( selectors.submitButton ).removeAttribute( 'disabled' );
	container.querySelector( selectors.submitButton ).classList.remove( 'disabled' );
	container.querySelector( selectors.submitButton ).value = config.calculator_submit;
    },
    disableButtons: function disableButtons( config, container ) {
	var selectors = {
	    submitButton: '.js-shipping-calc-submit'
	}
	container.querySelector( selectors.submitButton ).setAttribute( 'disabled', 'disabled' );
	container.querySelector( selectors.submitButton ).classList.add( 'disabled' );
	container.querySelector( selectors.submitButton ).value = config.calculator_calculating;
    },
    getRates      : function getRates( config, shipping_address, container ) {
	
	let url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + shipping_address.zip + '&shipping_address%5Bcountry%5D=' + shipping_address.country + '&shipping_address%5Bprovince%5D=' + shipping_address.province;
	
	fetch( url, {
	    method : "GET",
	    headers: {
		'Accept'      : 'application/json',
		'Content-Type': 'application/json',
	    }
	} ).then( res => res.json() )
	    .then( response => {
		if ( !response.shipping_rates ) {
		    Shopify.theme.shippingCalculator.onError( response, config, container );
		} else {
		    let rates = response.shipping_rates;
		    Shopify.theme.shippingCalculator.onRatesUpdate( rates, shipping_address, config, container );
		}
	    } ).catch( error => {
	    Shopify.theme.shippingCalculator.onError( error, config, container );
	} );
	
    },
    onError       : function onError( error, config, container ) {
	
	// Re-enable calculate shipping buttons.
	Shopify.theme.shippingCalculator.enableButtons( config, container );
	
	let feedback = config.calculator_error + ' ' + Object.keys( error )[ 0 ] + ' ' + Object.values( error )[ 0 ];
	
	// Update calculator.
	Shopify.theme.shippingCalculator.render( {
	    rates: [], errorFeedback: feedback, success: false
	}, container, config );
	
	container.querySelector( '.js-shipping-calc-rates' ).style.display    = "none";
	container.querySelector( '.js-shipping-calc-response' ).style.display = "block";
    },
    onRatesUpdate : function onRatesUpdate( rates, shipping_address, config, container ) {
	// Re-enable calculate shipping buttons.
	Shopify.theme.shippingCalculator.enableButtons( config, container );
	
	// Formatting shipping address.
	var readable_address = '';
	if ( shipping_address.zip ) readable_address += shipping_address.zip + ', ';
	if ( shipping_address.province ) readable_address += shipping_address.province + ', ';
	readable_address += shipping_address.country;
	
	if ( !rates ) return false;
	
	// Format rates for moneyFormat
	rates.forEach( ( rate, i ) => {
	    rate.price = Shopify.theme.shippingCalculator.formatRate( rate.price, config );
	} );
	
	// Show rates and feedback.
	Shopify.theme.shippingCalculator.render( {
	    rates: rates, address: readable_address, success: true
	}, container, config );
	
    },
    formatRate    : function formatRate( ratePrice, config ) {
	
	let formatDollarsToCents = function ( value ) {
	    value = ( value + '' ).replace( /[^\d.-]/g, '' );
	    if ( value && value.includes( '.' ) ) {
		value = value.substring( 0, value.indexOf( '.' ) + 3 );
	    }
	    return value ? Math.round( parseFloat( value ) * 100 ) : 0;
	}
	let cents                = formatDollarsToCents( ratePrice );
	
	return Shopify.formatMoney( cents, config.money_format );
    },
    render        : function render( response, container, config ) {
	let rateFeedback = document.querySelector( '.js-shipping-calc-rates-feedback' ),
	    rateList     = document.querySelector( '.js-shipping-calc-rates' );
	
	// Empty feedback
	rateFeedback.innerHTML = '';
	
	// Update feedback
	if ( response.rates.length > 1 ) {
	    rateFeedback.innerHTML = config.shipping_multi_rate_one + response.rates.length + config.shipping_multi_rate_two + response.address + config.shipping_multi_rate_three + response.rates[ 0 ].price;
	} else if ( response.rates.length === 1 ) {
	    rateFeedback.innerHTML = config.shipping_single_rate + response.address;
	} else {
	    rateFeedback.innerHTML = config.shipping_no_destination;
	}
	
	// Empty rates
	rateList.innerHTML = '';
	
	// Update rates
	response.rates.forEach( ( rate, i ) => {
	    const rateLI = document.createElement( 'li' );
	    rateLI.classList.add( 'shipping-calc__rate' );
	    rateLI.innerHTML = rate.name + ' at ' + rate.price;
	    rateList.appendChild( rateLI )
	} );
	
	container.querySelector( '.js-shipping-calc-rates' ).style.display   = "block";
	document.querySelector( '.js-shipping-calc-response' ).style.display = "block";
    }
}

Shopify.theme.quickview = {
    init          : function init() {
	
	var selectors = {
	    quickviewButton: '.js-quickview-trigger'
	}
	
	// Init on click event for buttons
	document.querySelectorAll( selectors.quickviewButton ).forEach( ( button, i ) => {
	    
	    button.addEventListener( 'click', function ( event ) {
		event.preventDefault();
		
		// Init modal
		WAU.Modal.init( "quickview" );
		
		// Get template
		let productUrl = this.dataset.productUrl;
		Shopify.theme.quickview.getTemplate( productUrl );
	    } );
	} );
	
    },
    formatTemplate: function getAjaxCart( response ) {
	const el     = document.createElement( 'div' );
	el.innerHTML = response;
	
	const htmls = el.querySelectorAll( '[data-html]' );
	
	let html = {};
	if ( htmls.length === 1 && htmls[ 0 ].getAttribute( 'data-html' ) === '' ) {
	    html = htmls[ 0 ].innerHTML;
	} else {
	    for ( let i = 0; i < htmls.length; i++ ) {
		html[ htmls[ i ].getAttribute( 'data-html' ) ] = htmls[ i ].innerHTML;
	    }
	}
	
	return html;
    },
    showModal     : function showModal() {
	
	WAU.Modal._openByName( "quickview" );
    },
    hideModal     : function hideModal() {
	
	document.querySelector( '.js-quickview-content' ).innerHTML = '';
	
	WAU.Modal._closeByName( "quickview" );
    },
    getTemplate   : function getTemplate( productUrl ) {
	let data, url;
	url = productUrl;
	
	fetch( url, data )
	    .then( res => res.text() )
	    .then( response => {
		let html = Shopify.theme.quickview.formatTemplate( response );
		
		// Replace modal content
		document.querySelector( '.js-quickview-content' ).innerHTML = html.content;
		
	    } ).then( response => {
	    
	    let context = document.querySelector( '.js-quickview-wrapper' );
	    
	    // Trigger quickview event
	    theme.Product( context );
	    
	} ).then( response => {
	    
	    let context = document.querySelector( '.js-quickview-wrapper' );
	    
	    // Load Payment Buttons
	    if ( context.dataset.paymentButton == 'true' && Shopify.PaymentButton ) {
		Shopify.PaymentButton.init()
	    }
	} ).then( response => {
	    
	    let context = document.querySelector( '.js-quickview-wrapper' );
	    
	    // Trigger event for add to cart
	    context.querySelector( '.js-ajax-submit' ).addEventListener( 'click', function ( e ) {
		e.preventDefault();
		
		var addToCartForm = this.closest( 'form' );
		
		let cartConfig = document.getElementById( 'cart-config' );
		if ( !cartConfig ) return false;
		cartConfig = JSON.parse( cartConfig.innerHTML || '{}' );
		
		Shopify.theme.ajaxCart.addToCart( addToCartForm, null, cartConfig, true );
		
		return false;
	    } );
	} ).then( response => {
		
		// Show modal
		Shopify.theme.quickview.showModal();
		
	    } )
	    .catch( error => {
		console.log( error )
	    } );
    }
}

Shopify.theme.quickview.init();
Shopify.theme.ajaxCart.init();

// Reinit cart on section events
document.addEventListener( 'shopify:section:select', function ( event ) {
    Shopify.theme.quickview.init();
    Shopify.theme.ajaxCart.init();
} );

/*============================================================================
  Other
==============================================================================*/
var mobile  = window.matchMedia( '(max-width: 740px)' );
var tablet  = window.matchMedia( '(max-width: 979px) and (min-width: 741px)' );
var desktop = window.matchMedia( '(min-width: 980px)' );

document.addEventListener( "DOMContentLoaded", function () {
    ( function headerSearch() {
	const searchBoxTriggers = document.querySelectorAll( '.js-search-trigger' );
	if ( !searchBoxTriggers ) return false;
	
	searchBoxTriggers.forEach( function ( element ) {
	    element.addEventListener( 'click', function ( event ) {
		event.stopPropagation();
		theme.Helpers.Toggle( 'searchbox' );
	    } );
	} );
	document.addEventListener( 'shopify:section:load', function ( event ) {
	    const searchBoxTriggers = document.querySelectorAll( '.js-search-trigger' );
	    if ( !searchBoxTriggers ) return false;
	    
	    searchBoxTriggers.forEach( function ( element ) {
		element.addEventListener( 'click', function ( event ) {
		    event.stopPropagation();
		    theme.Helpers.Toggle( 'searchbox' );
		} );
	    } );
	} );
    } )();
    
    ( function initModals() {
	
	if ( document.querySelector( '[data-wau-modal-content="create-customer"]' ) ) {
	    WAU.Modal.init( "create-customer" );
	}
	
	if ( document.querySelector( '[data-wau-modal-content="recover-password"]' ) ) {
	    WAU.Modal.init( "recover-password" );
	}
	
	if ( document.querySelector( '[data-wau-modal-content="new-address"]' ) ) {
	    WAU.Modal.init( "new-address" );
	}
	
	var modals = document.querySelectorAll( '[data-wau-modal-content]' );
	if ( !modals ) return false;
	modals.forEach( ( item, i ) => {
	    var contentType = item.dataset.wauModalContent;
	    if ( contentType.includes( "edit-address" ) ) {
		WAU.Modal.init( item.dataset.wauModalContent );
	    }
	} );
    } )();
} );

/*============================================================================
  Header
==============================================================================*/
var selectors = {
    disclosureLocale  : '[data-disclosure-locale]',
    disclosureCurrency: '[data-disclosure-currency]'
};

theme.Header = ( function () {
    function Header( container ) {
	const mobileHeader                 = document.querySelector( ".js-mobile-header" ),
	      blockTopWrapper              = document.querySelector( ".js-block-header" ),
	      clearElement                 = document.querySelector( ".js-clear-element" ),
	      menuItemsWithNestedDropdowns = document.querySelectorAll( ".js-menuitem-with-nested-dropdown" ),
	      doubleTapToGoItems           = document.querySelectorAll( ".js-doubletap-to-go" ),
	      topBar                       = document.querySelector( ".js-top-bar" ),
	      isMobile                     = window.innerWidth < 740,
	      isDesktop                    = window.innerWidth > 740;
	
	window.addEventListener( 'scroll', function ( event ) {
	    prepareSticky();
	} );
	window.addEventListener( 'resize', function ( event ) {
	    prepareSticky();
	} );
	window.addEventListener( 'shopify:section:select', function ( event ) {
	    prepareSticky();
	} );
	
	function prepareSticky() {
	    let isMobileStyle = document.querySelector( '.header__wrapper' ).classList.contains( "mobile-style-true" ),
		isMobile      = window.innerWidth < 740,
		elementClass, elementHeight, amountToScroll;
	    
	    switch ( isMobile || isMobileStyle ) {
		case true:
		    amountToScroll = topBar.clientHeight;
		    elementClass   = ".js-mobile-header";
		    elementHeight  = mobileHeader.clientHeight;
		    
		    break;
		case false:
		    if ( !blockTopWrapper ) {
			amountToScroll = topBar.clientHeight;
		    } else {
			amountToScroll = topBar.clientHeight + blockTopWrapper.clientHeight;
		    }
		    
		    elementClass  = ".js-theme-header";
		    elementHeight = document.querySelector( ".js-theme-header" ).clientHeight;
		    break;
	    }
	    
	    return theme.Helpers.makeSticky( amountToScroll, elementClass, elementHeight );
	}
	
	// Aria support
	theme.a11yHelpers.setUpAriaExpansion();
	theme.a11yHelpers.setUpAccessibleNavigationMenus();
	
	// Making sure that nested dropdowns are properly placed in the correct place if they're offscreen.
	menuItemsWithNestedDropdowns.forEach( function ( menuItem ) {
	    menuItem.addEventListener( 'mouseenter', function ( event ) {
		const nestedDropdown = menuItem.querySelector( ".js-dropdown-nested" );
		
		if ( nestedDropdown ) {
		    if ( theme.DOMHelpers.isElementPastEdge( nestedDropdown ) ) {
			nestedDropdown.classList.add( "dropdown--edge" );
		    }
		}
		
	    } );
	} );
	
	// Double Tap To Go on Tablets
	function closeMenu( activeClass ) {
	    document
		.querySelectorAll( `[data-active-class="${ activeClass }"]` )
		.forEach( function ( activeMenu ) {
		    activeMenu.classList.remove( activeClass );
		} );
	}
	
	doubleTapToGoItems.forEach( function ( doubleTapItem ) {
	    let preventClick    = false,
		prevEventTarget = undefined;
	    
	    const activeClass = doubleTapItem.getAttribute( "data-active-class" );
	    
	    Events.on( "device:touchstart", function () {
		preventClick = true;
	    } );
	    
	    doubleTapItem.addEventListener( "click", function ( event ) {
		if ( preventClick ) {
		    event.preventDefault();
		}
	    } );
	    
	    doubleTapItem.addEventListener( "touchstart", function ( event ) {
		event.target.setAttribute( "aria-expanded", "false" );
		closeMenu( activeClass );
		
		if ( prevEventTarget === event.target ) {
		    preventClick = false;
		} else {
		    event.target.classList.toggle( activeClass );
		    event.target.setAttribute( "aria-expanded", "true" );
		}
		
		prevEventTarget = event.target;
	    } );
	} );
	/* lang and currency disclosure */
	this.container = container;
	this.cache     = {};
	this.cacheSelectors();
	
	if ( this.cache.localeDisclosure ) {
	    this.localeDisclosure = new theme.Disclosure( this.cache.localeDisclosure );
	}
	
	if ( this.cache.currencyDisclosure ) {
	    this.currencyDisclosure = new theme.Disclosure( this.cache.currencyDisclosure );
	}
    }
    
    Header.prototype = _.assignIn( {}, Header.prototype, {
	cacheSelectors: function () {
	    this.cache = {
		localeDisclosure  : this.container.querySelector( selectors.disclosureLocale ),
		currencyDisclosure: this.container.querySelector( selectors.disclosureCurrency )
	    };
	},
	onUnload      : function () {
	    if ( this.cache.localeDisclosure ) {
		this.localeDisclosure.destroy();
	    }
	    
	    if ( this.cache.currencyDisclosure ) {
		this.currencyDisclosure.destroy();
	    }
	},
	
	onSelect: function () {
	    WAU.Slideout.init( "mobile-navigation" );
	}
    } );
    return Header;
} )();

/*============================================================================
  Custom page image Carousel with text
==============================================================================*/
theme.CustomPageCarousel = function ( context, events ) {
    
    ( function page_carousel() {
	
	const slideshows = document.querySelectorAll( '.js-slideshow' );
	
	slideshows.forEach( Slideshow => {
	    const flktyData    = Slideshow.getAttribute( 'data-flickity' );
	    const flktyOptions = JSON.parse( flktyData );
	    new Flickity( Slideshow, flktyOptions );
	} );
	
	document.addEventListener( 'shopify:section:unload', function ( event ) {
	    const Slideshow = document.querySelector( '.js-slideshow' );
	    if ( !Slideshow ) {
		return false;
	    }
	    const flkty = Flickity.data( Slideshow );
	    flkty.destroy();
	} );
	
	document.addEventListener( 'shopify:section:load', function ( event ) {
	    const Slideshow    = document.querySelector( '.js-slideshow' );
	    const flktyData    = Slideshow.getAttribute( 'data-flickity' );
	    const flktyOptions = JSON.parse( flktyData );
	    new Flickity( '.js-slideshow', flktyOptions );
	} );
	
	document.addEventListener( 'shopify:block:select', function ( event ) {
	    const Slideshow = document.querySelector( '.js-slideshow' );
	    if ( !Slideshow ) {
		return false;
	    }
	    const flkty = Flickity.data( Slideshow );
	    const Slide = event.target.getAttribute( "data-slider-index" );
	    flkty.select( Slide );
	} );
	
    } )();
}

/*============================================================================
  Custom pages
==============================================================================*/
theme.CustomPage = ( function () {
    function CustomPage( container ) {
	var events     = new EventEmitter3();
	events.trigger = events.emit; // alias
	
	theme.CustomPageCarousel();
	
    }
    
    CustomPage.prototype = _.assignIn( {}, CustomPage.prototype, {} );
    
    return CustomPage;
} )();

/*============================================================================
  Image Carousel with Text Section
==============================================================================*/
theme.Carousel = ( function () {
    function Carousel( container ) {
	
	const slideshows = document.querySelectorAll( '.js-slideshow' );
	
	slideshows.forEach( Slideshow => {
	    const flktyData    = Slideshow.getAttribute( 'data-flickity' );
	    const flktyOptions = JSON.parse( flktyData );
	    new Flickity( Slideshow, flktyOptions );
	} );
	
    }
    
    return Carousel;
} )();

theme.Carousel.prototype = _.assignIn( {}, theme.Carousel.prototype, {
    
    onLoad: function ( event ) {
	const Slideshow    = event.target.closest( '.js-slideshow' );
	const flktyData    = Slideshow.getAttribute( 'data-flickity' );
	const flktyOptions = JSON.parse( flktyData );
	new Flickity( '.js-slideshow', flktyOptions );
    },
    
    onBlockSelect: function ( event ) {
	const Slideshow = event.target.closest( '.js-slideshow' );
	const flkty     = Flickity.data( Slideshow );
	const Slide     = event.target.getAttribute( "data-slider-index" );
	flkty.select( Slide );
    }
    
} );

/*============================================================================
  Collection List Section
==============================================================================*/
theme.CollectionList = ( function () {
    function CollectionList( container ) {
	
    }
    
    CollectionList.prototype = _.assignIn( {}, CollectionList.prototype, {} );
    return CollectionList;
} )();

/*============================================================================
  Collection Section
==============================================================================*/
theme.Collection = ( function () {
    function Collection( container ) {
	
	( function tagFilters( container ) {
	    const tagFilters      = document.querySelectorAll( ".coll-filter [data-tag]" );
	    const tagFiltersLists = document.querySelectorAll( ".coll-filter" );
	    
	    const getCollectionHandle = function () {
		const urlPathArray = window.location.pathname.split( '/' );
		const collection   = urlPathArray[ urlPathArray.indexOf( 'collections' ) + 1 ];
		if ( collection && collection != '' ) {
		    return collection;
		} else {
		    console.log( 'Error, no collection URL' );
		    return false;
		}
	    }
	    
	    const collectionHandle = getCollectionHandle();
	    
	    // Check that tag filters exist
	    if ( tagFilters.length > 0 ) {
		tagFilters.forEach( tagFilter => {
		    tagFilter.addEventListener( 'click', event => {
			event.preventDefault();
			let parentFilterList = event.target.closest( 'ul' );
			let childTags        = parentFilterList.querySelectorAll( '[data-tag]' );
			
			childTags.forEach( childTag => {
			    if ( childTag == event.target ) {
				childTag.classList.toggle( 'current' );
			    } else {
				childTag.classList.remove( 'current' );
			    }
			} );
			
			let newTags = [];
			
			tagFiltersLists.forEach( tagFiltersList => {
			    let childTags = tagFiltersList.querySelectorAll( '[data-tag]' );
			    childTags.forEach( childTag => {
				if ( childTag.classList.contains( 'current' ) ) {
				    newTags.push( childTag.dataset.tag );
				}
			    } );
			} );
			
			if ( newTags.length ) {
			    let query = newTags.join( '+' );
			    if ( window.location.search ) {
				window.location.href = `/collections/${ collectionHandle }/` + query + window.location.search;
			    } else {
				window.location.href = `/collections/${ collectionHandle }/` + query;
			    }
			} else {
			    window.location.href = container.dataset.collectionLink;
			}
		    } );
		} );
	    }
	} )( container );
	
	( function accordion() {
	    
	    document.addEventListener( 'shopify:block:select', function ( event ) {
		
		// Dont' run on the mobile navigation
		if ( event.target.classList.contains( WAU.Accordion.getConfigClass( 'mobileNavAccordion' ) ) ) {
		    return;
		}
		
		WAU.Accordion.show( event.target, true );
		
	    } );
	    
	    document.addEventListener( 'shopify:block:deselect', function ( event ) {
		
		// Dont' run on the mobile navigation
		if ( event.target.classList.contains( WAU.Accordion.getConfigClass( 'mobileNavAccordion' ) ) ) {
		    return;
		}
		
		
		// Don't hide if it has the "open by default" setting enabled
		if ( !event.target.classList.contains( WAU.Accordion.getConfigClass( 'open' ) ) ) {
		    WAU.Accordion.hide( event.target, true );
		}
	    } );
	    
	} )();
	
	( function collectionFilters() {
	    
	    // Get all sidebar filter elements
	    var elements = document.querySelectorAll( "#full-width-filter .filter-wrapper .main-label" );
	    
	    // Bail if no sidebar filter elements exist
	    if ( !elements ) {
		return false;
	    }
	    
	    // Loop through each sidebar filter element
	    elements.forEach( function ( element, index ) {
		
		// Get the value from the data-id attribute, use this value to getElementById and re-use the variable
		var selectedFilter = element.dataset.id,
		    selectedFilter = document.getElementById( selectedFilter );
		
		// Add click event listener to each filter
		selectedFilter.addEventListener( "click", function () {
		    
		    event.preventDefault();
		    // Toggle active class
		    this.classList.toggle( "active" );
		    
		    // Get the next element sibling which is usually the filter content itself
		    var list = this.nextElementSibling;
		    if ( list.style.display === "inline-block" ) {
			list.style.display = "none";
		    } else {
			list.style.display = "inline-block";
		    }
		    
		} );
	    } );
	    
	    // Adding current class to sort by list
	    var sortItems = document.querySelectorAll( "#sort-by li" );
	    
	    if ( !sortItems ) return false;
	    sortItems.forEach( function ( element, index ) {
		if ( window.location.search.includes( "manual" ) ) {
		    element.classList.add( "current" );
		} else {
		    element.classList.remove( "current" );
		}
	    } );
	    
	    document.querySelector( '.js-filter-trigger' )?.addEventListener( 'click', function ( event ) {
		let filters = document.querySelector( '.js-sidebar-filters' );
		if ( !filters ) return false;
		if ( filters.style.display == 'none' ) {
		    filters.style.display = 'block';
		} else {
		    filters.style.display = 'none';
		}
	    } );
	} )();
	
	( function collectionLayout() {
	    var gridIcons = document.querySelectorAll( '.grid-layout li' );
	    
	    if ( !gridIcons ) return false;
	    
	    gridIcons.forEach( ( item, i ) => {
		item.classList.remove( 'active' );
		
		item.addEventListener( 'click', function () {
		    item.classList.add( 'active' );
		    
		    var gridType = item.dataset.gridType;
		    document.querySelector( '.product-loop' ).setAttribute( 'data-grid-type', gridType );
		} );
	    } );
	} )();
    }
    
    Collection.prototype = _.assignIn( {}, Collection.prototype, {} );
    
    return Collection;
} )();

/*============================================================================
  Product Modules
==============================================================================*/
var Events     = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

var mobile  = window.matchMedia( '(max-width: 740px)' );
var tablet  = window.matchMedia( '(max-width: 979px) and (min-width: 741px)' );
var desktop = window.matchMedia( '(min-width: 980px)' );

theme.ProductForm = function ( context, sectionId, events, Product ) {
    var formConfig = context.querySelector( '#AddToCartForm' );
    var config     = JSON.parse( formConfig.dataset.productForm || '{}' );
    
    ( function quantity() {
	var element = context.querySelector( "[name=quantity]" );
	
	events.on( "quantitycontrol:click", change );
	
	function change( value ) {
	    var quantity = parseInt( element.value ) + value;
	    
	    if ( quantity < 1 ) {
		return false;
	    }
	    
	    element.value = quantity;
	}
    } )();
    
    ( function quantity_controls() {
	Control( ".quantity-control-up", 1 );
	Control( ".quantity-control-down", -1 );
	
	function Control( selector, value ) {
	    var element = context.querySelector( selector );
	    
	    if ( !element ) {
		return false;
	    }
	    
	    element.addEventListener( "click", function ( event ) {
		event.preventDefault();
		events.trigger( "quantitycontrol:click", value );
	    } );
	}
    } )();
    
    function outOfStockNotification() {
        let addToCart = $('input#addToCart');
        
        if (addToCart.is(':disabled')) {
              var klaviyo = window.klaviyo || [];
              console.log('klaviyo logging: ', window.klaviyo);
              klaviyo.init({
                account: "RJiumz",
                platform: "shopify"
              });
              klaviyo.enable("backinstock",{
                trigger: {
                  product_page_text: "Informami quando disponibile",
                  product_page_class: "btn",
                  product_page_text_align: "center",
                  product_page_margin: "0px",
                  replace_anchor: false
                },
                modal: {
                 headline: "{product_name}",
                 body_content: "Fornisci il tuo indirizzo email per ricevere una notifica quando questo prodotto torna disponibile a magazzino.",
                 email_field_label: "Email",
                 button_label: "Notificami",
                 subscription_success_label: "Detto, fatto! Riceverai una notifica quando il prodotto torna disponibile.",
                 footer_content: '',
                 additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
                 font_family: '"HelveticaNeue","Helvetica Neue",Helvetica,Arial,sans-serif;',
                 drop_background_color: "#000",
                 background_color: "#fff",
                 text_color: "#222",
                 button_text_color: "#fff",
                 button_background_color: "#046a38",
                 close_button_color: "#ccc",
                 error_background_color: "#fcd6d7",
                 error_text_color: "#C72E2F",
                 success_background_color: "#d3efcd",
                 success_text_color: "#1B9500"
                }
              });
              
              addToCart.addClass('out-of-stock');
          		$('a.klaviyo-bis-trigger').show();
        } else {
          addToCart.removeClass('out-of-stock');
          $('a.klaviyo-bis-trigger').hide();
        }
     }   
         outOfStockNotification();    
        
    if ( Product.variants.length == 1 ) {
	if ( context.querySelector( '[data-store-availability-container]' ) ) {
	    Events.trigger( "storeavailability:variant", Product.variants[ 0 ].id, Product.title );
	}
	return false;
    }
    
    if ( config.featured_product ) {
	var prodSelector = 'fp-product-select-' + context.dataset.sectionId;
    } else if ( config.quickview ) {
	var prodSelector = "qv-product-select-" + Product.id;
    } else {
	var prodSelector = 'product-select-' + Product.id;
    }
    
    new Shopify.OptionSelectors( prodSelector, {
	product           : Product,
	onVariantSelected : function ( variant, selector ) {
	    
	    if ( !variant ) {
		events.trigger( "variantunavailable", variant, config );
		Events.trigger( "storeavailability:unavailable" );
		return;
	    }
	    
	    if ( Product.variants.length == 1 ) {
		return;
	    }
	    
	    events.trigger( "variantchange", variant, config );
	    
	    events.trigger( "variantchange:option1:" + variant.option1 );
	    events.trigger( "variantchange:option2:" + variant.option2 );
	    events.trigger( "variantchange:option3:" + variant.option3 );
	    
	    if ( context.querySelector( '[data-store-availability-container]' ) ) {
		Events.trigger( "storeavailability:variant", variant.id, Product.title );
	    }
	    
	    if ( variant.featured_media ) {
		Events.trigger( "variantchange:image", variant.featured_media.id, context );
	    }
	    
	},
	enableHistoryState: config.enable_history
    } );
    
    ( function single_option_selectors() {
	var elements = context.querySelectorAll( ".single-option-selector" );
	
	elements.forEach( Selector );
	
	function Selector( element, index ) {
	    var option_position = index + 1;
	    
	    events.on( "swatch:change:" + option_position, change );
	    
	    function change( value ) {
		element.value = value;
		
		element.dispatchEvent(
		    new CustomEvent( 'change', {
			bubbles   : true,
			cancelable: true
		    } )
		);
	    }
	}
    } )();
    
    ( function swatches() {
	var elements = context.querySelectorAll( "[type=radio]" );
	
	var states = {
	    sold_out : function ( element ) {
		element.parentElement.classList.add( "soldout" );
	    },
	    available: function ( element ) {
		element.parentElement.classList.remove( "soldout" );
	    }
	};
	
	events.on( "variantunavailable", set_unavailable );
	
	elements.forEach( Swatch );
	
	function set_unavailable() {
	    var selected = {};
	    
	    var selected_elements = document.querySelectorAll( "[type=radio]:checked" );
	    
	    selected_elements.forEach( function ( element ) {
		var option = "option" + element.getAttribute( "data-position" );
		var value  = element.value;
		
		selected[ option ] = value;
	    } );
	    
	    elements.forEach( function ( element ) {
		var available = false;
		
		var current_option = "option" + element.getAttribute( "data-position" );
		
		var current_value = element.value;
		
		var other_options = [ "option1", "option2", "option3" ].filter( function ( option ) {
		    return selected[ option ] && option != current_option;
		} );
		
		Product.variants.forEach( function ( variant ) {
		    if ( !variant.available ) {
			return;
		    }
		    
		    if ( variant[ current_option ] != current_value ) {
			return;
		    }
		    
		    if ( variant[ other_options[ 0 ] ] == selected[ other_options[ 0 ] ] && variant[ other_options[ 1 ] ] == selected[ other_options[ 1 ] ] ) {
			available = true;
			return;
		    }
		} );
		
		if ( available ) {
		    states.available( element );
		} else {
		    states.sold_out( element );
		}
	    } );
	}
	
	function Swatch( element ) {
	    var option_position = element.getAttribute( "data-position" );
	    
	    var current_option = "option" + option_position;
	    
	    var other_options = [ "option1", "option2", "option3" ].filter( function ( option ) {
		return option != current_option;
	    } );
	    
	    element.addEventListener( "change", function ( event ) {
		var selectedLabel = context.querySelector( '#selected-option-' + option_position );
		
		selectedLabel.innerHTML = element.value;
		
		events.trigger( "swatch:change:" + option_position, element.value );
	    } );
	    
	    events.on( "variantchange:option" + option_position + ":" + element.value, select );
	    
	    events.on( "variantchange", set_availability );
	    
	    function select() {
		element.checked = true;
	    }
	    
	    function set_availability( current_variant ) {
		var available = false;
		
		Product.variants.forEach( function ( variant ) {
		    if ( !variant.available ) {
			return;
		    }
		    
		    if ( variant[ current_option ] != element.value ) {
			return;
		    }
		    
		    if ( variant[ other_options[ 0 ] ] != current_variant[ other_options[ 0 ] ] ) {
			return;
		    }
		    
		    if ( variant[ other_options[ 1 ] ] != current_variant[ other_options[ 1 ] ] ) {
			return;
		    }
		    
		    available = true;
		} );
		
		if ( available ) {
		    states.available( element );
		} else {
		    states.sold_out( element );
		}
	    }
	}
    } )();
    
    ( function price() {
	var element = context.querySelector( ".price__regular .price-item--regular" );
	
	events.on( "variantchange", function ( variant ) {
	    var price         = money( variant.price );
	    element.innerHTML = price;
	    
	    events.on( "variantunavailable", function ( variant ) {
		price             = config.unavailable;
		element.innerHTML = price;
	    } );
	} );
    } )();
    
    ( function price_classes() {
	var element = context.querySelector( "[data-price]" );
	
	events.on( "variantchange", function ( variant ) {
        outOfStockNotification();
	    if ( variant.available && variant.compare_at_price > variant.price ) {
		element.classList.add( 'price--on-sale' );
		element.classList.remove( 'price--sold-out' );
	    } else if ( !variant.available && variant.compare_at_price > variant.price ) {
		element.classList.add( 'price--sold-out' );
		element.classList.add( 'price--on-sale' );
	    } else if ( !variant.available ) {
		element.classList.add( 'price--sold-out' );
		element.classList.remove( 'price--on-sale' );
	    } else {
		element.classList.remove( 'price--on-sale' );
		element.classList.remove( 'price--sold-out' );
	    }
	    
	    if ( variant.unit_price_measurement ) {
		element.classList.add( 'price--unit-available' );
	    } else {
		element.classList.remove( 'price--unit-available' );
	    }
	} );
	
    } )();
    
    ( function unit_price() {
	var element = context.querySelector( "[data-unit-price]" );
	var wrapper = context.querySelector( ".price__unit" );
	
	if ( !element ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant ) {
	    var unitPrice = "";
	    
	    if ( variant.unit_price ) {
		unitPrice =
		    Shopify.formatMoney( variant.unit_price, config.money_format );
		+
		    ' ' +
		config.unit_price_separator +
		' ' +
		getBaseUnit( variant );
		
		wrapper.style.display = "flex";
	    } else {
		wrapper.style.display = "none";
	    }
	    
	    element.innerHTML = unitPrice;
	} );
    } )();
    
    ( function compare_price() {
	var saleEl = context.querySelector( ".price__sale .price-item--sale" );
	var regEl  = context.querySelector( ".price__sale .price-item--regular" );
	
	if ( !saleEl ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant ) {
	    var salePrice = "",
		regPrice  = "";
	    
	    if ( variant.compare_at_price > variant.price ) {
		regPrice  = money( variant.compare_at_price );
		salePrice = money( variant.price );
	    }
	    
	    saleEl.innerHTML = salePrice;
	    regEl.innerHTML  = regPrice;
	} );
    } )();
    
    ( function add_to_cart() {
	var element = context.querySelector( ".add" );
	
	events.on( "variantchange", function ( variant ) {
	    var text     = config.button;
	    var disabled = false;
	    
	    if ( !variant.available ) {
		text     = config.sold_out;
		disabled = true;
	    }
	    
	    element.value    = text;
	    element.disabled = disabled;
	} );
	
	events.on( "variantunavailable", function () {
	    element.value    = config.unavailable;
	    element.disabled = true;
	} );
    } )();
    
    ( function smart_payment_buttons() {
	var element = context.querySelector( ".shopify-payment-button" );
	
	if ( !element ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant ) {
	    
	    if ( !variant.available ) {
		element.style.display = 'none';
	    } else {
		element.style.display = 'block';
	    }
	    
	} );
    } )();
    
    ( function sticky_bar() {
	var stickyBar = document.getElementById( 'sticky-cart' );
	
	if ( !stickyBar ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant ) {
	    
	    ( function price() {
		var element = context.querySelector( "#sticky-cart .price__regular .price-item--regular" );
		
		var price         = money( variant.price );
		element.innerHTML = price;
		
		events.on( "variantunavailable", function ( variant ) {
		    price             = config.unavailable;
		    element.innerHTML = price;
		} );
	    } )();
	    
	    ( function price_classes() {
		var element = context.querySelector( "#sticky-cart [data-price]" );
		
		if ( variant.available && variant.compare_at_price > variant.price ) {
		    element.classList.add( 'price--on-sale' );
		    element.classList.remove( 'price--sold-out' );
		} else if ( !variant.available && variant.compare_at_price > variant.price ) {
		    element.classList.add( 'price--sold-out' );
		    element.classList.add( 'price--on-sale' );
		} else if ( !variant.available ) {
		    element.classList.add( 'price--sold-out' );
		    element.classList.remove( 'price--on-sale' );
		} else {
		    element.classList.remove( 'price--on-sale' );
		    element.classList.remove( 'price--sold-out' );
		}
		
		if ( variant.unit_price_measurement ) {
		    element.classList.add( 'price--unit-available' );
		} else {
		    element.classList.remove( 'price--unit-available' );
		}
		
	    } )();
	    
	    ( function unit_price() {
		var element = context.querySelector( "#sticky-cart [data-unit-price]" );
		var wrapper = context.querySelector( "#sticky-cart .price__unit" );
		
		if ( !element ) {
		    return false;
		}
		
		var unitPrice = "";
		
		if ( variant.unit_price ) {
		    unitPrice =
			Shopify.formatMoney( variant.unit_price, config.money_format );
		    +
			' ' +
		    config.unit_price_separator +
		    ' ' +
		    getBaseUnit( variant );
		    
		    wrapper.style.display = "flex";
		} else {
		    wrapper.style.display = "none";
		}
		
		element.innerHTML = unitPrice;
	    } )();
	    
	    ( function compare_price() {
		var saleEl = context.querySelector( "#sticky-cart .price__sale .price-item--sale" );
		var regEl  = context.querySelector( "#sticky-cart .price__sale .price-item--regular" );
		
		if ( !saleEl ) {
		    return false;
		}
		
		var salePrice = "",
		    regPrice  = "";
		
		if ( variant.compare_at_price > variant.price ) {
		    regPrice  = money( variant.compare_at_price );
		    salePrice = money( variant.price );
		}
		
		saleEl.innerHTML = salePrice;
		regEl.innerHTML  = regPrice;
	    } )();
	    
	    
	    // Update Option 1
	    var option1 = stickyBar.querySelector( '#current-option-1 .option-selected' );
	    
	    if ( option1 ) {
		stickyBar.querySelector( '#current-option-1 .option-selected' ).innerHTML = variant.option1;
	    }
	    
	    var option2 = stickyBar.querySelector( '#current-option-2 .option-selected' );
	    if ( option2 ) {
		stickyBar.querySelector( '#current-option-2 .option-selected' ).innerHTML = variant.option2;
	    }
	    
	    var option3 = stickyBar.querySelector( '#current-option-3 .option-selected' );
	    if ( option3 ) {
		stickyBar.querySelector( '#current-option-3 .option-selected' ).innerHTML = variant.option3;
	    }
	    
	    // Update button
	    var button   = stickyBar.querySelector( ".sticky-add" );
	    var text     = config.button;
	    var disabled = false;
	    
	    if ( !variant.available ) {
		text     = config.sold_out;
		disabled = true;
	    }
	    
	    button.value    = text;
	    button.disabled = disabled;
	    
	    events.on( "variantunavailable", function () {
		button.value    = config.unavailable;
		button.disabled = true;
	    } );
	} );
	
    } )();
    
    function money( cents ) {
	return Shopify.formatMoney( cents, config.money_format );
    }
    
    function getBaseUnit( variant ) {
	return variant.unit_price_measurement.reference_value === 1
	    ? variant.unit_price_measurement.reference_unit
	    : variant.unit_price_measurement.reference_value +
	    variant.unit_price_measurement.reference_unit;
    }
}

theme.ProductGallery = ( function () {
    function init( context, sectionId, events, Product ) {
	let config      = JSON.parse( context.querySelector( '.js-product-gallery' ).dataset.galleryConfig || '{}' ),
	    main        = context.querySelector( '.js-carousel-main' ),
	    carouselNav = context.querySelector( '.js-thumb-carousel-nav' );
	
	if ( !main ) return false;
	
	this.mainSlider( main, carouselNav, config, context );
	
	if ( config.thumbPosition == 'bottom' && config.thumbSlider == true ) this.thumbSlider( carouselNav, main, context );
	
	if ( config.clickToEnlarge ) theme.ProductGallery.enlargePhoto( context );
    }
    
    function mainSlider( main, carouselNav, config, context ) {
	let initialEl = main.querySelector( "[data-image-id='" + context.dataset.initialVariant + "']" ),
	    initialIndex;
	
	if ( initialEl ) {
	    initialIndex = initialEl.dataset.slideIndex;
	} else {
	    initialIndex = 0;
	}
	
	if ( config.navStyle == 'dots' ) {
	    var dots   = true,
		arrows = false;
	} else {
	    var dots   = false,
		arrows = true;
	}
	
	var flkty = new Flickity( main, {
	    // options
	    fade              : true,
	    wrapAround        : true,
	    cellAlign         : 'left',
	    draggable         : true,
	    contain           : true,
	    pageDots          : dots,
	    prevNextButtons   : arrows,
	    autoPlay          : false,
	    selectedAttraction: 0.01,
	    dragThreshold     : 5,
	    adaptiveHeight    : false,
	    imagesLoaded      : true,
	    initialIndex      : initialIndex,
	    on                : {
		ready : function () {
		    let id = this.selectedElement.dataset.imageId;
		    
		    /* Fade in */
		    context.querySelector( '.js-product-gallery' ).style.visibility = "visible";
		},
		change: function () {
		    /* Set focus control on change */
		    theme.ProductGallery.removeFocus( context );
		    theme.ProductGallery.addFocus( this.selectedElement, context );
		    
		    /* Set media */
		    theme.ProductGallery.setActiveThumbnail( this.selectedElement.dataset.imageId, this.selectedElement, context );
		    theme.ProductGallery.switchMedia( this.selectedElement.dataset.imageId, context );
		    
		    /* Allow model drag */
		    if ( this.selectedElement.classList.contains( 'model-slide' ) ) {
			if ( this.isDraggable ) {
			    /* Turn off drag for model usage */
			    this.options.draggable = !this.options.draggable;
			    this.updateDraggable();
			}
		    }
		}
	    }
	} );
	
	theme.ProductGallery.galleryEvents( flkty, context );
	
	if ( carouselNav ) theme.ProductGallery.thumbnails( flkty, carouselNav, config, context );
    }
    
    function thumbSlider( wrapper, main, context ) {
	var flktyThumbs = new Flickity( wrapper, {
	    // options
	    asNavFor          : main,
	    wrapAround        : false,
	    groupCells        : true,
	    cellAlign         : 'left',
	    draggable         : false,
	    contain           : true,
	    imagesLoaded      : true,
	    pageDots          : false,
	    autoPlay          : false,
	    selectedAttraction: 0.01,
	    dragThreshold     : 5,
	    accessibility     : false
	} );
    }
    
    function thumbnails( flkty, carouselNav, config, context ) {
	if ( !carouselNav ) return false;
	
	let thumbs = carouselNav.querySelectorAll( '.js-thumb-item' );
	
	if ( !thumbs ) return false;
	
	/* on thumbnail click and key enter */
	thumbs.forEach( ( thumb, i ) => {
	    thumb.addEventListener( 'click', function ( event ) {
		event.preventDefault();
		
		let index   = this.dataset.slideIndex,
		    el      = carouselNav.querySelectorAll( '.js-thumb-item' )[ index ],
		    mediaId = this.dataset.imageId;
		
		/* Update classes & aria */
		theme.ProductGallery.setActiveThumbnail( mediaId, el, context );
		theme.ProductGallery.switchMedia( mediaId, context );
		
		/* move thumb slider to position */
		theme.ProductGallery.setThumbPos( this, carouselNav );
		
		/* change slide */
		flkty.select( index );
		
	    } );
	    
	    thumb.addEventListener( 'keypress', function ( event ) {
		event.preventDefault();
		
		if ( event.which == 13 ) { //Enter key pressed
		    
		    let index   = this.dataset.slideIndex,
			el      = carouselNav.querySelectorAll( '.js-thumb-item' )[ index ],
			mediaId = this.dataset.imageId;
		    
		    /* Update classes & aria */
		    theme.ProductGallery.setActiveThumbnail( mediaId, el, context );
		    theme.ProductGallery.switchMedia( mediaId, context );
		    
		    /* move thumb slider to position */
		    theme.ProductGallery.setThumbPos( this, carouselNav );
		    
		    /* change slide */
		    flkty.select( index );
		    
		}
	    } );
	} );
	
	/* adjust thumbnail sizes */
	if ( config.thumbPosition != 'bottom' ) {
	    theme.ProductGallery.setThumbSizes( carouselNav, config, context );
	}
    }
    
    function setThumbSizes( carouselNav, config, context ) {
	let wrapper      = context.querySelector( '.js-thumb-vertical-wrapper' ),
	    wrapperWidth = wrapper.offsetWidth,
	    thumbsShown  = config.thumbsShown || 4;
	
	carouselNav.querySelectorAll( '.js-thumb-item' ).forEach( ( item, i ) => {
	    item.style.maxWidth = wrapperWidth + 'px';
	} );
	
	carouselNav.querySelectorAll( '.js-thumb-item-img' ).forEach( ( item, i ) => {
	    item.style.width  = wrapperWidth + 20 + 'px';
	    item.style.height = wrapperWidth + 20 + 'px';
	} );
	
	let thumbHeight   = carouselNav.querySelectorAll( '.js-thumb-item-img' )[ 0 ].offsetWidth,
	    wrapperHeight = ( parseInt( thumbHeight ) * parseInt( thumbsShown ) ) + 40;
	
	wrapper.querySelector( '.js-thumb-carousel-nav' ).style.maxHeight = wrapperHeight + 'px';
    }
    
    function setThumbPos( selected, carouselNav ) {
	
	carouselNav.scrollTo( {
	    top     : selected.offsetTop - 20,
	    left    : 0,
	    behavior: 'smooth'
	} );
    }
    
    function galleryEvents( flkty, context ) {
	
	/* On Variant Change and Initial Load */
	Events.on( 'variantchange:image', function ( id, context ) {
	    
	    if ( id === null ) return false;
	    
	    /* Select new image in flickity */
	    let main  = context.querySelector( '.js-carousel-main' ),
		el    = main.querySelector( "[data-image-id='" + id + "']" ),
		index = el.dataset.slideIndex;
	    
	    theme.ProductGallery.setActiveThumbnail( id, el, context );
	    theme.ProductGallery.switchMedia( id, context );
	    
	    flkty.select( index );
	    
	} );
    }
    
    function removeFocus( context ) {
	let main;
	
	if ( context ) {
	    main = context;
	} else {
	    main = context.querySelector( '.js-carousel-main' );
	}
	
	/* Set all elements to no tab */
	context.querySelectorAll( '.js-carousel-main *' ).forEach( ( item, i ) => {
	    item.setAttribute( 'tabIndex', '-1' );
	    item.blur();
	} );
	
	let buttonContents = context.querySelectorAll( '.flickity-button *' );
	buttonContents.forEach( ( item, i ) => {
	    item.setAttribute( 'tabIndex', '-1' );
	    item.classList.add( 'js-hide-focus' )
	} );
	
	if ( main.classList.contains( '.flickity-enabled' ) ) {
	    main.setAttribute( 'tabIndex', '-1' );
	    main.classList.add( 'js-hide-focus' );
	}
	
    }
    
    function addFocus( current, context ) {
	/* Set current element to tab */
	if ( current.classList.contains( 'image-slide' ) ) {
	    current.querySelector( 'img' ).setAttribute( "tabIndex", "0" );
	} else if ( current.classList.contains( 'video-slide' ) ) {
	    current.querySelectorAll( '.plyr__controls *' ).forEach( ( item, i ) => {
		item.setAttribute( "tabIndex", "0" );
	    } );
	} else if ( current.classList.contains( 'external_video-slide' ) ) {
	    current.querySelector( 'iframe' ).setAttribute( "tabIndex", "0" );
	} else if ( current.classList.contains( 'model-slide' ) ) {
	    current.querySelectorAll( '.shopify-model-viewer-ui__controls-area *' ).forEach( ( item, i ) => {
		item.setAttribute( "tabIndex", "0" );
	    } );
	}
    }
    
    function enlargePhoto( context ) {
	
	let buttons = context.querySelectorAll( 'a.zoom_btn' );
	
	if ( !buttons ) return false;
	buttons.forEach( ( button, i ) => {
	    button.addEventListener( 'click', function ( event ) {
		event.preventDefault();
		var btn   = event.target,
		    index = btn.getAttribute( 'data-ps-slide-index' ),
		    index = parseInt( index, 10 );
		
		openPhotoSwipe( index );
	    } );
	} );
	
	var openPhotoSwipe = function ( index ) {
	    var pswpElement = document.querySelectorAll( '.pswp' )[ 0 ];
	    
	    let images = context.querySelectorAll( '.js-carousel-main .image-slide' );
	    
	    if ( images.length < 2 ) {
		var arrows = false;
	    } else {
		var arrows = true;
	    }
	    
	    let items = [];
	    images.forEach( ( image, i ) => {
		let imageTag = image.querySelector( '.product__image' );
		
		let item = {
		    src: imageTag.getAttribute( 'data-zoom-src' ),
		    w  : imageTag.getAttribute( 'data-width' ),
		    h  : imageTag.getAttribute( 'data-height' )
		}
		items.push( item );
	    } );
	    
	    var options = {
		index           : index,
		arrowEl         : arrows,
		captionEl       : false,
		closeOnScroll   : false,
		counterEl       : false,
		history         : false,
		fullscreenEl    : false,
		preloaderEl     : false,
		shareEl         : false,
		tapToClose      : false,
		getThumbBoundsFn: function ( index ) {
		    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
		    var thumbnail   = context.querySelector( '.product__image' );
		    var rect        = thumbnail.getBoundingClientRect();
		    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
		}
	    };
	    
	    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );
	    gallery.init();
	    
	    gallery.listen( 'afterChange', function () {
		var flkty       = Flickity.data( '.slides.carousel-main' );
		var newIndex    = gallery.getCurrentIndex();
		let sliderImage = document.querySelector( `[data-ps-slide-index="${ newIndex }"]` );
		let newNewIndex = parseInt( sliderImage.dataset.index, 10 );
		flkty.select( newNewIndex );
	    } );
	    
	};
    }
    
    function switchMedia( mediaId, context ) {
	let main         = context.querySelector( '.js-carousel-main' ),
	    currentMedia = main.querySelector( '[data-product-single-media-wrapper]:not(.inactive)' ),
	    newMedia     = main.querySelector( '[data-product-single-media-wrapper]' + "[data-thumbnail-id='product-template-" + mediaId + "']" ),
	    otherMedia   = main.querySelectorAll( '[data-product-single-media-wrapper]' + ":not([data-thumbnail-id='product-template-" + mediaId + "'])" );
	
	currentMedia.dispatchEvent(
	    new CustomEvent( 'mediaHidden', {
		bubbles   : true,
		cancelable: true
	    } )
	);
	
	newMedia.classList.add( 'active-slide' );
	newMedia.classList.remove( 'inactive' );
	newMedia.dispatchEvent(
	    new CustomEvent( 'mediaVisible', {
		bubbles   : true,
		cancelable: true
	    } )
	);
	
	otherMedia.forEach(
	    function ( el ) {
		el.classList.add( 'inactive' );
		el.classList.remove( 'active-slide' );
	    }.bind( this )
	);
    }
    
    function setActiveThumbnail( mediaId, el, context ) {
	
	let main        = context.querySelector( '.js-carousel-main' ),
	    carouselNav = context.querySelector( '.js-thumb-carousel-nav' );
	
	if ( typeof mediaId === 'undefined' ) {
	    mediaId = main.querySelector( '[data-product-single-media-wrapper]:not(.hide)' ).dataset.mediaId;
	}
	
	if ( carouselNav ) {
	    /* remove selected class from all */
	    carouselNav.querySelectorAll( '.js-thumb-item' ).forEach( ( item, i ) => {
		item.classList.remove( 'is-nav-selected' );
		item.classList.remove( 'active-slide' );
		item.removeAttribute( 'aria-current' );
	    } );
	}
	
	/* add selected class */
	let thumbActive = context.querySelector( ".js-thumb-item[data-image-id='" + mediaId + "']" );
	if ( thumbActive ) {
	    thumbActive.classList.add( 'is-nav-selected' );
	    thumbActive.classList.add( 'active-slide' );
	    thumbActive.setAttribute( 'aria-current', true );
	}
    }
    
    return {
	init              : init,
	mainSlider        : mainSlider,
	thumbSlider       : thumbSlider,
	thumbnails        : thumbnails,
	setThumbPos       : setThumbPos,
	setThumbSizes     : setThumbSizes,
	galleryEvents     : galleryEvents,
	removeFocus       : removeFocus,
	addFocus          : addFocus,
	enlargePhoto      : enlargePhoto,
	switchMedia       : switchMedia,
	setActiveThumbnail: setActiveThumbnail
    };
    
} )();

theme.ProductFullGallery = ( function () {
    function init( context, sectionId, events, Product ) {
	let config = JSON.parse( context.querySelector( '.js-product-gallery' ).dataset.galleryConfig || '{}' ),
	    main   = context.querySelector( '.js-carousel-main' );
	
	if ( !main ) return false;
	
	this.mainSlider( main, config, context );
	
	if ( config.clickToEnlarge ) theme.ProductFullGallery.enlargePhoto( context );
    }
    
    function mainSlider( main, config, context ) {
	let initialEl = main.querySelector( "[data-image-id='" + context.dataset.initialVariant + "']" ),
	    initialIndex;
	
	if ( initialEl ) {
	    initialIndex = initialEl.dataset.slideIndex;
	} else {
	    initialIndex = 0;
	}
	
	var flkty = new Flickity( main, {
	    // options
	    fade              : false,
	    wrapAround        : true,
	    cellAlign         : 'center',
	    draggable         : false,
	    contain           : true,
	    imagesLoaded      : true,
	    accessibility     : true,
	    lazyLoad          : 2,
	    pageDots          : true,
	    prevNextButtons   : true,
	    autoPlay          : false,
	    selectedAttraction: 0.01,
	    dragThreshold     : 15,
	    adaptiveHeight    : false,
	    initialIndex      : initialIndex,
	    on                : {
		ready : function () {
		    let id = this.selectedElement.dataset.imageId;
		    
		    /* Fade in */
		    context.querySelector( '.js-product-gallery' ).style.visibility = "visible";
		},
		change: function () {
		    /* Set focus control on change */
		    theme.ProductFullGallery.removeFocus( context );
		    theme.ProductFullGallery.addFocus( this.selectedElement, context );
		    
		    /* Set media */
		    theme.ProductFullGallery.switchMedia( this.selectedElement.dataset.imageId, context );
		    
		    /* Allow model drag */
		    if ( this.selectedElement.classList.contains( 'model-slide' ) ) {
			if ( this.isDraggable ) {
			    /* Turn off drag for model usage */
			    this.options.draggable = !this.options.draggable;
			    this.updateDraggable();
			}
		    }
		}
	    }
	} );
	
	theme.ProductFullGallery.galleryEvents( flkty, context );
    }
    
    function galleryEvents( flkty, context ) {
	
	/* On Variant Change and Initial Load */
	Events.on( 'variantchange:image', function ( id, context ) {
	    
	    if ( id === null ) return false;
	    
	    /* Select new image in flickity */
	    let main  = context.querySelector( '.js-carousel-main' ),
		el    = main.querySelector( "[data-image-id='" + id + "']" ),
		index = el.dataset.slideIndex;
	    
	    theme.ProductFullGallery.switchMedia( id, context );
	    
	    flkty.select( index );
	    
	} );
    }
    
    function removeFocus( context ) {
	let main;
	
	if ( context ) {
	    main = context;
	} else {
	    main = context.querySelector( '.js-carousel-main' );
	}
	
	/* Set all elements to no tab */
	context.querySelectorAll( '.js-carousel-main *' ).forEach( ( item, i ) => {
	    item.setAttribute( 'tabIndex', '-1' );
	    item.blur();
	} );
	
	let buttonContents = context.querySelectorAll( '.flickity-button *' );
	buttonContents.forEach( ( item, i ) => {
	    item.setAttribute( 'tabIndex', '-1' );
	    item.classList.add( 'js-hide-focus' )
	} );
	
	if ( main.classList.contains( '.flickity-enabled' ) ) {
	    main.setAttribute( 'tabIndex', '-1' );
	    main.classList.add( 'js-hide-focus' );
	}
	
    }
    
    function addFocus( current, context ) {
	/* Set buttons to tab */
	context.querySelectorAll( '.flickity-button' ).forEach( ( item, i ) => {
	    item.setAttribute( "tabIndex", "0" );
	} );
	/* Set current element to tab */
	if ( current.classList.contains( 'image-slide' ) ) {
	    current.querySelector( 'img' ).setAttribute( "tabIndex", "0" );
	} else if ( current.classList.contains( 'video-slide' ) ) {
	    current.querySelectorAll( '.plyr__controls *' ).forEach( ( item, i ) => {
		item.setAttribute( "tabIndex", "0" );
	    } );
	} else if ( current.classList.contains( 'external_video-slide' ) ) {
	    current.querySelector( 'iframe' ).setAttribute( "tabIndex", "0" );
	} else if ( current.classList.contains( 'model-slide' ) ) {
	    current.querySelectorAll( '.shopify-model-viewer-ui__controls-area *' ).forEach( ( item, i ) => {
		item.setAttribute( "tabIndex", "0" );
	    } );
	}
    }
    
    function enlargePhoto( context ) {
	
	let buttons = context.querySelectorAll( 'a.zoom_btn' );
	
	if ( !buttons ) return false;
	buttons.forEach( ( button, i ) => {
	    button.addEventListener( 'click', function ( event ) {
		event.preventDefault();
		var btn   = event.target,
		    index = btn.getAttribute( 'data-ps-slide-index' ),
		    index = parseInt( index, 10 );
		
		openPhotoSwipe( index );
	    } );
	} );
	
	var openPhotoSwipe = function ( index ) {
	    var pswpElement = document.querySelectorAll( '.pswp' )[ 0 ];
	    
	    let images = context.querySelectorAll( '.js-carousel-main .image-slide' );
	    
	    if ( images.length < 2 ) {
		var arrows = false;
	    } else {
		var arrows = true;
	    }
	    
	    let items = [];
	    images.forEach( ( image, i ) => {
		let imageTag = image.querySelector( '.product__image' );
		
		let item = {
		    src: imageTag.getAttribute( 'data-zoom-src' ),
		    w  : imageTag.getAttribute( 'data-width' ),
		    h  : imageTag.getAttribute( 'data-height' )
		}
		items.push( item );
	    } );
	    
	    var options = {
		index           : index,
		arrowEl         : arrows,
		captionEl       : false,
		closeOnScroll   : false,
		counterEl       : false,
		history         : false,
		fullscreenEl    : false,
		preloaderEl     : false,
		shareEl         : false,
		tapToClose      : false,
		getThumbBoundsFn: function ( index ) {
		    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
		    var thumbnail   = context.querySelector( '.product__image' );
		    var rect        = thumbnail.getBoundingClientRect();
		    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
		}
	    };
	    
	    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );
	    gallery.init();
	    
	    gallery.listen( 'afterChange', function () {
		var flkty       = Flickity.data( '.slides.carousel-main' );
		var newIndex    = gallery.getCurrentIndex();
		let sliderImage = document.querySelector( `[data-ps-slide-index="${ newIndex }"]` );
		let newNewIndex = parseInt( sliderImage.dataset.index, 10 );
		flkty.select( newNewIndex );
	    } );
	    
	};
    }
    
    function switchMedia( mediaId, context ) {
	let main         = context.querySelector( '.js-carousel-main' ),
	    currentMedia = main.querySelector( '[data-product-single-media-wrapper]:not(.inactive)' ),
	    newMedia     = main.querySelector( '[data-product-single-media-wrapper]' + "[data-thumbnail-id='product-template-" + mediaId + "']" ),
	    otherMedia   = main.querySelectorAll( '[data-product-single-media-wrapper]' + ":not([data-thumbnail-id='product-template-" + mediaId + "'])" );
	
	currentMedia.dispatchEvent(
	    new CustomEvent( 'mediaHidden', {
		bubbles   : true,
		cancelable: true
	    } )
	);
	
	newMedia.classList.add( 'active-slide' );
	newMedia.classList.remove( 'inactive' );
	newMedia.dispatchEvent(
	    new CustomEvent( 'mediaVisible', {
		bubbles   : true,
		cancelable: true
	    } )
	);
	
	otherMedia.forEach(
	    function ( el ) {
		el.classList.add( 'inactive' );
		el.classList.remove( 'active-slide' );
	    }.bind( this )
	);
    }
    
    return {
	init         : init,
	mainSlider   : mainSlider,
	galleryEvents: galleryEvents,
	removeFocus  : removeFocus,
	addFocus     : addFocus,
	enlargePhoto : enlargePhoto,
	switchMedia  : switchMedia
    };
    
} )();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
    theme.ProductVideo.loadVideos( theme.ProductVideo.hosts.youtube );
}

theme.ProductVideo = ( function ( context, sectionId ) {
    var videos = {};
    
    var hosts = {
	html5  : 'html5',
	youtube: 'youtube'
    };
    
    var selectors = {
	productMediaWrapper: '[data-product-single-media-wrapper]'
    };
    
    var attributes = {
	enableVideoLooping: 'enable-video-looping',
	videoId           : 'video-id'
    };
    
    function init( videoContainer, sectionId ) {
	if ( !videoContainer ) {
	    return;
	}
	
	var videoElement = videoContainer.querySelector( 'iframe, video' );
	
	if ( !videoElement ) {
	    return;
	}
	
	var mediaId = videoContainer.getAttribute( 'data-media-id' );
	
	videos[ mediaId ] = {
	    mediaId  : mediaId,
	    sectionId: sectionId,
	    host     : hostFromVideoElement( videoElement ),
	    container: videoContainer,
	    element  : videoElement,
	    ready    : function () {
		createPlayer( this );
	    }
	};
	
	var video = videos[ mediaId ];
	
	switch ( video.host ) {
	    case hosts.html5:
		window.Shopify.loadFeatures( [
		    {
			name   : 'video-ui',
			version: '1.0',
			onLoad : setupPlyrVideos
		    }
		] );
		theme.LibraryLoader.load( 'plyrShopifyStyles' );
		break;
	    case hosts.youtube:
		theme.LibraryLoader.load( 'youtubeSdk', setupYouTubeVideos );
		break;
	}
    }
    
    function setupPlyrVideos( errors ) {
	if ( errors ) {
	    fallbackToNativeVideo();
	    return;
	}
	
	loadVideos( hosts.html5 );
    }
    
    function setupYouTubeVideos() {
	if ( !window.YT.Player ) return;
	
	loadVideos( hosts.youtube );
    }
    
    function createPlayer( video ) {
	if ( video.player ) {
	    return;
	}
	
	var productMediaWrapper = video.container.closest(
	    selectors.productMediaWrapper
	);
	
	var enableLooping = productMediaWrapper.getAttribute(
	    'data-' + attributes.enableVideoLooping
	) === 'true';
	
	switch ( video.host ) {
	    case hosts.html5:
		// eslint-disable-next-line no-undef
		video.player = new Shopify.Plyr( video.element, {
		    loop               : { active: enableLooping },
		    muted              : true,
		    hideControlsOnPause: true,
		    tooltips           : { controls: false, seek: true }
		} );
		video.player.on( 'ready', event => {
		    video.container.querySelector( '.plyr--full-ui' ).setAttribute( 'tabindex', '-1' );
		    video.container.querySelectorAll( '.plyr--full-ui *' ).forEach( ( item, i ) => {
			item.setAttribute( 'tabindex', '-1' );
		    } );
		    
		} );
		video.player.on( 'play', event => {
		    video.container.querySelectorAll( '.plyr__controls *' ).forEach( ( item, i ) => {
			item.setAttribute( "tabIndex", "0" );
		    } );
		} );
		break;
	    case hosts.youtube:
		var videoId = productMediaWrapper.getAttribute(
		    'data-' + attributes.videoId
		);
		
		video.player = new YT.Player( video.element, {
		    videoId: videoId,
		    events : {
			onStateChange: function ( event ) {
			    if ( event.data === 0 && enableLooping ) event.target.seekTo( 0 );
			},
			onReady      : function ( event ) {
			    video.player.mute();
			}
		    }
		} );
		break;
	}
	
	var pauseVideo = function () {
	    if ( !video.player ) return;
	    
	    if ( video.host === hosts.html5 ) {
		video.player.pause();
	    }
	    
	    if ( video.host === hosts.youtube && video.player.pauseVideo ) {
		video.player.pauseVideo();
	    }
	};
	
	productMediaWrapper.addEventListener( 'mediaHidden', pauseVideo );
	productMediaWrapper.addEventListener( 'xrLaunch', pauseVideo );
	
	productMediaWrapper.addEventListener( 'mediaHidden xrLaunch', function () {
	    
	    if ( !video.player ) return;
	    
	    if ( video.host === hosts.html5 ) {
		video.player.pause();
	    }
	    if ( video.host === hosts.youtube && video.player.pauseVideo ) {
		video.player.pauseVideo();
	    }
	    
	} );
	
	productMediaWrapper.addEventListener( 'mediaVisible', function () {
	    
	    if ( theme.Helpers.isTouch() ) return;
	    
	    if ( !video.player ) return;
	    
	    if ( video.host === hosts.html5 ) {
		if ( desktop.matches ) {
		    video.player.play();
		}
	    }
	    
	    if ( video.host === hosts.youtube && video.player.playVideo ) {
		if ( desktop.matches ) {
		    video.player.playVideo();
		}
	    }
	} );
	
    }
    
    function hostFromVideoElement( video ) {
	if ( video.tagName === 'VIDEO' ) {
	    return hosts.html5;
	}
	
	if ( video.tagName === 'IFRAME' ) {
	    if (
		/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
		    video.src
		)
	    ) {
		return hosts.youtube;
	    }
	}
	return null;
    }
    
    function loadVideos( host ) {
	for ( var key in videos ) {
	    if ( videos.hasOwnProperty( key ) ) {
		var video = videos[ key ];
		if ( video.host === host ) {
		    video.ready();
		}
	    }
	}
    }
    
    function fallbackToNativeVideo() {
	for ( var key in videos ) {
	    if ( videos.hasOwnProperty( key ) ) {
		var video = videos[ key ];
		
		if ( video.nativeVideo ) continue;
		
		if ( video.host === hosts.html5 ) {
		    video.element.setAttribute( 'controls', 'controls' );
		    video.nativeVideo = true;
		}
	    }
	}
    }
    
    function removeSectionVideos( sectionId ) {
	for ( var key in videos ) {
	    if ( videos.hasOwnProperty( key ) ) {
		var video = videos[ key ];
		
		if ( video.sectionId === sectionId ) {
		    if ( video.player ) video.player.destroy();
		    delete videos[ key ];
		}
	    }
	}
    }
    
    return {
	init               : init,
	hosts              : hosts,
	loadVideos         : loadVideos,
	removeSectionVideos: removeSectionVideos
    };
    
} )();

theme.ProductModel = ( function () {
    var modelJsonSections = {};
    var models            = {};
    var xrButtons         = {};
    
    var selectors = {
	mediaGroup: '[data-product-single-media-group]',
	xrButton  : '[data-shopify-xr]'
    };
    
    function init( modelViewerContainers, sectionId ) {
	modelJsonSections[ sectionId ] = {
	    loaded: false
	};
	
	modelViewerContainers.forEach( function ( modelViewerContainer, index ) {
	    var mediaId            = modelViewerContainer.getAttribute( 'data-media-id' );
	    var modelViewerElement = modelViewerContainer.querySelector(
		'model-viewer'
	    );
	    var modelId            = modelViewerElement.getAttribute( 'data-model-id' );
	    
	    if ( index === 0 ) {
		var mediaGroup         = modelViewerContainer.closest( selectors.mediaGroup );
		var xrButton           = mediaGroup.querySelector( selectors.xrButton );
		xrButtons[ sectionId ] = {
		    element  : xrButton,
		    defaultId: modelId
		};
	    }
	    
	    models[ mediaId ] = {
		modelId  : modelId,
		sectionId: sectionId,
		container: modelViewerContainer,
		element  : modelViewerElement
	    };
	} );
	
	window.Shopify.loadFeatures( [
	    {
		name   : 'shopify-xr',
		version: '1.0',
		onLoad : setupShopifyXr
	    },
	    {
		name   : 'model-viewer-ui',
		version: '1.0',
		onLoad : setupModelViewerUi
	    }
	] );
	theme.LibraryLoader.load( 'modelViewerUiStyles' );
    }
    
    function setupShopifyXr( errors ) {
	if ( errors ) return;
	
	if ( !window.ShopifyXR ) {
	    document.addEventListener( 'shopify_xr_initialized', function () {
		setupShopifyXr();
	    } );
	    return;
	}
	
	for ( var sectionId in modelJsonSections ) {
	    if ( modelJsonSections.hasOwnProperty( sectionId ) ) {
		var modelSection = modelJsonSections[ sectionId ];
		
		if ( modelSection.loaded ) continue;
		var modelJson = document.querySelector( '#ModelJson-' + sectionId );
		if ( !modelJson ) return false;
		window.ShopifyXR.addModels( JSON.parse( modelJson.innerHTML ) );
		modelSection.loaded = true;
	    }
	}
	window.ShopifyXR.setupXRElements();
    }
    
    function setupModelViewerUi( errors ) {
	if ( errors ) return;
	
	for ( var key in models ) {
	    if ( models.hasOwnProperty( key ) ) {
		var model = models[ key ];
		if ( !model.modelViewerUi ) {
		    model.modelViewerUi = new Shopify.ModelViewerUI( model.element );
		}
		setupModelViewerListeners( model );
	    }
	}
    }
    
    function setupModelViewerListeners( model ) {
	var xrButton = xrButtons[ model.sectionId ];
	
	model.container.addEventListener( 'mediaVisible', function () {
	    xrButton.element.setAttribute( 'data-shopify-model3d-id', model.modelId );
	    if ( theme.Helpers.isTouch() ) return;
	    model.modelViewerUi.play();
	} );
	
	model.container.addEventListener( 'mediaHidden', function () {
	    xrButton.element.setAttribute(
		'data-shopify-model3d-id',
		xrButton.defaultId
	    );
	    model.modelViewerUi.pause();
	} );
	
	model.container.addEventListener( 'xrLaunch', function () {
	    model.modelViewerUi.pause();
	} );
    }
    
    function removeSectionModels( sectionId ) {
	for ( var key in models ) {
	    if ( models.hasOwnProperty( key ) ) {
		var model = models[ key ];
		if ( model.sectionId === sectionId ) {
		    models[ key ].modelViewerUi.destroy();
		    delete models[ key ];
		}
	    }
	}
	delete modelJsonSections[ sectionId ];
    }
    
    return {
	init               : init,
	removeSectionModels: removeSectionModels
    };
} )();

theme.ProductDetails = function ( context, events, Product ) {
    ( function sku() {
	var element = context.querySelector( ".variant_sku" );
	
	if ( !element ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant, config ) {
	    var variant_sku   = variant.sku;
	    element.innerHTML = variant_sku;
	} );
	events.on( "variantunavailable", function ( variant, config ) {
	    var variant_sku   = config.unavailable;
	    element.innerHTML = variant_sku;
	} );
	
    } )();
    
    ( function current_variant() {
	var element = context.querySelector( ".variant_selected" );
	
	if ( !element ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant ) {
	    var variant_selected = variant.title;
	    element.innerHTML    = variant_selected;
	} );
	events.on( "variantunavailable", function ( variant, config ) {
	    var variant_selected = config.unavailable;
	    element.innerHTML    = variant_selected;
	} );
	
    } )();
    
    ( function inventory() {
	var element = context.querySelector( ".variant_inventory" );
	
	if ( !element ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant, config ) {
	    var inventory_quantity = variant.inventory_quantity;
	    if ( inventory_quantity > 0 ) {
		element.innerHTML = inventory_quantity;
	    } else {
		element.innerHTML = config.unavailable;
	    }
	} );
	events.on( "variantunavailable", function ( variant, config ) {
	    var inventory_quantity = config.unavailable;
	    element.innerHTML      = inventory_quantity;
	} );
	
    } )();
    
    ( function weight() {
	var element = context.querySelector( ".variant_weight" );
	
	if ( !element ) {
	    return false;
	}
	
	events.on( "variantchange", function ( variant, config ) {
	    var variant_weight      = variant.weight_in_unit;
	    var variant_weight_unit = variant.weight_unit;
	    if ( variant_weight > 0 ) {
		element.innerHTML = variant_weight + '&nbsp;' + variant_weight_unit;
	    } else {
		element.innerHTML = config.unavailable;
	    }
	} );
	events.on( "variantunavailable", function ( variant, config ) {
	    var variant_weight = config.unavailable;
	    element.innerHTML  = variant_weight;
	} );
	
    } )();
}

theme.ProductAccordion = function () {
    ( function accordion() {
	
	document.addEventListener( 'shopify:block:select', function ( event ) {
	    
	    // Dont' run on the mobile navigation
	    if ( event.target.classList.contains( WAU.Accordion.getConfigClass( 'mobileNavAccordion' ) ) ) {
		return;
	    }
	    
	    WAU.Accordion.show( event.target, true );
	    
	} );
	
	document.addEventListener( 'shopify:block:deselect', function ( event ) {
	    
	    // Dont' run on the mobile navigation
	    if ( event.target.classList.contains( WAU.Accordion.getConfigClass( 'mobileNavAccordion' ) ) ) {
		return;
	    }
	    
	    
	    // Don't hide if it has the "open by default" setting enabled
	    if ( !event.target.classList.contains( WAU.Accordion.getConfigClass( 'open' ) ) ) {
		WAU.Accordion.hide( event.target, true );
	    }
	} );
	
    } )();
}

theme.ProductStickyBar = function () {
    var stickyBar = document.getElementById( 'sticky-cart' );
    
    if ( !stickyBar ) {
	return false;
    }
    
    let lastKnownScrollPosition = 0;
    let ticking                 = false;
    
    function initSticky( scrollPos ) {
	var cartForm = document.querySelectorAll( '.js-product-bottom' );
	if ( !cartForm ) return false;
	
	cartForm.forEach( ( item, i ) => {
	    var topOfHiddenDiv = item.offsetTop;
	    var position       = scrollPos >= topOfHiddenDiv,
		footer         = document.getElementById( 'footer' ),
		stickyBar      = document.querySelector( '.js-sticky-cart' );
	    
	    if ( i === 1 ) return false;
	    
	    if ( position && !stickyBar.classList.contains( 'show' ) ) {
		stickyBar.classList.add( 'show' );
		footer.classList.add( 'padding-sticky' );
	    } else if ( !position && stickyBar.classList.contains( 'show' ) ) {
		stickyBar.classList.remove( 'show' );
		footer.classList.remove( 'padding-sticky' );
	    }
	} );
    }
    
    document.addEventListener( 'scroll', function ( e ) {
	lastKnownScrollPosition = window.scrollY;
	
	if ( !ticking ) {
	    window.requestAnimationFrame( function () {
		initSticky( lastKnownScrollPosition );
		ticking = false;
	    } );
	    
	    ticking = true;
	}
    } );
}

theme.Product = ( function () {
    function Product( context ) {
	var events     = new EventEmitter3();
	events.trigger = events.emit; // alias
	
	var productJson = context.querySelector( '.product-json' );
	
	if ( !productJson ) {
	    return false;
	}
	
	var Product = productJson.innerHTML,
	    Product = JSON.parse( Product || '{}' );
	
	var sectionId = context.dataset.sectionId;
	
	theme.ProductAccordion( Product );
	
	if ( context.querySelector( "[data-product-details]" ) ) {
	    theme.ProductDetails( context, events, Product );
	}
	
	if ( context.querySelector( "[data-gallery-thumbnails]" ) ) {
	    theme.ProductGallery.init( context, sectionId, events, Product );
	}
	
	if ( context.querySelector( "[data-gallery-fullwidth]" ) ) {
	    theme.ProductFullGallery.init( context, sectionId, events, Product );
	}
	
	if ( context.querySelector( "[data-product-form]" ) ) {
	    theme.ProductForm( context, sectionId, events, Product );
	}
	
	if ( context.querySelector( "[data-product-sticky-bar]" ) ) {
	    theme.ProductStickyBar( context, events, Product );
	}
	
	if ( context.querySelector( "[data-product-image-carousel]" ) ) {
	    theme.CustomPageCarousel( context, events, Product );
	}
	
	/* Product media */
	context.querySelectorAll( "[data-product-media-type-video]" ).forEach( function ( context, sectionId ) {
	    theme.ProductVideo.init( context, sectionId );
	} );
	
	let modelViewerElements = context.querySelectorAll( '[data-product-media-type-model]' );
	
	if ( modelViewerElements.length > 0 ) {
	    theme.ProductModel.init( modelViewerElements, sectionId );
	}
	
	var self = this;
	
	document.addEventListener( 'shopify_xr_launch', function () {
	    var currentMedia = document.querySelector( '[data-product-single-media-wrapper]:not(.inactive)', self );
	    
	    currentMedia.dispatchEvent(
		new CustomEvent( 'xrLaunch', {
		    bubbles   : true,
		    cancelable: true
		} )
	    );
	} );
    }
    
    return Product;
} )();

theme.StoreAvailability = ( function () {
    
    Events.on( "storeavailability:variant", function ( id, title ) {
	updateContent( id, title )
    } );
    
    function updateContent( id, title ) {
	const container         = document.querySelector( '[data-store-availability-container]' );
	const variantSectionUrl =
		  '/variants/' + id + '/?section_id=store-availability';
	container.innerHTML     = '';
	
	fetch( variantSectionUrl )
	    .then( function ( response ) {
		return response.text();
	    } )
	    .then( function ( storeAvailabilityHTML ) {
		if ( storeAvailabilityHTML.trim() === '' ) {
		    return;
		}
		
		container.innerHTML     = storeAvailabilityHTML;
		container.innerHTML     = container.firstElementChild.innerHTML;
		container.style.opacity = 1;
		
		// Show or hide container if variant unavailable
		container.querySelector( '.store-availability-container' ).classList.remove( 'fadeOut' );
		container.querySelector( '.store-availability-container' ).style.display = "block";
		
		Events.on( "storeavailability:unavailable", function () {
		    container.querySelector( '.store-availability-container' ).classList.add( 'fadeOut' )
		    container.querySelector( '.store-availability-container' ).style.display = "none";
		} );
		
		// If no active pickup locations hide container and stop function
		if ( document.querySelector( '[data-pick-up-available="false"]' ) ) {
		    container.style.display = "none";
		    return false;
		}
		
		// Move modal code to slideout
		const source = document.getElementById( "StoreAvailabilityModal" );
		
		// create the slideout el, assign it a name, and then add
		const slideoutContainer = document.querySelector( ".js-slideout-toggle-wrapper" );
		const slideoutAside     = document.getElementById( 'slideout-store-availability' );
		
		if ( slideoutAside ) {
		    slideoutAside.innerHTML = "";
		    slideoutAside.appendChild( source );
		} else {
		    const newSlideout = WAU.Slideout._createSlideoutEl( "right", "store-availability", slideoutContainer );
		    newSlideout.appendChild( source );
		}
		
		WAU.Slideout.init( "store-availability" );
		
		// Update product title
		const storeAvailabilityModalProductTitle       = document.querySelector( '[data-store-availability-modal-product-title]' );
		let strippedTitle                              = title.replace( /(<([^>]+)>)/gi, "" );
		storeAvailabilityModalProductTitle.textContent = strippedTitle;
		
	    } );
    }
} )();

/*============================================================================
  Slideshow Section
==============================================================================*/
theme.Slideshow = ( function () {
    function Slideshow( container ) {
	
	const slideshows = document.querySelectorAll( '.js-slideshow' );
	
	slideshows.forEach( Slideshow => {
	    const flktyData    = Slideshow.getAttribute( 'data-flickity' );
	    const flktyOptions = JSON.parse( flktyData );
	    new Flickity( Slideshow, flktyOptions );
	} );
	
    }
    
    return Slideshow;
} )();

theme.Slideshow.prototype = _.assignIn( {}, theme.Slideshow.prototype, {
    
    onLoad: function ( event ) {
	const Slideshow    = event.target.closest( '.js-slideshow' );
	const flktyData    = Slideshow.getAttribute( 'data-flickity' );
	const flktyOptions = JSON.parse( flktyData );
	new Flickity( '.js-slideshow', flktyOptions );
    },
    
    onBlockSelect: function ( event ) {
	const Slideshow = event.target.closest( '.js-slideshow' );
	const flkty     = Flickity.data( Slideshow );
	const Slide     = event.target.getAttribute( "data-slider-index" );
	flkty.select( Slide );
	flkty.pausePlayer();
    },
    
    onBlockDeselect: function () {
	const Slideshow = event.target.closest( '.js-slideshow' );
	const flkty     = Flickity.data( Slideshow );
	flkty.unpausePlayer();
    }
} );

/*============================================================================
  Map Section
==============================================================================*/
theme.Maps = ( function () {
    
    var google_api_loaded = false;
    
    function Map( container ) {
	
	var events     = new EventEmitter3();
	events.trigger = events.emit; // alias
	
	window.gm_authFailure = function () {
	    google_api_loaded = false;
	    
	    if ( Shopify.designMode ) {
		events.trigger( "gmauthfailure:themeeditor" );
	    } else {
		events.trigger( "gmauthfailure" );
	    }
	};
	
	var config = container.querySelector( "[data-map-config]" ).innerHTML,
	    config = JSON.parse( config );
	
	if ( !config.api_key ) {
	    return false;
	}
	
	( function section_container() {
	    var element = container;
	    
	    events.on( "gmauthfailure:themeeditor", error );
	    events.on( "map:error", error );
	    
	    function error() {
		element.classList.add( "map-section-load-error" );
	    }
	} )();
	
	( function background_image() {
	    var element = container.querySelector( "[data-bg-image]" );
	    
	    events.on( "gmauthfailure", show );
	    
	    function show() {
		element.classList.add( "show-image" );
	    }
	} )();
	
	( function overlay() {
	    var element = container.querySelector( "[data-map-overlay]" );
	    
	    events.on( "gmauthfailure:themeeditor", error );
	    events.on( "map:error", error );
	    
	    function error( message ) {
		message           = message || config.auth_error;
		element.innerHTML = '<div class="map-section-error errors text-center">' + message + '</div>';
	    }
	} )();
	
	( function map() {
	    var element = container.querySelector( "[data-map]" );
	    
	    events.on( "ready", geolocate );
	    
	    function geolocate() {
		
		var geocoder = new google.maps.Geocoder();
		
		geocoder.geocode( { address: config.address }, function ( results, status ) {
		    
		    if ( status == google.maps.GeocoderStatus.OK ) {
			render( results );
		    } else {
			error( status );
		    }
		} );
	    }
	    
	    function render( results ) {
		element.innerHTML = "";
		
		var map = new google.maps.Map( element, {
		    zoom                  : config.zoom,
		    center                : results[ 0 ].geometry.location,
		    draggable             : false,
		    clickableIcons        : false,
		    scrollwheel           : false,
		    disableDoubleClickZoom: true,
		    styles                : config.styles,
		    disableDefaultUI      : true
		} );
		
		var center = map.getCenter();
		
		new google.maps.Marker( {
		    map     : map,
		    position: center
		} );
		
		google.maps.event.addDomListener( window, "resize", function () {
		    theme.Helpers.debounce( function () {
			google.maps.event.trigger( map, "resize" );
			map.setCenter( center );
		    }, 250 );
		} );
		
		document.addEventListener( 'shopify:section:unload', function () {
		    google.maps.event.clearListeners( map, "resize" );
		} );
	    }
	    
	    function error( status ) {
		var message = config.address_error;
		switch ( status ) {
		    case 'ZERO_RESULTS':
			message = config.address_no_results;
			break;
		    case 'OVER_QUERY_LIMIT':
			message = config.address_query_limit;
			break;
		    case 'REQUEST_DENIED':
			message = config.auth_error;
			break;
		}
		
		if ( Shopify.designMode ) {
		    events.trigger( "map:error", message );
		}
	    }
	} )();
	
	if ( google_api_loaded ) {
	    events.trigger( "ready" );
	} else {
	    const getScript = url => new Promise( ( resolve, reject ) => {
		const script = document.createElement( 'script' )
		script.src   = url
		script.async = true
		
		script.onerror = reject
		
		script.onload = script.onreadystatechange = function () {
		    const loadState = this.readyState
		    
		    if ( loadState && loadState !== 'loaded' && loadState !== 'complete' ) return
		    
		    script.onload = script.onreadystatechange = null
		    
		    resolve()
		}
		
		document.head.appendChild( script )
	    } )
	    
	    getScript( "https://maps.googleapis.com/maps/api/js?key=" + config.api_key )
		.then( () => {
		    google_api_loaded = true;
		    events.trigger( "ready" );
		} )
		.catch( () => {
		    events.trigger( "map:error", 'Could not load map with API key. Check billing with Google.' );
		    console.error( 'Could not load script with api given' )
		} )
	}
    }
    
    Map.prototype = _.assignIn( {}, Map.prototype, {} );
    
    return Map;
} )();

/*============================================================================
  Featured Collection Section
==============================================================================*/
theme.FeaturedCollection = ( function () {
    function FeaturedCollection( container ) {
	
	var Carousels = document.querySelectorAll( '.featured__collection-carousel' );
	if ( !Carousels ) {
	    return false;
	}
	Carousels.forEach( Carousel => {
	    const flktyData    = Carousel.getAttribute( 'data-flickity' );
	    const flktyOptions = JSON.parse( flktyData );
	    new Flickity( Carousel, flktyOptions );
	} );
	
	document.addEventListener( 'shopify:section:unload', function ( event ) {
	    var Carousel = event.target.closest( '.featured__collection-carousel' );
	    if ( !Carousel ) {
		return false;
	    }
	    const flkty = Flickity.data( Carousel );
	    flkty.destroy()
	} );
	
	document.addEventListener( 'shopify:section:load', function ( event ) {
	    var Carousel = event.target.closest( '.js-carousel' );
	    if ( !Carousel ) {
		return false;
	    }
	    const flktyData    = Carousel.getAttribute( 'data-flickity' );
	    const flktyOptions = JSON.parse( flktyData );
	    new Flickity( '.js-carousel', flktyOptions );
	} );
	
    }
    
    FeaturedCollection.prototype = _.assignIn( {}, FeaturedCollection.prototype, {} );
    return FeaturedCollection;
} )();

/*============================================================================
  Mobile Nav
==============================================================================*/
theme.mobileNav = ( function () {
    
    function mobileNav( container ) {
	WAU.Slideout.init( "mobile-navigation" );
    }
    
    mobileNav.prototype = _.assignIn( {}, mobileNav.prototype, {
	onSelect     : function () {
	    WAU.Slideout._openByName( "mobile-navigation" );
	},
	onDeselect   : function () {
	    WAU.Slideout._closeByName( "mobile-navigation" );
	},
	onBlockSelect: function () {
	    WAU.Slideout._openByName( "mobile-navigation" );
	}
    } );
    
    return mobileNav;
    
} )();

/*============================================================================
  Homepage Collection slider
==============================================================================*/
theme.CollectionSlider = function () {
    
    let slideshowPlugin = ( function () {
	"use strict";
	
	let publicAPIs = {};
	// Store the index slide for each slider
	let slideIndex = [];
	// Id for each slider
	let slideId    = [];
	
	// Helper function to get the index of the slideId array
	let getSliderIdIndex = function ( sliderId ) {
	    return slideId.indexOf( sliderId );
	};
	
	// Wrapper function to determine which slide to show
	let _selectSlide = function ( n, no ) {
	    showDivs( n, no );
	};
	
	// Change slide
	let showDivs = function ( n, no ) {
	    // Increment variable used for for loop
	    let i;
	    let parentSlide = document.getElementById( slideId[ no ] );
	    let slides      = parentSlide.querySelectorAll( ".slide" );
	    
	    // If slide index is greater than slideshow slides then go to first slide
	    if ( n > slides.length ) {
		slideIndex[ no ] = 1;
	    }
	    
	    // If slide index is less than 1 then go to last slide
	    if ( n < 1 ) {
		slideIndex[ no ] = slides.length;
	    }
	    
	    slides.forEach( ( slide ) => {
		slide.style.display = "none";
	    } );
	    
	    // Show this slide
	    // slides[slideIndex[no] - 1].style.display = "block";
	    slides[ slideIndex[ no ] - 1 ].style.display = "flex";
	};
	
	// Select a specific slide
	publicAPIs.selectSlide = function ( n, sliderId ) {
	    let no = getSliderIdIndex( sliderId );
	    _selectSlide( ( slideIndex[ no ] = n ), no );
	};
	
	// Select the next slide
	publicAPIs.nextSlide = function ( sliderId ) {
	    let n  = 1;
	    let no = getSliderIdIndex( sliderId );
	    _selectSlide( ( slideIndex[ no ] += n ), no );
	};
	
	// Select the previous slide
	publicAPIs.prevSlide = function ( sliderId ) {
	    let n  = -1;
	    let no = getSliderIdIndex( sliderId );
	    _selectSlide( ( slideIndex[ no ] += n ), no );
	};
	
	// Initialize plugin
	publicAPIs.init = function () {
	    // Get all slideshows
	    let slideshows = document.querySelectorAll( ".featured-collections-slider" );
	    
	    // Bail if not slideshows
	    if ( !slideshows ) {
		console.log( "Error, no slideshows" );
		return;
	    }
	    
	    // Initialize each slideshow
	    slideshows.forEach( ( slideshow, i ) => {
		slideIndex.push( 1 );
		slideId.push( slideshow.id );
		showDivs( 1, i );
	    } );
	    
	    // Add event handlers for buttons
	    document.addEventListener( "click", ( event ) => {
		
		let target = event.target;
		
		
		// If child SVG element is selected then get parent button element
		if ( target.classList.contains( 'left-arrow' ) || target.classList.contains( 'right-arrow' ) ) {
		    target = target.parentElement;
		}
		
		// Check which slider action to do
		if ( target.hasAttribute( "data-arrow-prev" ) ) {
		    publicAPIs.prevSlide( target.dataset.parent );
		} else if ( target.hasAttribute( "data-arrow-next" ) ) {
		    publicAPIs.nextSlide( target.dataset.parent );
		} else if ( target.hasAttribute( "data-slide-to" ) ) {
		    publicAPIs.selectSlide(
			Number( target.dataset.slideTo ),
			target.dataset.parent
		    );
		} else {
		    // console.log("not an arrow button");
		    return;
		}
	    } );
	};
	
	return publicAPIs;
    } )();
    
    slideshowPlugin.init();
    
    // Theme editor interaction
    document.addEventListener( 'shopify:block:select', function ( event ) {
	var id         = event.detail.blockId;
	let sliderId   = event.target.parentElement.id;
	let slideIndex = event.target.dataset.slideIndex;
	slideshowPlugin.selectSlide( Number( slideIndex ), sliderId );
    } );
}

/*============================================================================
  Footer Section
==============================================================================*/
var selectors = {
    disclosureLocale  : '[data-disclosure-locale]',
    disclosureCurrency: '[data-disclosure-currency]'
};

theme.Footer = ( function () {
    function Footer( container ) {
	this.container = container;
	this.cache     = {};
	this.cacheSelectors();
	
	if ( this.cache.localeDisclosure ) {
	    this.localeDisclosure = new theme.Disclosure( this.cache.localeDisclosure );
	}
	
	if ( this.cache.currencyDisclosure ) {
	    this.currencyDisclosure = new theme.Disclosure(
		this.cache.currencyDisclosure
	    );
	}
    }
    
    Footer.prototype = _.assignIn( {}, Footer.prototype, {
	cacheSelectors: function () {
	    this.cache = {
		localeDisclosure  : this.container.querySelector(
		    selectors.disclosureLocale
		),
		currencyDisclosure: this.container.querySelector(
		    selectors.disclosureCurrency
		)
	    };
	},
	onUnload      : function () {
	    if ( this.cache.localeDisclosure ) {
		this.localeDisclosure.destroy();
	    }
	    
	    if ( this.cache.currencyDisclosure ) {
		this.currencyDisclosure.destroy();
	    }
	}
    } );
    
    return Footer;
} )();

/*======================================================
  Password Page Section
========================================================*/
theme.Password = ( function () {
    function Password( container ) {
	
	window.addEventListener( 'DOMContentLoaded', ( event ) => {
	    const passwordError = document.querySelector( '.errors' );
	    
	    if ( passwordError ) {
		WAU.Slideout._openByName( "password" );
	    } else {
		return false;
	    }
	    
	} );
	
	WAU.Slideout.init( "password" );
	
	window.addEventListener( 'shopify:section:select', ( event ) => {
	    WAU.Slideout.init( "password" );
	} );
    }
    
    Password.prototype = _.assignIn( {}, Password.prototype, {} );
    return Password;
} )();

/*======================================================
  Mailing Popup
========================================================*/
theme.MailingPopup = ( function () {
    
    const Popup = ( function () {
	
	const defaults = {
	    selectors        : {
		popupContainer  : ".newsletter__popup-container",
		popupOverlay    : ".newsletter__popup-overlay",
		popupCloseButton: ".newsletter__popup-container-close"
	    },
	    classes          : {
		visible: "is-visible",
	    },
	    viewportWidth    : 740, // Viewport must be greater than this number to open
	    overlay          : true,      // Enabled overlay
	    defaultFrequency : 5,  // Days
	    defaultPopupDelay: 5000, // Milliseconds
	    cookieSetName    : "popupShown", // What cookie sets
	    debug            : false,
	    escape           : true, // Listen to escape button to close the pop up
	    successMessage   : false, // Show popup on success ?customer_posted=true
	    fadeAnimation    : false // Use fade functions from theme helpers
	    
	};
	
	let lastFocus, popupTestMode, popupFrequency;
	const publicAPIs = {};
	
	/*
     * @description check URL query string. Determines if customer post success is true or not
     */
	const checkURLQueryString = () => {
	    
	    if ( settings.debug ) {
		console.log( `checkURLQueryString() ran` );
	    }
	    
	    if ( settings.successMessage ) {
		const urlParams = new URLSearchParams( location.search );
		if ( urlParams.get( 'customer_posted' ) == 'true' ) {
		    return true;
		}
	    }
	    return false;
	};
	
	/*
     * @description return the viewport width
     */
	const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth;
	
	/*
     * @description handle overlay click event to exit overlay
     */
	const handleOverlayEvent = ( event ) => {
	    if ( event.target === document.querySelector( `${ settings.selectors.popupOverlay }.${ settings.classes.visible }` ) ) {
		publicAPIs.close();
	    }
	};
	
	/*
     * @description handle escape keyboard event
     */
	const handleEscapeKeyboardEvent = ( event ) => {
	    if ( event.key === 'Escape' ) {
		event.preventDefault();
		publicAPIs.close();
	    }
	};
	
	/*
     * @description check if theme.Helper fade functions are available
     */
	const checkFadeSupport = () => typeof theme.Helpers.fadeIn === 'function' && typeof theme.Helpers.fadeOut === 'function';
	
	/*
     * @description checks to see if fadeAnimations option is enabled and supported
     */
	const useFadeAnimation = () => settings.fadeAnimation && checkFadeSupport();
	
	/*
     * @description handle close button event
     */
	const handleCloseButtonEvent = ( event ) => {
	    publicAPIs.close( event );
	};
	
	/*
     * @description check if working in the theme editor
     */
	const themeEditorCheck = () => Shopify.designMode;
	
	/*
     * @description open the pop up
     */
	publicAPIs.open = () => {
	    
	    if ( getViewportWidth() < settings.viewportWidth ) {
		return;
	    }
	    
	    if ( settings.overlay && document.querySelector( settings.selectors.popupOverlay ) ) document.querySelector( settings.selectors.popupOverlay ).classList.add( settings.classes.visible );
	    
	    if ( document.querySelector( settings.selectors.popupContainer ) ) {
		if ( useFadeAnimation() ) {
		    theme.Helpers.fadeIn( document.querySelector( settings.selectors.popupContainer ) );
		} else {
		    document.querySelector( settings.selectors.popupContainer ).style.display = "block";
		}
	    }
	    
	    // Don't set cookie when inside the theme editor
	    if ( themeEditorCheck() !== true ) {
		Cookies.set( settings.cookieSetName, 'yes', { expires: popupFrequency } );
	    }
	    
	    if ( typeof theme.a11yHelpers.focusOnElement === 'function' ) {
		theme.a11yHelpers.focusOnElement( document.querySelector( settings.selectors.popupContainer ) );
	    }
	};
	
	/*
     * @description close the pop up
     */
	publicAPIs.close = event => {
	    
	    if ( document.querySelector( settings.selectors.popupContainer ) ) {
		if ( useFadeAnimation() ) {
		    theme.Helpers.fadeOut( document.querySelector( settings.selectors.popupContainer ) );
		} else {
		    document.querySelector( settings.selectors.popupContainer ).style.display = "none";
		}
	    }
	    
	    if ( settings.overlay && document.querySelector( settings.selectors.popupOverlay ) ) document.querySelector( settings.selectors.popupOverlay ).classList.remove( settings.classes.visible );
	    
	    // If there was an event passed in, prevent it from redirecting
	    if ( event ) event.preventDefault();
	    
	    // If there is a lastFocus element then focus on it
	    if ( lastFocus ) lastFocus.focus();
	};
	
	/*
     * @description initialize the pop up
     */
	publicAPIs.init = ( options ) => {
	    
	    settings = Object.assign( {}, defaults, options );
	    
	    popupFrequency = document.querySelector( settings.selectors.popupContainer ).getAttribute( 'data-popup-frequency' ) ? Number( document.querySelector( settings.selectors.popupContainer ).getAttribute( 'data-popup-frequency' ) ) : settings.defaultFrequency;
	    
	    const popupDelayAttribute = document.querySelector( settings.selectors.popupContainer ).getAttribute( 'data-popup-delay' );
	    
	    let popupDelay = ( Number( popupDelayAttribute ) != 0 ) ? Number( popupDelayAttribute ) * 1000 : settings.defaultPopupDelay;
	    
	    const popupCloseEl = document.querySelector( settings.selectors.popupCloseButton );
	    
	    if ( !popupCloseEl ) {
		if ( settings.debug ) console.log( 'err. no popup close button' );
	    }
	    
	    const popupEnabledAttribute = document.querySelector( settings.selectors.popupContainer ).getAttribute( 'data-popup-enabled' );
	    
	    const popupEnabled = popupEnabledAttribute == 'true' ? true : false;
	    
	    // Register events
	    popupCloseEl.addEventListener( 'click', handleCloseButtonEvent )
	    
	    if ( settings.escape ) {
		document.addEventListener( 'keyup', handleEscapeKeyboardEvent );
	    }
	    
	    if ( settings.overlay ) {
		document.addEventListener( 'click', handleOverlayEvent );
	    }
	    
	    // Bail if working inside the theme editor
	    if ( themeEditorCheck() || !popupEnabled ) return;
	    
	    if ( checkURLQueryString() ) {
		popupDelay = 10;
	    }
	    
	    setTimeout( function () {
		
		// if (themeEditorCheck() == true || checkURLQueryString() ) {
		if ( checkURLQueryString() ) {
		    
		    lastFocus = document.activeElement;
		    
		    publicAPIs.open();
		    
		} else {
		    
		    const popUpShownCookie = Cookies.get( settings.cookieSetName );
		    
		    if ( !popUpShownCookie ) {
			lastFocus = document.activeElement;
			publicAPIs.open();
		    }
		}
	    }, popupDelay );
	};
	
	return publicAPIs;
	
    } )();
    
    function MailingPopup( container ) {
	// Initialize pop up
	Popup.init( {
	    selectors     : {
		popupContainer  : ".js-popup",
		popupOverlay    : ".js-popup-overlay",
		popupCloseButton: ".js-popup-close",
	    },
	    overlay       : true,
	    successMessage: true
	} );
    };
    
    // Interact with the theme editor
    MailingPopup.prototype = _.assignIn( {}, MailingPopup.prototype, {
	onSelect  : function () {
	    Popup.open();
	},
	onDeselect: function () {
	    Popup.close();
	}
    } );
    
    return MailingPopup;
} )();


// REVIEWS
theme.Reviews = function () {
  
    const base_url = "https://community.oppostore.it";
    
    const AddToCartForm       = $( "#AddToCartForm" ),
	  reviewsAverageRatingDiv = $( "#reviews-average-rating" ),
	  reviewsListContainer    = $( "#reviews-list-container" );
    
    if ( AddToCartForm.length > 0 ) {
	const productID = AddToCartForm.closest( '.product-page' ).attr( 'data-product-id' );
	
	const starsSVG = {
	    "empty": '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_24:7)"><rect width="16" height="16" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5163L6.91967 5.78254C6.71006 6.41629 6.11657 6.82949 5.46449 6.82949H2.01858L4.79097 8.80822C5.32912 9.19231 5.56338 9.88313 5.35264 10.5203L4.28418 13.7506L7.10648 11.7363C7.64044 11.3552 8.35956 11.3552 8.89352 11.7363L11.7158 13.7506L10.6474 10.5203C10.4366 9.88313 10.6709 9.19231 11.209 8.80822L13.9814 6.82949H10.5355C9.88343 6.82949 9.28994 6.41629 9.08033 5.78254L8 2.5163ZM8.50577 0.86098C8.34658 0.379673 7.65342 0.379674 7.49423 0.860981L5.97026 5.46851C5.89906 5.68376 5.69488 5.82949 5.46449 5.82949H0.532819C0.017652 5.82949 -0.196544 6.47709 0.220235 6.77455L4.21004 9.62217C4.39643 9.7552 4.47442 9.991 4.40322 10.2062L2.87926 14.8138C2.72006 15.2951 3.28083 15.6953 3.69761 15.3979L7.68742 12.5502C7.8738 12.4172 8.12619 12.4172 8.31258 12.5502L12.3024 15.3979C12.7192 15.6953 13.2799 15.2951 13.1207 14.8138L11.5968 10.2062C11.5256 9.991 11.6036 9.7552 11.79 9.62217L15.7798 6.77455C16.1965 6.47709 15.9823 5.82949 15.4672 5.82949H10.5355C10.3051 5.82949 10.1009 5.68376 10.0297 5.46851L8.50577 0.86098Z" fill="#FFC700"/></g><defs><clipPath id="clip0_24:7"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>',
	    "half" : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
		'<rect width="16" height="16" fill="white"/>\n' +
		'<path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5163L6.91967 5.78254C6.71006 6.41629 6.11657 6.82949 5.46449 6.82949H2.01858L4.79097 8.80822C5.32912 9.19231 5.56338 9.88313 5.35264 10.5203L4.28418 13.7506L7.10648 11.7363C7.64044 11.3552 8.35956 11.3552 8.89352 11.7363L11.7158 13.7506L10.6474 10.5203C10.4366 9.88313 10.6709 9.19231 11.209 8.80822L13.9814 6.82949H10.5355C9.88343 6.82949 9.28994 6.41629 9.08033 5.78254L8 2.5163ZM8.50577 0.86098C8.34658 0.379673 7.65342 0.379674 7.49423 0.860981L5.97026 5.46851C5.89906 5.68376 5.69488 5.82949 5.46449 5.82949H0.532819C0.017652 5.82949 -0.196544 6.47709 0.220235 6.77455L4.21004 9.62217C4.39643 9.7552 4.47442 9.991 4.40322 10.2062L2.87926 14.8138C2.72006 15.2951 3.28083 15.6953 3.69761 15.3979L7.68742 12.5502C7.8738 12.4172 8.12619 12.4172 8.31258 12.5502L12.3024 15.3979C12.7192 15.6953 13.2799 15.2951 13.1207 14.8138L11.5968 10.2062C11.5256 9.991 11.6036 9.7552 11.79 9.62217L15.7798 6.77455C16.1965 6.47709 15.9823 5.82949 15.4672 5.82949H10.5355C10.3051 5.82949 10.1009 5.68376 10.0297 5.46851L8.50577 0.86098Z" fill="#FFC700"/>\n' +
		'<path d="M8 0.5C7.78691 0.5 7.57382 0.620327 7.49423 0.860981L5.97026 5.46851C5.89906 5.68376 5.69488 5.82949 5.46449 5.82949H0.532819C0.017652 5.82949 -0.196544 6.47709 0.220235 6.77455L4.21004 9.62217C4.39643 9.7552 4.47442 9.991 4.40322 10.2062L2.87926 14.8138C2.72006 15.2951 3.28083 15.6953 3.69761 15.3979L7.68742 12.5502C7.78061 12.4837 7.89031 12.4505 8 12.4505V0.5Z" fill="#FFC700"/>\n' +
		'</svg>',
	    "full" : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
		'<rect width="16" height="16" fill="white"/>\n' +
		'<path d="M7.49423 0.860981C7.65342 0.379674 8.34658 0.379673 8.50577 0.86098L10.0297 5.46851C10.1009 5.68376 10.3051 5.82949 10.5355 5.82949H15.4672C15.9823 5.82949 16.1965 6.47709 15.7798 6.77455L11.79 9.62217C11.6036 9.7552 11.5256 9.991 11.5968 10.2062L13.1207 14.8138C13.2799 15.2951 12.7192 15.6953 12.3024 15.3979L8.31258 12.5502C8.12619 12.4172 7.8738 12.4172 7.68742 12.5502L3.69761 15.3979C3.28083 15.6953 2.72006 15.2951 2.87926 14.8138L4.40323 10.2062C4.47442 9.991 4.39643 9.7552 4.21004 9.62217L0.220235 6.77455C-0.196544 6.47709 0.017652 5.82949 0.532819 5.82949H5.46449C5.69488 5.82949 5.89906 5.68376 5.97026 5.46851L7.49423 0.860981Z" fill="#FFC700"/>\n' +
		'</svg>\n'
	};
	
	var settings = {
	    "url"    : base_url + "/api/get-reviews/" + productID,
	    "method" : "GET",
	    "timeout": 0,
	};
	
	console.log( 'ProductID: ' + productID );
	
	$.ajax( settings ).done( function ( response ) {
	    
	    if ( response.response.success ) {
          const resp = response.response;

          const averageRating = ( Math.round( resp.data.summary.avg_rating * 100 ) / 100 ).toFixed( 2 );
          let n               = 1, stars = '<div class="stars" title="Voto medio: ' + averageRating + '/5.00">';
          while ( n <= 5 ) {
              if ( n <= averageRating ) {
              stars += starsSVG.full;
              } else {
              stars += averageRating > ( n - 1 ) ? starsSVG.half : starsSVG.empty;
              }
              n++;
          }
          stars += '</div>';

          const leggiLeRecensioni = '<div><a class="leggi_recensioni" href="#reviews-list">Leggi le recensioni</a></div>';

          reviewsAverageRatingDiv.empty().html( '<div class="reviews_average_container">' + stars + leggiLeRecensioni + '</div>' );

          const reviewsCoinValue = $( '#reviewsCoinValue' );
          const questionMarkIcon = '<a href="https://oppostore.it/pages/oppo-points" target="_blank"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M5.25073 12C5.25073 8.02498 8.47456 4.79999 12.4507 4.79999C16.4269 4.79999 19.6507 8.02498 19.6507 12C19.6507 15.9773 16.4269 19.2 12.4507 19.2C8.47456 19.2 5.25073 15.9773 5.25073 12Z" fill="#2DC84D"/>\n' +
              '<path d="M11.6379 15.2516C11.6379 14.8027 12.0018 14.4387 12.4508 14.4387C12.8997 14.4387 13.2637 14.8027 13.2637 15.2516C13.2637 15.7006 12.8997 16.0645 12.4508 16.0645C12.0018 16.0645 11.6379 15.7006 11.6379 15.2516Z" fill="white"/>\n' +
              '<path d="M12.2089 13.7419H12.6735C12.8659 13.7419 13.0218 13.5859 13.0218 13.3936V13.3825C13.0218 12.1179 15.2701 12.2214 15.2701 10.2642C15.2701 8.79922 13.9602 7.93549 12.4412 7.93549C11.1397 7.93549 10.4086 8.44396 9.79235 9.23442C9.66998 9.39137 9.70583 9.61933 9.86914 9.7331L10.2505 9.99875C10.4012 10.1038 10.6087 10.0744 10.7222 9.92977C11.1561 9.37691 11.5951 9.09678 12.4412 9.09678C13.5932 9.09678 14.1088 9.68308 14.1088 10.2642C14.1088 11.5355 11.8606 11.3403 11.8606 13.3825V13.3936C11.8606 13.5859 12.0165 13.7419 12.2089 13.7419Z" fill="white"/>\n' +
              '</svg></a>';
          reviewsCoinValue.empty().html( '<div class="reviews_community_coins">Vale <strong style="margin-left:5px">' + resp.data.summary.community_coin + ' OPPO Points</strong>' + questionMarkIcon + '</div>' );

          if ( resp.data.reviews.length === 0 ) {
              reviewsListContainer.empty().html( '<p style="text-align: center;color: gray;font-size: 12px;">Non sono ancora presenti recensioni. <a href="' + resp.data.summary.all_reviews_link + '" target="_blank">Scrivine una tu.</a></p>' );
              return;
          }

          const reviewOrderDiv = $('#reviews-order');
          reviewOrderDiv.html('Ordina per: <span id="reviews-order-date" class="reviews_order_link selected">data di inserimento</span><span id="reviews-order-rating" class="reviews_order_link">punteggio</span>');
          
          const displayReviews = (offset = 0) => {
              console.log('Offset: ' + offset);
              const reviewsToShow = 3;
              const firstReviewsToLoad = resp.data.reviews.slice( offset ).slice( 0, reviewsToShow );
              console.log(resp.data.reviews, firstReviewsToLoad);
              const totalNumberOfReviews = resp.data.reviews.length;

              // Convert date to dd/mm/yyyy
              function convertDate( inputFormat ) {
                function pad( s ) {
                    return ( s < 10 ) ? '0' + s : s;
                }
                var d = new Date( inputFormat.replace(/\s/, 'T') );
                return [ pad( d.getDate() ), pad( d.getMonth() + 1 ), d.getFullYear() ].join( '/' );
              }

              // Count words in a string
              function countWords( s ) {
                s = s.replace( /(^\s*)|(\s*$)/gi, "" );//exclude  start and end white-space
                s = s.replace( /[ ]{2,}/gi, " " );//2 or more space to 1
                s = s.replace( /\n /, "\n" ); // exclude newline with a start spacing
                return s.split( ' ' ).filter( function ( str ) {
                    return str !== "";
                } ).length;
              }

              firstReviewsToLoad.forEach( item => {

                let n = 1, stars = '';
                while ( n <= 5 ) {
                    if ( n <= item.rating ) {
                    stars += starsSVG.full;
                    } else {
                    stars += starsSVG.empty;
                    }
                    n++;
                }

                const truncateLimit   = 60;
                const truncateContent = countWords( item.content ) > truncateLimit ? "truncate" : "";
                const readMore        = countWords( item.content ) > truncateLimit ? '<div class="reviews_review-box_review_readmore">Continua a leggere</div>' : "";

                const reviewBox = '<div class="reviews_review-box">\n' +
                    '      <div class="reviews_review-box_stars" title="Voto: ' + item.rating + '/5">' + stars + '</div>\n' +
                    '      <div class="reviews_review-box_review">\n' +
                    '        <div class="reviews_review-box_review_info">\n' +
                    '          <span class="username" title="' + item.user_name + '"><strong>' + item.user_name + '</strong></span>\n' +
                    '          <span class="date" title="' + convertDate( item.created_at ) + '">' + convertDate( item.created_at ) + '</span>\n' +
                    '        </div>\n' +
                    '        <div class="reviews_review-box_review_title" title="' + item.title + '"><a href="' + item.thread_page_link + '" target="_blank">' + item.title + '</a></div>\n' +
                    '        <div class="reviews_review-box_review_description ' + truncateContent + '">' + item.content + '</div>\n' + readMore +
                    '      </div>\n' +
                    '    </div>';

                reviewsListContainer.append(reviewBox);

              } );

              const currentDisplayedReviews = $('.reviews_review-box').length;
              console.log(currentDisplayedReviews, totalNumberOfReviews, currentDisplayedReviews < totalNumberOfReviews);
              const readMore = currentDisplayedReviews < totalNumberOfReviews ?
                    '<div class="reviews_readmore">Mostra di più</div>' : '';

              reviewsListContainer.find('.reviews_readmore').remove();
              if (readMore.length > 0) reviewsListContainer.append(readMore);

              reviewsListContainer.on( "click", ".reviews_review-box_review_readmore", function ( e ) {
                e.preventDefault();
                $( this ).closest( '.reviews_review-box' ).find( '.reviews_review-box_review_description' ).removeClass( 'truncate' );
                $( this ).remove();
              } );
          }
		
		
		  displayReviews();
          
          reviewsListContainer.on("click", ".reviews_readmore", (e) => {
            e.preventDefault();
            displayReviews($('.reviews_review-box').length);
          });
          
          
          // sorting
          const compareByRating = ( a, b ) => {
            if ( a.rating > b.rating ){
              return -1;
            }
            if ( a.rating < b.rating ){
              return 1;
            }
            return 0;
          }
          const compareByDate = ( a, b ) => {
            if ( a.created_at > b.created_at ){
              return -1;
            }
            if ( a.created_at < b.created_at ){
              return 1;
            }
            return 0;
          }
           
          reviewOrderDiv.on("click", '.reviews_order_link:not(.selected)', e => {
            e.preventDefault();
            $('.reviews_order_link').removeClass('selected');
            e.target.classList.add('selected');
            reviewsListContainer.empty();
            resp.data.reviews.sort(e.target.id === "reviews-order-date" ? compareByDate : compareByRating);
            displayReviews();
          });
          
          
          $('#reviews-list-write-review').append('<p id="reviews-insert"><a href="' + base_url + '/threads/inserisci-nuovo?categoria=recensioni" target="_blank">Scrivi una recensione</a></p>');
          
		
	    } else {
		
			reviewsListContainer.empty().html( '<p style="text-align: center;color: gray;font-size: 12px;">Non sono ancora presenti recensioni. <a href="' + base_url + '/threads/inserisci-nuovo?categoria=recensioni" target="_blank">Scrivine una tu.</a></p>' );
		
	    }
	    
	} );
	
    }
    
};

// USER PROFILE COMMUNITY [DEV 2022-03-17]
theme.UserProfileComm = function () {

	const base_url = "https://community.oppostore.it";

	const AccountDetails       = $( "#account-details" ),
		AccountCommCont = $( "#account-community-container" );

	if(AccountDetails.length >0 && AccountCommCont.length >0 ){
		const userID = meta.page.customerId;
		if(userID==='' || !userID){ return;}
		//console.log( 'userID: ' + userID );

		const starsSVG = {
			"empty": '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_24:7)"><rect width="16" height="16" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5163L6.91967 5.78254C6.71006 6.41629 6.11657 6.82949 5.46449 6.82949H2.01858L4.79097 8.80822C5.32912 9.19231 5.56338 9.88313 5.35264 10.5203L4.28418 13.7506L7.10648 11.7363C7.64044 11.3552 8.35956 11.3552 8.89352 11.7363L11.7158 13.7506L10.6474 10.5203C10.4366 9.88313 10.6709 9.19231 11.209 8.80822L13.9814 6.82949H10.5355C9.88343 6.82949 9.28994 6.41629 9.08033 5.78254L8 2.5163ZM8.50577 0.86098C8.34658 0.379673 7.65342 0.379674 7.49423 0.860981L5.97026 5.46851C5.89906 5.68376 5.69488 5.82949 5.46449 5.82949H0.532819C0.017652 5.82949 -0.196544 6.47709 0.220235 6.77455L4.21004 9.62217C4.39643 9.7552 4.47442 9.991 4.40322 10.2062L2.87926 14.8138C2.72006 15.2951 3.28083 15.6953 3.69761 15.3979L7.68742 12.5502C7.8738 12.4172 8.12619 12.4172 8.31258 12.5502L12.3024 15.3979C12.7192 15.6953 13.2799 15.2951 13.1207 14.8138L11.5968 10.2062C11.5256 9.991 11.6036 9.7552 11.79 9.62217L15.7798 6.77455C16.1965 6.47709 15.9823 5.82949 15.4672 5.82949H10.5355C10.3051 5.82949 10.1009 5.68376 10.0297 5.46851L8.50577 0.86098Z" fill="#FFC700"/></g><defs><clipPath id="clip0_24:7"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>',
			"half" : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
				'<rect width="16" height="16" fill="white"/>\n' +
				'<path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5163L6.91967 5.78254C6.71006 6.41629 6.11657 6.82949 5.46449 6.82949H2.01858L4.79097 8.80822C5.32912 9.19231 5.56338 9.88313 5.35264 10.5203L4.28418 13.7506L7.10648 11.7363C7.64044 11.3552 8.35956 11.3552 8.89352 11.7363L11.7158 13.7506L10.6474 10.5203C10.4366 9.88313 10.6709 9.19231 11.209 8.80822L13.9814 6.82949H10.5355C9.88343 6.82949 9.28994 6.41629 9.08033 5.78254L8 2.5163ZM8.50577 0.86098C8.34658 0.379673 7.65342 0.379674 7.49423 0.860981L5.97026 5.46851C5.89906 5.68376 5.69488 5.82949 5.46449 5.82949H0.532819C0.017652 5.82949 -0.196544 6.47709 0.220235 6.77455L4.21004 9.62217C4.39643 9.7552 4.47442 9.991 4.40322 10.2062L2.87926 14.8138C2.72006 15.2951 3.28083 15.6953 3.69761 15.3979L7.68742 12.5502C7.8738 12.4172 8.12619 12.4172 8.31258 12.5502L12.3024 15.3979C12.7192 15.6953 13.2799 15.2951 13.1207 14.8138L11.5968 10.2062C11.5256 9.991 11.6036 9.7552 11.79 9.62217L15.7798 6.77455C16.1965 6.47709 15.9823 5.82949 15.4672 5.82949H10.5355C10.3051 5.82949 10.1009 5.68376 10.0297 5.46851L8.50577 0.86098Z" fill="#FFC700"/>\n' +
				'<path d="M8 0.5C7.78691 0.5 7.57382 0.620327 7.49423 0.860981L5.97026 5.46851C5.89906 5.68376 5.69488 5.82949 5.46449 5.82949H0.532819C0.017652 5.82949 -0.196544 6.47709 0.220235 6.77455L4.21004 9.62217C4.39643 9.7552 4.47442 9.991 4.40322 10.2062L2.87926 14.8138C2.72006 15.2951 3.28083 15.6953 3.69761 15.3979L7.68742 12.5502C7.78061 12.4837 7.89031 12.4505 8 12.4505V0.5Z" fill="#FFC700"/>\n' +
				'</svg>',
			"full" : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
				'<rect width="16" height="16" fill="white"/>\n' +
				'<path d="M7.49423 0.860981C7.65342 0.379674 8.34658 0.379673 8.50577 0.86098L10.0297 5.46851C10.1009 5.68376 10.3051 5.82949 10.5355 5.82949H15.4672C15.9823 5.82949 16.1965 6.47709 15.7798 6.77455L11.79 9.62217C11.6036 9.7552 11.5256 9.991 11.5968 10.2062L13.1207 14.8138C13.2799 15.2951 12.7192 15.6953 12.3024 15.3979L8.31258 12.5502C8.12619 12.4172 7.8738 12.4172 7.68742 12.5502L3.69761 15.3979C3.28083 15.6953 2.72006 15.2951 2.87926 14.8138L4.40323 10.2062C4.47442 9.991 4.39643 9.7552 4.21004 9.62217L0.220235 6.77455C-0.196544 6.47709 0.017652 5.82949 0.532819 5.82949H5.46449C5.69488 5.82949 5.89906 5.68376 5.97026 5.46851L7.49423 0.860981Z" fill="#FFC700"/>\n' +
				'</svg>\n'
		};

		var settings = {
			"url"    : base_url + "/api/get-profile-data/" + userID.toString(),
			"method" : "GET",
			"timeout": 0,
		};
		$.ajax( settings ).done( function ( response )
		{
			if ( response.response.success ) {
				//console.log( 'AJAX SUCCESS');
				const resp = response.response;

				const punti = resp.data.profile_data.score.toString();
				const punti_link = resp.data.profile_data.punti_link;
				const counpons = resp.data.profile_data.coupons.toString();
				const counpons_link = resp.data.profile_data.coupons_link;

				const ranking = resp.data.profile_data.ranking.toString();
				const ranking_tot = resp.data.profile_data.ranking_tot.toString();
				const classifica_link = resp.data.profile_data.ranking_link;
				const badges = resp.data.profile_data.badge.toString();
				const badges_link = resp.data.profile_data.badges_link;
				const followers = resp.data.profile_data.followers.toString();
				const followers_link = resp.data.profile_data.followers_link;

				// Svg
				const svg_arrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 7" class="svg w-4 inlined-svg" role="img" aria-labelledby="title"><title>Vai</title>' +
					'<path fill-rule="evenodd" clip-rule="evenodd" d="M1.25847 0.000976562L0.62207 0.637373L3.23464 3.24994L0.622076 5.86251L1.25847 6.49891L4.50743 3.24995L1.25847 0.000976562Z"></path>' +
					'</svg>';
				const svg_classifica = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg inlined-svg" role="img" aria-labelledby="title"><title>Classifica</title>' +
					'<path d="M16.4092 6.79998V5.39165C16.4092 5.2129 16.263 5.06665 16.0842 5.06665H8.06755C7.8888 5.06665 7.74255 5.2129 7.74255 5.39165V6.79998H4.60088C4.42213 6.79998 4.27588 6.94623 4.27588 7.12498V8.79332C4.27588 10.4752 6.12025 12.4333 8.62817 12.8044C9.42442 14.4483 10.6242 15.25 11.6425 15.4287V18.0666H9.31338C8.92338 18.0666 8.60921 18.3835 8.60921 18.7735C8.60921 18.8629 8.68234 18.9333 8.77171 18.9333H15.38C15.4694 18.9333 15.5425 18.8629 15.5425 18.7735C15.5425 18.3835 15.2284 18.0666 14.8384 18.0666H12.5092V15.4287C13.5303 15.25 14.7273 14.4483 15.5236 12.8044C18.0342 12.4333 19.8759 10.4725 19.8759 8.79332V7.12498C19.8759 6.94623 19.7296 6.79998 19.5509 6.79998H16.4092ZM5.14255 8.79332V7.66665H7.74255V8.31665C7.74255 9.71957 7.93213 10.8869 8.24359 11.8429C6.38567 11.3635 5.14255 9.88748 5.14255 8.79332ZM12.0759 14.6C10.1259 14.6 8.60921 11.7833 8.60921 8.31665V5.93332H15.5425V8.31665C15.5425 11.7833 14.0259 14.6 12.0759 14.6ZM19.0092 8.79332C19.0092 9.88748 17.7634 11.3635 15.9082 11.8429C16.2196 10.8869 16.4092 9.71957 16.4092 8.31665V7.66665H19.0092V8.79332Z"></path>' +
					'</svg>';
				const svg_punti =
					'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg inlined-svg" role="img" aria-labelledby="title"><title>Punti</title>' +
				'    <path d="M14.232 5.96252C12.9221 5.96252 11.7362 6.2051 10.8764 6.59323C10.8521 6.60401 9.48828 7.15924 9.48828 8.11877V8.56889C7.22691 8.66323 5.17578 9.50417 5.17578 10.7063V15.8813C5.17578 17.0726 7.29969 18.0375 9.91953 18.0375C12.5394 18.0375 14.6633 17.0726 14.6633 15.8813V15.4392C17.081 15.3395 18.9758 14.4177 18.9758 13.2938V8.11877C18.9758 7.12151 17.302 5.96252 14.232 5.96252ZM13.8008 15.8813C13.8008 16.2559 12.4396 17.175 9.91953 17.175C7.39941 17.175 6.03828 16.2559 6.03828 15.8813V14.5309C6.89539 15.0862 8.31313 15.45 9.91953 15.45C11.5259 15.45 12.9437 15.0862 13.8008 14.5309V15.8813ZM13.8008 13.2938C13.8008 13.6684 12.4396 14.5875 9.91953 14.5875C7.39941 14.5875 6.03828 13.6684 6.03828 13.2938V11.9434C6.89539 12.4987 8.31313 12.8625 9.91953 12.8625C11.5259 12.8625 12.9437 12.4987 13.8008 11.9434V13.2938ZM9.91953 12C7.73633 12 5.96551 11.4205 5.96551 10.7063C5.96551 9.99202 7.73633 9.41252 9.91953 9.41252C12.1027 9.41252 13.8736 9.99202 13.8736 10.7063C13.8736 11.4205 12.1027 12 9.91953 12ZM18.1133 13.2938C18.1133 13.6469 16.9004 14.4689 14.6633 14.5687V12.841C16.0864 12.7817 17.3343 12.4474 18.1133 11.9434V13.2938ZM18.1133 10.7063C18.1133 11.0594 16.8977 11.876 14.6633 11.9785V10.7063C14.6633 10.5553 14.6175 10.4098 14.5528 10.2669C16.0244 10.2211 17.3128 9.87612 18.1133 9.35592V10.7063ZM14.232 9.41252C14.0353 9.41252 13.8547 9.39905 13.6687 9.38827C12.6741 8.80338 11.3777 8.62819 10.5529 8.57967C10.3831 8.43682 10.2807 8.28319 10.2807 8.11877C10.2807 7.40452 12.0515 6.82502 14.2347 6.82502C16.4179 6.82502 18.1888 7.40452 18.1888 8.11877C18.1888 8.83303 16.4152 9.41252 14.232 9.41252Z"></path>' +
				'</svg>';
				const svg_badges = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg inlined-svg" role="img" aria-labelledby="title"><title>Badge</title>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9063 12.8438C14.3398 12.8438 16.3125 10.871 16.3125 8.4375C16.3125 6.004 14.3398 4.03125 11.9063 4.03125C9.47276 4.03125 7.50002 6.004 7.50002 8.4375C7.50002 10.871 9.47276 12.8438 11.9063 12.8438ZM11.9063 13.8438C14.8921 13.8438 17.3125 11.4233 17.3125 8.4375C17.3125 5.45171 14.8921 3.03125 11.9063 3.03125C8.92048 3.03125 6.50002 5.45171 6.50002 8.4375C6.50002 11.4233 8.92048 13.8438 11.9063 13.8438Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80105 11.6258C9.05951 11.723 9.19023 12.0113 9.09301 12.2698L6.94841 17.9713L8.42402 17.3234C8.55165 17.2674 8.69687 17.2672 8.82466 17.3228C8.95245 17.3785 9.05121 17.485 9.09712 17.6166L9.56971 18.9713L11.6545 13.1745C11.748 12.9147 12.0344 12.7798 12.2942 12.8733C12.5541 12.9667 12.689 13.2531 12.5955 13.513L10.033 20.638C9.96134 20.8372 9.77189 20.9698 9.56012 20.9687C9.34834 20.9677 9.16017 20.8334 9.09042 20.6334L8.33099 18.4564L6.26351 19.3641C6.07933 19.4449 5.86464 19.4076 5.71862 19.2692C5.57261 19.1309 5.52371 18.9185 5.59453 18.7302L8.15703 11.9177C8.25425 11.6593 8.54259 11.5285 8.80105 11.6258Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0126 11.6257C14.7541 11.7229 14.6234 12.0112 14.7206 12.2697L16.8642 17.9711L15.3896 17.3235C15.262 17.2674 15.1168 17.2672 14.9889 17.3228C14.8611 17.3785 14.7624 17.485 14.7165 17.6166L14.2443 18.9708L12.1605 13.1746C12.0671 12.9147 11.7807 12.7798 11.5209 12.8732C11.261 12.9667 11.1261 13.253 11.2195 13.5129L13.7809 20.6379C13.8526 20.8372 14.0421 20.9698 14.2539 20.9687C14.4657 20.9677 14.6538 20.8334 14.7236 20.6334L15.4826 18.4565L17.549 19.364C17.7331 19.4449 17.9478 19.4076 18.0939 19.2693C18.2399 19.1309 18.2888 18.9186 18.218 18.7303L15.6566 11.9178C15.5594 11.6593 15.2711 11.5286 15.0126 11.6257Z"></path>' +
					'</svg>';
				const svg_followers = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="svg inlined-svg" role="img" aria-labelledby="title"><title>Followers</title>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.037 10.4967C13.4278 10.4967 14.5553 9.36923 14.5553 7.97839C14.5553 6.58755 13.4278 5.46006 12.037 5.46006C10.6461 5.46006 9.51863 6.58755 9.51863 7.97839C9.51863 9.36923 10.6461 10.4967 12.037 10.4967ZM12.037 11.3967C13.9249 11.3967 15.4553 9.86629 15.4553 7.97839C15.4553 6.0905 13.9249 4.56006 12.037 4.56006C10.1491 4.56006 8.61863 6.0905 8.61863 7.97839C8.61863 9.86629 10.1491 11.3967 12.037 11.3967Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8673 13.2543H9.28424C8.25462 13.2543 7.37685 14.0008 7.2115 15.0171L6.9306 16.7435C6.72272 18.0211 7.70894 19.1807 9.00334 19.1807H15.1482C16.4426 19.1807 17.4288 18.0211 17.2209 16.7435L16.94 15.0171C16.7747 14.0008 15.8969 13.2543 14.8673 13.2543ZM9.28424 12.3543C7.81335 12.3543 6.5594 13.4208 6.32318 14.8726L6.04228 16.599C5.74532 18.4241 7.1542 20.0807 9.00334 20.0807H15.1482C16.9973 20.0807 18.4062 18.4241 18.1093 16.599L17.8284 14.8726C17.5921 13.4208 16.3382 12.3543 14.8673 12.3543H9.28424Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9682 10.1727C5.70624 10.1727 6.30454 9.57444 6.30454 8.8364C6.30454 8.09836 5.70624 7.50006 4.9682 7.50006C4.23016 7.50006 3.63186 8.09836 3.63186 8.8364C3.63186 9.57444 4.23016 10.1727 4.9682 10.1727ZM4.9682 11.0727C6.2033 11.0727 7.20454 10.0715 7.20454 8.8364C7.20454 7.6013 6.2033 6.60005 4.9682 6.60005C3.7331 6.60005 2.73186 7.6013 2.73186 8.8364C2.73186 10.0715 3.7331 11.0727 4.9682 11.0727Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.1809 12.6436H3.64761C2.84971 12.6436 2.16949 13.2221 2.04135 14.0096C1.88026 14.9997 2.64453 15.8984 3.64761 15.8984H5.08722L4.94078 16.7984H3.64761C2.08978 16.7984 0.902853 15.4027 1.15303 13.8651C1.35204 12.642 2.40844 11.7436 3.64761 11.7436H6.33963C6.67657 11.7436 7.00001 11.81 7.29636 11.9313C6.87364 12.0837 6.49304 12.3285 6.1809 12.6436Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1327 10.1727C19.8707 10.1727 20.469 9.57444 20.469 8.8364C20.469 8.09836 19.8707 7.50006 19.1327 7.50006C18.3946 7.50006 17.7963 8.09836 17.7963 8.8364C17.7963 9.57444 18.3946 10.1727 19.1327 10.1727ZM19.1327 11.0727C20.3678 11.0727 21.369 10.0715 21.369 8.8364C21.369 7.6013 20.3678 6.60005 19.1327 6.60005C17.8976 6.60005 16.8963 7.6013 16.8963 8.8364C16.8963 10.0715 17.8976 11.0727 19.1327 11.0727Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9706 12.6436H20.5039C21.3018 12.6436 21.982 13.2221 22.1102 14.0096C22.2713 14.9997 21.507 15.8984 20.5039 15.8984H19.0643L19.2108 16.7984H20.5039C22.0617 16.7984 23.2487 15.4027 22.9985 13.8651C22.7995 12.642 21.7431 11.7436 20.5039 11.7436H17.8119C17.475 11.7436 17.1515 11.81 16.8552 11.9313C17.2779 12.0836 17.6585 12.3285 17.9706 12.6436Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.037 10.4967C13.4278 10.4967 14.5553 9.36923 14.5553 7.97839C14.5553 6.58755 13.4278 5.46006 12.037 5.46006C10.6461 5.46006 9.51863 6.58755 9.51863 7.97839C9.51863 9.36923 10.6461 10.4967 12.037 10.4967ZM12.037 11.3967C13.9249 11.3967 15.4553 9.86629 15.4553 7.97839C15.4553 6.0905 13.9249 4.56006 12.037 4.56006C10.1491 4.56006 8.61863 6.0905 8.61863 7.97839C8.61863 9.86629 10.1491 11.3967 12.037 11.3967Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8673 13.2543H9.28424C8.25462 13.2543 7.37685 14.0008 7.2115 15.0171L6.9306 16.7435C6.72272 18.0211 7.70894 19.1807 9.00334 19.1807H15.1482C16.4426 19.1807 17.4288 18.0211 17.2209 16.7435L16.94 15.0171C16.7747 14.0008 15.8969 13.2543 14.8673 13.2543ZM9.28424 12.3543C7.81335 12.3543 6.5594 13.4208 6.32318 14.8726L6.04228 16.599C5.74532 18.4241 7.1542 20.0807 9.00334 20.0807H15.1482C16.9973 20.0807 18.4062 18.4241 18.1093 16.599L17.8284 14.8726C17.5921 13.4208 16.3382 12.3543 14.8673 12.3543H9.28424Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9682 10.1727C5.70624 10.1727 6.30454 9.57444 6.30454 8.8364C6.30454 8.09836 5.70624 7.50006 4.9682 7.50006C4.23016 7.50006 3.63186 8.09836 3.63186 8.8364C3.63186 9.57444 4.23016 10.1727 4.9682 10.1727ZM4.9682 11.0727C6.2033 11.0727 7.20454 10.0715 7.20454 8.8364C7.20454 7.6013 6.2033 6.60005 4.9682 6.60005C3.7331 6.60005 2.73186 7.6013 2.73186 8.8364C2.73186 10.0715 3.7331 11.0727 4.9682 11.0727Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.1809 12.6436H3.64761C2.84971 12.6436 2.16949 13.2221 2.04135 14.0096C1.88026 14.9997 2.64453 15.8984 3.64761 15.8984H5.08722L4.94078 16.7984H3.64761C2.08978 16.7984 0.902853 15.4027 1.15303 13.8651C1.35204 12.642 2.40844 11.7436 3.64761 11.7436H6.33963C6.67657 11.7436 7.00001 11.81 7.29636 11.9313C6.87364 12.0837 6.49304 12.3285 6.1809 12.6436Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1327 10.1727C19.8707 10.1727 20.469 9.57444 20.469 8.8364C20.469 8.09836 19.8707 7.50006 19.1327 7.50006C18.3946 7.50006 17.7963 8.09836 17.7963 8.8364C17.7963 9.57444 18.3946 10.1727 19.1327 10.1727ZM19.1327 11.0727C20.3678 11.0727 21.369 10.0715 21.369 8.8364C21.369 7.6013 20.3678 6.60005 19.1327 6.60005C17.8976 6.60005 16.8963 7.6013 16.8963 8.8364C16.8963 10.0715 17.8976 11.0727 19.1327 11.0727Z"></path>' +
					'    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9706 12.6436H20.5039C21.3018 12.6436 21.982 13.2221 22.1102 14.0096C22.2713 14.9997 21.507 15.8984 20.5039 15.8984H19.0643L19.2108 16.7984H20.5039C22.0617 16.7984 23.2487 15.4027 22.9985 13.8651C22.7995 12.642 21.7431 11.7436 20.5039 11.7436H17.8119C17.475 11.7436 17.1515 11.81 16.8552 11.9313C17.2779 12.0836 17.6585 12.3285 17.9706 12.6436Z"></path>' +
					'</svg>';
				const svg_ollie = '<svg width="123" height="105" style="margin-top:-5rem;" viewBox="0 0 123 105" fill="none" xmlns="http://www.w3.org/2000/svg">' +
					'<path d="M47.2784 76.6662C47.2784 76.6662 58.8212 80.0459 50.2837 80.1233C50.2837 80.1233 22.7459 81.9695 20.4075 81.7786C18.0793 81.9076 20.0381 85.7554 17.3219 85.9059C16.1937 86.3123 12.7823 86.9259 11.8383 86.5976C10.8943 86.2692 7.02232 83.9727 7.15703 81.0521C7.29174 78.1316 8.95815 75.5555 10.4731 73.2822C12.4056 72.776 18.5138 68.793 24.5656 69.6151C30.6173 70.4372 43.6197 74.7508 47.2784 76.6662Z" fill="white"/>' +
					'<path d="M8.72763 76.5855C8.72763 76.5855 22.1171 66.329 49.122 78.9513L48.3481 77.3759C48.348 77.3761 18.4605 62.5416 8.72763 76.5855Z" fill="#C9C9C9"/>' +
					'<path d="M19.1816 81.8335C19.0695 82.138 18.9494 82.4397 18.816 82.7363C18.7868 82.8009 18.6044 83.1927 18.7271 82.9353C18.6599 83.0766 18.5831 83.2151 18.507 83.3519C18.2559 83.8024 17.9703 84.2353 17.6443 84.6356C17.6174 84.6689 17.5896 84.7014 17.5625 84.7345C17.4159 84.9134 17.7347 84.5477 17.5789 84.714C17.5096 84.7879 17.4418 84.8629 17.3708 84.9351C17.2228 85.0858 17.0682 85.2292 16.9069 85.3645C16.8237 85.4344 16.7385 85.5021 16.6518 85.5672C16.6236 85.5885 16.5949 85.609 16.5667 85.6302C16.413 85.7458 16.5199 85.5953 16.6154 85.5977C16.5704 85.5966 16.4409 85.711 16.4028 85.7342C16.3193 85.7852 16.2346 85.8343 16.1487 85.8808C16.0051 85.9588 15.8585 86.0302 15.7092 86.0949C15.6355 86.127 15.554 86.1501 15.4827 86.1873C15.7882 86.028 15.5501 86.1621 15.4428 86.1962C15.1736 86.2822 14.8988 86.3469 14.6219 86.3899C14.557 86.3999 14.492 86.4074 14.4269 86.4165C14.2146 86.4465 14.691 86.3986 14.477 86.4112C14.3604 86.4181 14.2441 86.4263 14.1277 86.4281C13.9329 86.4314 13.7384 86.4239 13.5455 86.4054C13.4771 86.3988 13.4091 86.3897 13.3409 86.3813C13.0888 86.35 13.6266 86.4402 13.3976 86.3908C13.3448 86.3792 13.2916 86.3692 13.2392 86.3555C13.0284 86.3003 12.8213 86.2274 12.6171 86.1538C12.4888 86.1075 12.3617 86.0584 12.2356 86.0068C12.1851 85.986 12.1347 85.965 12.0846 85.9435C12.0431 85.9257 11.7187 85.7765 11.9483 85.8864C11.4199 85.6334 10.9157 85.3301 10.4483 84.9781C10.3297 84.8887 10.2131 84.7963 10.0996 84.7004C10.0584 84.6655 10.0175 84.6306 9.97709 84.5949C10.1651 84.7609 9.96387 84.5783 9.93512 84.5509C9.72294 84.3475 9.52273 84.1314 9.33685 83.9027C9.24458 83.7891 9.15588 83.6724 9.07133 83.5525C9.03292 83.4981 8.99609 83.4428 8.95853 83.3879C8.8087 83.1687 9.05344 83.5663 8.92579 83.3327C8.7844 83.0739 8.64609 82.8174 8.53456 82.5422C8.48399 82.417 8.43875 82.2899 8.39564 82.1614C8.47046 82.3839 8.38718 82.125 8.37836 82.091C8.36437 82.0379 8.35094 81.9843 8.33859 81.9307C8.28098 81.6812 8.25041 81.4291 8.22784 81.1722C8.21453 81.0205 8.22237 81.2319 8.22974 81.2354C8.21673 81.2292 8.2275 81.0567 8.22761 81.0381C8.22823 80.9273 8.23228 80.8163 8.23933 80.7055C8.25502 80.4564 8.28579 80.2073 8.32931 79.9601C8.34082 79.8944 8.34701 79.8179 8.36849 79.7545C8.28785 79.9914 8.34929 79.8421 8.36711 79.7738C8.40003 79.6471 8.43056 79.5202 8.4669 79.3941C8.5407 79.1375 8.62616 78.8838 8.72167 78.6337C8.81024 78.4018 8.90763 78.1728 9.0122 77.9472C9.0432 77.8806 9.07109 77.806 9.10932 77.7431C8.96053 77.9876 9.0951 77.7737 9.12268 77.7211C9.19301 77.5862 9.26594 77.4527 9.34131 77.3205C9.60607 76.8563 9.90106 76.4089 10.2223 75.9816C10.306 75.8704 10.3913 75.7605 10.4784 75.6521C10.5179 75.6031 10.5576 75.5542 10.5977 75.5058C10.634 75.4619 10.7896 75.2557 10.6111 75.4865C10.7755 75.2738 10.9769 75.0804 11.1664 74.8907C11.5329 74.524 11.9241 74.1817 12.3409 73.8776C12.335 73.8818 12.4448 73.7963 12.4505 73.7989C12.418 73.7836 12.2585 73.9274 12.4513 73.8008C12.5491 73.7366 12.6486 73.6751 12.7487 73.6151C13.0344 73.444 13.3261 73.2836 13.6221 73.1332C13.9228 72.9802 14.228 72.8375 14.5368 72.7042C14.6786 72.6431 14.8212 72.5839 14.9644 72.5265C15.0507 72.492 15.1374 72.4588 15.224 72.425C15.4234 72.3472 15.1088 72.4631 15.3303 72.3858C15.981 72.1587 16.6369 71.9581 17.3029 71.7956C17.9546 71.6365 18.6119 71.509 19.2719 71.4121C19.4396 71.3873 19.6074 71.3646 19.7753 71.3439C19.8363 71.3364 19.8971 71.329 19.9579 71.322C19.975 71.3201 20.2761 71.288 20.0679 71.3088C20.3983 71.2756 20.7292 71.2517 21.06 71.2349C22.4141 71.1656 23.773 71.2147 25.1175 71.2966C26.484 71.38 27.8441 71.521 29.1933 71.7171C29.5029 71.7621 29.8121 71.8101 30.1208 71.8607C29.9214 71.8279 30.2262 71.8789 30.2385 71.8811C30.3156 71.8943 30.3924 71.9079 30.4695 71.9214C30.6541 71.9542 30.8386 71.9876 31.0226 72.0225C31.6824 72.1467 32.3391 72.284 32.9925 72.4335C35.6411 73.0396 38.2332 73.8511 40.7515 74.836C42.0009 75.3247 43.2294 75.8599 44.4435 76.4264C44.7237 76.5572 44.2663 76.3406 44.5449 76.4744C44.6153 76.5081 44.6855 76.5419 44.7558 76.5757C44.9103 76.6503 45.0645 76.7257 45.2183 76.8014C45.5261 76.9532 45.8327 77.1076 46.138 77.2643C46.7491 77.5781 47.3549 77.9019 47.9552 78.235C48.5289 78.5533 51.4376 79.5076 52.0014 79.8422C52.4399 80.1025 53.0887 80.0136 53.3878 79.5199C53.6672 79.0587 53.6176 78.3984 53.1473 78.1191C48.2623 75.2193 40.6576 72.2749 35.1183 70.8396C32.3231 70.1152 29.4549 69.6114 26.5574 69.3584C23.7473 69.1133 20.8853 69.0436 18.0602 69.577C16.6367 69.8458 15.2333 70.2643 13.8806 70.8306C12.6924 71.3281 11.5333 71.9578 10.5346 72.8071C8.76285 74.3147 7.31359 76.4459 6.63403 78.6732C6.29692 79.7786 6.13749 80.9514 6.31665 82.0746C6.5252 83.3817 7.17566 84.6002 8.03386 85.5505C8.95087 86.566 10.0912 87.3117 11.3368 87.8585C11.8003 88.062 12.2832 88.2571 12.7873 88.35C13.822 88.5409 14.9186 88.4811 15.944 88.1224C17.8032 87.4722 19.2628 86.0511 20.2084 84.2939C20.535 83.6867 20.8181 83.0593 21.0555 82.4143C21.2418 81.9082 20.9609 81.2812 20.455 81.1495C19.9304 81.0137 19.3812 81.2909 19.1816 81.8335Z" fill="#181818"/>' +
					'<path d="M120.831 86.375C124.231 79.675 119.415 74.1667 116.581 72.25C108.781 65.45 108.498 76 109.331 82.125C111.748 86.3333 117.431 93.075 120.831 86.375Z" fill="white"/>' +
					'<path d="M113.582 70.5C117.582 71.6667 124.532 76.75 120.332 87.75" stroke="black" stroke-width="2.2" stroke-linecap="round"/>' +
					'<g clip-path="url(#clip0_310_257)">' +
					'<path d="M43.0392 5.45416C43.212 6.83751 46.351 11.3622 47.899 13.4517C43.5791 15.397 36.3434 25.1237 35.3715 26.7448C34.5939 28.0417 33.6795 33.8417 33.3196 36.5796L28.8917 35.6069C27.8118 35.6069 25.1335 36.7741 23.06 41.4429C20.4681 47.2789 24.4639 59.7074 25.6519 63.2739C26.8398 66.8403 31.1597 70.0826 33.3196 71.1633C35.0475 72.0279 36.7034 72.1 37.3154 72.0279C39.3025 78.1665 51.0308 83.736 56.6466 85.7533C84.2935 92.6701 98.7649 83.1596 102.545 81.2142C106.325 79.2689 111.616 72.5683 112.264 71.1633C112.783 70.0393 113.488 66.1559 113.776 64.3546V60.3559L116.692 58.3025L119.392 51.4938L120.256 45.8739L119.392 40.4702L116.692 35.6069L113.776 32.7969C113.128 33.1572 111.789 33.4022 111.616 31.5001C111.4 29.1224 108.808 27.1771 106.757 21.9895C104.705 16.802 95.417 10.3175 87.2094 7.83179C80.6432 5.84323 69.2821 7.00322 64.4223 7.83179L62.6944 6.75105L60.1025 4.91379C57.0426 4.76969 50.7501 4.28696 50.0589 3.50882C49.1949 2.53615 44.7671 1.77963 44.1191 1.77963C43.4711 1.77963 42.8232 3.72497 43.0392 5.45416Z" fill="white"/>' +
					'<path d="M97.6914 65.4959C96.3544 70.4478 95.8144 73.0849 91.9827 75.4776C88.151 77.8725 79.6475 78.1427 75.2391 78.3221C70.5175 78.5123 66.5282 75.3328 64.1328 71.2238C67.0919 66.6307 75.2672 62.8092 81.4337 61.9294C86.5419 61.201 92.9957 62.0807 97.3674 65.1219" fill="#E39693"/>' +
					'<path d="M98.0926 60.6022C97.9587 62.6016 97.8248 63.4986 97.6909 65.4958C93.2242 62.152 85.9799 61.6246 79.9731 62.1845C73.9664 62.7443 67.9964 66.9462 64.5427 71.896C62.9444 70.1193 62.0416 67.7351 62.0588 65.3445C63.6874 65.1478 65.0827 63.7169 65.2382 62.0829C72.4178 59.9257 79.8738 58.685 87.3644 58.3997C89.5502 58.3176 91.7598 58.3176 93.8981 58.778C95.3755 59.0957 96.8053 59.6339 98.1272 60.3688" fill="#CD5960"/>' +
					'<path d="M25.2671 37.3858C25.2671 37.3858 32.1766 36.3374 34.9111 45.0439C36.9349 51.4851 40.2288 70.4349 30.993 70.8196C30.993 70.8196 40.3498 76.8221 40.7645 58.3608C41.1792 39.8996 30.9909 32.5786 25.2671 37.3858Z" fill="#559A6B"/>' +
					'<path d="M25.9089 64.6205C27.3193 67.4218 30.8918 66.0341 30.5138 57.5827C29.8809 43.425 23.3839 44.8321 23.3839 44.8321C23.3839 44.8321 21.2305 55.3283 25.9089 64.6205Z" fill="#559A6B"/>' +
					'<g style="mix-blend-mode:multiply">' +
					'<path d="M24.1836 39.4651C24.1836 39.4651 25.2678 67.4066 39.3202 68.1523C39.3202 68.1523 34.8384 77.4143 27.391 66.6825C19.9436 55.9508 23.0993 41.5445 24.1836 39.4651Z" fill="#C9C9C9"/>' +
					'</g>' +
					'<path d="M113.202 38.0925C113.202 38.0925 116.858 42.984 113.202 56.5343V38.0925Z" fill="#559A6B"/>' +
					'<path d="M40.3491 64.6205C40.3491 64.6205 60.9741 102.436 107.514 77.5397C107.514 77.5397 87.0917 95.7653 53.2999 84.3376C53.2999 84.3376 42.5997 80.9981 37.3101 71.4746C37.3101 71.4746 40.0099 67.8995 40.3491 64.6205Z" fill="#C9C9C9"/>' +
					'<path d="M50.7727 12.667C44.5435 17.874 41.0768 21.9441 39.3424 27.1035C37.608 32.263 37.2171 37.8677 38.2193 43.2174C37.6253 41.7433 36.4568 40.5934 35.4006 39.4089C34.3444 38.2244 33.3314 36.867 33.1802 35.2848C33.07 34.1457 33.4221 33.0152 33.7914 31.9323C35.0852 28.1303 36.6641 24.3822 39.0357 21.1422C41.4073 17.9021 44.6299 15.1808 48.4551 13.966" fill="#C9C9C9"/>' +
					'<path d="M55.134 10.5401C55.7172 10.0948 54.972 9.31023 52.6955 9.34481C50.6004 9.37723 48.3973 8.70069 46.7601 7.33463C45.9609 6.66673 45.2503 5.81078 44.8874 4.82515C44.7276 4.39069 44.4533 2.6615 43.8118 2.6615C43.4446 2.6615 43.1357 2.97924 43.0277 3.33156C42.9241 3.66875 42.9651 4.03188 43.0212 4.38204C43.2027 5.54492 43.4554 6.69267 43.8183 7.81016C44.3345 9.39885 44.9716 11.2772 46.4361 12.2542C47.6845 13.0885 49.3368 13.108 50.771 12.6649C51.6328 12.4012 53.7538 11.5971 55.134 10.5401Z" fill="#C9C9C9"/>' +
					'<path d="M34.416 35.8965C34.4397 35.6349 34.4656 35.3756 34.4959 35.1162C34.5024 35.0643 34.5088 35.0124 34.5153 34.9606C34.5175 34.9519 34.5499 34.6969 34.5283 34.859C34.5067 35.0232 34.5412 34.766 34.5434 34.7574C34.5542 34.6796 34.565 34.6018 34.578 34.5239C34.6557 34.0073 34.7507 33.4951 34.8587 32.985C35.0747 31.9777 35.349 30.9834 35.6773 30.0086C35.8393 29.5266 36.0143 29.0489 36.2044 28.5777C36.2519 28.4566 36.3016 28.3356 36.3512 28.2146C36.4204 28.0438 36.3556 28.2038 36.3426 28.234C36.3728 28.1627 36.4031 28.0892 36.4355 28.0179C36.5392 27.7779 36.6471 27.5402 36.7573 27.3046C37.1936 26.3708 37.6817 25.4608 38.2174 24.5789C38.7531 23.6971 39.3341 22.8411 39.9605 22.0197C39.9626 22.0176 40.1203 21.8122 40.0253 21.9333C39.9302 22.0543 40.09 21.8511 40.0922 21.849C40.1721 21.7452 40.2542 21.6436 40.3363 21.5421C40.5004 21.3389 40.6667 21.1379 40.8374 20.939C41.1765 20.5413 41.5264 20.1522 41.8871 19.774C42.5891 19.0347 43.3278 18.3344 44.1032 17.673C44.3019 17.5044 44.5027 17.338 44.7058 17.1737C44.7965 17.1002 44.8894 17.0267 44.9822 16.9554C45.0254 16.923 45.168 16.8106 44.9974 16.9424C45.06 16.8949 45.1205 16.8473 45.1831 16.7998C45.5978 16.4842 46.0233 16.1816 46.4553 15.8898C47.4078 15.25 48.3971 14.6685 49.423 14.1541C49.6801 14.0244 49.9371 13.9012 50.1984 13.7802C50.341 13.7153 50.4835 13.6505 50.6261 13.5878C50.6736 13.5662 50.7211 13.5467 50.7687 13.5251C50.855 13.4884 50.9782 13.4365 50.8205 13.5013C51.3756 13.2701 51.9372 13.0561 52.5052 12.8637C52.9955 12.6973 53.3692 12.1742 53.1964 11.6446C53.0387 11.1583 52.5031 10.7735 51.9782 10.9529C47.8463 12.3622 44.0902 14.755 41.0037 17.8394C37.9172 20.9282 35.5175 24.6805 34.0121 28.7809C33.1719 31.072 32.6513 33.467 32.4353 35.8965C32.39 36.4152 32.9235 36.9102 33.4267 36.8886C34.0013 36.8605 34.3684 36.4498 34.416 35.8965Z" fill="#181818"/>' +
					'<path d="M61.3468 9.2778C67.7984 7.7064 74.546 7.20926 81.1402 8.08033C87.4709 8.91467 93.8966 11.0545 99.0761 14.8652C103.772 18.3193 107.197 23.2475 109.521 28.608C110.856 31.6859 111.787 35.0038 112.105 38.3909C112.429 41.8579 112.256 45.34 112.137 48.8114C112.077 50.5665 112.031 52.326 112.064 54.0832C112.098 55.8297 112.262 57.5611 112.405 59.3011C112.522 60.7255 112.604 62.1542 112.597 63.5851C112.593 64.2552 112.571 64.9253 112.519 65.591C112.465 66.2956 112.414 66.7517 112.31 67.3569C112.204 67.9794 112.066 68.5976 111.893 69.2072C111.809 69.5011 111.718 69.7929 111.617 70.0826C111.567 70.2274 111.513 70.3722 111.459 70.5149C111.435 70.5797 111.409 70.6424 111.385 70.7051C111.381 70.7137 111.267 70.9925 111.329 70.8477C110.841 72.002 110.118 73.2167 109.409 74.1332C107.549 76.5324 105.035 78.4454 102.491 80.0643C97.2402 83.4081 91.2637 85.3945 85.1274 86.3521C79.2978 87.2621 73.2781 87.154 67.3923 86.4666C66.1266 86.3196 65.0596 86.1705 63.7248 85.9479C62.4224 85.7317 61.1264 85.4788 59.8391 85.1892C57.2472 84.6034 54.6899 83.8534 52.2168 82.8764C49.9597 81.9837 47.5341 80.7452 45.4282 79.2797C44.3914 78.5577 43.5167 77.8531 42.5534 76.9345C42.1084 76.5087 41.6786 76.0656 41.2682 75.6073C41.063 75.376 40.8621 75.1426 40.6656 74.9027C40.415 74.5957 40.3459 74.5071 40.1235 74.2067C39.3761 73.1908 38.7238 72.1079 38.1666 70.9753C37.9311 70.4954 37.2486 70.3636 36.8102 70.6186C36.3199 70.9061 36.2183 71.494 36.4538 71.976C38.8491 76.8437 43.0242 80.5269 47.7803 83.0169C52.6401 85.5588 58.0162 87.0135 63.4051 87.8954C69.2002 88.8443 75.1162 89.2722 80.9782 88.814C87.4514 88.3082 93.8642 86.7887 99.7025 83.9053C102.616 82.4679 105.348 80.6782 107.826 78.5772C110.118 76.634 112.018 74.3083 113.178 71.52C114.213 69.0342 114.558 66.3194 114.578 63.6435C114.599 60.3991 114.096 57.185 114.04 53.9427C113.979 50.3676 114.252 46.799 114.271 43.2261C114.291 39.5624 113.992 35.8749 112.979 32.3387C112.087 29.2348 110.735 26.2001 109.122 23.4053C107.603 20.7747 105.761 18.3106 103.605 16.1686C98.9314 11.5236 92.7799 8.62071 86.4298 7.07092C79.665 5.42171 72.5999 5.32012 65.7379 6.38789C64.0855 6.64511 62.4461 6.97581 60.8219 7.37137C59.5821 7.66749 60.1048 9.58041 61.3468 9.2778Z" fill="#181818"/>' +
					'<path d="M29.7642 34.5347C27.9909 34.6493 26.3429 35.4274 25.0599 36.6508C24.0879 37.5781 23.36 38.7496 22.8395 39.9795C21.7466 42.5539 21.3513 45.3897 21.3319 48.1737C21.3124 50.8604 21.645 53.5666 22.198 56.195C22.7941 59.0287 23.6948 61.8105 24.9648 64.4173C26.1614 66.8749 27.7468 69.2309 29.8311 71.0206C31.1422 72.1468 32.734 72.9984 34.5073 72.9335C36.1186 72.8752 37.6198 72.1295 38.6932 70.9342C40.7581 68.63 41.3175 65.5067 41.5897 62.5303C41.9396 58.6893 41.715 54.8224 41.0735 51.0247C40.5205 47.7393 39.7883 44.4689 38.4578 41.4039C37.1964 38.4946 35.1531 35.7019 31.9651 34.792C31.2567 34.5888 30.5007 34.4958 29.7642 34.5347C29.2479 34.5607 28.749 34.9714 28.7728 35.5269C28.7965 36.0413 29.2091 36.5471 29.7642 36.519C29.9175 36.5103 30.073 36.5082 30.2285 36.5125C30.2825 36.5147 30.7491 36.5082 30.7642 36.5514C30.7642 36.5536 30.572 36.5211 30.6908 36.5428C30.7275 36.5492 30.7664 36.5536 30.8052 36.5622C30.8808 36.5752 30.9564 36.5903 31.032 36.6054C31.207 36.6422 31.3819 36.6876 31.5526 36.7395C31.7016 36.7848 31.8463 36.8346 31.991 36.8908C32.0385 36.9102 32.0882 36.9297 32.1357 36.9491C32.1271 36.9448 31.9759 36.8756 32.0774 36.9253C32.1595 36.9664 32.2437 37.001 32.3258 37.0421C32.6347 37.1955 32.9327 37.3706 33.2179 37.563C33.2848 37.6084 33.3496 37.6538 33.4166 37.7013C33.477 37.7445 33.6088 37.8483 33.4749 37.7424C33.6239 37.8613 33.773 37.9845 33.9133 38.112C34.1833 38.3541 34.4382 38.6113 34.6758 38.8837C34.7881 39.0112 34.8961 39.1409 35.0019 39.2749C35.1186 39.4219 34.9458 39.1927 35.0559 39.3462C35.1229 39.4392 35.1899 39.5321 35.2568 39.6272C35.4706 39.9363 35.665 40.2584 35.8486 40.5869C36.0365 40.9176 36.2115 41.257 36.3778 41.5985C36.4556 41.7584 36.5312 41.9205 36.6046 42.0827C36.6413 42.1648 36.678 42.2469 36.7148 42.3269C36.7385 42.3809 36.7623 42.4371 36.786 42.4912C36.8184 42.5668 36.8292 42.5949 36.7904 42.502C37.0884 43.2347 37.3584 43.9739 37.5982 44.7283C38.0733 46.2284 38.4427 47.7587 38.7516 49.302C38.9027 50.052 39.0388 50.8021 39.1641 51.5564C39.2375 51.9974 39.3066 52.4362 39.3693 52.8793C39.3758 52.9311 39.3844 52.983 39.3909 53.0349C39.3714 52.8901 39.3952 53.0652 39.3974 53.0846C39.4103 53.1884 39.4233 53.2943 39.4362 53.398C39.4643 53.625 39.4902 53.8519 39.5162 54.0767C39.7127 55.8902 39.8013 57.7167 39.7689 59.541C39.7537 60.4531 39.7084 61.3631 39.6306 62.2731C39.5918 62.727 39.5464 63.1809 39.4924 63.6348C39.4794 63.7386 39.4665 63.8445 39.4535 63.9482C39.447 64.0001 39.4406 64.052 39.4341 64.1039C39.4406 64.0585 39.4557 63.9461 39.4276 64.1536C39.4038 64.3222 39.3801 64.4886 39.352 64.655C39.2505 65.2581 39.1079 65.8547 38.9265 66.4383C38.8315 66.743 38.7256 67.0456 38.6068 67.3418C38.5939 67.3764 38.5032 67.5839 38.5572 67.4628C38.6112 67.3418 38.5183 67.5493 38.5032 67.5817C38.4319 67.7395 38.3563 67.8951 38.2785 68.0486C38.1338 68.3317 37.974 68.6084 37.799 68.8743C37.7191 68.9953 37.637 69.1142 37.5506 69.2309C37.542 69.2417 37.4837 69.3066 37.4858 69.3174C37.4837 69.3044 37.6327 69.1358 37.5074 69.2871C37.4534 69.352 37.4016 69.4146 37.3454 69.4795C37.1424 69.7108 36.9221 69.9226 36.691 70.1214C36.6694 70.1387 36.637 70.1776 36.6089 70.1884C36.6089 70.1884 36.7644 70.0761 36.6716 70.1409C36.6132 70.1798 36.5592 70.223 36.5009 70.2619C36.367 70.3549 36.2288 70.4392 36.0862 70.517C36.0257 70.5494 35.9631 70.5818 35.9005 70.6121C35.8681 70.6272 35.6629 70.7159 35.7946 70.664C35.9242 70.6121 35.665 70.7094 35.624 70.7245C35.5052 70.7656 35.3864 70.8023 35.2655 70.8347C35.1769 70.8585 35.0883 70.878 34.9976 70.8974C34.9544 70.9061 34.9091 70.9147 34.8637 70.9234C34.8486 70.9255 34.7017 70.9471 34.8184 70.932C34.935 70.9169 34.7881 70.9342 34.773 70.9363C34.7298 70.9406 34.6844 70.9428 34.6412 70.9471C34.5246 70.9558 34.408 70.9579 34.2935 70.9558C34.2071 70.9558 34.1207 70.9515 34.0343 70.945C33.9911 70.9428 33.9479 70.9385 33.9047 70.9342C33.8874 70.932 33.7449 70.9147 33.8658 70.932C33.9868 70.9471 33.8442 70.9277 33.827 70.9255C33.7838 70.9169 33.7427 70.9104 33.6995 70.9017C33.5872 70.8801 33.4749 70.852 33.3647 70.8239C33.1984 70.7785 33.0321 70.7245 32.8723 70.6618C32.8312 70.6467 32.7902 70.6294 32.7513 70.6143C32.7664 70.6208 32.8874 70.6791 32.788 70.6272C32.6844 70.5732 32.5764 70.5278 32.4705 70.4716C32.3129 70.3873 32.1573 70.2987 32.0083 70.2014C31.9327 70.1539 31.8571 70.102 31.7815 70.0523C31.7448 70.0263 31.7059 70.0004 31.6692 69.9745C31.6519 69.9615 31.4618 69.8167 31.5504 69.8858C31.613 69.9334 31.4532 69.8059 31.4251 69.7821C31.3711 69.7367 31.3171 69.6913 31.2631 69.6459C31.1379 69.5378 31.0126 69.4298 30.8916 69.3174C30.4424 68.9045 30.0169 68.4657 29.6173 68.0053C29.4099 67.7654 29.2112 67.5212 29.0147 67.2726C29.1378 67.4282 29.019 67.2769 28.9672 67.2099C28.9218 67.1516 28.8786 67.091 28.8354 67.0327C28.7404 66.903 28.6475 66.7711 28.5546 66.6393C28.1809 66.1032 27.8332 65.5499 27.5071 64.9836C27.1744 64.4065 26.8656 63.8142 26.5804 63.2112C26.4357 62.9064 26.2953 62.5995 26.1614 62.2904C26.1312 62.2191 26.0988 62.1477 26.0685 62.0742C26.1485 62.258 26.0621 62.0569 26.0318 61.9856C25.967 61.8278 25.9044 61.67 25.8418 61.5122C25.3428 60.2391 24.9238 58.9358 24.5739 57.6151C24.2305 56.3139 23.9562 54.9975 23.7466 53.6682C23.7229 53.5191 23.7013 53.3699 23.6775 53.2186C23.6646 53.1322 23.6516 53.0457 23.6408 52.9571C23.6365 52.9225 23.6365 52.8793 23.6257 52.8447C23.6473 52.9052 23.6473 53.0154 23.6322 52.8858C23.5911 52.568 23.5523 52.2481 23.5199 51.9304C23.4551 51.3122 23.4032 50.6918 23.3708 50.0715C23.306 48.8805 23.3039 47.6852 23.3859 46.4942C23.4075 46.1765 23.4356 45.8588 23.4702 45.5432C23.4853 45.394 23.5047 45.2471 23.522 45.1001C23.5458 44.9034 23.4983 45.2622 23.5263 45.0655C23.5415 44.9661 23.5544 44.8666 23.5695 44.7672C23.6667 44.1317 23.792 43.5006 23.9518 42.8759C24.1117 42.2469 24.3061 41.6244 24.5458 41.0214C24.5588 40.9868 24.5739 40.9522 24.5868 40.9176C24.6624 40.7274 24.5696 40.9435 24.5717 40.95C24.5609 40.9198 24.6452 40.7793 24.6603 40.7469C24.7251 40.602 24.792 40.4594 24.8633 40.3167C25.0016 40.0379 25.1527 39.7634 25.3169 39.4975C25.3968 39.3657 25.4811 39.236 25.5675 39.1106C25.6063 39.0522 25.6474 38.9939 25.6884 38.9377C25.7143 38.9031 25.8612 38.7064 25.7791 38.8123C25.6906 38.9247 25.8569 38.7172 25.8763 38.6934C25.9217 38.6394 25.967 38.5875 26.0124 38.5335C26.1117 38.4211 26.2154 38.3087 26.3213 38.2028C26.4271 38.0969 26.5351 37.9931 26.6474 37.8915C26.6992 37.8461 26.7511 37.8007 26.8051 37.7554C26.831 37.7337 26.8591 37.7121 26.885 37.6884C26.9023 37.6732 26.9217 37.6603 26.939 37.6451C26.9822 37.6127 26.9757 37.617 26.9217 37.6581C26.9066 37.6689 26.8915 37.6819 26.8764 37.6927C26.9044 37.6711 26.9325 37.6516 26.9606 37.63C27.0016 37.5997 27.0448 37.5695 27.0859 37.5392C27.1831 37.4722 27.2803 37.4052 27.3796 37.3425C27.5589 37.2301 27.7403 37.1242 27.9282 37.0291C28.0125 36.9859 28.0989 36.9491 28.1831 36.9059C28.2825 36.854 28.1788 36.9059 28.1593 36.9124C28.2155 36.8886 28.2738 36.867 28.33 36.8454C28.4984 36.7827 28.6691 36.7265 28.8419 36.6768C29.0255 36.6271 29.2091 36.5838 29.397 36.5514C29.4402 36.5449 29.4812 36.5384 29.5244 36.5298C29.5114 36.532 29.3581 36.5449 29.4747 36.5384C29.5741 36.532 29.6734 36.519 29.7728 36.5125C30.289 36.4801 30.788 36.0802 30.7642 35.5204C30.7318 35.0168 30.3171 34.498 29.7642 34.5347Z" fill="#181818"/>' +
					'<path d="M53.0332 65.4335C55.7335 65.1896 57.7695 63.2947 57.5806 61.2011C57.3918 59.1075 55.0496 57.6081 52.3493 57.852C49.649 58.0959 47.6131 59.9909 47.8019 62.0844C47.9908 64.178 50.3329 65.6775 53.0332 65.4335Z" fill="#DDA09A"/>' +
					'<path d="M106.586 58.3011C109.199 58.0651 111.163 56.1766 110.975 54.083C110.786 51.9894 108.515 50.4835 105.903 50.7195C103.29 50.9555 101.325 52.844 101.514 54.9376C101.703 57.0312 103.974 58.5371 106.586 58.3011Z" fill="#DBA590"/>' +
					'<path d="M63.4455 59.7398C63.4951 59.7182 63.5427 59.6966 63.5923 59.675C63.7975 59.5842 63.4217 59.7441 63.5448 59.6944C63.6571 59.649 63.7695 59.6015 63.8839 59.5583C64.1194 59.4675 64.3548 59.381 64.5945 59.2989C65.1108 59.1195 65.6313 58.9595 66.1562 58.8104C67.4219 58.4516 68.707 58.1576 69.9965 57.8982C71.4695 57.6021 72.9512 57.3514 74.4373 57.1331C74.6165 57.1071 74.798 57.0812 74.9772 57.0553C75.0744 57.0423 75.1716 57.0272 75.2667 57.0142C75.3379 57.0034 75.7181 56.9493 75.4416 56.9904C75.8326 56.9321 76.2278 56.8888 76.6188 56.8391C77.4287 56.7397 78.2387 56.6511 79.0487 56.5689C82.2518 56.249 85.4744 56.0545 88.6948 56.0523C90.1182 56.0502 91.5416 56.0891 92.9628 56.1907C93.5914 56.2361 94.2199 56.2944 94.8463 56.3744C94.883 56.3787 95.153 56.4155 94.9586 56.3874C94.7793 56.3614 94.9953 56.3917 95.0407 56.3982C95.1962 56.4198 95.3539 56.4436 95.5094 56.4695C95.5806 56.4803 95.6519 56.4933 95.7232 56.5084C95.7729 56.5192 95.8204 56.5408 95.8679 56.5495C96.0018 56.5732 95.721 56.4673 95.8398 56.5322C95.9262 56.5819 96.0105 56.6294 96.0947 56.6813C96.2092 56.7527 95.9802 56.5624 96.0666 56.6662C96.1055 56.7116 96.153 56.7548 96.1962 56.798C96.2459 56.8456 96.2632 56.9299 96.1789 56.7721C96.2027 56.8153 96.2351 56.8564 96.2589 56.8975C96.2848 56.9407 96.3042 56.9861 96.3301 57.0315C96.3129 57.0012 96.2632 56.8348 96.315 57.0055C96.3885 57.2411 96.4662 57.4746 96.5353 57.7124C96.6757 58.2008 96.7967 58.6958 96.8982 59.1951C96.9479 59.4372 96.9911 59.6793 97.0299 59.9236C97.0472 60.0295 97.0623 60.1375 97.0775 60.2434C97.1055 60.4423 97.0839 60.2953 97.0796 60.2543C97.0904 60.345 97.1034 60.438 97.112 60.5309C97.1682 61.0216 97.2027 61.5144 97.22 62.0072C97.2546 63.0102 97.2092 64.0152 97.0883 65.0095C97.0839 65.0376 97.058 65.23 97.0753 65.1068C97.0926 64.9858 97.0645 65.176 97.0602 65.2041C97.0429 65.3251 97.0235 65.4483 97.0019 65.5694C96.9587 65.8287 96.909 66.0859 96.855 66.3432C96.7535 66.8252 96.6325 67.305 96.4921 67.7784C96.3474 68.2669 96.1833 68.7489 95.9997 69.2223C95.9543 69.3368 95.9068 69.4514 95.8614 69.5659C95.8031 69.7129 95.9176 69.4384 95.8528 69.5854C95.8334 69.6286 95.8161 69.6697 95.7966 69.7129C95.6865 69.9637 95.5698 70.2122 95.4489 70.4586C95.2567 70.8434 95.0428 71.2152 94.8096 71.574C94.6951 71.7512 94.5741 71.9241 94.451 72.0927C94.4208 72.1338 94.3884 72.177 94.3581 72.2181C94.3776 72.19 94.4834 72.0603 94.3689 72.203C94.3041 72.2851 94.2393 72.3651 94.1724 72.445C93.6281 73.0978 93.0103 73.6793 92.3451 74.2088C92.5157 74.0726 92.2933 74.2456 92.2393 74.2866C92.168 74.3407 92.0945 74.3925 92.0211 74.4444C91.844 74.5698 91.6626 74.6908 91.4768 74.8097C91.1183 75.0388 90.7489 75.2506 90.3731 75.4473C89.9929 75.6462 89.6063 75.8234 89.2154 75.9964C89.3947 75.9164 89.2046 76.0007 89.129 76.0309C89.0318 76.0699 88.9346 76.1088 88.8374 76.1455C88.63 76.2255 88.4227 76.3011 88.2132 76.3746C87.4097 76.6535 86.5868 76.8804 85.7552 77.062C85.334 77.1549 84.9107 77.2349 84.4852 77.3062C84.2929 77.3386 84.1007 77.3667 83.9063 77.3948C83.6342 77.4338 84.051 77.3776 83.8134 77.4078C83.7141 77.4208 83.6147 77.4338 83.5175 77.4467C82.7875 77.5375 82.0553 77.6088 81.3209 77.6607C79.8003 77.7666 78.2733 77.7839 76.7527 77.6758C76.3812 77.6499 76.0097 77.6153 75.6403 77.5721C75.5475 77.5613 75.4567 77.5505 75.3639 77.5397C75.3185 77.5332 75.2688 77.531 75.2256 77.5224C75.2494 77.5267 75.4611 77.5548 75.2818 77.5289C75.0982 77.5029 74.9168 77.4748 74.7332 77.4446C73.9902 77.3214 73.2536 77.1592 72.5279 76.9539C72.1823 76.8545 71.8389 76.7464 71.4998 76.6254C71.3313 76.5648 71.165 76.5022 70.9987 76.4373C70.9231 76.407 70.8173 76.3833 70.7503 76.3379C70.7676 76.3487 70.9641 76.4308 70.8021 76.3595C70.7525 76.3379 70.7006 76.3141 70.6509 76.2925C69.9965 76.0007 69.3658 75.6613 68.7675 75.2658C68.6206 75.1685 68.4759 75.0691 68.3334 74.9675C68.2707 74.9221 68.2102 74.8767 68.1476 74.8313C68.1174 74.8097 68.0072 74.7146 68.1174 74.8075C68.2362 74.9091 68.0893 74.7838 68.0634 74.7622C67.7804 74.533 67.5061 74.2909 67.2469 74.0359C66.9834 73.7765 66.7329 73.5063 66.4953 73.221C66.4434 73.1605 66.3959 73.0978 66.3441 73.0373C66.1886 72.8471 66.4369 73.167 66.2901 72.9681C66.1734 72.8103 66.059 72.6504 65.951 72.4883C65.7415 72.1727 65.5449 71.8485 65.3678 71.5134C65.2749 71.3405 65.1885 71.1676 65.1043 70.9904C65.0611 70.9017 65.02 70.811 64.9812 70.7202C64.9531 70.6597 64.9272 70.5991 64.9012 70.5386C64.8883 70.5084 64.8753 70.4781 64.8624 70.4478C64.8904 70.517 64.8926 70.5192 64.8645 70.4565C64.4498 69.4644 64.1064 68.442 63.8213 67.4066C63.5319 66.3518 63.3008 65.2797 63.1172 64.2011C63.0761 63.9547 63.0351 63.7083 62.9984 63.4619C62.9789 63.3301 62.9595 63.1982 62.94 63.0663C62.9357 63.0426 62.9076 62.8394 62.9228 62.9518C62.9357 63.0534 62.9012 62.7789 62.9012 62.7875C62.8342 62.2601 62.7759 61.7305 62.7241 61.201C62.7133 61.0821 62.6981 60.9632 62.696 60.8443C62.696 60.7925 62.6981 60.7406 62.6981 60.6887C62.6981 60.4639 62.7003 60.7298 62.6873 60.7211C62.6679 60.7082 62.75 60.4466 62.7586 60.4229C62.7737 60.3753 62.791 60.3277 62.8105 60.2802C62.7975 60.3191 62.7154 60.4574 62.8061 60.3105C62.858 60.224 62.9076 60.1375 62.966 60.0532C62.8472 60.2305 63.0048 60.023 63.061 59.9689C63.0891 59.943 63.1193 59.9192 63.1452 59.8933C63.2424 59.7982 63.007 59.9733 63.128 59.9084C63.2424 59.8565 63.3375 59.7895 63.4455 59.7398C63.9163 59.5172 64.074 58.8061 63.8019 58.3824C63.4908 57.8982 62.9487 57.7902 62.4454 58.0258C61.4173 58.5099 60.7909 59.5734 60.7283 60.6887C60.6981 61.2161 60.8082 61.7695 60.8687 62.2925C60.94 62.8934 61.0199 63.4922 61.1106 64.0887C61.4497 66.2978 61.9724 68.4874 62.7932 70.5689C63.4606 72.2635 64.3094 73.8241 65.573 75.1534C66.6378 76.273 67.9359 77.1852 69.3291 77.8509C72.245 79.2429 75.5107 79.7184 78.7182 79.7314C80.2582 79.7379 81.7961 79.6363 83.3253 79.4547C85.1159 79.2408 86.887 78.9165 88.5998 78.3394C92.0729 77.1657 95.2847 75.0172 97.0386 71.7145C99.0667 67.8951 99.6434 63.3625 98.9004 59.1238C98.8097 58.6072 98.6974 58.0949 98.5635 57.5891C98.4253 57.0661 98.2849 56.5192 98.0473 56.0329C97.814 55.5574 97.4058 55.1315 96.9436 54.8722C96.5569 54.656 96.1573 54.5739 95.7297 54.509C94.3473 54.3037 92.9542 54.187 91.5567 54.1264C88.3579 53.9859 85.1483 54.1005 81.9581 54.3339C78.5692 54.5825 75.1868 54.9781 71.8346 55.5465C69.1887 55.9961 66.5169 56.5235 63.979 57.4162C63.4606 57.5978 62.9487 57.8031 62.4454 58.0279C61.9702 58.2398 61.8212 58.9682 62.089 59.3853C62.4065 59.8738 62.9379 59.9668 63.4455 59.7398Z" fill="#181818"/>' +
					'<path d="M65.599 71.3189C65.7307 71.1201 65.8668 70.9255 66.0093 70.7353C66.0245 70.7159 66.0374 70.6964 66.0525 70.677C66.1173 70.5905 66.1109 70.6013 66.0288 70.7072C66.0331 70.7072 66.1065 70.6099 66.1195 70.5948C66.2102 70.4803 66.3031 70.37 66.3981 70.2576C66.7329 69.8642 67.0915 69.4881 67.4651 69.1293C67.8474 68.7619 68.2492 68.4117 68.6617 68.0788C68.7157 68.0356 69.0159 67.8022 68.8237 67.9491C68.9166 67.8778 69.0095 67.8087 69.1023 67.7395C69.3205 67.5774 69.543 67.4196 69.7676 67.2661C70.6812 66.6415 71.6402 66.0816 72.6295 65.5845C73.1262 65.3337 73.6295 65.0982 74.1414 64.8777C74.1889 64.8561 74.2386 64.8366 74.2861 64.815C74.0593 64.9123 74.3056 64.8064 74.3423 64.7934C74.4632 64.7437 74.5863 64.694 74.7073 64.6442C74.9514 64.547 75.1954 64.454 75.4417 64.3654C76.446 63.998 77.472 63.6845 78.5109 63.4338C79.0034 63.3149 79.5001 63.209 80.0012 63.1204C80.2302 63.0793 80.4613 63.0426 80.6903 63.008C80.7313 63.0015 80.7875 62.9864 80.8263 62.9885C80.5779 62.9691 80.7464 62.9993 80.8328 62.9885C80.9559 62.9734 81.0769 62.9583 81.2 62.9453C82.4743 62.8091 83.7638 62.7551 85.0446 62.7832C85.6969 62.7962 86.3492 62.8329 86.9994 62.8934C87.3082 62.9215 87.6149 62.9583 87.9216 62.995C87.9562 62.9993 88.116 63.021 87.9324 62.995C88.0232 63.008 88.116 63.021 88.2067 63.0339C88.3752 63.0599 88.5415 63.0858 88.71 63.1139C90.1312 63.3538 91.5309 63.7126 92.8916 64.186C93.248 64.3114 93.6022 64.4432 93.9521 64.5816C94.0104 64.6053 94.0688 64.6291 94.1292 64.6529C94.1875 64.6767 94.2459 64.7004 94.3063 64.7242C94.4035 64.7653 94.423 64.7739 94.3647 64.748C94.2394 64.694 94.5288 64.8193 94.5094 64.8107C94.5979 64.8496 94.6843 64.8885 94.7729 64.9274C95.4857 65.2473 96.1811 65.5996 96.8658 65.9757C97.3194 66.2264 97.9674 66.1011 98.2223 65.6191C98.4685 65.1543 98.3519 64.5297 97.8659 64.2617C95.4403 62.9215 92.8225 61.91 90.1032 61.3588C87.4443 60.8184 84.7142 60.6757 82.01 60.8854C77.5562 61.2313 73.1198 62.7508 69.3572 65.1608C67.234 66.5204 65.2922 68.2064 63.8861 70.316C63.5989 70.7483 63.7868 71.4335 64.2425 71.6734C64.7415 71.9393 65.2922 71.7815 65.599 71.3189Z" fill="#181818"/>' +
					'<path d="M64.6198 6.86557C63.907 5.94045 63.0258 5.20123 61.9674 4.6976C60.9696 4.22207 59.9112 3.9173 58.8226 3.74006C57.6433 3.54769 56.4597 3.48284 55.2674 3.43313C54.6626 3.40935 54.0557 3.38342 53.4531 3.34019C53.1593 3.31857 52.8677 3.2948 52.5761 3.26237C52.5157 3.25589 52.453 3.2494 52.3926 3.24076C52.3688 3.2386 52.0664 3.19753 52.291 3.22995C52.1398 3.20834 51.9886 3.18456 51.8375 3.15862C51.2392 3.05703 50.6473 2.91437 50.075 2.71336C49.9324 2.66364 49.7899 2.6096 49.6516 2.55124C49.8266 2.62473 49.481 2.46911 49.4313 2.44533C49.1527 2.30916 48.8827 2.15353 48.617 1.99358C47.5587 1.35378 46.5111 0.646975 45.2497 0.512963C43.9862 0.378951 42.7572 1.11602 42.2302 2.26377C41.6988 3.42232 41.7593 4.68895 42.2388 5.85616C42.8198 7.26977 43.7443 8.54072 44.5521 9.83113C45.4052 11.1929 46.2584 12.5546 47.1094 13.9163C47.3837 14.3551 48.0058 14.5691 48.4658 14.273C48.9065 13.9898 49.116 13.3868 48.8222 12.9156C47.4269 10.6892 45.9841 8.48452 44.6406 6.22577C44.4959 5.98152 44.3555 5.73295 44.2281 5.4779C44.1935 5.40657 44.1611 5.33524 44.1266 5.26391C44.1136 5.23797 44.0553 5.08883 44.1158 5.24229C44.0575 5.09747 44.0056 4.95049 43.9603 4.80135C43.9192 4.66734 43.8847 4.53116 43.8566 4.39283C43.8458 4.33663 43.8199 4.12697 43.8436 4.35176C43.8393 4.30205 43.8328 4.25449 43.8307 4.20478C43.8242 4.09454 43.822 3.98215 43.8263 3.87191C43.8285 3.80923 43.835 3.74871 43.8393 3.68602C43.8523 3.47852 43.7896 3.87407 43.8458 3.65576C43.8695 3.56066 43.8868 3.46339 43.9149 3.36829C43.9279 3.32073 43.9473 3.27534 43.9603 3.22779C44.0251 3.00299 43.889 3.35748 43.9559 3.22779C44.0056 3.13052 44.0531 3.03542 44.1093 2.94247C44.1201 2.92518 44.1654 2.83872 44.1892 2.82359C44.105 2.9295 44.0985 2.94031 44.1676 2.85817C44.1827 2.84088 44.2 2.82359 44.2151 2.8063C44.2497 2.76955 44.3166 2.72632 44.3426 2.68309C44.403 2.5815 44.159 2.79117 44.3382 2.68526C44.4203 2.63554 44.5046 2.59015 44.5888 2.5426C44.4354 2.62906 44.5283 2.56421 44.5823 2.54908C44.6471 2.53179 44.7097 2.51018 44.7745 2.49505C44.8696 2.47343 44.9452 2.39994 44.7832 2.4864C44.835 2.4583 44.9603 2.47775 45.0165 2.47775C45.1093 2.47991 45.3556 2.52963 45.1439 2.48208C45.2756 2.51234 45.4052 2.53828 45.5348 2.57718C45.6407 2.6096 45.7443 2.64851 45.848 2.68958C45.6601 2.61609 45.8372 2.68742 45.8847 2.70903C45.9495 2.73929 46.0143 2.77172 46.0791 2.80414C46.5845 3.05703 47.0597 3.36612 47.5414 3.66009C48.5457 4.26962 49.6214 4.71921 50.7705 4.96778C53.0189 5.45412 55.3192 5.31795 57.5936 5.55787C57.6606 5.56435 57.7275 5.573 57.7945 5.57949C57.8226 5.58381 58.0882 5.61407 57.9457 5.59678C57.7859 5.57732 58.0494 5.61191 58.0558 5.61191C58.1358 5.62271 58.2157 5.63568 58.2977 5.64865C58.5656 5.69188 58.8312 5.7416 59.0948 5.80212C59.6434 5.92316 60.1769 6.08743 60.7017 6.28629C60.8745 6.3533 60.7147 6.29061 60.6845 6.27548C60.7557 6.30574 60.8292 6.33817 60.9004 6.37059C61.0192 6.42463 61.1359 6.48299 61.2504 6.54351C61.5009 6.67536 61.745 6.82234 61.9782 6.98661C62.0214 7.01687 62.0625 7.04713 62.1035 7.07739C62.313 7.2287 61.9502 6.94554 62.1467 7.11198C62.2461 7.19412 62.3433 7.27841 62.4383 7.36703C62.5333 7.45565 62.6241 7.54644 62.7126 7.64154C62.758 7.6891 62.8012 7.73881 62.8422 7.78636C62.8746 7.82311 63.056 8.05006 62.9113 7.86201C63.2267 8.27053 63.7774 8.53424 64.2677 8.21866C64.6695 7.96144 64.9589 7.30435 64.6198 6.86557Z" fill="#181818"/>' +
					'<path d="M97.5761 58.7845C97.4465 58.8082 97.3191 58.832 97.1895 58.8558C97.1398 58.8644 97.088 58.8731 97.0383 58.8817C97.0059 58.8861 96.792 58.925 96.9476 58.8969C97.1031 58.8709 96.8741 58.9055 96.8612 58.9055C96.8136 58.9098 96.7683 58.9142 96.7208 58.9163C96.6085 58.9228 96.4961 58.9271 96.3838 58.9206C96.3557 58.9185 96.2802 58.899 96.2564 58.9098C96.3773 58.8515 96.4443 58.9552 96.3082 58.9077C96.2866 58.9012 96.1786 58.8601 96.1657 58.8644C96.2046 58.8515 96.3557 58.9725 96.2434 58.8904C96.1786 58.8428 96.0944 58.8428 96.1981 58.8666C96.4033 58.912 96.0987 58.8774 96.1657 58.8169C96.1786 58.8039 96.278 59.0071 96.2046 58.8579C96.1851 58.819 96.0814 58.6072 96.1743 58.8298C95.9907 58.3846 95.7013 58.1468 95.2196 58.1014C90.7681 57.6886 86.2862 57.5135 81.8195 57.788C78.0267 58.0215 74.2512 58.5813 70.5578 59.4761C68.5555 59.9625 66.577 60.5439 64.6223 61.188C64.2227 61.3199 63.8728 61.6981 63.8944 62.1434C63.9074 62.3898 63.9463 62.7097 63.8728 62.9496C63.9052 62.8459 63.8988 62.7962 63.8685 62.9324C63.8556 62.9886 63.8469 63.0426 63.8318 63.0988C63.8059 63.2025 63.7713 63.302 63.7389 63.4036C63.6849 63.5722 63.8188 63.2631 63.7584 63.3603C63.7346 63.3992 63.7173 63.449 63.6936 63.49C63.6504 63.5722 63.5985 63.6478 63.5489 63.7256C63.4603 63.8661 63.6741 63.5916 63.5921 63.6716C63.5618 63.7018 63.5359 63.7386 63.5078 63.7688C63.4517 63.8294 63.389 63.8856 63.3285 63.9418C63.1514 64.1039 63.5035 63.838 63.2983 63.9634C63.2313 64.0044 63.1665 64.0477 63.0974 64.0844C63.037 64.1169 62.9398 64.1406 62.8922 64.186C62.903 64.1752 63.1277 64.0952 63.0046 64.1385C62.97 64.1493 62.9354 64.1644 62.9009 64.1752C62.767 64.2206 62.6309 64.2573 62.4927 64.2876C62.4279 64.3006 62.3631 64.3092 62.2983 64.3222C62.2075 64.3416 62.5207 64.2249 62.4322 64.3049C62.4171 64.32 62.3458 64.3135 62.3263 64.3157C61.8123 64.3654 61.309 64.7372 61.3349 65.3078C61.3565 65.8028 61.7734 66.3518 62.3263 66.3C63.2205 66.2157 64.0435 65.9411 64.7325 65.3467C65.6396 64.5621 65.9334 63.2998 65.8772 62.1456C65.6353 62.4633 65.3913 62.7832 65.1493 63.1009C68.6052 61.9597 72.1323 61.0346 75.7264 60.4445C76.1865 60.3688 76.6487 60.2975 77.1109 60.2327C77.2146 60.2175 77.3183 60.2024 77.422 60.1894C77.1714 60.2175 77.4824 60.1808 77.5494 60.1743C77.7978 60.1419 78.0462 60.1116 78.2967 60.0835C79.2492 59.9733 80.2039 59.8847 81.1586 59.8155C83.217 59.6685 85.284 59.6188 87.3489 59.6469C89.9775 59.6815 92.604 59.8436 95.2218 60.0857C94.9043 59.8436 94.5846 59.5993 94.2671 59.3573C94.576 60.1073 95.1008 60.706 95.9367 60.8508C96.6668 60.9762 97.3882 60.8292 98.1074 60.6974C98.6193 60.6023 98.9541 59.956 98.7986 59.4783C98.6172 58.9293 98.1226 58.685 97.5761 58.7845Z" fill="#181818"/>' +
					'<path d="M111.767 32.9417C111.894 32.9893 112.019 33.039 112.147 33.0909C112.309 33.1557 111.95 33.0022 112.149 33.093C112.218 33.1254 112.289 33.1557 112.358 33.1881C112.607 33.3027 112.849 33.4259 113.086 33.5599C113.32 33.6896 113.549 33.8301 113.773 33.9771C113.873 34.0419 113.97 34.1089 114.067 34.1781C114.119 34.2148 114.171 34.2516 114.222 34.2905C114.283 34.3359 114.497 34.5239 114.261 34.3164C114.65 34.6558 115.045 34.9757 115.404 35.3496C115.583 35.5377 115.758 35.7322 115.924 35.9311C115.998 36.0175 116.071 36.158 116.162 36.225C116.171 36.2315 116.028 36.0478 116.089 36.1321C116.11 36.1602 116.132 36.1904 116.153 36.2185C116.197 36.2769 116.24 36.3353 116.281 36.3936C116.583 36.8129 116.858 37.2496 117.108 37.7035C117.236 37.9369 117.357 38.1725 117.471 38.4124C117.527 38.5292 117.581 38.6459 117.633 38.7648C117.659 38.8231 117.685 38.8836 117.711 38.942C117.771 39.0825 117.627 38.7345 117.717 38.9615C118.128 39.9687 118.428 41.0214 118.635 42.0891C118.689 42.3636 118.737 42.6425 118.778 42.9191C118.789 42.9861 118.797 43.0532 118.808 43.1223C118.827 43.252 118.78 42.9018 118.795 43.0315C118.799 43.0596 118.801 43.0899 118.806 43.118C118.823 43.2628 118.84 43.4098 118.855 43.5546C118.914 44.1231 118.951 44.6959 118.963 45.2665C118.992 46.4143 118.929 47.5642 118.789 48.7054C118.782 48.753 118.754 48.9821 118.776 48.8113C118.797 48.6427 118.767 48.8719 118.76 48.9173C118.739 49.0664 118.715 49.2155 118.691 49.3625C118.644 49.65 118.592 49.9353 118.536 50.2185C118.424 50.7761 118.292 51.3273 118.141 51.8742C117.987 52.4253 117.814 52.97 117.62 53.5083C117.525 53.7741 117.423 54.0378 117.318 54.2994C117.292 54.362 117.266 54.4247 117.24 54.4874C117.199 54.589 117.287 54.375 117.283 54.3837C117.266 54.4182 117.253 54.455 117.238 54.4896C117.182 54.6214 117.121 54.7533 117.063 54.8851C116.616 55.8664 116.091 56.8132 115.48 57.7015C115.331 57.9177 115.173 58.1295 115.015 58.3392C114.953 58.4235 115.097 58.2376 115.089 58.2462C115.065 58.2657 115.041 58.3067 115.022 58.3305C114.983 58.3802 114.944 58.4278 114.905 58.4775C114.821 58.5813 114.734 58.6828 114.648 58.7844C114.324 59.1627 113.978 59.5237 113.613 59.8609C113.432 60.0295 113.244 60.1937 113.052 60.3494C112.65 60.6801 112.685 61.4128 113.052 61.7522C113.479 62.1455 114.024 62.1045 114.454 61.7522C116.149 60.358 117.475 58.5121 118.454 56.5581C119.527 54.4161 120.255 52.1011 120.629 49.7365C121.02 47.2637 121.061 44.7737 120.678 42.2966C120.333 40.0508 119.586 37.8137 118.346 35.8986C117.104 33.9814 115.369 32.3819 113.283 31.433C112.959 31.286 112.631 31.1499 112.298 31.0245C111.812 30.8429 111.19 31.2255 111.08 31.7162C110.946 32.2846 111.244 32.7472 111.767 32.9417Z" fill="#181818"/>' +
					'<path d="M82.857 48.0419C82.857 48.0419 71.5693 47.8106 71.092 50.2639C70.6146 52.7171 77.5004 52.4621 80.6474 51.859C83.7879 51.256 90.7083 48.3834 82.857 48.0419Z" fill="#C9C9C9"/>' +
					'<path d="M93.931 48.3402C93.9828 48.1154 94.0519 47.9014 94.1405 47.6896C94.0843 47.8214 94.0304 47.9533 93.9742 48.0851C94.0714 47.8646 94.188 47.6528 94.3241 47.4539C94.3932 47.3524 94.5444 47.1967 94.2226 47.5728C94.255 47.5339 94.2852 47.4929 94.3198 47.4539C94.4019 47.3567 94.4883 47.2637 94.5811 47.1751C94.6632 47.0951 94.7518 47.0238 94.8382 46.946C94.9678 46.8293 94.4753 47.2054 94.715 47.0411C94.7561 47.013 94.7993 46.9827 94.8403 46.9546C95.052 46.8141 95.2766 46.6953 95.5121 46.5958C95.3803 46.652 95.2485 46.7061 95.1168 46.7623C95.4235 46.6369 95.7388 46.5526 96.0672 46.5051C95.9203 46.5245 95.7734 46.544 95.6287 46.5634C95.9332 46.5267 96.2356 46.5288 96.5402 46.5677C96.3933 46.5483 96.2464 46.5288 96.1017 46.5094C96.43 46.5569 96.7454 46.6456 97.0521 46.7709C96.9203 46.7147 96.7886 46.6607 96.6568 46.6045C96.8793 46.6996 97.0931 46.812 97.294 46.9438C97.348 46.9784 97.3998 47.0152 97.4517 47.0519C97.6374 47.1794 97.3113 46.9352 97.2983 46.933C97.3804 46.9482 97.5208 47.1276 97.5834 47.1859C97.6655 47.2659 97.7432 47.3502 97.8188 47.4367C97.9009 47.5318 98.0046 47.7133 97.7281 47.3091C97.7562 47.3502 97.7886 47.3913 97.8167 47.4323C97.9614 47.642 98.0823 47.8646 98.1839 48.0959C98.1277 47.9641 98.0737 47.8322 98.0175 47.7004C98.0845 47.8646 98.1428 48.0332 98.1882 48.2061C98.4106 49.0426 99.3761 49.6327 100.221 49.3604C101.078 49.0815 101.612 48.2234 101.374 47.3264C100.884 45.4762 99.3848 44.015 97.5726 43.4509C95.7151 42.8738 93.6977 43.4746 92.3024 44.7802C91.5508 45.4848 90.9784 46.4489 90.7494 47.4561C90.5572 48.2969 91.0065 49.2847 91.9028 49.4901C92.7387 49.6868 93.7236 49.2415 93.931 48.3402Z" fill="#181818"/>' +
					'<path d="M59.5791 52.3303C59.5511 52.0233 59.5575 51.7207 59.5943 51.416C59.5748 51.5629 59.5554 51.7099 59.536 51.8547C59.59 51.4743 59.6915 51.109 59.8362 50.7524C59.78 50.8842 59.726 51.0161 59.6699 51.1479C59.78 50.8886 59.9118 50.64 60.0651 50.4044C60.0997 50.3504 60.1364 50.2985 60.1731 50.2466C60.333 50.024 60.1299 50.3266 60.0759 50.3676C60.1796 50.292 60.2638 50.145 60.3546 50.0521C60.4431 49.9613 60.536 49.8727 60.631 49.7884C60.6785 49.7473 60.7304 49.7084 60.7779 49.6652C60.4302 49.9937 60.5705 49.8229 60.6893 49.7408C60.9205 49.5809 61.1645 49.4468 61.4216 49.3345C61.2898 49.3907 61.158 49.4447 61.0263 49.5009C61.3524 49.3647 61.6894 49.2718 62.0393 49.2221C61.8924 49.2415 61.7455 49.261 61.6008 49.2804C61.968 49.235 62.333 49.2393 62.7002 49.2847C62.5533 49.2653 62.4065 49.2458 62.2618 49.2264C62.6527 49.2826 63.0307 49.3863 63.3957 49.5376C63.264 49.4814 63.1322 49.4274 63.0004 49.3712C63.251 49.4771 63.4907 49.6025 63.7197 49.7473C63.7823 49.7862 63.8428 49.8294 63.9033 49.8705C63.9595 49.9116 64.1517 50.0564 63.9141 49.8748C63.6765 49.6933 63.8644 49.8402 63.9184 49.8856C63.9746 49.9332 64.0286 49.9829 64.0826 50.0348C64.1711 50.1191 64.2554 50.2077 64.3374 50.3006C64.385 50.3547 64.4281 50.4195 64.4778 50.4692C64.4217 50.3957 64.3655 50.3244 64.3094 50.2509C64.3374 50.2898 64.3677 50.3309 64.3936 50.3698C64.5469 50.5946 64.6722 50.8324 64.7781 51.0809C64.9271 51.4333 65.4152 51.7445 65.7651 51.8396C66.1604 51.9477 66.6874 51.9001 67.0373 51.6732C67.3894 51.4462 67.7004 51.1069 67.7955 50.6854C67.9013 50.2228 67.8127 49.8446 67.6291 49.4123C67.208 48.4201 66.4369 47.6312 65.5707 47.013C64.6917 46.3884 63.6506 46.0793 62.5901 45.9625C60.3848 45.7183 58.2551 47.013 57.1298 48.8611C56.5121 49.8748 56.1665 51.1371 56.2745 52.3259C56.3155 52.7734 56.4322 53.1668 56.7583 53.4953C57.0456 53.7828 57.5143 53.9968 57.9268 53.9795C58.7562 53.9449 59.6634 53.2511 59.5791 52.3303Z" fill="#181818"/>' +
					'<g clip-path="url(#clip1_310_257)">' +
					'<path d="M42.8453 5.62274C43.0181 7.00609 46.1572 11.5308 47.7051 13.6202C43.3853 15.5656 36.1496 25.2923 35.1776 26.9134C34.4001 28.2103 33.4857 34.0102 33.1257 36.7481L28.6979 35.7755C27.6179 35.7755 24.9397 36.9427 22.8661 41.6115C20.2742 47.4475 24.2701 59.876 25.458 63.4425C26.646 67.0089 30.9658 70.2512 33.1257 71.3319C34.8536 72.1965 36.5096 72.2685 37.1216 72.1965C39.1087 78.3351 50.837 83.9045 56.4528 85.9219C84.0996 92.8387 98.5711 83.3281 102.351 81.3828C106.131 79.4375 111.423 72.7369 112.071 71.3319C112.589 70.2079 113.294 66.3245 113.582 64.5232V60.5245L116.498 58.4711L119.198 51.6624L120.062 46.0425L119.198 40.6388L116.498 35.7755L113.582 32.9655C112.934 33.3258 111.595 33.5707 111.423 31.6686C111.207 29.291 108.615 27.3457 106.563 22.1581C104.511 16.9705 95.2232 10.4861 87.0155 8.00037C80.4494 6.0118 69.0883 7.1718 64.2285 8.00037L62.5005 6.91963L59.9086 5.08237C56.8488 4.93827 50.5562 4.45553 49.865 3.6774C49.0011 2.70473 44.5732 1.94821 43.9253 1.94821C43.2773 1.94821 42.6293 3.89355 42.8453 5.62274Z" fill="white"/>' +
					'<path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M58.8768 48.2016C58.8939 47.6016 59.3943 47.129 59.9943 47.1462C63.48 47.2457 67.1286 48.676 68.5383 49.3814C69.0751 49.65 69.2926 50.3029 69.024 50.8398C68.7554 51.3766 68.1024 51.5941 67.5656 51.3255C66.3049 50.6948 62.9795 49.4062 59.9323 49.3192C59.3322 49.302 58.8596 48.8017 58.8768 48.2016Z" fill="black"/>' +
					'<path d="M25.0732 37.5543C25.0732 37.5543 31.9828 36.506 34.7173 45.2125C36.7411 51.6537 40.035 70.6035 30.7992 70.9882C30.7992 70.9882 40.1559 76.9906 40.5706 58.5294C40.9853 40.0681 30.797 32.7472 25.0732 37.5543Z" fill="#559A6B"/>' +
					'<path d="M25.715 64.7891C27.1254 67.5903 30.6979 66.2027 30.3199 57.7513C29.6871 43.5935 23.1901 45.0007 23.1901 45.0007C23.1901 45.0007 21.0366 55.4968 25.715 64.7891Z" fill="#559A6B"/>' +
					'<g style="mix-blend-mode:multiply">' +
					'<path d="M23.9897 39.6337C23.9897 39.6337 25.074 67.5752 39.1264 68.3209C39.1264 68.3209 34.6446 77.5829 27.1972 66.8511C19.7498 56.1193 22.9054 41.713 23.9897 39.6337Z" fill="#C9C9C9"/>' +
					'</g>' +
					'<path d="M113.008 38.2611C113.008 38.2611 116.664 43.1526 113.008 56.7029V38.2611Z" fill="#559A6B"/>' +
					'<path d="M40.1552 64.7891C40.1552 64.7891 60.7802 102.604 107.32 77.7083C107.32 77.7083 86.8979 95.9339 53.106 84.5061C53.106 84.5061 42.4058 81.1666 37.1162 71.6431C37.1162 71.6431 39.8161 68.068 40.1552 64.7891Z" fill="#C9C9C9"/>' +
					'<path d="M50.5788 12.8356C44.3496 18.0426 40.883 22.1127 39.1486 27.2721C37.4142 32.4316 37.0232 38.0363 38.0254 43.386C37.4314 41.9119 36.2629 40.762 35.2067 39.5775C34.1505 38.393 33.1375 37.0356 32.9863 35.4533C32.8762 34.3142 33.2282 33.1838 33.5976 32.1009C34.8914 28.2988 36.4703 24.5508 38.8419 21.3108C41.2134 18.0707 44.436 15.3494 48.2612 14.1346" fill="#C9C9C9"/>' +
					'<path d="M54.9397 10.7087C55.5229 10.2634 54.7777 9.47881 52.5012 9.51339C50.406 9.54581 48.2029 8.86927 46.5657 7.50321C45.7666 6.83531 45.0559 5.97936 44.6931 4.99373C44.5332 4.55927 44.2589 2.83008 43.6174 2.83008C43.2503 2.83008 42.9414 3.14782 42.8334 3.50014C42.7297 3.83733 42.7708 4.20046 42.8269 4.55062C43.0083 5.7135 43.2611 6.86125 43.6239 7.97874C44.1401 9.56743 44.7773 11.4458 46.2417 12.4228C47.4902 13.2571 49.1425 13.2765 50.5767 12.8334C51.4385 12.5697 53.5595 11.7657 54.9397 10.7087Z" fill="#C9C9C9"/>' +
					'<path d="M64.426 7.03415C63.7132 6.10903 62.8319 5.3698 61.7736 4.86618C60.7757 4.39065 59.7174 4.08588 58.6288 3.90864C57.4495 3.71627 56.2658 3.65142 55.0735 3.60171C54.4688 3.57793 53.8618 3.552 53.2592 3.50877C52.9655 3.48715 52.6739 3.46337 52.3823 3.43095C52.3218 3.42447 52.2592 3.41798 52.1987 3.40934C52.1749 3.40718 51.8726 3.36611 52.0972 3.39853C51.946 3.37691 51.7948 3.35314 51.6436 3.3272C51.0453 3.22561 50.4535 3.08295 49.8811 2.88193C49.7386 2.83222 49.596 2.77818 49.4578 2.71982C49.6327 2.79331 49.2871 2.63769 49.2375 2.61391C48.9588 2.47774 48.6888 2.32211 48.4232 2.16216C47.3648 1.52236 46.3173 0.815554 45.0559 0.681542C43.7923 0.54753 42.5633 1.2846 42.0363 2.43235C41.505 3.5909 41.5655 4.85753 42.045 6.02473C42.626 7.43835 43.5504 8.7093 44.3582 9.99971C45.2114 11.3614 46.0646 12.7232 46.9156 14.0849C47.1899 14.5237 47.8119 14.7377 48.272 14.4416C48.7126 14.1584 48.9221 13.5554 48.6284 13.0841C47.2331 10.8578 45.7902 8.6531 44.4468 6.39435C44.3021 6.1501 44.1617 5.90153 44.0342 5.64647C43.9997 5.57515 43.9673 5.50382 43.9327 5.43249C43.9198 5.40655 43.8614 5.25741 43.9219 5.41087C43.8636 5.26605 43.8118 5.11907 43.7664 4.96993C43.7254 4.83592 43.6908 4.69974 43.6627 4.56141C43.6519 4.50521 43.626 4.29555 43.6498 4.52034C43.6455 4.47063 43.639 4.42307 43.6368 4.37336C43.6303 4.26312 43.6282 4.15073 43.6325 4.04049C43.6347 3.97781 43.6411 3.91729 43.6455 3.8546C43.6584 3.6471 43.5958 4.04265 43.6519 3.82434C43.6757 3.72924 43.693 3.63197 43.7211 3.53686C43.734 3.48931 43.7534 3.44392 43.7664 3.39637C43.8312 3.17157 43.6951 3.52606 43.7621 3.39637C43.8118 3.2991 43.8593 3.204 43.9154 3.11105C43.9262 3.09376 43.9716 3.0073 43.9954 2.99217C43.9111 3.09808 43.9046 3.10889 43.9738 3.02675C43.9889 3.00946 44.0062 2.99217 44.0213 2.97488C44.0558 2.93813 44.1228 2.8949 44.1487 2.85167C44.2092 2.75008 43.9651 2.95975 44.1444 2.85384C44.2265 2.80412 44.3107 2.75873 44.3949 2.71118C44.2416 2.79764 44.3345 2.73279 44.3885 2.71766C44.4533 2.70037 44.5159 2.67875 44.5807 2.66362C44.6757 2.64201 44.7513 2.56852 44.5893 2.65498C44.6412 2.62688 44.7664 2.64633 44.8226 2.64633C44.9155 2.64849 45.1617 2.69821 44.95 2.65066C45.0818 2.68092 45.2114 2.70685 45.341 2.74576C45.4468 2.77818 45.5505 2.81709 45.6542 2.85816C45.4663 2.78467 45.6434 2.856 45.6909 2.87761C45.7557 2.90787 45.8205 2.94029 45.8853 2.97272C46.3907 3.22561 46.8659 3.5347 47.3475 3.82867C48.3519 4.4382 49.4275 4.88779 50.5766 5.13636C52.8251 5.6227 55.1254 5.48653 57.3998 5.72645C57.4667 5.73293 57.5337 5.74158 57.6006 5.74806C57.6287 5.75239 57.8944 5.78265 57.7518 5.76536C57.592 5.7459 57.8555 5.78049 57.862 5.78049C57.9419 5.79129 58.0218 5.80426 58.1039 5.81723C58.3717 5.86046 58.6374 5.91018 58.9009 5.9707C59.4495 6.09174 59.983 6.25601 60.5079 6.45487C60.6807 6.52188 60.5208 6.45919 60.4906 6.44406C60.5619 6.47432 60.6353 6.50675 60.7066 6.53917C60.8254 6.59321 60.942 6.65157 61.0565 6.71209C61.3071 6.84394 61.5511 6.99092 61.7844 7.15519C61.8276 7.18545 61.8686 7.21571 61.9097 7.24597C62.1192 7.39728 61.7563 7.11412 61.9529 7.28056C62.0522 7.36269 62.1494 7.44699 62.2445 7.53561C62.3395 7.62423 62.4302 7.71502 62.5188 7.81012C62.5641 7.85768 62.6073 7.90739 62.6484 7.95494C62.6808 7.99169 62.8622 8.21864 62.7175 8.03059C63.0328 8.43911 63.5836 8.70282 64.0739 8.38724C64.4756 8.13002 64.7651 7.47293 64.426 7.03415Z" fill="#181818"/>' +
					'<path d="M34.2221 36.0651C34.2459 35.8035 34.2718 35.5441 34.302 35.2848C34.3085 35.2329 34.315 35.181 34.3215 35.1291C34.3236 35.1205 34.356 34.8654 34.3344 35.0276C34.3128 35.1918 34.3474 34.9346 34.3495 34.926C34.3603 34.8481 34.3711 34.7703 34.3841 34.6925C34.4619 34.1759 34.5569 33.6637 34.6649 33.1535C34.8809 32.1463 35.1552 31.152 35.4835 30.1772C35.6455 29.6952 35.8204 29.2175 36.0105 28.7463C36.058 28.6252 36.1077 28.5042 36.1574 28.3831C36.2265 28.2124 36.1617 28.3723 36.1488 28.4026C36.179 28.3313 36.2092 28.2578 36.2416 28.1864C36.3453 27.9465 36.4533 27.7088 36.5635 27.4732C36.9998 26.5394 37.4879 25.6294 38.0236 24.7475C38.5592 23.8656 39.1402 23.0097 39.7666 22.1883C39.7688 22.1862 39.9264 21.9808 39.8314 22.1019C39.7364 22.2229 39.8962 22.0197 39.8984 22.0176C39.9783 21.9138 40.0604 21.8122 40.1424 21.7106C40.3066 21.5075 40.4729 21.3064 40.6435 21.1076C40.9826 20.7099 41.3325 20.3208 41.6932 19.9425C42.3952 19.2033 43.1339 18.503 43.9093 17.8416C44.108 17.673 44.3089 17.5065 44.5119 17.3423C44.6027 17.2688 44.6955 17.1953 44.7884 17.124C44.8316 17.0915 44.9742 16.9791 44.8035 17.111C44.8662 17.0634 44.9266 17.0159 44.9893 16.9683C45.404 16.6528 45.8295 16.3502 46.2615 16.0584C47.214 15.4186 48.2032 14.8371 49.2292 14.3227C49.4862 14.193 49.7432 14.0698 50.0046 13.9487C50.1471 13.8839 50.2897 13.8191 50.4323 13.7564C50.4798 13.7348 50.5273 13.7153 50.5748 13.6937C50.6612 13.6569 50.7843 13.6051 50.6266 13.6699C51.1817 13.4386 51.7433 13.2246 52.3114 13.0323C52.8017 12.8658 53.1753 12.3428 53.0025 11.8132C52.8449 11.3269 52.3092 10.9421 51.7844 11.1215C47.6524 12.5308 43.8964 14.9236 40.8098 18.008C37.7233 21.0968 35.3237 24.8491 33.8182 28.9495C32.978 31.2406 32.4575 33.6356 32.2415 36.0651C32.1961 36.5838 32.7296 37.0788 33.2329 37.0572C33.8074 37.0291 34.1746 36.6184 34.2221 36.0651Z" fill="#181818"/>' +
					'<path d="M61.1529 9.44638C67.6046 7.87498 74.3521 7.37783 80.9463 8.24891C87.277 9.08325 93.7028 11.2231 98.8823 15.0338C103.578 18.4879 107.004 23.4161 109.328 28.7765C110.662 31.8545 111.593 35.1724 111.911 38.5594C112.235 42.0265 112.062 45.5086 111.943 48.98C111.883 50.7351 111.837 52.4945 111.87 54.2518C111.904 55.9983 112.069 57.7297 112.211 59.4696C112.328 60.8941 112.41 62.3228 112.403 63.7537C112.399 64.4238 112.377 65.0938 112.326 65.7596C112.272 66.4642 112.22 66.9203 112.116 67.5255C112.01 68.148 111.872 68.7662 111.699 69.3757C111.615 69.6697 111.524 69.9615 111.423 70.2511C111.373 70.396 111.319 70.5408 111.265 70.6834C111.241 70.7483 111.215 70.811 111.192 70.8736C111.187 70.8823 111.073 71.1611 111.135 71.0163C110.647 72.1705 109.924 73.3853 109.215 74.3018C107.356 76.701 104.841 78.6139 102.297 80.2329C97.0463 83.5767 91.0698 85.5631 84.9335 86.5206C79.1039 87.4306 73.0843 87.3226 67.1985 86.6352C65.9328 86.4882 64.8658 86.3391 63.531 86.1164C62.2285 85.9003 60.9326 85.6474 59.6453 85.3578C57.0534 84.772 54.4961 84.022 52.023 83.045C49.7659 82.1523 47.3403 80.9137 45.2344 79.4483C44.1976 78.7263 43.3228 78.0217 42.3595 77.1031C41.9146 76.6772 41.4847 76.2341 41.0744 75.7759C40.8692 75.5446 40.6683 75.3112 40.4717 75.0713C40.2212 74.7643 40.1521 74.6757 39.9296 74.3753C39.1823 73.3594 38.53 72.2765 37.9727 71.1438C37.7373 70.664 37.0548 70.5321 36.6163 70.7872C36.126 71.0747 36.0245 71.6626 36.2599 72.1446C38.6553 77.0123 42.8304 80.6954 47.5865 83.1855C52.4463 85.7274 57.8223 87.1821 63.2113 88.0639C69.0063 89.0128 74.9223 89.4408 80.7843 88.9826C87.2576 88.4768 93.6704 86.9573 99.5086 84.0738C102.422 82.6365 105.155 80.8467 107.632 78.7458C109.924 76.8026 111.824 74.4768 112.984 71.6885C114.019 69.2028 114.365 66.488 114.384 63.8121C114.406 60.5677 113.902 57.3535 113.846 54.1113C113.786 50.5362 114.058 46.9676 114.077 43.3947C114.097 39.731 113.799 36.0435 112.786 32.5073C111.894 29.4034 110.541 26.3687 108.928 23.5739C107.41 20.9433 105.567 18.4792 103.412 16.3372C98.7375 11.6922 92.5861 8.78928 86.236 7.2395C79.4711 5.59029 72.4061 5.4887 65.544 6.55647C63.8917 6.81369 62.2523 7.14439 60.628 7.53995C59.3883 7.83607 59.911 9.74898 61.1529 9.44638Z" fill="#181818"/>' +
					'<path d="M29.5703 34.7033C27.797 34.8179 26.149 35.596 24.866 36.8194C23.8941 37.7467 23.1662 38.9182 22.6456 40.1481C21.5527 42.7224 21.1575 45.5583 21.138 48.3423C21.1186 51.029 21.4512 53.7352 22.0041 56.3636C22.6003 59.1973 23.501 61.9791 24.771 64.5859C25.9676 67.0435 27.553 69.3995 29.6373 71.1892C30.9483 72.3153 32.5402 73.167 34.3135 73.1021C35.9248 73.0438 37.4259 72.298 38.4994 71.1027C40.5643 68.7986 41.1237 65.6753 41.3958 62.6989C41.7457 58.8579 41.5211 54.991 40.8796 51.1933C40.3267 47.9078 39.5945 44.6375 38.264 41.5725C37.0026 38.6632 34.9593 35.8705 31.7713 34.9605C31.0628 34.7574 30.3068 34.6644 29.5703 34.7033C29.0541 34.7293 28.5552 35.1399 28.5789 35.6954C28.6027 36.2099 29.0152 36.7157 29.5703 36.6876C29.7237 36.6789 29.8792 36.6768 30.0347 36.6811C30.0887 36.6832 30.5552 36.6768 30.5704 36.72C30.5704 36.7221 30.3781 36.6897 30.4969 36.7113C30.5336 36.7178 30.5725 36.7221 30.6114 36.7308C30.687 36.7438 30.7626 36.7589 30.8382 36.774C31.0131 36.8108 31.1881 36.8562 31.3587 36.908C31.5078 36.9534 31.6525 37.0031 31.7972 37.0593C31.8447 37.0788 31.8944 37.0982 31.9419 37.1177C31.9333 37.1134 31.7821 37.0442 31.8836 37.0939C31.9657 37.135 32.0499 37.1696 32.132 37.2106C32.4408 37.3641 32.7389 37.5392 33.024 37.7316C33.091 37.777 33.1558 37.8223 33.2227 37.8699C33.2832 37.9131 33.415 38.0169 33.281 37.911C33.4301 38.0298 33.5791 38.1531 33.7195 38.2806C33.9895 38.5227 34.2444 38.7799 34.482 39.0522C34.5943 39.1798 34.7023 39.3094 34.8081 39.4435C34.9247 39.5904 34.7519 39.3613 34.8621 39.5148C34.9291 39.6077 34.996 39.7007 35.063 39.7958C35.2768 40.1049 35.4712 40.4269 35.6548 40.7555C35.8427 41.0862 36.0176 41.4255 36.184 41.7671C36.2617 41.927 36.3373 42.0891 36.4108 42.2512C36.4475 42.3334 36.4842 42.4155 36.5209 42.4955C36.5447 42.5495 36.5684 42.6057 36.5922 42.6598C36.6246 42.7354 36.6354 42.7635 36.5965 42.6706C36.8946 43.4033 37.1646 44.1425 37.4043 44.8969C37.8795 46.397 38.2488 47.9273 38.5577 49.4706C38.7089 50.2206 38.845 50.9707 38.9702 51.725C39.0437 52.166 39.1128 52.6047 39.1754 53.0479C39.1819 53.0997 39.1906 53.1516 39.197 53.2035C39.1776 53.0587 39.2014 53.2337 39.2035 53.2532C39.2165 53.3569 39.2294 53.4629 39.2424 53.5666C39.2705 53.7936 39.2964 54.0205 39.3223 54.2453C39.5189 56.0588 39.6074 57.8853 39.575 59.7095C39.5599 60.6217 39.5145 61.5317 39.4368 62.4417C39.3979 62.8956 39.3526 63.3495 39.2986 63.8034C39.2856 63.9072 39.2726 64.0131 39.2597 64.1168C39.2532 64.1687 39.2467 64.2206 39.2402 64.2724C39.2467 64.2271 39.2618 64.1147 39.2338 64.3222C39.21 64.4908 39.1862 64.6572 39.1582 64.8236C39.0566 65.4267 38.9141 66.0233 38.7327 66.6069C38.6376 66.9116 38.5318 67.2142 38.413 67.5103C38.4 67.5449 38.3093 67.7524 38.3633 67.6314C38.4173 67.5103 38.3244 67.7179 38.3093 67.7503C38.238 67.9081 38.1624 68.0637 38.0847 68.2172C37.94 68.5003 37.7801 68.777 37.6052 69.0428C37.5253 69.1639 37.4432 69.2828 37.3568 69.3995C37.3482 69.4103 37.2898 69.4751 37.292 69.486C37.2898 69.473 37.4389 69.3044 37.3136 69.4557C37.2596 69.5205 37.2078 69.5832 37.1516 69.6481C36.9486 69.8793 36.7283 70.0912 36.4971 70.29C36.4756 70.3073 36.4432 70.3462 36.4151 70.357C36.4151 70.357 36.5706 70.2446 36.4777 70.3095C36.4194 70.3484 36.3654 70.3916 36.3071 70.4305C36.1732 70.5235 36.0349 70.6078 35.8924 70.6856C35.8319 70.718 35.7693 70.7504 35.7066 70.7807C35.6742 70.7958 35.469 70.8844 35.6008 70.8326C35.7304 70.7807 35.4712 70.878 35.4302 70.8931C35.3114 70.9342 35.1926 70.9709 35.0716 71.0033C34.9831 71.0271 34.8945 71.0465 34.8038 71.066C34.7606 71.0746 34.7152 71.0833 34.6699 71.0919C34.6547 71.0941 34.5079 71.1157 34.6245 71.1006C34.7411 71.0855 34.5943 71.1027 34.5791 71.1049C34.5359 71.1092 34.4906 71.1114 34.4474 71.1157C34.3308 71.1244 34.2141 71.1265 34.0996 71.1244C34.0133 71.1244 33.9269 71.12 33.8405 71.1136C33.7973 71.1114 33.7541 71.1071 33.7109 71.1027C33.6936 71.1006 33.551 71.0833 33.672 71.1006C33.7929 71.1157 33.6504 71.0963 33.6331 71.0941C33.5899 71.0855 33.5489 71.079 33.5057 71.0703C33.3934 71.0487 33.281 71.0206 33.1709 70.9925C33.0046 70.9471 32.8383 70.8931 32.6784 70.8304C32.6374 70.8153 32.5963 70.798 32.5575 70.7828C32.5726 70.7893 32.6935 70.8477 32.5942 70.7958C32.4905 70.7418 32.3825 70.6964 32.2767 70.6402C32.119 70.5559 31.9635 70.4673 31.8145 70.37C31.7389 70.3224 31.6633 70.2706 31.5877 70.2209C31.551 70.1949 31.5121 70.169 31.4754 70.143C31.4581 70.1301 31.268 69.9853 31.3566 70.0544C31.4192 70.102 31.2594 69.9744 31.2313 69.9507C31.1773 69.9053 31.1233 69.8599 31.0693 69.8145C30.944 69.7064 30.8187 69.5984 30.6978 69.486C30.2485 69.0731 29.823 68.6343 29.4234 68.1739C29.2161 67.934 29.0174 67.6898 28.8208 67.4412C28.9439 67.5968 28.8251 67.4455 28.7733 67.3785C28.7279 67.3201 28.6847 67.2596 28.6415 67.2013C28.5465 67.0716 28.4536 66.9397 28.3608 66.8079C27.9871 66.2718 27.6394 65.7185 27.3132 65.1522C26.9806 64.5751 26.6717 63.9828 26.3866 63.3798C26.2419 63.075 26.1015 62.7681 25.9676 62.459C25.9373 62.3876 25.9049 62.3163 25.8747 62.2428C25.9546 62.4265 25.8682 62.2255 25.838 62.1542C25.7732 61.9964 25.7105 61.8386 25.6479 61.6808C25.149 60.4077 24.7299 59.1043 24.38 57.7837C24.0366 56.4825 23.7623 55.1661 23.5528 53.8368C23.529 53.6877 23.5074 53.5385 23.4837 53.3872C23.4707 53.3007 23.4578 53.2143 23.447 53.1257C23.4426 53.0911 23.4426 53.0478 23.4318 53.0133C23.4534 53.0738 23.4534 53.184 23.4383 53.0543C23.3973 52.7366 23.3584 52.4167 23.326 52.099C23.2612 51.4808 23.2094 50.8604 23.177 50.2401C23.1122 49.0491 23.11 47.8538 23.1921 46.6628C23.2137 46.3451 23.2418 46.0273 23.2763 45.7118C23.2914 45.5626 23.3109 45.4156 23.3282 45.2687C23.3519 45.072 23.3044 45.4308 23.3325 45.2341C23.3476 45.1347 23.3606 45.0352 23.3757 44.9358C23.4729 44.3003 23.5982 43.6692 23.758 43.0445C23.9178 42.4155 24.1122 41.793 24.352 41.1899C24.3649 41.1554 24.38 41.1208 24.393 41.0862C24.4686 40.896 24.3757 41.1121 24.3779 41.1186C24.3671 41.0883 24.4513 40.9479 24.4664 40.9154C24.5312 40.7706 24.5982 40.628 24.6695 40.4853C24.8077 40.2065 24.9589 39.932 25.1231 39.6661C25.203 39.5342 25.2872 39.4046 25.3736 39.2792C25.4125 39.2208 25.4535 39.1625 25.4946 39.1063C25.5205 39.0717 25.6674 38.875 25.5853 38.9809C25.4967 39.0933 25.663 38.8858 25.6825 38.862C25.7278 38.808 25.7732 38.7561 25.8185 38.7021C25.9179 38.5897 26.0216 38.4773 26.1274 38.3714C26.2332 38.2654 26.3412 38.1617 26.4536 38.0601C26.5054 38.0147 26.5572 37.9693 26.6112 37.9239C26.6372 37.9023 26.6652 37.8807 26.6911 37.8569C26.7084 37.8418 26.7279 37.8288 26.7451 37.8137C26.7883 37.7813 26.7819 37.7856 26.7279 37.8267C26.7127 37.8375 26.6976 37.8504 26.6825 37.8613C26.7106 37.8396 26.7387 37.8202 26.7667 37.7986C26.8078 37.7683 26.851 37.738 26.892 37.7078C26.9892 37.6408 27.0864 37.5738 27.1858 37.5111C27.365 37.3987 27.5465 37.2928 27.7344 37.1977C27.8186 37.1544 27.905 37.1177 27.9893 37.0745C28.0886 37.0226 27.9849 37.0745 27.9655 37.081C28.0217 37.0572 28.08 37.0356 28.1361 37.0139C28.3046 36.9513 28.4752 36.8951 28.648 36.8454C28.8316 36.7956 29.0152 36.7524 29.2031 36.72C29.2463 36.7135 29.2874 36.707 29.3306 36.6984C29.3176 36.7005 29.1642 36.7135 29.2809 36.707C29.3802 36.7005 29.4796 36.6876 29.579 36.6811C30.0952 36.6487 30.5941 36.2488 30.5704 35.689C30.538 35.1853 30.1232 34.6666 29.5703 34.7033Z" fill="#181818"/>' +
					'<path d="M111.573 33.1103C111.7 33.1579 111.826 33.2076 111.953 33.2594C112.115 33.3243 111.756 33.1708 111.955 33.2616C112.024 33.294 112.096 33.3243 112.165 33.3567C112.413 33.4713 112.655 33.5945 112.893 33.7285C113.126 33.8582 113.355 33.9987 113.579 34.1457C113.679 34.2105 113.776 34.2775 113.873 34.3467C113.925 34.3834 113.977 34.4202 114.029 34.4591C114.089 34.5045 114.303 34.6925 114.068 34.485C114.456 34.8244 114.852 35.1443 115.21 35.5182C115.389 35.7062 115.564 35.9008 115.731 36.0996C115.804 36.1861 115.878 36.3266 115.968 36.3936C115.977 36.4001 115.834 36.2164 115.895 36.3007C115.916 36.3288 115.938 36.359 115.96 36.3871C116.003 36.4455 116.046 36.5038 116.087 36.5622C116.389 36.9815 116.664 37.4181 116.914 37.8721C117.042 38.1055 117.163 38.3411 117.277 38.581C117.333 38.6977 117.387 38.8145 117.439 38.9333C117.465 38.9917 117.491 39.0522 117.517 39.1106C117.577 39.2511 117.433 38.9031 117.523 39.13C117.934 40.1373 118.234 41.1899 118.441 42.2577C118.495 42.5322 118.543 42.811 118.584 43.0877C118.595 43.1547 118.603 43.2217 118.614 43.2909C118.634 43.4206 118.586 43.0704 118.601 43.2001C118.605 43.2282 118.608 43.2585 118.612 43.2866C118.629 43.4314 118.647 43.5784 118.662 43.7232C118.72 44.2917 118.757 44.8645 118.77 45.4351C118.798 46.5828 118.735 47.7327 118.595 48.874C118.588 48.9216 118.56 49.1507 118.582 48.9799C118.603 48.8113 118.573 49.0404 118.567 49.0858C118.545 49.235 118.521 49.3841 118.497 49.5311C118.45 49.8186 118.398 50.1039 118.342 50.3871C118.23 50.9447 118.098 51.4959 117.947 52.0427C117.793 52.5939 117.621 53.1386 117.426 53.6768C117.331 53.9427 117.23 54.2064 117.124 54.4679C117.098 54.5306 117.072 54.5933 117.046 54.656C117.005 54.7576 117.094 54.5436 117.089 54.5522C117.072 54.5868 117.059 54.6236 117.044 54.6581C116.988 54.79 116.927 54.9218 116.869 55.0537C116.422 56.035 115.897 56.9817 115.286 57.8701C115.137 58.0863 114.979 58.2981 114.821 58.5077C114.759 58.592 114.903 58.4062 114.895 58.4148C114.871 58.4343 114.847 58.4753 114.828 58.4991C114.789 58.5488 114.75 58.5964 114.711 58.6461C114.627 58.7498 114.541 58.8514 114.454 58.953C114.13 59.3313 113.785 59.6922 113.42 60.0294C113.238 60.198 113.05 60.3623 112.858 60.5179C112.456 60.8486 112.491 61.5814 112.858 61.9207C113.286 62.3141 113.83 62.2731 114.26 61.9207C115.955 60.5266 117.281 58.6807 118.26 56.7267C119.333 54.5847 120.061 52.2697 120.435 49.905C120.826 47.4323 120.867 44.9423 120.485 42.4652C120.139 40.2194 119.392 37.9823 118.152 36.0672C116.91 34.15 115.176 32.5505 113.089 31.6016C112.765 31.4546 112.437 31.3184 112.104 31.1931C111.618 31.0115 110.996 31.3941 110.886 31.8847C110.752 32.4532 111.05 32.9158 111.573 33.1103Z" fill="#181818"/>' +
					'<path opacity="0.5" d="M75.7529 59.7672C75.7529 59.7672 87.0258 60.3666 87.5664 58.773C88.107 57.1794 81.2199 57.0742 78.0598 57.3458C74.9061 57.6178 67.9166 59.2317 75.7529 59.7672Z" fill="#C9C9C9"/>' +
					'<rect width="5.64822" height="10.6355" rx="2.82411" transform="matrix(0.995562 -0.0941052 0.0936113 0.995609 91.2344 47.0315)" fill="black"/>' +
					'<circle cx="63.2607" cy="58.5" r="1" fill="white"/>' +
					'<circle cx="94.2607" cy="54.6686" r="1" fill="white"/>' +
					'<path fill-rule="evenodd" clip-rule="evenodd" d="M58.351 53.5848C58.328 53.5971 58.3051 53.6096 58.2821 53.6221C57.7972 53.8866 57.6186 54.494 57.883 54.9789C58.1475 55.4637 58.7549 55.6424 59.2398 55.3779C61.7182 54.026 64.0866 54.1329 65.6413 54.4208C66.2288 54.5296 66.6562 54.6528 66.9819 54.7467C67.1009 54.781 67.2063 54.8113 67.301 54.8357C67.3444 54.8468 67.3995 54.8602 67.457 54.8707L67.4578 54.8709C67.4961 54.8779 67.6187 54.9002 67.7642 54.8895C67.8331 54.8844 68.0074 54.8663 68.1965 54.7595C68.4317 54.6267 68.6545 54.3711 68.7019 54.0116C68.74 53.7229 68.6439 53.5053 68.6028 53.4227C68.554 53.3247 68.4994 53.2539 68.4695 53.2174C68.3713 53.0974 68.2432 52.995 68.1828 52.9467L68.18 52.9445C68.0947 52.8762 67.9857 52.7936 67.8609 52.7L67.8032 52.6567L67.7398 52.6221C62.9292 49.9982 59.596 51.8105 58.4472 53.4188C58.4092 53.4719 58.3772 53.5275 58.351 53.5848Z" fill="black"/>' +
					'<path fill-rule="evenodd" clip-rule="evenodd" d="M71.4627 71.1775C72.0335 70.7531 72.8599 70.7707 73.3085 71.2168C74.8542 72.7537 76.8967 73.0981 78.9421 72.8759C81.034 72.6486 83.0439 71.8282 84.225 71.1499C84.8515 70.7901 85.6568 70.9035 86.0236 71.4032C86.3904 71.9028 86.1799 72.5996 85.5534 72.9593C84.0839 73.8033 81.6517 74.8025 79.0316 75.0872C76.365 75.3769 73.4258 74.9255 71.2415 72.7536C70.7929 72.3076 70.8919 71.6019 71.4627 71.1775Z" fill="black"/>' +
					'</g>' +
					'</g>' +
					'<path d="M101.131 69.8272C98.766 72.2613 98.6674 80.0371 98.9139 83.6207L107.636 80.578C107.587 80.0371 107.37 78.225 106.897 75.304C106.306 71.6528 104.088 66.7845 101.131 69.8272Z" fill="white" stroke="black" stroke-width="2.2" stroke-linecap="round"/>' +
					'<path d="M118.458 81.5152C116.218 76.0878 108.307 75.5108 104.632 75.9007C93.781 75.9007 96.6563 95.7855 100.332 99.9964C104.007 104.207 111.982 101.634 115.483 99.9964C118.983 98.3589 121.258 88.2995 118.458 81.5152Z" fill="white" stroke="black" stroke-width="2.2" stroke-linecap="round"/>' +
					'<defs>' +
					'<clipPath id="clip0_310_257">' +
					'<rect width="99.6087" height="88.4955" fill="white" transform="translate(21.3315 0.5)"/>' +
					'</clipPath>' +
					'<clipPath id="clip1_310_257">' +
					'<rect width="99.6087" height="88.4955" fill="white" transform="translate(21.1377 0.668579)"/>' +
					'</clipPath>' +
					'</defs>' +
					'</svg>';

				// Title
				var titleH2 = '<div style="width: 100%;">';
				titleH2 += '<h5 class="font-bold pt-20"">Oppo <span style="text-transform:none;">Community</span></h5>';
				titleH2 += '<div style="clear:both;width:100%"><br></div>';
				titleH2 += '</div>';

				// Punti Box + Coupons [DESKTOP]
				var punti_box = '<div class="account-card-info card-lg float-left punti-mobile-box" style="overflow:visible;">';

				punti_box += '<div class="card-info__sub-w50 align-left only-desktop">';
				punti_box += '<div class="card-info__icon card-info__icon_lg float-left">' + svg_punti + '</div>';
				punti_box += '<div>';
				punti_box += '<a href="' + punti_link + '" target="_blank">' +
					'<span class="mr-10 card-info__title">PUNTI</span></a>' +
					'<p><span class="card-info__text-lg card-info__text-green font-bold">' + punti + '</span></p>';
				punti_box += '</div>';
				punti_box += '</div>';

				punti_box += '<div class="card-info__sub-w50 align-center text-white">';
				punti_box += '<div class="card-info__sub-green" style="z-index:-2;">';
				punti_box += '<div style="z-index:10;overflow:visible;">';
				punti_box += svg_ollie + '</div>';
				punti_box += '<a href="' + counpons_link + '" target="_blank">';
				punti_box += '<p class="font-bold mb-0 text-white" style="font-size:22px;padding-top:0.3rem;">' + counpons + ' Coupon</p>';
				punti_box += '<p class=" text-white" style="padding-bottom:.3rem;">da riscattare</p>';
				punti_box += '</a>';
				punti_box += '</div>';
				punti_box += '</div>';

				punti_box += '</div>';


				// Punti MOBILE
				var puntiM_box = '<div class="account-card-info card-sm only-mobile" style="float:left;">';//  ml-20
				puntiM_box += '<div class="card-info__icon" style="float:left;">' + svg_punti + '</div>';
				puntiM_box += '<div>';
				puntiM_box += '<a href="' + punti_link + '" target="_blank">' +
					'<span class="mr-10 card-info__title">PUNTI</span></a>' +
					'<p><span class="card-info__text-md card-info__text-green font-bold">' + punti + '</span></p>';
				puntiM_box += '</div>';
				puntiM_box += '</div>';

				// classifica Box
				var classifica_box = '<div class="account-card-info card-sm" style="float:left;">';//  ml-20
				classifica_box += '<div class="card-info__icon">' + svg_classifica + '</div>';
				classifica_box += '<div>';
				classifica_box += '<a href="' + classifica_link + '" target="_blank">' +
					'<span class="mr-10 card-info__title">CLASSIFICA</span></a>' +
					'<p><span class="card-info__text-md card-info__text-green font-bold">' + ranking + '°</span>' +
					'<span class="card-info__text-gray card-info__text-md">/' + ranking_tot + '</span></p>';
				classifica_box += '</div>';
				classifica_box += '</div>';

				// badges Box
				var badges_box = '<div class="account-card-info card-sm" style="float:left;">'; //  ml-20
				badges_box += '<div class="card-info__icon">' + svg_badges + '</div>';
				badges_box += '<div>';
				badges_box += '<a href="' + badges_link + '" target="_blank">' +
					'<span class="mr-10 card-info__title">BADGE</span></a>' +
					'<p><span class="card-info__text-md card-info__text-green font-bold">' + badges + '</span></p>';
				badges_box += '</div>';
				badges_box += '</div>';

				// Followers Box
				var followers_box = '<div class="account-card-info card-sm" style="float:left;margin-right:0 !important;">'; //  ml-20
				followers_box += '<div class="card-info__icon">' + svg_followers + '</div>';
				followers_box += '<div>';
				followers_box += '<a href="' + followers_link + '" target="_blank">' +
					'<span class="mr-10 card-info__title">FOLLOWERS</span></a>' +
					'<p><span class="card-info__text-md card-info__text-green font-bold">' + followers + '</span></p>';
				followers_box += '</div>';
				followers_box += '</div>';

				// Box
				var boxCommData = '<div id="account-community-box">';
				boxCommData += titleH2;
				boxCommData += puntiM_box;
				boxCommData += '<div style="width:100%;"></div>';
				boxCommData += punti_box;
				//boxCommData += couponM_box;
				boxCommData += '<div style="width:100%;"></div>';
				boxCommData += classifica_box;
				boxCommData += badges_box;
				boxCommData += followers_box;
				boxCommData += '</div>';

				// Show
				AccountCommCont.html(boxCommData).show();

			} else {
				// Hide
				AccountCommCont.html("").hide();
			}

		});
	}
};
      
/*============================================================================
  Global Events
==============================================================================*/
var mobile  = window.matchMedia( '(max-width: 740px)' );
var tablet  = window.matchMedia( '(max-width: 979px) and (min-width: 741px)' );
var desktop = window.matchMedia( '(min-width: 980px)' );

window.addEventListener( 'DOMContentLoaded', ( event ) => {
    
    /* Initialize Accordions */
    WAU.Accordion.init();
    
    ( function helperRteFormat() {
	theme.DOMHelpers.wrapIframe( {
	    iframes           : document.querySelectorAll( '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]' ),
	    iframeWrapperClass: 'video-wrapper'
	} );
	
	theme.DOMHelpers.wrapTable( {
	    tables           : document.querySelectorAll( '.rte table' ),
	    tableWrapperClass: 'table-wrapper'
	} );
    } )();
    
    ( function eventTriggers() {
	if ( mobile.matches ) {
	    Events.trigger( "mediaquery:mobile" );
	}
	if ( tablet.matches ) {
	    Events.trigger( "mediaquery:tablet" );
	}
	if ( desktop.matches ) {
	    Events.trigger( "mediaquery:desktop" );
	}
	window.addEventListener( "resize", function () {
	    if ( mobile.matches ) {
		Events.trigger( "mediaquery:mobile" );
	    }
	    if ( tablet.matches ) {
		Events.trigger( "mediaquery:tablet" );
	    }
	    if ( desktop.matches ) {
		Events.trigger( "mediaquery:desktop" );
	    }
	} );
	window.addEventListener( 'touchstart', function onFirstTouch() {
	    Events.trigger( "device:touchstart" );
	    window.removeEventListener( 'touchstart', onFirstTouch, false );
	} );
	document.addEventListener( 'shopify:section:select', function ( event ) {
	    Events.trigger( "editor:section:select", event );
	} );
	document.addEventListener( 'shopify:section:deselect', function ( event ) {
	    Events.trigger( "editor:section:deselect", event );
	} );
	document.addEventListener( 'shopify:section:load', function ( event ) {
	    Events.trigger( "editor:section:load", event );
	} );
	document.addEventListener( 'shopify:section:unload', function ( event ) {
	    Events.trigger( "editor:section:unload", event );
	} );
	document.addEventListener( 'shopify:block:select', function ( event ) {
	    Events.trigger( "editor:block:select", event );
	} );
	document.addEventListener( 'shopify:block:deselect', function ( event ) {
	    Events.trigger( "editor:block:deselect", event );
	} );
	document.addEventListener( 'lazyloaded', function ( e ) {
	    Events.trigger( "lazyLoad:complete" );
	} );
    } )();
    
    // SMOOTH SCROLLING TO ANCHOR
    $( document ).on( 'click', 'a[href^="#"]', function ( event ) {
	event.preventDefault();
	
	$( 'html, body' ).animate( {
	    scrollTop: $( $.attr( this, 'href' ) ).offset().top - 90
	}, 500 );
    } );
    
    theme.Reviews();
    
	// USER PROFILE COMMUNITY [DEV 2022-03-17]
    theme.UserProfileComm();
} );

/*============================================================================
  Registering Sections
==============================================================================*/

document.addEventListener( "DOMContentLoaded", function () {
  
  	// Added event push on newsletter submit - 19 Jan '22
  	window.addEventListener("klaviyoForms", function(e) { 
      if (e.detail.type == 'submit') {
        window.dataLayer.push({
           'event':'GAevent',
           'eventCategory':'newsletter registration',
           'eventAction': 'submission',
           'eventLabel': 'newsletter'
        }); 
      }
    });
  
  	// Transforming the string of product skus into an array
  	if (window.currentProductSKUs) window.currentProductSKUs = window.currentProductSKUs.split(',');
  
    var sections = new theme.Sections();
    sections.register( 'slideshow-section', theme.Slideshow );
    sections.register( 'collection-slider', theme.CollectionSlider );
    sections.register( 'featured-collection', theme.FeaturedCollection );
    sections.register( 'product-section', theme.Product );
    sections.register( 'store-availability', theme.StoreAvailability );
    sections.register( 'collection-list-section', theme.CollectionList );
    sections.register( 'collection-section', theme.Collection );
    sections.register( 'mobile-navigation', theme.mobileNav );
    sections.register( 'header-section', theme.Header );
    sections.register( 'footer-section', theme.Footer );
    sections.register( 'image-carousel', theme.Carousel );
    sections.register( 'map', theme.Maps );
    sections.register( 'custom-page-section', theme.CustomPage );
    sections.register( 'password-page', theme.Password );
    sections.register( 'mailing-popup', theme.MailingPopup );
} );

/* Log Theme Version */
log = function () {
    var args = Array.prototype.slice.call( arguments );
    args.unshift( console );
    return Function.prototype.bind.apply( console.log, args );
}

log( "Vantage Version 7.4.3 by Underground", { bar: 1 } )();
      
      
      
